(function() {
    'use strict';

    angular
        .module('eDocumentsApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ui.bootstrap',
            'ngPrettyJson',
            'prettyXml',
            'ngFileUpload',
            'ui.router',
            'ui-notification',
            'ngScrollbars',
            'ngFileUpload',
            'moment-picker',
            'angularMoment',
            'angularjs.daterangepicker',
            'uiCropper',
            'dndLists',
            'cp.ngConfirm',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.select',
            'ngSanitize',
            'duScroll',
            'color.picker'
        ])
        .run(run)
        .constant('angularMomentConfig', {
            timezone: 'Europe/Lisbon'
        });

    run.$inject = ['stateHandler', 'translationHandler','amMoment'];

    function run(stateHandler, translationHandler, amMoment) {
        stateHandler.initialize();
        translationHandler.initialize();
        amMoment.changeLocale('pt');
        moment.tz.setDefault('Europe/Lisbon' );
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('smart-search', {
            parent: 'app',
            url: '/smart-search?page&sort&search',
            data: {
                authorities: ['ROLE_SUPERADMIN', 'ROLE_BETATESTER'],
                pageTitle: 'eDocumentsApp.smart-search.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/smart-search/smart-search.html',
                    controller: 'SmartSearchController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sid: null,
                eid: null,
                did: null,
                oid: null,
                sort: {
                    value: 'createdDate,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: [
                    '$stateParams',
                    'PaginationUtil',
                    function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }
                ],
                loggeduser: [
                    'Principal',
                    function(Principal) {
                        return Principal.identity().$promise;
                    }
                ],
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('smartSearch');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('invoiceHeader');
                        $translatePartialLoader.addPart('invoiceLine');
                        $translatePartialLoader.addPart('invoiceType');
                        $translatePartialLoader.addPart('communicationEntity');
                        return $translate.refresh();
                    }
                ]
            }
        });
    }
})();

/* global moment:true, _:true*/
(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('SmartSearchController', SmartSearchController);

    SmartSearchController.$inject = [
        '$state',
        '$scope',
        'ParseLinks',
        'AlertService',
        'paginationConstants',
        'PaginationUtil',
        '$window',
        'InvoiceHeader',
        'CommunicationEntity',
        'InvoiceLine',
        'CurrencyUtils'
    ];

    function SmartSearchController(
        $state,
        $scope,
        ParseLinks,
        AlertService,
        paginationConstants,
        PaginationUtil,
        $window,
        InvoiceHeader,
        CommunicationEntity,
        InvoiceLine,
        CurrencyUtils
    ) {
        var vm = this;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.reset = reset;
        vm.loadAll = loadAll;
        vm.loadInvoiceHeaders = loadInvoiceHeaders;
        vm.loadInvoiceLines = loadInvoiceLines;
        vm.loadCommunicationEntities = loadCommunicationEntities;
        vm.initFilters = initFilters;
        vm.totalItems = 1000;
        vm.isTableLoading = true;
        vm.getCurrency = CurrencyUtils.getCurrency;
        vm.types = ['INVOICE', 'CREDITNOTE', 'DEBITNOTE', 'SELFBILLED', 'PROFORMAINVOICE', 'CONSIGNMENTNOTE', 'ORDER', 'DESPATCHADVICE'];
        vm.states = ['IN_COMMUNICATION', 'PROCESSING', 'WAITING', 'SCHEDULED', 'FINISHED', 'ERROR', 'DUPLICATED'];

        vm.filters = {};
        vm.page = {};
        vm.predicate = {};
        vm.reverse = {};
        vm.totalItems = {};
        vm.queryCount = {};
        vm.pagination = {};
        vm.pagination.invoiceHeader = {};
        vm.pagination.invoiceLine = {};
        vm.pagination.communicationEntity = {};

        vm.isCollapseInvoiceHeadersOpen = false;
        vm.isCollapseInvoiceLinesOpen = false;
        vm.isCollapsedCommunicationEntitiesOpen = false;

        function isSmallScreen() {
            var w = angular.element($window);
            vm.width = w.width();
            $scope.$apply();
        }

        $(window).resize(function() {
            isSmallScreen();
        });

        function reset() {
            vm.filters.invoiceHeader = PaginationUtil.clearFilters($state.current.name + '_invoiceHeader', filterBy());
            vm.filters.invoiceLine = PaginationUtil.clearFilters($state.current.name + '_invoiceLine', filterBy());
            vm.filters.communicationEntity = PaginationUtil.clearFilters($state.current.name + '_communicationEntity', filterBy());
            vm.omniboxSearchValue = null;
            loadAll();
        }

        function filterBy() {
            return {
                omniboxSearch: {
                    name: 'omniboxSearch',
                    value: undefined
                }
            };
        }

        function initFilters() {
            vm.filters.invoiceHeader = PaginationUtil.getFilters($state.current.name + '_invoiceHeader', filterBy());
            vm.filters.invoiceLine = PaginationUtil.getFilters($state.current.name + '_invoiceLine', filterBy());
            vm.filters.communicationEntity = PaginationUtil.getFilters($state.current.name + '_communicationEntity', filterBy());
            vm.omniboxSearchValue = vm.filters.invoiceHeader.filterBy.omniboxSearch.value;

            vm.pagination.invoiceHeader.page = vm.filters.invoiceHeader.currentPage + 1;
            vm.pagination.invoiceLine.page = vm.filters.invoiceLine.currentPage + 1;
            vm.pagination.communicationEntity.page = vm.filters.communicationEntity.currentPage + 1;
            vm.predicate.invoiceHeader = vm.filters.invoiceHeader.orderBy;
            vm.predicate.invoiceLine = vm.filters.invoiceLine.orderBy;
            vm.predicate.communicationEntity = vm.filters.communicationEntity.orderBy;
            vm.reverse.invoiceHeader = vm.filters.invoiceHeader.orderReverse;
            vm.reverse.invoiceLine = vm.filters.invoiceLine.orderReverse;
            vm.reverse.communicationEntity = vm.filters.communicationEntity.orderReverse;
            loadAll();
        }

        vm.$onInit = function() {
            initFilters();
        };

        function loadInvoiceHeaders() {
            vm.filters.invoiceHeader = PaginationUtil.updateFilters(
                $state.current.name + '_invoiceHeader',
                vm.pagination.invoiceHeader.page - 1,
                vm.filters.invoiceHeader.filterBy,
                vm.predicate.invoiceHeader,
                vm.reverse.invoiceHeader,
                vm.itemsPerPage
            );
            if (vm.filters.invoiceHeader.filterBy.omniboxSearch.value) {
                InvoiceHeader.omniboxSearch(
                    {
                        omniboxSearchValue: vm.filters.invoiceHeader.filterBy.omniboxSearch.value,
                        page: vm.filters.invoiceHeader.currentPage,
                        size: vm.filters.invoiceHeader.itemsPerPage,
                        sort: sort()
                    },
                    onSuccess,
                    onError
                );
            } else {
                vm.invoiceHeaders = {};
            }

            function sort() {
                if (!vm.predicate.invoiceHeader) {
                    vm.predicate.invoiceHeader = 'id';
                }
                var result = [vm.predicate.invoiceHeader + ',' + (vm.reverse.invoiceHeader ? 'asc' : 'desc')];
                if (vm.predicate.invoiceHeader !== 'id') {
                    result.push('id,desc');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pagination.invoiceHeader.totalItems = headers('X-Total-Count');
                vm.pagination.invoiceHeader.queryCount = vm.pagination.invoiceHeader.totalItems;
                vm.invoiceHeaders = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadInvoiceLines() {
            vm.filters.invoiceLine = PaginationUtil.updateFilters(
                $state.current.name + '_invoiceLine',
                vm.pagination.invoiceLine.page - 1,
                vm.filters.invoiceLine.filterBy,
                vm.predicate.invoiceLine,
                vm.reverse.invoiceLine,
                vm.itemsPerPage
            );
            if (vm.filters.invoiceLine.filterBy.omniboxSearch.value) {
                InvoiceLine.omniboxSearch(
                    {
                        omniboxSearchValue: vm.filters.invoiceLine.filterBy.omniboxSearch.value,
                        page: vm.filters.invoiceLine.currentPage,
                        size: vm.filters.invoiceLine.itemsPerPage,
                        sort: sort()
                    },
                    onSuccess,
                    onError
                );
            } else {
                vm.invoiceLines = {};
            }

            function sort() {
                if (!vm.predicate.invoiceLine) {
                    vm.predicate.invoiceLine = 'id';
                }
                var result = [vm.predicate.invoiceLine + ',' + (vm.reverse.invoiceLine ? 'asc' : 'desc')];
                if (vm.predicate.invoiceLine !== 'id') {
                    result.push('id,desc');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pagination.invoiceLine.totalItems = headers('X-Total-Count');
                vm.pagination.invoiceLine.queryCount = vm.pagination.invoiceLine.totalItems;
                vm.invoiceLines = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadCommunicationEntities() {
            vm.filters.communicationEntity = PaginationUtil.updateFilters(
                $state.current.name + '_communicationEntity',
                vm.pagination.communicationEntity.page - 1,
                vm.filters.communicationEntity.filterBy,
                vm.predicate.communicationEntity,
                vm.reverse.communicationEntity,
                vm.itemsPerPage
            );
            if (vm.filters.communicationEntity.filterBy.omniboxSearch.value) {
                CommunicationEntity.omniboxSearch(
                    {
                        omniboxSearchValue: vm.filters.communicationEntity.filterBy.omniboxSearch.value,
                        page: vm.filters.communicationEntity.currentPage,
                        size: vm.filters.communicationEntity.itemsPerPage,
                        sort: sort()
                    },
                    onSuccess,
                    onError
                );
            } else {
                vm.communicationEntities = {};
            }

            function sort() {
                if (!vm.predicate.communicationEntity) {
                    vm.predicate.communicationEntity = 'id';
                }
                var result = [vm.predicate.communicationEntity + ',' + (vm.reverse.communicationEntity ? 'asc' : 'desc')];
                if (vm.predicate.communicationEntity !== 'id') {
                    result.push('id,desc');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.pagination.communicationEntity.totalItems = headers('X-Total-Count');
                vm.pagination.communicationEntity.queryCount = vm.pagination.communicationEntity.totalItems;
                vm.communicationEntities = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAll() {
            vm.filters.invoiceHeader.filterBy.omniboxSearch.value = vm.omniboxSearchValue;
            vm.filters.invoiceLine.filterBy.omniboxSearch.value = vm.omniboxSearchValue;
            vm.filters.communicationEntity.filterBy.omniboxSearch.value = vm.omniboxSearchValue;
            vm.filters.invoiceHeader = PaginationUtil.updateFilters(
                $state.current.name + '_invoiceHeader',
                vm.pagination.invoiceHeader.page - 1,
                vm.filters.invoiceHeader.filterBy,
                vm.predicate.invoiceHeader,
                vm.reverse.invoiceHeader,
                vm.itemsPerPage
            );
            vm.filters.invoiceLine = PaginationUtil.updateFilters(
                $state.current.name + '_invoiceLine',
                vm.pagination.invoiceLine.page - 1,
                vm.filters.invoiceLine.filterBy,
                vm.predicate.invoiceLine,
                vm.reverse.invoiceLine,
                vm.itemsPerPage
            );
            vm.filters.communicationEntity = PaginationUtil.updateFilters(
                $state.current.name + '_communicationEntity',
                vm.pagination.communicationEntity.page - 1,
                vm.filters.communicationEntity.filterBy,
                vm.predicate.communicationEntity,
                vm.reverse.communicationEntity,
                vm.itemsPerPage
            );
            vm.emptySearchBox = !vm.filters.invoiceHeader.filterBy.omniboxSearch.value;
            vm.loadInvoiceHeaders();
            vm.loadInvoiceLines();
            vm.loadCommunicationEntities();
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').factory('User', User);

  User.$inject = ['$resource'];

  function User($resource) {
    return $resource(
      'api/users/:login',
      {},
      {
        query: {
          method: 'GET',
          isArray: true,
        },
        get: {
          method: 'GET',
          transformResponse: function (data) {
            data = angular.fromJson(data);
            return data;
          },
        },
        findByEntity: {
          method: 'GET',
          url: 'api/users-by-entity/:id',
          isArray: true,
        },
        addEntityToUser: {
          method: 'PUT',
          url: 'api/users-add-entity',
          isArray: false,
        },
        updateUserEntity: {
          method: 'PUT',
          url: 'api/users-update-entity',
          isArray: false,
        },
        removeEntityFromUser: {
          method: 'GET',
          url: 'api/users-remove-entity/:userId/:entityId',
          isArray: false,
        },
        findByEmail: {
          method: 'GET',
          url: 'api/users-by-email/:email',
          isArray: false,
        },
        save: { method: 'POST' },
        update: { method: 'PUT' },
        delete: { method: 'DELETE' },
      }
    );
  }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').factory('SendGridService', SendGridService);

    SendGridService.$inject = ['$resource'];

    function SendGridService($resource) {
        return $resource(
      'api/sendgrid/:email',
      {},
            {
                removeFromList: {
                    method: 'DELETE',
                    url: 'api/sendgrid/removeFromUnsubscribeList/:email',
                },
                addToList: {
                    method: 'GET',
                    url: 'api/sendgrid/addToUnsubscribeList/:email',
                    isArray: false,
                },
                getStatus: {
                    method: 'GET',
                    url: 'api/sendgrid/getEmailStatus',
                    isArray: false,
                    transformResponse: function (data) {
                        return angular.fromJson(data);
                    },
                },
                getLanguageByEmail: {
                    method: 'GET',
                    url: 'api/sendgrid/getLanguageByEmail/:email',
                    isArray: false,
                    transformResponse: function (data) {
                        return {
                            responseData: data.toString(),
                        };
                    },
                },
            }
    );
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        return {
            getProfileInfo: getProfileInfo
        };

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService'];

    function pageRibbon(ProfileService) {
        return {
            replace : true,
            restrict: 'AE',
            template: '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link    : linkFunc
        };

        function linkFunc(scope, element) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    /**
     * SUP-12293: when a user's access ends. The server keeps one instant (User.accessValidUntil: from then on the account
     * can neither sign in nor be used); the screen shows and asks for the last day the access still works, in the
     * browser's time zone, so "31/10" means "until the end of 31 October" — the instant is the following midnight.
     */
    angular.module('eDocumentsApp').factory('UserAccessWindow', UserAccessWindow);

    function UserAccessWindow() {
        var MAX_DAYS = 90;
        var FULL_ACCESS_ROLES = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPERADMIN', 'ROLE_PARTNER', 'ROLE_INTEGRATION'];

        return {
            lastDay: lastDay,
            endOf: endOf,
            hasEnded: hasEnded,
            isRestricted: isRestricted,
            maxLastDay: maxLastDay,
            isoDay: isoDay,
        };

        /** No role that opens the application: the account must have an end date (server: UserAccessPolicy). */
        function isRestricted(authorities) {
            return !(authorities || []).some(function (role) {
                return FULL_ACCESS_ROLES.indexOf(role) !== -1;
            });
        }

        /** The latest last day an end date may have: 90 days from today. */
        function maxLastDay() {
            var today = new Date();
            return new Date(today.getFullYear(), today.getMonth(), today.getDate() + MAX_DAYS);
        }

        /** yyyy-MM-dd of a local date, as the date input's min/max want it. */
        function isoDay(day) {
            function pad(n) {
                return (n < 10 ? '0' : '') + n;
            }
            return day.getFullYear() + '-' + pad(day.getMonth() + 1) + '-' + pad(day.getDate());
        }

        /** The last day the access works, as a local date (midnight); null without an end. */
        function lastDay(accessValidUntil) {
            if (!accessValidUntil) {
                return null;
            }
            var end = new Date(accessValidUntil);
            if (isNaN(end.getTime())) {
                return null;
            }
            var last = new Date(end.getTime() - 1);
            return new Date(last.getFullYear(), last.getMonth(), last.getDate());
        }

        /** The instant (ISO string) the access ends when its last day is the given local date; null without one. */
        function endOf(day) {
            if (!day || isNaN(new Date(day).getTime())) {
                return null;
            }
            var d = new Date(day);
            return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1).toISOString();
        }

        function hasEnded(accessValidUntil) {
            return !!accessValidUntil && new Date(accessValidUntil).getTime() <= Date.now();
        }
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal($q, Account) {
        var _identity,
            _pendingIdentity,
            _authenticated = false;

        // SUP-12293: an account with the Digital Archive role and none of these sees the Digital Archive only (the
        // server confines it the same way: ArchiveOnlyAccount.FULL_ACCESS_ROLES).
        var FULL_ACCESS_ROLES = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPERADMIN', 'ROLE_PARTNER', 'ROLE_INTEGRATION'];

        return {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isUserEntityManager: isUserEntityManager,
            isUserEntityMember: isUserEntityMember,
            isIdentityResolved: isIdentityResolved,
            isArchiveOnly: isArchiveOnly,
            hasNoAccess: hasNoAccess,
            homeState: homeState,
        };

        function isArchiveOnly() {
            return hasAnyAuthority(['ROLE_DIGITAL_ARCHIVE']) && !hasAnyAuthority(FULL_ACCESS_ROLES);
        }

        /**
         * A signed-in account left with no role that opens any area (the server allows it its own account only).
         * False while the identity is being (re)loaded: identity(true) clears it but leaves _authenticated set, and
         * reading "no roles yet" as "no access" sent every user to the access-denied page right after signing in.
         */
        function hasNoAccess() {
            return _authenticated && !!_identity && !hasAnyAuthority(FULL_ACCESS_ROLES.concat(['ROLE_DIGITAL_ARCHIVE']));
        }

        /**
         * The state a signed-in user starts on: the Documents list, the Digital Archive for an archive-only account, or
         * the access-denied page for an account with no role left.
         */
        function homeState() {
            if (hasNoAccess()) {
                return 'accessdenied';
            }
            return isArchiveOnly() ? 'digital-archive-document' : 'document';
        }

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        /** Whether the account belongs to the entity, as its manager or not. */
        function isUserEntityMember(communicationEntityId) {
            if (!_authenticated || !_identity || !_identity.userEntities) {
                return false;
            }
            for (var i = 0; i < _identity.userEntities.length; i++) {
                if (_identity.userEntities[i].entityId === communicationEntityId) {
                    return true;
                }
            }
            return false;
        }

        function isUserEntityManager(communicationEntityId) {
            if (!_authenticated || !_identity || !_identity.userEntities) {
                return false;
            }

            if (_identity.userEntities && _identity.userEntities.length > 0) {
                for (var i = 0; i < _identity.userEntities.length; i++) {
                    if (_identity.userEntities[i].entityId === communicationEntityId) {
                        return _identity.userEntities[i].manager;
                    }
                }
            }

            return false;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(
        function (_id) {
            return _id.authorities && _id.authorities.indexOf(authority) !== -1;
        },
        function () {
            return false;
        }
      );
        }

        function identity(force) {
            if (force === true) {
                _identity = undefined;
                _pendingIdentity = undefined;
            }

      // EDOCS-652: a page load asks for the identity from several places at once (the router's authorisation,
      // the navbar); share the request in flight instead of sending GET /api/account once per caller.
            if (angular.isUndefined(_identity) && _pendingIdentity) {
                return _pendingIdentity;
            }

            var deferred = $q.defer();

      // check and see if we have retrieved the identity data from the server.
      // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

      // retrieve the identity data from the server, update the identity object, and then resolve.
            _pendingIdentity = deferred.promise;
            Account.get().$promise.then(getAccountThen).catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                if (_pendingIdentity === deferred.promise) {
                    _pendingIdentity = undefined;
                }
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                if (_pendingIdentity === deferred.promise) {
                    _pendingIdentity = undefined;
                }
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        return $resource('api/account/reset-password/init', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        return $resource('api/account/reset-password/finish', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        return $resource('api/account/change-password', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        return {
            restrict: 'A',
            link    : linkFunc
        };

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        return {
            restrict: 'A',
            link    : linkFunc
        };

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').factory('Auth', Auth);

  Auth.$inject = [
    '$rootScope',
    '$state',
    '$sessionStorage',
    '$q',
    '$translate',
    'Principal',
    'AuthServerProvider',
    'Account',
    'Activate',
    'Password',
    'PasswordResetInit',
    'PasswordResetFinish',
  ];

  function Auth(
    $rootScope,
    $state,
    $sessionStorage,
    $q,
    $translate,
    Principal,
    AuthServerProvider,
    Account,
    Activate,
    Password,
    PasswordResetInit,
    PasswordResetFinish
  ) {
    return {
      activateAccount: activateAccount,
      authorize: authorize,
      changePassword: changePassword,
      homeState: Principal.homeState,
      getPreviousState: getPreviousState,
      goToPreviousState: goToPreviousState,
      login: login,
      logout: logout,
      loginWithToken: loginWithToken,
      resetPasswordFinish: resetPasswordFinish,
      resetPasswordInit: resetPasswordInit,
      resetPreviousState: resetPreviousState,
      storePreviousState: storePreviousState,
      updateAccount: updateAccount,
    };

    function activateAccount(key, callback) {
      var cb = callback || angular.noop;

      return Activate.get(
        key,
        function (response) {
          return cb(response);
        },
        function (err) {
          return cb(err);
        }.bind(this)
      ).$promise;
    }

    function authorize(force) {
      return Principal.identity(force).then(authThen);

      function authThen() {
        var isAuthenticated = Principal.isAuthenticated();

        // an authenticated user can't access to login and register pages
        if (
          isAuthenticated &&
          ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'requestReset' || $rootScope.toState.name === 'requestFinish')
        ) {
          $state.go(Principal.homeState());
        }

        // recover and clear previousState after external login redirect (e.g. oauth2)
        if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
          var previousState = getPreviousState();
          resetPreviousState();
          $state.go(previousState.name, previousState.params);
        }

        if (
          $rootScope.toState.data.authorities &&
          $rootScope.toState.data.authorities.length > 0 &&
          !Principal.hasAnyAuthority($rootScope.toState.data.authorities)
        ) {
          if (isAuthenticated && Principal.isArchiveOnly()) {
            // SUP-12293: an archive-only account has the Digital Archive and nothing else; send it there
            $state.go(Principal.homeState());
          } else if (isAuthenticated) {
            // user is signed in but not authorized for desired state
            $state.go('accessdenied');
          } else {
            // user is not authenticated. stow the state they wanted before you
            // send them to the login service, so you can return them when you're done
            storePreviousState($rootScope.toState.name, $rootScope.toStateParams);
            // now, send them to the signin state so they can log in
            $state.go('landing-page');
          }
        }
      }
    }

    function changePassword(newPassword, callback) {
      var cb = callback || angular.noop;

      return Password.save(
        newPassword,
        function () {
          return cb();
        },
        function (err) {
          return cb(err);
        }
      ).$promise;
    }

    function login(credentials, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      AuthServerProvider.login(credentials)
        .then(loginThen)
        .catch(
          function (err) {
            this.logout();
            deferred.reject(err);
            return cb(err);
          }.bind(this)
        );

      function loginThen(data) {
        Principal.identity(true).then(function (account) {
          // After the login the language will be changed to
          // the language selected by the user during his registration
          if (account !== null) {
            $translate.use(account.langKey).then(function () {
              $translate.refresh();
            });
          }
          deferred.resolve(data);
        });
        return cb();
      }

      return deferred.promise;
    }

    function loginWithToken(jwt, rememberMe) {
      return AuthServerProvider.loginWithToken(jwt, rememberMe);
    }

    function logout() {
      AuthServerProvider.logout();
      Principal.authenticate(null);
    }

    function resetPasswordFinish(keyAndPassword, callback) {
      var cb = callback || angular.noop;

      return PasswordResetFinish.save(
        keyAndPassword,
        function () {
          return cb();
        },
        function (err) {
          return cb(err);
        }
      ).$promise;
    }

    function resetPasswordInit(mail, callback) {
      var cb = callback || angular.noop;

      return PasswordResetInit.save(
        mail,
        function () {
          return cb();
        },
        function (err) {
          return cb(err);
        }
      ).$promise;
    }

    function updateAccount(account, callback) {
      var cb = callback || angular.noop;

      return Account.save(
        account,
        function () {
          return cb(account);
        },
        function (err) {
          return cb(err);
        }.bind(this)
      ).$promise;
    }

    function getPreviousState() {
      return $sessionStorage.previousState;
    }

    function resetPreviousState() {
      delete $sessionStorage.previousState;
    }

    /**
     * After a sign-in: open the page asked for while signed out, or the home page when the account cannot open it -
     * the stored page may be another user's, left when their session expired in this tab. Waits for the identity,
     * which the navbar reloads on authenticationSuccess.
     */
    function goToPreviousState() {
      var previousState = getPreviousState();
      resetPreviousState();
      return Principal.identity().then(function () {
        var target = previousState && $state.get(previousState.name);
        var authorities = target && target.data && target.data.authorities;
        if (target && (!authorities || authorities.length === 0 || Principal.hasAnyAuthority(authorities))) {
          $state.go(previousState.name, previousState.params);
        } else {
          $state.go(Principal.homeState());
        }
      });
    }

    function storePreviousState(previousStateName, previousStateParams) {
      $sessionStorage.previousState = {
        name: previousStateName,
        params: previousStateParams,
      };
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken                : getToken,
            login                   : login,
            loginWithToken          : loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout                  : logout
        };

        return service;

        function getToken() {

            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login(credentials) {

            var data = {
                username  : credentials.username,
                password  : credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            // eslint-disable-next-line
            function authenticateSuccess(data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if (rememberMe) {
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout() {

            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate($resource) {
        return $resource('api/activate', {}, {
            'get': {
                method : 'GET',
                params : {},
                isArray: false
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account($resource) {
        return $resource('api/account', {}, {
            'get'                    : {
                method     : 'GET',
                params     : {},
                isArray    : false,
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response;
                    }
                }
            },
            'getHomeInfo'            : {
                method: 'GET',
                url   : 'api/homeInfo'
            },
            'createRegistrationCache': {
                method: 'GET',
                url   : 'api/createRegistrationCache'
            },
            'knowMore': {
                method: 'POST',
                url   : 'api/account/know-more'
            },
            'contactUs': {
                method: 'POST',
                url   : 'api/account/contact-us'
            },
            'addToNewsletter': {
                method: 'POST',
                url   : 'api/account/add-to-newsletter'
            }
        });
    }
})();

/* global $:true*/

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('SidebarController', SidebarController);

    SidebarController.$inject = [
        '$scope',
        '$timeout',
        '$window',
        '$state',
        'Auth',
        'Principal',
        'ProfileService',
        '$uibModal',
        'DocumentationUtils'
    ];

    function SidebarController($scope, $timeout, $window, $state, Auth, Principal, ProfileService, $uibModal, DocumentationUtils) {
        var vm = this;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.toggleSidebar = toggleSidebar;
        vm.userManualUrl = userManualUrl;
        vm.$state = $state;
        vm.config = {
            theme: 'minimal'
        };
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.knowMore = knowMore;

        function knowMore() {
            $uibModal
                .open({
                    templateUrl: 'app/layouts/footer/know-more/know-more-dialog.html',
                    controller: 'KnowMoreController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                })
                .result.then(
                function() {
                },
                function() {
                }
            );
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('landing-page');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function toggleSidebar() {
            $('#content').toggleClass('active');
            $('#sidebar').toggleClass('active');
            $('#sidebarCollapse').toggleClass('active');
            $('#navbar').toggleClass('active');
        }

        angular.element($window).on('click', function(event) {
            var target = $(event.target);
            var attr = target.attr('id');
            if (
                attr !== 'sidebar' &&
                attr !== 'sidebarCollapse' &&
                !$('#content').hasClass('active') &&
                !isDescendant($('#sidebarCollapse')[0], target[0]) &&
                !isDescendant($('#sidebar')[0], target[0])
            ) {
                toggleSidebar();
            }
        });

        function isDescendant(parent, child) {
            if (!parent || !child) return false;
            var node = child.parentNode;
            while (node != null) {
                if (node === parent) {
                    return true;
                }
                node = node.parentNode;
            }
            return false;
        }

        var start = null;

        addEventSlide();

        function addEventSlide() {
            window.addEventListener('touchstart', addTouchStart);
            window.addEventListener('touchend', addTouchEnd);
        }

        function addTouchStart(event) {
            if (event.touches.length === 1) {
                //just one finger touched
                start = event.touches.item(0).clientX;
            } else {
                start = null;
            }
        }

        function addTouchEnd(event) {
            var offset = 100; //at least 100px are a swipe
            if (start) {
                //just one finger touched
                var end = event.changedTouches.item(0).clientX;

                if (vm.isNavbarCollapsed === false && end > 250) {
                    auxClose();
                }
                if (end > start + offset) {
                    //a left -> right swipe
                    vm.isNavbarCollapsed = false;
                    $scope.$apply();
                    $timeout(function() {
                        openNav();
                    }, 250);
                }
                if (end < start - offset) {
                    auxClose();
                    //a right -> left swipe
                }
            }
        }

        function auxClose() {
            closeNav();
            $timeout(function() {
                vm.isNavbarCollapsed = true;
                $scope.$apply();
            }, 200);
        }

        function openNav() {
            if ($('#sidebar').hasClass('active')) {
                toggleSidebar();
            }
        }

        function closeNav() {
            if (!$('#sidebar').hasClass('active')) {
                toggleSidebar();
            }
        }

        /**
         * The manual is a public page under /content/, not an application state, so it opens
         * in a new tab for everyone, signed in or not. Returned as a URL rather than opened
         * from script so the link stays middle-clickable and copyable.
         */
        function userManualUrl() {
            return DocumentationUtils.userManualUrl();
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('SendGridCheckerController', SendGridCheckerController);

    SendGridCheckerController.$inject = ['Notification', 'SendGridService', '$state', '$translate'];

    function SendGridCheckerController(Notification, SendGridService, $state, $translate) {
        var vm = this;
        vm.step1 = true;
        vm.step2 = false;
        vm.step3 = false;
        vm.email = null;

        vm.getEmailStatus = getEmailStatus;
        vm.removeFromList = removeFromList;
        vm.back = back;

        function getEmailStatus() {
            if (vm.email) {
                SendGridService.getStatus({ email: vm.email }).$promise.then(
                    function(resp) {
                        if (resp.recipient_email || resp.email) {
                            vm.step1 = false;
                            vm.step2 = true;
                            vm.step3 = false;
                        } else {
                            vm.step1 = false;
                            vm.step2 = false;
                            vm.step3 = true;
                        }
                    },
                    function() {
                        errorMessage($translate.instant('sendGrid.message.error.serverError'));
                    }
                );
            } else {
                errorMessage($translate.instant('sendGrid.message.error.emailError'));
            }
        }

        function removeFromList() {
            if (vm.email) {
                SendGridService.removeFromList({ email: vm.email }).$promise.then(
                    function() {
                        vm.step1 = true;
                        vm.step2 = false;
                        vm.step3 = false;
                        vm.email = null;
                        successMessage($translate.instant('sendGrid.message.success.emailRemoved'));
                    },
                    function() {
                        errorMessage($translate.instant('sendGrid.message.error.serverError'));
                    }
                );
            } else {
                errorMessage($translate.instant('sendGrid.message.error.emailError'));
            }
        }

        function back() {
            vm.step1 = true;
            vm.step2 = false;
            vm.step3 = false;
            vm.email = null;
            $state.go('send-grid-checker');
        }

        function errorMessage(message) {
            Notification.error({
                message: message,
                delay: 5000
            });
        }

        function successMessage(message) {
            Notification.success({
                message: message,
                delay: 5000
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('send-grid', {
                url: '/unsubscribe?email',
                data: {
                    authorities: []
                },
                views: {
                    'main@': {
                        templateUrl: 'app/layouts/send-grid/send-grid.html',
                        controller: 'SendGridController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('sendGrid');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('send-grid-checker', {
                parent: 'app',
                url: '/sendGrid',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/send-grid/send-grid-checker.html',
                        controller: 'SendGridCheckerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('sendGrid');
                            return $translate.refresh();
                        }
                    ]
                }
            });
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('SendGridController', SendGridController);

    SendGridController.$inject = [
        'Notification',
        'SendGridService',
        '$localStorage',
        '$location',
        '$state',
        '$translate',
        '$stateParams',
        '$scope',
        'tmhDynamicLocale'
    ];

    function SendGridController(Notification, SendGridService, $localStorage, $location, $state, $translate, $stateParams, $scope, tmhDynamicLocale) {
        var vm = this;
        vm.email = $stateParams.email;
        vm.errorEmail = false;

        vm.goHome = goHome;
        vm.subscribeAgain = subscribeAgain;

        $scope.$on('$viewContentLoaded', function() {
            var emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            vm.errorEmail = false;

            // ADD PATH EMAIL TO LOCAL STORAGE
            if (vm.email && emailPattern.test(vm.email)) {
                $localStorage.email = vm.email;
            } else if ($localStorage.email && emailPattern.test($localStorage.email)) {
                vm.email = $localStorage.email;
            } else {
                vm.errorEmail = true;
                Notification.warning({
                    title: $translate.instant('sendGrid.message.invalidEmail.title'),
                    message: $translate.instant('sendGrid.message.invalidEmail.message'),
                    delay: 5000
                });
            }

            // CHECK USER PREF LANG AND SET TO CURRENT PAGE
            var languageKey = 'pt-pt';
            SendGridService.getLanguageByEmail({ email: vm.email }).$promise.then(
                function(data) {
                    if (data.responseData) {
                        languageKey = data.responseData;
                    }
                    $translate.use(languageKey);
                    tmhDynamicLocale.set(languageKey);
                },
                function() {
                    $translate.use(languageKey);
                    tmhDynamicLocale.set(languageKey);
                }
            );
            // CLEAR EMAIL ADDRESS FROM URL
            $location.search('email', null);
        });

        function subscribeAgain() {
            SendGridService.removeFromList({ email: vm.email }).$promise.then(
                function() {
                    Notification.success({
                        title: $translate.instant('sendGrid.message.subscribed.title'),
                        message: $translate.instant('sendGrid.message.subscribed.message'),
                        delay: 5000
                    });
                    vm.goHome();
                },
                function() {
                    vm.goHome();
                }
            );
        }

        function goHome() {
            // Reset Stored Email
            $localStorage.email = null;
            $state.go('landing-page');
        }
    }
})();

/* global $:true*/
(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('NavbarController', NavbarController).value('duScrollDuration', 100).value('duScrollOffset', 80);

  NavbarController.$inject = ['$scope', '$state', '$stateParams', '$timeout', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'ContactUsService'];

  function NavbarController($scope, $state, $stateParams, $timeout, Auth, Principal, ProfileService, LoginService, ContactUsService) {
    var vm = this;
    vm.isAuthenticated = Principal.isAuthenticated;
    vm.login = login;
    vm.logout = logout;
    vm.toggleSidebar = toggleSidebar;
    vm.changeStyle = changeStyle;
    vm.contactUs = contactUs;
    vm.$state = $state;
    init();

    function init() {
      Principal.identity().then(function (account) {
        vm.account = account;
        if (vm.account) {
          if (vm.account.imageContentType && vm.account.image) {
            vm.account.imageURL = 'data:' + vm.account.imageContentType + ';base64,' + vm.account.image;
          }
        }
      });
    }

    ProfileService.getProfileInfo().then(function (response) {
      vm.inProduction = response.inProduction;
      vm.swaggerEnabled = response.swaggerEnabled;
    });
    $scope.$on('authenticationSuccess', function () {
      Principal.identity(true).then(function (account) {
        vm.account = account;
        if (vm.account) {
          if (vm.account.imageContentType && vm.account.image) {
            vm.account.imageURL = 'data:' + vm.account.imageContentType + ';base64,' + vm.account.image;
          }
        }
      });
    });

    $scope.$on('updateAccountSuccess', function () {
      Principal.identity(true).then(function (account) {
        vm.account = account;
        if (vm.account) {
          if (vm.account.imageContentType && vm.account.image) {
            vm.account.imageURL = 'data:' + vm.account.imageContentType + ';base64,' + vm.account.image;
          }
        }
      });
    });

    function changeStyle(style) {
      $('body').removeClass('dark');
      $('body').removeClass('white');
      $('body').removeClass('light');
      $('body').addClass(style);
    }

    function login() {
      LoginService.open();
    }

    function logout() {
      Auth.logout();
      $state.go('landing-page');
    }

    toggleSidebar();

    function toggleSidebar() {
      $('#content').toggleClass('active');
      $('#sidebar').toggleClass('active');
      $('#sidebarCollapse').toggleClass('active');
      $('#navbar').toggleClass('active');
    }

    function contactUs() {
      ContactUsService.open();
    }

    $timeout(function () {
      if ($stateParams.section) {
        goToSection($stateParams.section);
      }
    }, 500);

    function goToSection(section) {
      $('#' + section + 'NavLink').click();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', 'tmhDynamicLocale'];

    function activeMenu($translate, tmhDynamicLocale) {
        return {
            restrict: 'A',
            link    : linkFunc
        };

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function () {
                return $translate.use();
            }, function (selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();


(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('landing-page', {
            url: '/',
            data: {
                authorities: [],
                pageTitle: 'global.title'
            },
            params: {
                section: null
            },
            views: {
                'main@': {
                    templateUrl: 'app/layouts/landing-page/landing-page.html',
                    controller: 'LandingPageController',
                    controllerAs: 'vm'
                },
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('login');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('landingPage');
                        $translatePartialLoader.addPart('faqs');
                        return $translate.refresh();
                    }
                ]
            }
        });
    }
})();

/* global d3:true, _:true */

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('LandingPageController', LandingPageController);

    LandingPageController.$inject = [
        '$scope',
        'Account',
        'Principal',
        '$state',
        'Auth',
        '$rootScope',
        '$translate',
        'PaginationUtil',
        'Notification',
        'ContactUsService',
        'DocumentationUtils',
        '$sessionStorage',
        'LoginService'
    ];

    function LandingPageController(
        $scope,
        Account,
        Principal,
        $state,
        Auth,
        $rootScope,
        $translate,
        PaginationUtil,
        Notification,
        ContactUsService,
        DocumentationUtils,
        $sessionStorage,
        LoginService
    ) {
        var vm = this;
        vm.authenticationError = false;
        vm.credentials = {};
        vm.password = null;
        vm.rememberMe = true;
        vm.email = null;
        vm.isSaving = false;
        vm.addToNewsletter = addToNewsletter;
        vm.login = login;
        vm.downloadManual = downloadManual;
        vm.userManualUrl = userManualUrl;
        vm.contactUs = contactUs;
        $scope.$on('authenticationSuccess', function() {
            // A page asked for while signed out is restored by whoever signed in (LoginController, or vm.login below);
            // sending the user home here as well overrode it. Checked now: the sign-in clears it right after this event.
            if (Auth.getPreviousState()) {
                return;
            }
            init();
        });

        function addToNewsletter() {
            vm.isSaving = true;
            Account.addToNewsletter(
                {
                    email: vm.email
                },
                function() {
                    Notification.success({
                        message: $translate.instant('global.addToNewsletter.success.message'),
                        delay: 5000
                    });
                    vm.email = '';
                    vm.isSaving = false;
                },
                function() {
                    Notification.error({
                        message: $translate.instant('global.addToNewsletter.error.message'),
                        delay: 5000
                    });
                    vm.isSaving = false;
                }
            );
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            })
                .then(function() {
                    PaginationUtil.resetFilters();
                    vm.authenticationError = false;
                    $rootScope.$broadcast('authenticationSuccess');
                    if (Auth.getPreviousState()) {
                        Auth.goToPreviousState();
                    } else {
                        $state.go(Principal.homeState());
                    }
                })
                .catch(function() {
                    vm.authenticationError = true;
                });
        }

        init();

        function init() {
            Principal.identity().then(function(account) {
                if (account && account.login) {
                    $state.go(Principal.homeState());
                } else if ($sessionStorage.accessExpired) {
                    // SUP-12293: signed out because the account's access ended - tell the user why
                    LoginService.open();
                }
            });
        }

        function downloadManual() {
            DocumentationUtils.openUserManual();
        }

        function userManualUrl() {
            return DocumentationUtils.userManualUrl();
        }

        function contactUs() {
            ContactUsService.open();
        }
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('KnowMoreController', KnowMoreController);

    KnowMoreController.$inject = ['$uibModalInstance', '$translate', 'Principal', 'Account', 'Notification'];

    function KnowMoreController($uibModalInstance, $translate, Principal, Account, Notification) {
        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated();

        vm.eDocumentsNewFunctionalities = false;
        vm.flowinnProducts = false;
        vm.beContactedByFlowinn = false;
        vm.email = null;

        vm.isSaving = false;

        vm.save = save;
        vm.clear = clear;

        function save() {
            vm.isSaving = true;
            Account.knowMore({
                eDocumentsNewFunctionalities: vm.eDocumentsNewFunctionalities,
                flowinnProducts: vm.flowinnProducts,
                beContactedByFlowinn: vm.beContactedByFlowinn,
                email: vm.email
            }, function () {
                vm.isSaving = false;
                vm.successTitle = $translate.instant('global.knowMore.success.title');
                vm.successMessage   = $translate.instant('global.knowMore.success.message');
                Notification.success({
                    title: vm.successTitle,
                    message: vm.successMessage
                });
                vm.clear();
            }, function () {
                vm.errorTitle = $translate.instant('global.knowMore.error.title');
                vm.errorMessage   = $translate.instant('global.knowMore.error.message');
                Notification.error({
                    title: vm.errorTitle,
                    message: vm.errorMessage
                });
                vm.isSaving = false;
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('FooterController', FooterController);

    FooterController.$inject = ['$uibModal'];

    function FooterController($uibModal) {
        var vm = this;

        vm.knowMore = knowMore;

        function knowMore() {
            $uibModal.open({
                templateUrl: 'app/layouts/footer/know-more/know-more-dialog.html',
                controller: 'KnowMoreController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md'
            }).result.then(function() {

            }, function() {
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'main@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                url: '/accessdenied',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'main@': {
                        templateUrl: 'app/layouts/error/accessdenied.html',
                        controller: 'AccessDeniedController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('AccessDeniedController', AccessDeniedController);

    AccessDeniedController.$inject = ['$state', 'Auth', 'Principal'];

    // SUP-12293: an account left with no role is told so, and offered to sign out instead of a way back to a page it
    // cannot open
    function AccessDeniedController($state, Auth, Principal) {
        var vm = this;

        vm.noAccess = Principal.hasNoAccess();
        vm.logout = logout;

        // the page can open while the identity is being reloaded (after a sign-in); decide once it is known
        Principal.identity().then(function () {
            vm.noAccess = Principal.hasNoAccess();
        });

        function logout() {
            Auth.logout();
            $state.go('landing-page');
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_SUPERADMIN'],
                pageTitle: 'global.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('documentType');
                        $translatePartialLoader.addPart('documentStatus');
                        return $translate.refresh();
                    }
                ]
            }
        });
    }
})();

/* global d3:true, _:true */

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'Account', 'DocumentDownloadPdf', 'CurrencyUtils', 'DataUtils'];

    function HomeController($scope, Principal, Account, DocumentDownloadPdf, CurrencyUtils, DataUtils) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.activeView = 'ORIGIN';
        vm.documentsDates = [];
        vm.username = null;
        vm.changeCompany = changeCompany;
        vm.download = download;
        vm.getCurrency = CurrencyUtils.getCurrency;
        vm.getFileIconClass = DataUtils.getFileIconClass;
        $scope.$on('authenticationSuccess', function () {
            init();
        });

        init();

        function download($event, document, fileId, fileType) {
            DocumentDownloadPdf.download($event, document, fileId, fileType);
        }

        function init() {
            Principal.identity().then(function (account) {
                vm.account = account;
                if (vm.account && vm.account.login) {
                    Account.getHomeInfo().$promise.then(function (res) {
                        vm.homeInfo = res;
                        if (vm.homeInfo.admin) {
                            vm.company = 'all';
                            changeCompany('all');
                        } else {
                            vm.companies = [];
                            var keys = Object.keys(vm.homeInfo);
                            for (var i = 0; i < keys.length; i++) {
                                if (vm.homeInfo[keys[i]].clients) {
                                    vm.companies.push(keys[i]);
                                }
                            }
                            vm.company = 'all';
                            changeCompany('all');
                        }
                    });
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function changeCompany(company) {
            vm.company = company;
            vm.clients = {
                origin: vm.homeInfo[vm.company].clients.ORIGIN,
                destination: vm.homeInfo[vm.company].clients.DESTINATION,
            };
            vm.status = {
                origin: vm.homeInfo[vm.company].status.ORIGIN,
                destination: vm.homeInfo[vm.company].status.DESTINATION,
            };
            vm.documents = {
                origin: vm.homeInfo[vm.company].documents.ORIGIN,
                destination: vm.homeInfo[vm.company].documents.DESTINATION,
            };
            vm.values = {
                origin: vm.homeInfo[vm.company].values.ORIGIN,
                destination: vm.homeInfo[vm.company].values.DESTINATION,
            };
            vm.last10Sent = vm.homeInfo[vm.company].last10Sent.ORIGIN;
            vm.last10Received = vm.homeInfo[vm.company].last10Received.DESTINATION;
            vm.valuesSent =
        (vm.values.origin.INVOICE ? vm.values.origin.INVOICE : 0) +
        (vm.values.origin.DEBITNOTE ? vm.values.origin.DEBITNOTE : 0) +
        (vm.values.origin.PROFORMAINVOICE ? vm.values.origin.PROFORMAINVOICE : 0) +
        (vm.values.origin.CONSIGNMENTNOTE ? vm.values.origin.CONSIGNMENTNOTE : 0) -
        (vm.values.origin.CREDITNOTE ? vm.values.origin.CREDITNOTE : 0) -
        (vm.values.origin.SELFBILLED ? vm.values.origin.SELFBILLED : 0);
            vm.valuesReceived =
        (vm.values.destination.INVOICE ? vm.values.destination.INVOICE : 0) +
        (vm.values.destination.DEBITNOTE ? vm.values.destination.DEBITNOTE : 0) +
        (vm.values.destination.PROFORMAINVOICE ? vm.values.destination.PROFORMAINVOICE : 0) +
        (vm.values.destination.CONSIGNMENTNOTE ? vm.values.destination.CONSIGNMENTNOTE : 0) -
        (vm.values.destination.CREDITNOTE ? vm.values.destination.CREDITNOTE : 0) -
        (vm.values.destination.SELFBILLED ? vm.values.destination.SELFBILLED : 0);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('external', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('externalDocuments', {
            parent: 'external',
            url: '/external/documents?hash',
            data: {
                authorities: [],
                pageTitle: 'eDocumentsApp.document.home.title'
            },
            views: {
                'main@': {
                    templateUrl: 'app/external/document/documents.external.html',
                    controller: 'DocumentsExternalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    $translatePartialLoader.addPart('documentType');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('DocumentsExternalController', DocumentsExternalController);

    DocumentsExternalController.$inject = ['$stateParams', 'Document', 'DocumentDownloadPdf', 'DataUtils'];

    function DocumentsExternalController($stateParams, Document, DocumentDownloadPdf, DataUtils) {
        var vm = this;

        vm.hashMissing = angular.isUndefined($stateParams.hash);
        vm.error = null;
        vm.download = download;
        vm.downloadAllFiles = downloadAllFiles;
        vm.getFileIconClass = DataUtils.getFileIconClass;
        vm.success = null;
        vm.externalDocuments = null;

        Document.getAllByExternalHash(
            {
                hash: $stateParams.hash,
            },
      function (result) {
          vm.externalDocuments = result;
      },
      function (error) {
          vm.externalDocuments = null;
          vm.error = error;
      }
    );

        function download($event, document, fileHashedId) {
            DocumentDownloadPdf.downloadExternal($event, document, fileHashedId);
        }

        function downloadAllFiles($event) {
            DocumentDownloadPdf.downloadAllFilesExternal($event, $stateParams.hash, vm.externalDocuments);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('externalDocument', {
            parent: 'external',
            url: '/external/document?hash',
            data: {
                authorities: [],
                pageTitle: 'eDocumentsApp.document.detail.title'
            },
            views: {
                'main@': {
                    templateUrl: 'app/external/document/document.external.html',
                    controller: 'DocumentExternalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('document');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('DocumentExternalController', DocumentExternalController);

    DocumentExternalController.$inject = [
        '$stateParams',
        '$uibModal',
        '$translate',
        '$sce',
        'Document',
        'DocumentFile',
        'DocumentDownloadPdf',
        'Notification',
        'DataUtils',
        'CurrencyUtils',
        'translationHandler',
    ];

    function DocumentExternalController(
    $stateParams,
    $uibModal,
    $translate,
    $sce,
    Document,
    DocumentFile,
    DocumentDownloadPdf,
    Notification,
    DataUtils,
    CurrencyUtils,
    translationHandler
  ) {
        var vm = this;

        vm.hashMissing = angular.isUndefined($stateParams.hash);
        vm.error = null;
        vm.download = download;
        vm.downloadAllFiles = downloadAllFiles;
        vm.getCurrency = CurrencyUtils.getCurrency;
        vm.getFileIconClass = DataUtils.getFileIconClass;
        vm.success = null;
        vm.viewableFile = null;

        if (!vm.hashMissing) {
            Document.getByExternalHash(
                {
                    hash: $stateParams.hash,
                },
        function (result) {
            vm.externalDocument = result;
            // This tab belongs to the customer, not to us: name the document they were sent.
            if (vm.externalDocument && vm.externalDocument.documentNumber) {
                translationHandler.setSubject(vm.externalDocument.documentNumber);
            }
            vm.approvalInfo = {
                approvedBy: vm.externalDocument.approvedBy,
                approvedDate: vm.externalDocument.approvedDate,
            };
            Document.addExternalView(vm.externalDocument.hashedId);
            if (angular.isDefined(vm.externalDocument.files) && vm.externalDocument.files.length > 0) {
                var pdfDocumentFile = vm.externalDocument.files.find(isPDF);
                if (angular.isDefined(pdfDocumentFile)) {
                    Document.downloadNeedApprovalExternal({ hash: vm.externalDocument.hashedId }).$promise.then(
                function (result) {
                    var downloadNeedApproval = result.body;

                  // SELFBILLED documents will never be sent with an external access hash
                    if (
                    (vm.externalDocument.documentType === 'SELFBILLED' || vm.externalDocument.documentType === 'CREDITNOTE') &&
                    !vm.externalDocument.approved &&
                    downloadNeedApproval === 'true'
                  ) {
                        $uibModal
                      .open({
                          templateUrl: 'app/entities/document/document-approval-by-hashid-dialog.html',
                          controller: 'DocumentApprovalByHashIdController',
                          controllerAs: 'vm',
                          size: 'md',
                          resolve: {
                              entity: [
                                  'Document',
                                  function (Document) {
                                      return Document.getByExternalHash({ hash: vm.externalDocument.hashedId }).$promise;
                                  },
                              ],
                          },
                      })
                      .result.then(function () {
                          Document.getByExternalHash(
                              {
                                  hash: $stateParams.hash,
                              },
                          function (result) {
                              vm.externalDocument = result;
                              vm.approvalInfo = {
                                  approvedBy: vm.externalDocument.approvedBy,
                                  approvedDate: vm.externalDocument.approvedDate,
                              };
                          },
                          function (err) {
                              if (err.status === 404) {
                                  Notification.error({ message: $translate.instant('eDocumentsApp.document.message.documentNotFound') });
                              } else {
                                  Notification.error({
                                      message:
                                  $translate.instant('eDocumentsApp.document.message.errorDownloading') +
                                  ': ' +
                                  $translate.instant('error.' + DataUtils.getErrorMessageFromArrayBuffer(err.data.data)),
                                  });
                              }
                          }
                        );
                          getViewableFile(pdfDocumentFile.hashedId);
                      });
                    } else {
                        getViewableFile(pdfDocumentFile.hashedId);
                    }
                },
                function (e) {
                    Notification.error({ message: e.statusText });
                }
              );
                }
            }
        },
        function (error) {
            vm.externalDocument = null;
            vm.error = error;
        }
      );
        }

        function getViewableFile(fileHashedId) {
            DocumentFile.externalDownload({ hash: fileHashedId }).$promise.then(
        function (result) {
            var file = new Blob([result.data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            vm.viewableFile = $sce.trustAsResourceUrl(fileURL);
            DocumentFile.addExternalDownload(fileHashedId);
        },
        function (err) {
            processDownloadError(err);
        }
      );
        }

        function processDownloadError(error) {
            if (error.status === 404) {
                Notification.error({ message: $translate.instant('eDocumentsApp.document.message.documentNotFound') });
            } else {
                Notification.error({
                    message:
            $translate.instant('eDocumentsApp.document.message.errorDownloading') +
            ': ' +
            $translate.instant('error.' + DataUtils.getErrorMessageFromArrayBuffer(error.data.data)),
                });
            }
        }

        function isPDF(documentFile) {
            return documentFile.fileType === 'PDF';
        }

        function download($event, fileHashedId) {
            DocumentDownloadPdf.downloadExternal($event, vm.externalDocument, fileHashedId);
        }

        function downloadAllFiles($event) {
            DocumentDownloadPdf.downloadAllFilesExternal($event, $stateParams.hash, vm.externalDocument);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('UnitOfMeasureDialogController', UnitOfMeasureDialogController);

    UnitOfMeasureDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'UnitOfMeasure'];

    function UnitOfMeasureDialogController ($timeout, $scope, $uibModalInstance, entity, UnitOfMeasure) {
        var vm = this;

        vm.unitOfMeasure = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.unitOfMeasure.id !== null) {
                UnitOfMeasure.update(vm.unitOfMeasure, onSaveSuccess, onSaveError);
            } else {
                UnitOfMeasure.save(vm.unitOfMeasure, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('eDocumentsApp:unitOfMeasureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('UnitOfMeasureDetailController', UnitOfMeasureDetailController);

    UnitOfMeasureDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function UnitOfMeasureDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.unitOfMeasure = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('eDocumentsApp:unitOfMeasureUpdate', function (result) {
            vm.unitOfMeasure = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('UnitOfMeasureDeleteController',UnitOfMeasureDeleteController);

    UnitOfMeasureDeleteController.$inject = ['$uibModalInstance', 'entity', 'UnitOfMeasure'];

    function UnitOfMeasureDeleteController($uibModalInstance, entity, UnitOfMeasure) {
        var vm = this;

        vm.unitOfMeasure = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UnitOfMeasure.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('unit-of-measure', {
                parent: 'entity',
                url: '/unit-of-measure?page&sort&search',
                data: {
                    authorities: ['ROLE_SUPERADMIN'],
                    pageTitle: 'eDocumentsApp.unitOfMeasure.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/unit-of-measure/unit-of-measures.html',
                        controller: 'UnitOfMeasureController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'commonCode,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('unitOfMeasure');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('unit-of-measure-detail', {
                parent: 'unit-of-measure',
                url: '/unit-of-measure/{id}',
                data: {
                    authorities: ['ROLE_SUPERADMIN'],
                    pageTitle: 'eDocumentsApp.unitOfMeasure.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/unit-of-measure/unit-of-measure-detail.html',
                        controller: 'UnitOfMeasureDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('unitOfMeasure');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'UnitOfMeasure', function($stateParams, UnitOfMeasure) {
                        return UnitOfMeasure.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ['$state', function($state) {
                        return {
                            name: $state.current.name || 'unit-of-measure',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('unit-of-measure-detail.edit', {
                parent: 'unit-of-measure-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/unit-of-measure/unit-of-measure-dialog.html',
                        controller: 'UnitOfMeasureDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['UnitOfMeasure', function(UnitOfMeasure) {
                                return UnitOfMeasure.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('unit-of-measure.new', {
                parent: 'unit-of-measure',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/unit-of-measure/unit-of-measure-dialog.html',
                        controller: 'UnitOfMeasureDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    commonCode: null,
                                    name: null,
                                    symbol: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('unit-of-measure', null, { reload: 'unit-of-measure' });
                    }, function() {
                        $state.go('unit-of-measure');
                    });
                }]
            })
            .state('unit-of-measure.edit', {
                parent: 'unit-of-measure',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/unit-of-measure/unit-of-measure-dialog.html',
                        controller: 'UnitOfMeasureDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['UnitOfMeasure', function(UnitOfMeasure) {
                                return UnitOfMeasure.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('unit-of-measure', null, { reload: 'unit-of-measure' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('unit-of-measure.delete', {
                parent: 'unit-of-measure',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/unit-of-measure/unit-of-measure-delete-dialog.html',
                        controller: 'UnitOfMeasureDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['UnitOfMeasure', function(UnitOfMeasure) {
                                return UnitOfMeasure.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('unit-of-measure', null, { reload: 'unit-of-measure' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('UnitOfMeasure', UnitOfMeasure);

    UnitOfMeasure.$inject = ['$resource'];

    function UnitOfMeasure ($resource) {
        var resourceUrl =  'api/unit-of-measures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('UnitOfMeasureController', UnitOfMeasureController);

    UnitOfMeasureController.$inject = ['$state', 'UnitOfMeasure', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function UnitOfMeasureController($state, UnitOfMeasure, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            UnitOfMeasure.query({
                search: pagingParams.search ? pagingParams.search : undefined,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.unitOfMeasures = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'commonCode';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ScheduledTaskDialogController', ScheduledTaskDialogController);

    ScheduledTaskDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ScheduledTask', 'Document', 'CommunicationWorkflowStep'];

    function ScheduledTaskDialogController($timeout, $scope, $uibModalInstance, entity, ScheduledTask, Document, CommunicationWorkflowStep) {
        var vm = this;

        vm.scheduledTask = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.documents = Document.query();
        vm.communicationworkflowsteps = CommunicationWorkflowStep.query();

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.scheduledTask.id !== null) {
                ScheduledTask.update(vm.scheduledTask, onSaveSuccess, onSaveError);
            } else {
                ScheduledTask.save(vm.scheduledTask, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('eDocumentsApp:scheduledTaskUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.executionDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('ScheduledTaskDetailController', ScheduledTaskDetailController);

    ScheduledTaskDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity', 'translationHandler'];

    function ScheduledTaskDetailController($scope, $rootScope, previousState, entity, translationHandler) {
        var vm = this;

        vm.scheduledTask = entity;
        if (vm.scheduledTask && vm.scheduledTask.documentDocumentNumber) {
            translationHandler.setSubject(vm.scheduledTask.documentDocumentNumber, 'eDocumentsApp.scheduledTask.home.title');
        }
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('eDocumentsApp:scheduledTaskUpdate', function (result) {
            vm.scheduledTask = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ScheduledTaskDeleteController',ScheduledTaskDeleteController);

    ScheduledTaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScheduledTask'];

    function ScheduledTaskDeleteController($uibModalInstance, entity, ScheduledTask) {
        var vm = this;

        vm.scheduledTask = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ScheduledTask.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('scheduled-task', {
                parent: 'entity',
                url: '/scheduled-task?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'eDocumentsApp.scheduledTask.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/scheduled-task/scheduled-tasks.html',
                        controller: 'ScheduledTaskController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduledTask');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('scheduled-task-detail', {
                parent: 'scheduled-task',
                url: '/scheduled-task/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'eDocumentsApp.scheduledTask.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-detail.html',
                        controller: 'ScheduledTaskDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('scheduledTask');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ScheduledTask', function($stateParams, ScheduledTask) {
                        return ScheduledTask.get({ id: $stateParams.id }).$promise;
                    }],
                    previousState: ['$state', function($state) {
                        return {
                            name: $state.current.name || 'scheduled-task',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('scheduled-task-detail.edit', {
                parent: 'scheduled-task-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-dialog.html',
                        controller: 'ScheduledTaskDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ScheduledTask', function(ScheduledTask) {
                                return ScheduledTask.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('scheduled-task.new', {
                parent: 'scheduled-task',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-dialog.html',
                        controller: 'ScheduledTaskDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function() {
                                return {
                                    executionDate: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('scheduled-task', null, { reload: 'scheduled-task' });
                    }, function() {
                        $state.go('scheduled-task');
                    });
                }]
            })
            .state('scheduled-task.edit', {
                parent: 'scheduled-task',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-dialog.html',
                        controller: 'ScheduledTaskDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ScheduledTask', function(ScheduledTask) {
                                return ScheduledTask.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('scheduled-task', null, { reload: 'scheduled-task' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('scheduled-task.delete', {
                parent: 'scheduled-task',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/scheduled-task/scheduled-task-delete-dialog.html',
                        controller: 'ScheduledTaskDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ScheduledTask', function(ScheduledTask) {
                                return ScheduledTask.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('scheduled-task', null, { reload: 'scheduled-task' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('ScheduledTask', ScheduledTask);

    ScheduledTask.$inject = ['$resource', 'DateUtils'];

    function ScheduledTask ($resource, DateUtils) {
        var resourceUrl =  'api/scheduled-tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.executionDate = DateUtils.convertDateTimeFromServer(data.executionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ScheduledTaskController', ScheduledTaskController);

    ScheduledTaskController.$inject = ['$state', 'ScheduledTask', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ScheduledTaskController($state, ScheduledTask, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            ScheduledTask.query({
                search: pagingParams.search ? pagingParams.search : undefined,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.scheduledTasks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceLineDialogController', InvoiceLineDialogController);

    InvoiceLineDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'InvoiceLine', 'Document'];

    function InvoiceLineDialogController($timeout, $scope,  $uibModalInstance, entity, InvoiceLine, Document) {
        var vm = this;

        vm.invoiceLine          = entity;
        vm.clear                = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar         = openCalendar;
        vm.save                 = save;
        vm.documents            = Document.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (angular.isDefined(vm.invoiceLine.id) && vm.invoiceLine.id !== null) {
                InvoiceLine.update(vm.invoiceLine, onSaveSuccess, onSaveError);
            } else {
                InvoiceLine.save(vm.invoiceLine, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('eDocumentsApp:invoiceLineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lotValidUntil = false;
        vm.datePickerOpenStatus.deliveryDate  = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceLineDetailController', InvoiceLineDetailController);

    InvoiceLineDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function InvoiceLineDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.invoiceLine   = entity;
        vm.previousState = previousState.name;
        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:invoiceLineUpdate', function (event, result) {
            vm.invoiceLine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceLineDeleteController',InvoiceLineDeleteController);

    InvoiceLineDeleteController.$inject = ['$uibModalInstance', 'entity', 'InvoiceLine'];

    function InvoiceLineDeleteController($uibModalInstance, entity, InvoiceLine) {
        var vm = this;

        vm.invoiceLine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InvoiceLine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('invoice-line', {
                parent : 'entity',
                url    : '/invoice-line',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.invoiceLine.home.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/invoice-line/invoice-lines.html',
                        controller  : 'InvoiceLineController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceLine');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-line-detail', {
                parent : 'invoice-line',
                url    : '/invoice-line/{id}',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.invoiceLine.detail.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/invoice-line/invoice-line-detail.html',
                        controller  : 'InvoiceLineDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceLine');
                        return $translate.refresh();
                    }],
                    entity                : ['$stateParams', 'InvoiceLine', function ($stateParams, InvoiceLine) {
                        return InvoiceLine.get({id: $stateParams.id}).$promise;
                    }],
                    previousState         : ["$state", function ($state) {
                        return {
                            name  : $state.current.name || 'invoice-line',
                            params: $state.params,
                            url   : $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('invoice-line-detail.edit', {
                parent : 'invoice-line-detail',
                url    : '/detail/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/invoice-line/invoice-line-dialog.html',
                        controller  : 'InvoiceLineDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['InvoiceLine', function (InvoiceLine) {
                                return InvoiceLine.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('invoice-line.new', {
                parent : 'invoice-line',
                url    : '/new',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/invoice-line/invoice-line-dialog.html',
                        controller  : 'InvoiceLineDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: function () {
                                return {
                                    lineNumber            : null,
                                    itemCode              : null,
                                    itemDescription       : null,
                                    supplierLotCode       : null,
                                    lotValidUntil         : null,
                                    lotQualityCode        : null,
                                    productType           : null,
                                    quantity              : null,
                                    bonusQuantity         : null,
                                    unitOfMeasure         : null,
                                    grossUnitPrice        : null,
                                    netUnitPrice          : null,
                                    grossLineAmount       : null,
                                    lineDiscountAmount    : null,
                                    lineNetAmount         : null,
                                    vatRate               : null,
                                    vatAmount             : null,
                                    deliveryDate          : null,
                                    lineDiscountPercentage: null,
                                    id                    : null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('invoice-line', null, {reload: 'invoice-line'});
                    }, function () {
                        $state.go('invoice-line');
                    });
                }]
            })
            .state('invoice-line.edit', {
                parent : 'invoice-line',
                url    : '/{id}/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/invoice-line/invoice-line-dialog.html',
                        controller  : 'InvoiceLineDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['InvoiceLine', function (InvoiceLine) {
                                return InvoiceLine.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('invoice-line', null, {reload: 'invoice-line'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('invoice-line.delete', {
                parent : 'invoice-line',
                url    : '/{id}/delete',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/invoice-line/invoice-line-delete-dialog.html',
                        controller  : 'InvoiceLineDeleteController',
                        controllerAs: 'vm',
                        size        : 'md',
                        resolve     : {
                            entity: ['InvoiceLine', function (InvoiceLine) {
                                return InvoiceLine.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('invoice-line', null, {reload: 'invoice-line'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('InvoiceLine', InvoiceLine);

    InvoiceLine.$inject = ['$resource', 'DateUtils'];

    function InvoiceLine ($resource, DateUtils) {
        var resourceUrl =  'api/invoice-lines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lotValidUntil = DateUtils.convertLocalDateFromServer(data.lotValidUntil);
                        data.deliveryDate = DateUtils.convertLocalDateFromServer(data.deliveryDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.lotValidUntil = DateUtils.convertLocalDateToServer(copy.lotValidUntil);
                    copy.deliveryDate = DateUtils.convertLocalDateToServer(copy.deliveryDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.lotValidUntil = DateUtils.convertLocalDateToServer(copy.lotValidUntil);
                    copy.deliveryDate = DateUtils.convertLocalDateToServer(copy.deliveryDate);
                    return angular.toJson(copy);
                }
            },
            'omniboxSearch': {
                method: 'GET',
                isArray: true,
                url: 'api/invoice-lines/omniboxSearch'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceLineController', InvoiceLineController);

    InvoiceLineController.$inject = ['InvoiceLine'];

    function InvoiceLineController(InvoiceLine) {

        var vm = this;

        vm.invoiceLines = [];
        var loaded = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            InvoiceLine.query(function(result) {
                loaded = result;
                vm.invoiceLines = result;
                vm.searchQuery = null;
                vm.currentSearch = null;
            });
        }

        function search() {
        if (!vm.searchQuery) {
            vm.invoiceLines = loaded;
            vm.currentSearch = null;
            return;
        }
        /* There is no search endpoint for this entity. The XSearch service this used to call was
           JHipster Elasticsearch scaffolding that this application never had - injecting it threw
           "Unknown provider", which killed the whole controller, so the page rendered NOTHING at
           all. The list is loaded in full above, so the box filters what is already here. */
        var needle = String(vm.searchQuery).toLowerCase();
        vm.invoiceLines = loaded.filter(function(item) {
            return Object.keys(item).some(function(key) {
                var value = item[key];
                return value !== null && value !== undefined && typeof value !== 'object' &&
                    String(value).toLowerCase().indexOf(needle) !== -1;
            });
        });
        vm.currentSearch = vm.searchQuery;
        }

        function clear() {
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.invoiceLines = loaded;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceHeaderDialogController', InvoiceHeaderDialogController);

    InvoiceHeaderDialogController.$inject = ['$timeout', '$scope',  '$uibModalInstance', '$q', 'entity', 'InvoiceHeader', 'Document'];

    function InvoiceHeaderDialogController ($timeout, $scope,  $uibModalInstance, $q, entity, InvoiceHeader, Document) {
        var vm = this;

        vm.invoiceHeader = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.documents = Document.query({filter: 'invoiceheader-is-null'});
        $q.all([vm.invoiceHeader.$promise, vm.documents.$promise]).then(function() {
            if (!vm.invoiceHeader.documentId) {
                return $q.reject();
            }
            return Document.get({id : vm.invoiceHeader.documentId}).$promise;
        }).then(function(document) {
            vm.documents.push(document);
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (angular.isDefined(vm.invoiceHeader.id) && vm.invoiceHeader.id !== null) {
                InvoiceHeader.update(vm.invoiceHeader, onSaveSuccess, onSaveError);
            } else {
                InvoiceHeader.save(vm.invoiceHeader, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('eDocumentsApp:invoiceHeaderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.salesOrderDate = false;
        vm.datePickerOpenStatus.invoiceExpirationDate = false;
        vm.datePickerOpenStatus.dueDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceHeaderDetailController', InvoiceHeaderDetailController);

    InvoiceHeaderDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function InvoiceHeaderDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.invoiceHeader = entity;
        vm.previousState = previousState.name;
        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:invoiceHeaderUpdate', function (event, result) {
            vm.invoiceHeader = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceHeaderDeleteController',InvoiceHeaderDeleteController);

    InvoiceHeaderDeleteController.$inject = ['$uibModalInstance', 'entity', 'InvoiceHeader'];

    function InvoiceHeaderDeleteController($uibModalInstance, entity, InvoiceHeader) {
        var vm = this;

        vm.invoiceHeader = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InvoiceHeader.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('invoice-header', {
                parent : 'entity',
                url    : '/invoice-header?page&sort&search',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.invoiceHeader.home.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/invoice-header/invoice-headers.html',
                        controller  : 'InvoiceHeaderController',
                        controllerAs: 'vm'
                    }
                },
                params : {
                    page  : {
                        value : '1',
                        squash: true
                    },
                    sort  : {
                        value : 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams          : ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page     : PaginationUtil.parsePage($stateParams.page),
                            sort     : $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search   : $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceHeader');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoice-header-detail', {
                parent : 'invoice-header',
                url    : '/invoice-header/{id}',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.invoiceHeader.detail.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/invoice-header/invoice-header-detail.html',
                        controller  : 'InvoiceHeaderDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceHeader');
                        return $translate.refresh();
                    }],
                    entity                : ['$stateParams', 'InvoiceHeader', function ($stateParams, InvoiceHeader) {
                        return InvoiceHeader.get({id: $stateParams.id}).$promise;
                    }],
                    previousState         : ["$state", function ($state) {
                        return {
                            name  : $state.current.name || 'invoice-header',
                            params: $state.params,
                            url   : $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('invoice-header-detail.edit', {
                parent : 'invoice-header-detail',
                url    : '/detail/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/invoice-header/invoice-header-dialog.html',
                        controller  : 'InvoiceHeaderDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['InvoiceHeader', function (InvoiceHeader) {
                                return InvoiceHeader.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('invoice-header.new', {
                parent : 'invoice-header',
                url    : '/new',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/invoice-header/invoice-header-dialog.html',
                        controller  : 'InvoiceHeaderDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: function () {
                                return {
                                    environment           : null,
                                    company               : null,
                                    subCompany            : null,
                                    documentType          : null,
                                    selfBilling           : null,
                                    documentSeries        : null,
                                    documentNumber        : null,
                                    supplierCode          : null,
                                    documentCertification : null,
                                    salesOrderNumber      : null,
                                    salesOrderDate        : null,
                                    invoiceExpirationDate : null,
                                    customerOrderReference: null, // should be PurchaseOrderNumber
                                    externalCustomerId    : null,
                                    currencyCode          : null,
                                    vatBaseAmount         : null,
                                    vatAmount             : null,
                                    totalAmount           : null,
                                    totalDiscountAmount   : null,
                                    dueDate               : null,
                                    salesReference        : null,
                                    id                    : null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('invoice-header', null, {reload: 'invoice-header'});
                    }, function () {
                        $state.go('invoice-header');
                    });
                }]
            })
            .state('invoice-header.edit', {
                parent : 'invoice-header',
                url    : '/{id}/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/invoice-header/invoice-header-dialog.html',
                        controller  : 'InvoiceHeaderDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['InvoiceHeader', function (InvoiceHeader) {
                                return InvoiceHeader.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('invoice-header', null, {reload: 'invoice-header'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('invoice-header.delete', {
                parent : 'invoice-header',
                url    : '/{id}/delete',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/invoice-header/invoice-header-delete-dialog.html',
                        controller  : 'InvoiceHeaderDeleteController',
                        controllerAs: 'vm',
                        size        : 'md',
                        resolve     : {
                            entity: ['InvoiceHeader', function (InvoiceHeader) {
                                return InvoiceHeader.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('invoice-header', null, {reload: 'invoice-header'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('InvoiceHeader', InvoiceHeader);

    InvoiceHeader.$inject = ['$resource', 'DateUtils'];

    function InvoiceHeader ($resource, DateUtils) {
        var resourceUrl =  'api/invoice-headers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.salesOrderDate = DateUtils.convertLocalDateFromServer(data.salesOrderDate);
                        data.invoiceExpirationDate = DateUtils.convertLocalDateFromServer(data.invoiceExpirationDate);
                        data.dueDate = DateUtils.convertLocalDateFromServer(data.dueDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.salesOrderDate = DateUtils.convertLocalDateToServer(copy.salesOrderDate);
                    copy.invoiceExpirationDate = DateUtils.convertLocalDateToServer(copy.invoiceExpirationDate);
                    copy.dueDate = DateUtils.convertLocalDateToServer(copy.dueDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.salesOrderDate = DateUtils.convertLocalDateToServer(copy.salesOrderDate);
                    copy.invoiceExpirationDate = DateUtils.convertLocalDateToServer(copy.invoiceExpirationDate);
                    copy.dueDate = DateUtils.convertLocalDateToServer(copy.dueDate);
                    return angular.toJson(copy);
                }
            },
            'omniboxSearch': {
                method: 'GET',
                isArray: true,
                url: 'api/invoice-headers/omniboxSearch'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('InvoiceHeaderController', InvoiceHeaderController);

    InvoiceHeaderController.$inject = ['$state', 'InvoiceHeader', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function InvoiceHeaderController($state, InvoiceHeader, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;

        loadAll();

        /* The search branch that used to sit here called InvoiceHeaderSearch - JHipster
           Elasticsearch scaffolding this application never had. Injecting it threw "Unknown
           provider", which killed the controller, so this page rendered NOTHING even when nobody
           was searching. There is no search endpoint for this entity, so the control has been
           removed rather than left looking operable; it also sorted by '_score', a relevance
           field that does not exist here. */
        function loadAll () {
            InvoiceHeader.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.invoiceHeaders = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ExternalEntityDialogController', ExternalEntityDialogController);

    ExternalEntityDialogController.$inject = ['$timeout', '$scope', 'readOnly', '$state', 'entity', 'ExternalEntity', 'CommunicationEntity', 'translationHandler'];

    function ExternalEntityDialogController($timeout, $scope, readOnly, $state, entity, ExternalEntity, CommunicationEntity, translationHandler) {
        var vm = this;

        vm.externalEntity = entity;
        if (vm.externalEntity && vm.externalEntity.name) {
            translationHandler.setSubject(vm.externalEntity.name, 'eDocumentsApp.externalEntity.home.title');
        }
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.communicationentities = CommunicationEntity.query();
        vm.readOnly = readOnly;
        vm.goBack = goBack;

        activate();

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });


        function activate() {
            if (!vm.externalEntity) {
                clear();
            }
        }

        function clear() {
            $state.go('external-entity');
        }

        function save() {
            vm.isSaving = true;
            if (vm.externalEntity.id !== null) {
                ExternalEntity.update(vm.externalEntity, onSaveSuccess, onSaveError);
            } else {
                ExternalEntity.save(vm.externalEntity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('eDocumentsApp:externalEntityUpdate', result);
            $state.go('external-entity');
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function goBack() {
            window.history.back();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ExternalEntityDeleteController',ExternalEntityDeleteController);

    ExternalEntityDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExternalEntity', 'Notification'];

    function ExternalEntityDeleteController($uibModalInstance, entity, ExternalEntity, Notification) {
        var vm = this;

        vm.externalEntity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ExternalEntity.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                },
                function (error) {
                    Notification.error({ message: error.data.detail });
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('external-entity', {
                parent: 'entity', url: '/external-entity/{ceid}?&page&sort&search', data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                    pageTitle: 'eDocumentsApp.externalEntity.home.title'
                }, views: {
                    'content@': {
                        templateUrl: 'app/entities/external-entity/external-entities.html',
                        controller: 'ExternalEntityController',
                        controllerAs: 'vm'
                    }
                }, params: {
                    page: {
                        value: '1', squash: true
                    }, ceid: null, sort: {
                        value: 'id,asc', squash: true
                    }, search: null
                }, resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    communicationEntity: ['$stateParams', 'CommunicationEntity', function($stateParams, CommunicationEntity) {
                        if ($stateParams.ceid) {
                            return CommunicationEntity.get({ id: $stateParams.ceid }).$promise;
                        }
                        return undefined;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('externalEntity');
                        $translatePartialLoader.addPart('externalEntityStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('external-entity-detail', {
                parent: 'external-entity', url: '/external-entity', data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                    pageTitle: 'eDocumentsApp.externalEntity.detail.title'
                }, views: {
                    'content@': {
                        templateUrl: 'app/entities/external-entity/external-entity-dialog.html',
                        controller: 'ExternalEntityDialogController',
                        controllerAs: 'vm'
                    }
                }, params: {
                    id: null, ceid: null
                }, resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('externalEntity');
                        $translatePartialLoader.addPart('externalEntityStatus');
                        return $translate.refresh();
                    }], entity: ['$stateParams', 'ExternalEntity', function($stateParams, ExternalEntity) {
                        if ($stateParams.id != null) {
                            return ExternalEntity.get({ id: $stateParams.id }).$promise;
                        }
                        return null;
                    }], readOnly: function() {
                        return true;
                    }, previousState: ['$state', function($state) {
                        return {
                            name: $state.current.name || 'external-entity',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('external-entity-detail.edit', {
                parent: 'external-entity-detail', url: '/detail/edit', data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                }, views: {
                    'content@': {
                        templateUrl: 'app/entities/external-entity/external-entity-dialog.html',
                        controller: 'ExternalEntityDialogController',
                        controllerAs: 'vm'
                    }
                }, resolve: {
                    entity: ['$stateParams', 'ExternalEntity', function($stateParams, ExternalEntity) {
                        return ExternalEntity.get({ id: $stateParams.id }).$promise;
                    }], readOnly: function() {
                        return false;
                    }, previousState: ['$state', function($state) {
                        return {
                            name: $state.current.name || 'external-entity',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('external-entity.edit', {
                parent: 'external-entity', url: '/edit', data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                }, views: {
                    'content@': {
                        templateUrl: 'app/entities/external-entity/external-entity-dialog.html',
                        controller: 'ExternalEntityDialogController',
                        controllerAs: 'vm'
                    }
                }, params: {
                    id: null, ceid: null
                }, resolve: {
                    entity: ['$stateParams', 'ExternalEntity', function($stateParams, ExternalEntity) {
                        if ($stateParams.id != null) {
                            return ExternalEntity.get({ id: $stateParams.id }).$promise;
                        }
                        return null;
                    }], readOnly: function() {
                        return false;
                    }, previousState: ['$state', function($state) {
                        return {
                            name: $state.current.name || 'external-entity',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('external-entity.delete', {
                parent: 'external-entity', url: '/{id}/delete', data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                }, onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/external-entity/external-entity-delete-dialog.html',
                        controller: 'ExternalEntityDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ExternalEntity', function(ExternalEntity) {
                                return ExternalEntity.get({ id: $stateParams.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('external-entity', null, { reload: 'external-entity' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('ExternalEntity', ExternalEntity);

    ExternalEntity.$inject = ['$resource', 'DateUtils'];

    function ExternalEntity($resource, DateUtils) {
        var resourceUrl = 'api/external-entities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'synchronize': { method: 'PUT', url: 'api/external-entities-synchronize' },
            transformResponse: function(data) {
                if (data) {
                    data = angular.fromJson(data);
                }
                return data;
            },
            'getLastSynchronization': {
                method: 'GET', url: 'api/external-entity-synchronizing-entities/:communicationEntityId',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'activate': { method: 'PUT', url: 'api/external-entities-activate' },
            'inactivate': { method: 'PUT', url: 'api/external-entities-inactivate' }
        });
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('ExternalEntityController', ExternalEntityController);

    ExternalEntityController.$inject = [
        '$state',
        '$translate',
        'communicationEntity',
        'ExternalEntity',
        'ParseLinks',
        'AlertService',
        'paginationConstants',
        'pagingParams',
        'PaginationUtil',
        'Notification',
        '$uibModal',
        '$interval',
    ];

    function ExternalEntityController(
    $state,
    $translate,
    communicationEntity,
    ExternalEntity,
    ParseLinks,
    AlertService,
    paginationConstants,
    pagingParams,
    PaginationUtil,
    Notification,
    $uibModal,
    $interval
  ) {
        var vm = this;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.communicationEntity = communicationEntity;
        vm.clear = clear;
        vm.search = search;
        vm.reset = reset;
        vm.loadAll = loadAll;
        vm.deselectOne = deselectOne;
        vm.selectAll = selectAll;
        vm.selectChange = selectChange;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.activateEntities = activateEntities;
        vm.getTotalSelected = getTotalSelected;
        vm.selectedEntities = {};
        vm.entitiesToSelection = {};
        vm.synchronize = synchronize;
        vm.activateBtnEnable = activateBtnEnable;
        vm.showTooltipOnActivateButton = showTooltipOnActivateButton;
        vm.activateEntity = activateEntity;
        vm.inactivateEntity = inactivateEntity;

        vm.synchronizeButtonProtected = true;
        vm.isSynchronizing = false;
        vm.lastSynchronizationData = {};

        vm.totalItems = 1000;

        vm.changeStatus = changeStatus;
        vm.isSearchActive = isSearchActive;

        vm.statuses = ['CREATED', 'PENDING', 'ACTIVE'];

        initFilters();

        function loadAll() {
            if (vm.stateCurrentName === $state.current.name) {
        // avoiding synchronization thread issues
                vm.filters = PaginationUtil.updateFilters($state.current.name, vm.page - 1, vm.filters.filterBy, vm.predicate, vm.reverse, vm.itemsPerPage);
            }
            if (vm.communicationEntity) {
                ExternalEntity.query(
                    {
                        originEntityID: vm.communicationEntity.id,
                        query: search(),
                        page: vm.filters.currentPage,
                        size: vm.filters.itemsPerPage,
                        sort: sort(),
                    },
          onSuccess,
          onError
        );
            }

            function sort() {
                if (!vm.predicate) {
                    vm.predicate = 'id';
                }
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.externalEntities = data;
                vm.entitiesToSelection = vm.externalEntities.filter(function (ent) {
                    return ent.status === 'CREATED';
                });
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function initFilters() {
            vm.stateCurrentName = $state.current.name;
            vm.filters = PaginationUtil.getFilters($state.current.name, filterBy());
            vm.page = vm.filters.currentPage + 1;
            vm.predicate = vm.filters.orderBy;
            vm.reverse = vm.filters.orderReverse;
            validateSynchronization();
            loadAll();
        }

        $interval(function () {
            if (vm.isSynchronizing) {
                validateSynchronization();
            }
        }, 10000);

        function validateSynchronization() {
            ExternalEntity.getLastSynchronization(
        { communicationEntityId: vm.communicationEntity.id },
        function (result) {
            vm.lastSynchronizationData = result;
          // enable or disable the sync button if the process is not finished or if there is no data or if 1 hour has passed for the start time
            var syncStartDatePlusOneHour = moment(vm.lastSynchronizationData.startDate).add(60, 'm').toDate();
            var now = new Date();
            if (syncStartDatePlusOneHour < now || moment(vm.lastSynchronizationData.endDate).toDate() < now) {
                if (vm.isSynchronizing) {
                    if (moment(vm.lastSynchronizationData.endDate).toDate() < now && vm.lastSynchronizationData.numberEntitiesSynchronized >= 0) {
                // the reason why the previous validation passed was because it ended the synchronization
                        Notification.success({ message: $translate.instant('eDocumentsApp.externalEntity.message.synchronize.finishedSuccessfully') });
                    } else {
                        Notification.error({ message: $translate.instant('eDocumentsApp.externalEntity.message.synchronize.error') });
                    }
                }
                vm.synchronizeButtonProtected = false;
                vm.isSynchronizing = false;
                loadAll();
            } else {
                vm.synchronizeButtonProtected = true;
                vm.isSynchronizing = true;
            }
            vm.lastSynchronizationData.startDate = moment(vm.lastSynchronizationData.startDate).format('DD-MMM-YYYY HH:mm:ss');
            if (vm.lastSynchronizationData.endDate != null) {
                vm.lastSynchronizationData.endDate = moment(vm.lastSynchronizationData.endDate).format('DD-MMM-YYYY HH:mm:ss');
            }
        },
        function () {
            vm.lastSynchronizationData = {};
            vm.synchronizeButtonProtected = false;
            vm.isSynchronizing = false;
        }
      );
        }

        function filterBy() {
            return {
                name: {
                    name: 'name',
                    value: undefined,
                },
                status: {
                    name: 'status',
                    value: undefined,
                },
                country: {
                    name: 'country',
                    value: undefined,
                },
                vatRegistrationNumber: {
                    name: 'vatRegistrationNumber',
                    value: undefined,
                },
                postalCode: {
                    name: 'postalCode',
                    value: undefined,
                },
            };
        }

        function transition() {
            $state.transitionTo($state.$current, {
                origin: communicationEntity,
                page: vm.filters.currentPage + 1,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
            });
        }

        function changeStatus(value) {
            vm.filters.filterBy.status.value = value;
            vm.page = 1;
            loadAll();
        }

        function search() {
            var result = '';
            for (var x in vm.filters.filterBy) {
                if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
                    result += vm.filters.filterBy[x].name + ':' + vm.filters.filterBy[x].value + '#AND,';
                }
            }
            return result;
        }

        function isSearchActive() {
            return (
        vm.filters.filterBy.name.value ||
        vm.filters.filterBy.country.value ||
        vm.filters.filterBy.vatRegistrationNumber.value ||
        vm.filters.filterBy.postalCode.value
            );
        }

        function reset() {
            vm.filters = PaginationUtil.clearFilters($state.current.name, filterBy());
            loadAll();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function synchronize() {
            ExternalEntity.synchronize(
        vm.communicationEntity,
        function () {
            validateSynchronization();
            Notification.success({ message: $translate.instant('eDocumentsApp.externalEntity.message.synchronize.success') });
        },
        function () {
            Notification.error({ message: $translate.instant('eDocumentsApp.externalEntity.message.synchronize.error') });
        }
      );
        }

        function activateEntity(entity) {
            vm.selectedEntities = [];
            vm.selectedEntities[entity.id] = entity;
            vm.activateEntities();
            vm.selectedEntities = [];
        }

        function activateEntities() {
            var errorExists = false;
            var entitiesToActivate = [];
            var entitiesWithError = {};
            angular.forEach(vm.selectedEntities, function (ent) {
                if (ent.gln !== '' && ent.emailTo !== '') {
                    entitiesToActivate.push({ id: ent.id });
                } else {
                    errorExists = true;
                    entitiesWithError[ent.id] = ent;
                }
            });
            if (!errorExists) {
                $uibModal
          .open({
              templateUrl: 'app/entities/external-entity/external-entities-activate-confirmation-dialog.html',
              controller: 'ExternalEntitiesActivateConfirmationController',
              controllerAs: 'vm',
              size: 'md',
          })
          .result.then(
            function () {
                ExternalEntity.activate(
                JSON.stringify({ entities: entitiesToActivate }),
                function onSuccess(result) {
                    for (var i in result.success) {
                        Notification.success({ message: result.success[i].message });
                    }
                    for (var j in result.errors) {
                        Notification.error({ message: result.errors[j].message });
                    }
                    for (var k in result.warnings) {
                        Notification.warning({ message: result.warnings[k].message });
                    }

                    vm.selectedEntities = [];
                    checkSelectAll();
                    loadAll();
                },
                function onError() {
                    Notification.error({ message: $translate.instant('eDocumentsApp.externalEntity.activate.error') });
                }
              );
            },
            function () {
              // do nothing
            }
          );
            } else {
                $uibModal
          .open({
              templateUrl: 'app/entities/external-entity/external-entities-error-dialog.html',
              controller: 'ExternalEntitiesErrorController',
              controllerAs: 'vm',
              size: 'xl',
              resolve: {
                  list: entitiesWithError,
              },
          })
          .result.then(
            function () {
              // do nothing
            },
            function () {
              // do nothing
            }
          );
            }
        }

        function inactivateEntity(entity) {
            $uibModal
        .open({
            templateUrl: 'app/entities/external-entity/external-entities-inactivate-confirmation-dialog.html',
            controller: 'ExternalEntitiesInactivateConfirmationController',
            controllerAs: 'vm',
            size: 'md',
        })
        .result.then(
          function () {
              ExternalEntity.inactivate(
              entity,
              function onSuccess() {
                  Notification.success($translate.instant('eDocumentsApp.externalEntity.inactivate.message'));
                  loadAll();
              },
              function onError() {
                  Notification.error({ message: $translate.instant('eDocumentsApp.externalEntity.inactivate.error') });
              }
            );
          },
          function () {
            // do nothing
          }
        );
        }

        function checkSelectAll() {
            var entSelected = vm.externalEntities.filter(function (ent) {
                if (ent.status === 'CREATED') {
                    return vm.selectedEntities[ent.id] != null;
                }
            });
            vm.selectedAll = vm.entitiesToSelection.length === entSelected.length;
        }

        function getTotalSelected() {
            var keys = Object.keys(vm.selectedEntities);
            return keys.length;
        }

        function selectChange(entity) {
            if (entity.selected) {
                vm.selectedEntities[entity.id] = entity;
                checkSelectAll();
            } else {
                delete vm.selectedEntities[entity.id];
            }
        }

        function selectAll() {
            vm.entitiesToSelection.map(function (x) {
                x.selected = !vm.selectedAll;
                return x;
            });
            if (!vm.selectedAll) {
                for (var entityToSelection in vm.entitiesToSelection) {
                    vm.selectedEntities[entityToSelection.id] = entityToSelection;
                }
            } else {
                for (var entityToSelection2 in vm.entitiesToSelection) {
                    delete vm.selectedEntities[entityToSelection2.id];
                }
            }
        }

        function deselectOne() {
            vm.selectedAll = false;
        }

        function activateBtnEnable(entity) {
            return entity.status === 'CREATED' && entity.gln !== '' && entity.emailTo !== '';
        }

        function showTooltipOnActivateButton(entity) {
            return entity.status === 'CREATED' && (entity.gln === '' || entity.emailTo === '');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ExternalEntitiesInactivateConfirmationController', ExternalEntitiesInactivateConfirmationController);

    ExternalEntitiesInactivateConfirmationController.$inject = ['$uibModalInstance'];

    function ExternalEntitiesInactivateConfirmationController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;
        vm.confirmInactivation = confirmInactivation;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmInactivation() {
            $uibModalInstance.close(true);
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('ExternalEntitiesErrorController', ExternalEntitiesErrorController);

    ExternalEntitiesErrorController.$inject = [
        '$uibModalInstance',
        'list'
    ];

    function ExternalEntitiesErrorController(
        $uibModalInstance,
        list
    ) {
        var vm = this;
        vm.externalEntities = list;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ExternalEntitiesActivateConfirmationController', ExternalEntitiesActivateConfirmationController);

    ExternalEntitiesActivateConfirmationController.$inject = ['$uibModalInstance'];

    function ExternalEntitiesActivateConfirmationController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;
        vm.confirmActivation = confirmActivation;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmActivation() {
            $uibModalInstance.close(true);
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('ExternalAuthKeyRevokeController', ExternalAuthKeyRevokeController);

  ExternalAuthKeyRevokeController.$inject = ['$uibModalInstance', 'externalAuthKey'];

  function ExternalAuthKeyRevokeController($uibModalInstance, externalAuthKey) {
    var vm = this;

    vm.externalAuthKey = externalAuthKey;
    vm.clear = clear;
    vm.confirmRevoke = confirmRevoke;

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmRevoke() {
      $uibModalInstance.close(true);
    }
  }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('ExternalAuthKeyGenerationDialogController', ExternalAuthKeyGenerationDialogController);

  ExternalAuthKeyGenerationDialogController.$inject = ['Notification', '$translate', '$uibModalInstance', 'externalAuthKeyGenerationResponse'];

  function ExternalAuthKeyGenerationDialogController(Notification, $translate, $uibModalInstance, externalAuthKeyGenerationResponse) {
    var vm = this;
    vm.externalAuthKeyGenerationResponse = externalAuthKeyGenerationResponse;
    vm.clear = clear;
    vm.close = close;

    vm.copyExternalAuthKey = function () {
      var externalAuthKey = vm.externalAuthKeyGenerationResponse.apiKey; // Get the API key value
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(externalAuthKey)
          .then(function () {
            Notification.warning({
              message: $translate.instant('eDocumentsApp.externalAuthKey.generation.keyCopied'),
            });
          })
          .catch(function () {
            Notification.error({
              message: $translate.instant('eDocumentsApp.externalAuthKey.generation.keyCopyError'),
            });
          });
      } else {
        // Fallback for browsers that don't support Clipboard API
        var inputElement = document.getElementById('externalAuthKeyInput');
        inputElement.select();
        document.execCommand('copy');
        Notification.warning({
          message: $translate.instant('eDocumentsApp.externalAuthKey.generation.keyCopied'),
        });
      }
    };

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function close() {
      $uibModalInstance.close();
    }
  }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('ExternalAuthKeyDisclaimerDialogController', ExternalAuthKeyDisclaimerDialogController);

  ExternalAuthKeyDisclaimerDialogController.$inject = ['$uibModalInstance'];

  function ExternalAuthKeyDisclaimerDialogController($uibModalInstance) {
    var vm = this;
    vm.clear = clear;
    vm.accept = accept;

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function accept() {
      $uibModalInstance.close();
    }
  }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('ExternalAuthKeyDialogController', ExternalAuthKeyDialogController);

  ExternalAuthKeyDialogController.$inject = ['$state', '$timeout', '$translate', '$uibModal', 'entity', 'previousState', 'ExternalAuthKey', 'Notification'];

  function ExternalAuthKeyDialogController($state, $timeout, $translate, $uibModal, entity, previousState, ExternalAuthKey, Notification) {
    var vm = this;
    vm.communicationEntity = entity;
    vm.clear = clear;
    vm.save = save;

    activate();

    function activate() {
      if (!entity || !entity.id) {
        $state.go('communication-entity');
        Notification.error({
          message: $translate.instant('eDocumentsApp.externalAuthKey.message.error.communicationEntityUndefined'),
        });
      } else {
        vm.amaSafeCredential = {};
        vm.amaSafeCredential.communicationEntityId = entity.id;
        $uibModal
          .open({
            templateUrl: 'app/entities/external-auth-key/external-auth-key-disclaimer-dialog.html',
            controller: 'ExternalAuthKeyDisclaimerDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
          })
          .result.then(
            function () {
              // do nothing
            },
            function () {
              back();
            }
          );
      }
    }

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    // SUP-12293: back to where the key was asked for — a member who is not the entity's manager comes from the read-only
    // view, and must not land in the entity's edit dialog
    function back() {
      if (previousState && previousState.name && previousState.name.indexOf('communication-entity') === 0) {
        $state.go(previousState.name, previousState.params);
      } else {
        $state.go('communication-entity-detail.edit', { id: vm.communicationEntity.id });
      }
    }

    function clear() {
      back();
    }

    function save() {
      vm.isSaving = true;
      var postObject = {
        communicationEntityId: vm.communicationEntity.id,
        processId: vm.externalAuthKey.processId,
      };
      ExternalAuthKey.generate(postObject, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess(result) {
      vm.isSaving = false;
      $uibModal
        .open({
          templateUrl: 'app/entities/external-auth-key/external-auth-key-generation-dialog.html',
          controller: 'ExternalAuthKeyGenerationDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            externalAuthKeyGenerationResponse: result,
          },
        })
        .result.then(
          function () {
            back();
          },
          function () {
            back();
          }
        );
    }

    function onSaveError(error) {
      vm.isSaving = false;
      if (error.data.detail) {
        Notification.error({ message: $translate.instant(error.data.detail) });
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider.state('external-auth-key-new', {
      parent: 'entity',
      url: '/external-auth-key/new',
      data: {
        authorities: ['ROLE_SUPERADMIN', 'ROLE_USER'],
      },
      views: {
        'content@': {
          templateUrl: 'app/entities/external-auth-key/external-auth-key-dialog.html',
          controller: 'ExternalAuthKeyDialogController',
          controllerAs: 'vm',
        },
      },
      params: {
        communicationEntityId: null,
      },
      resolve: {
        entity: [
          '$stateParams',
          'CommunicationEntity',
          function ($stateParams, CommunicationEntity) {
            if ($stateParams.communicationEntityId !== null) {
              return CommunicationEntity.get({ id: $stateParams.communicationEntityId }).$promise;
            }
            return null;
          },
        ],
        previousState: [
          '$state',
          function ($state) {
            return {
              name: $state.current.name || 'external-auth-key',
              params: $state.params,
              url: $state.href($state.current.name, $state.params),
            };
          },
        ],
        translatePartialLoader: [
          '$translate',
          '$translatePartialLoader',
          function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart('externalAuthKey');
            $translatePartialLoader.addPart('global');
            return $translate.refresh();
          },
        ],
      },
    });
  }
})();

(function () {
  'use strict';
  angular.module('eDocumentsApp').factory('ExternalAuthKey', ExternalAuthKey);

  ExternalAuthKey.$inject = ['$resource'];

  function ExternalAuthKey($resource) {
    var resourceUrl = 'api/external-auth-keys/:id';

    return $resource(
      resourceUrl,
      { id: '@id' }, // Default parameter mapping
      {
        query: { method: 'GET', isArray: true },
        generate: {
          method: 'POST',
        },
        findByEntity: {
          method: 'GET',
          url: 'api/external-auth-keys-for-communication-entity/:communicationEntityId',
          isArray: true,
        },
        revoke: {
          method: 'PUT',
          url: 'api/external-auth-keys/revoke/:id',
        },
      }
    );
  }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

/* global saveAs:true */
(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('DocumentStorageDetailController', DocumentStorageDetailController);

  DocumentStorageDetailController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'DataUtils', 'entity', 'Notification', '$filter', '$translate', 'translationHandler'];

  function DocumentStorageDetailController($scope, $rootScope, $state, $stateParams, DataUtils, entity, Notification, $filter, $translate, translationHandler) {
    var vm = this;
    vm.documentStorage = entity;

    // Same document, different view of it - so the tab keeps the number and names the view.
    if (vm.documentStorage && vm.documentStorage.documentNumber) {
      translationHandler.setSubject(vm.documentStorage.documentNumber, 'eDocumentsApp.documentStorage.detail.title');
    }
    vm.documentId = $stateParams.id;
    vm.selectedTab = null;
    vm.loading = !entity;
    vm.download = download;
    vm.goBack = goBack;
    vm.copyToClipboard = copyToClipboard;

    var tabKeys = ['incomingString', 'typedString', 'outgoingString', 'responseString'];

    activate();

    vm.selected = function (option) {
      vm.selectedTab = option;
    };

    function clear() {
      $state.go('document');
    }

    function activate() {
      if (vm.documentStorage == null) {
        vm.loading = false;
        Notification.error({ message: $translate.instant('eDocumentsApp.documentStorage.notFound') });
        clear();
      } else {
        vm.loading = false;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.getInputType = DataUtils.getInputType;
        vm.documentStorage.incomingStringType = vm.getInputType(vm.documentStorage.incomingString);
        vm.documentStorage.typedStringType = vm.getInputType(vm.documentStorage.typedString);
        vm.documentStorage.outgoingStringType = vm.getInputType(vm.documentStorage.outgoingString);
        vm.documentStorage.responseStringType = vm.getInputType(vm.documentStorage.responseString);

        if (vm.documentStorage.incomingStringType === DataUtils.JSON_TYPE) {
          vm.documentStorage.incomingString = angular.fromJson(vm.documentStorage.incomingString);
        }
        if (vm.documentStorage.typedStringType === DataUtils.JSON_TYPE) {
          vm.documentStorage.typedString = angular.fromJson(vm.documentStorage.typedString);
        }
        if (vm.documentStorage.outgoingStringType === DataUtils.JSON_TYPE) {
          vm.documentStorage.outgoingString = angular.fromJson(vm.documentStorage.outgoingString);
        }
        if (vm.documentStorage.responseStringType === DataUtils.JSON_TYPE) {
          vm.documentStorage.responseString = angular.fromJson(vm.documentStorage.responseString);
        }

        // Set default selected tab to the first available one
        for (var i = 0; i < tabKeys.length; i++) {
          if (vm.documentStorage[tabKeys[i]]) {
            vm.selectedTab = tabKeys[i];
            break;
          }
        }

        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:documentStorageUpdate', function (event, result) {
          vm.documentStorage = result;
        });
        $scope.$on('$destroy', unsubscribe);
      }
    }

    function getSelectedData() {
      if (!vm.selectedTab || !vm.documentStorage) {
        return undefined;
      }
      return vm.documentStorage[vm.selectedTab];
    }

    function getSelectedType() {
      if (!vm.selectedTab || !vm.documentStorage) {
        return undefined;
      }
      return vm.documentStorage[vm.selectedTab + 'Type'];
    }

    function dataToString(data, type) {
      if (!data) return '';
      if (type === 'JSON' || angular.isObject(data)) {
        return JSON.stringify(data, null, '\t');
      }
      return data;
    }

    function copyToClipboard() {
      var data = getSelectedData();
      if (!angular.isDefined(data)) return;

      var type = getSelectedType();
      var text = dataToString(data, type);

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(text)
          .then(function () {
            Notification.success({
              message: $translate.instant('eDocumentsApp.documentStorage.copied'),
              delay: 3000,
            });
          })
          .catch(function () {
            Notification.error({
              message: $translate.instant('eDocumentsApp.documentStorage.copyError'),
            });
          });
      }
    }

    function download() {
      var data = getSelectedData();
      if (angular.isDefined(data)) {
        var blob;
        var type = vm.getInputType(data).toLowerCase();
        switch (type) {
          case 'json':
            blob = new Blob([JSON.stringify(data, null, '\t')], {
              type: 'application/' + type,
            });
            break;
          case 'xml':
            blob = new Blob([data], {
              type: 'application/' + type,
            });
            break;
          default:
            blob = new Blob([data], {
              type: 'application/text',
            });
            type = 'txt';
        }
        var dateTime = $filter('date')(new Date(), 'HHmmddMMyyyy');

        var filename = 'Document_' + vm.documentStorage.documentId + dateTime + '.' + type;
        saveAs(blob, filename, true);
      }
    }

    function goBack() {
      window.history.back();
    }
  }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('document-storage-detail', {
            parent: 'document',
            url: '/document-storage/{id}',
            data: {
                authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                pageTitle: 'eDocumentsApp.documentStorage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-storage/document-storage-detail.html',
                    controller: 'DocumentStorageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('documentStorage');
                        return $translate.refresh();
                    }
                ],
                entity: [
                    '$stateParams',
                    'DocumentStorage',
                    function($stateParams, DocumentStorage) {
                        return DocumentStorage.getByDocument({ id: $stateParams.id }).$promise.then(
                            function(result) {
                                return result;
                            },
                            function() {
                                return null;
                            }
                        );
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('DocumentStorage', DocumentStorage);

    DocumentStorage.$inject = ['$resource'];

    function DocumentStorage($resource) {
        var resourceUrl = 'api/document-storages/:id';

        return $resource(resourceUrl, {}, {
            'query'        : {
                method : 'GET',
                isArray: true
            },
            'get'          : {
                method           : 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getByDocument': {
                url:'api/document-storages-by-document/:id',
                method           : 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update'       : {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentFileDialogController', DocumentFileDialogController);

    DocumentFileDialogController.$inject = ['$timeout', '$scope',  '$uibModalInstance', 'entity', 'DocumentFile', 'Document'];

    function DocumentFileDialogController ($timeout, $scope,  $uibModalInstance, entity, DocumentFile, Document) {
        var vm = this;

        vm.documentFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.documents = Document.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (angular.isDefined(vm.documentFile.id ) && vm.documentFile.id !== null) {
                DocumentFile.update(vm.documentFile, onSaveSuccess, onSaveError);
            } else {
                DocumentFile.save(vm.documentFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('eDocumentsApp:documentFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentFileDetailController', DocumentFileDetailController);

    DocumentFileDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity', 'translationHandler'];

    function DocumentFileDetailController($scope, $rootScope, previousState, entity, translationHandler) {
        var vm = this;

        vm.documentFile  = entity;
        if (vm.documentFile && vm.documentFile.filename) {
            translationHandler.setSubject(vm.documentFile.filename, 'eDocumentsApp.documentFile.home.title');
        }
        vm.previousState = previousState.name;
        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:documentFileUpdate', function (event, result) {
            vm.documentFile = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentFileDeleteController',DocumentFileDeleteController);

    DocumentFileDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentFile'];

    function DocumentFileDeleteController($uibModalInstance, entity, DocumentFile) {
        var vm = this;

        vm.documentFile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentFile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('document-file', {
                parent : 'entity',
                url    : '/document-file',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.documentFile.home.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/document-file/document-files.html',
                        controller  : 'DocumentFileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('documentFile');
                        $translatePartialLoader.addPart('fileType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('document-file-detail', {
                parent : 'document-file',
                url    : '/document-file/{id}',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.documentFile.detail.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/document-file/document-file-detail.html',
                        controller  : 'DocumentFileDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('documentFile');
                        $translatePartialLoader.addPart('fileType');
                        return $translate.refresh();
                    }],
                    entity                : ['$stateParams', 'DocumentFile', function ($stateParams, DocumentFile) {
                        return DocumentFile.get({id: $stateParams.id}).$promise;
                    }],
                    previousState         : ["$state", function ($state) {
                        return {
                            name  : $state.current.name || 'document-file',
                            params: $state.params,
                            url   : $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('document-file-detail.edit', {
                parent : 'document-file-detail',
                url    : '/detail/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/document-file/document-file-dialog.html',
                        controller  : 'DocumentFileDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['DocumentFile', function (DocumentFile) {
                                return DocumentFile.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('document-file.new', {
                parent : 'document-file',
                url    : '/new',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/document-file/document-file-dialog.html',
                        controller  : 'DocumentFileDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: function () {
                                return {
                                    filename: null,
                                    path    : null,
                                    fileType: null,
                                    id      : null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('document-file', null, {reload: 'document-file'});
                    }, function () {
                        $state.go('document-file');
                    });
                }]
            })
            .state('document-file.edit', {
                parent : 'document-file',
                url    : '/{id}/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/document-file/document-file-dialog.html',
                        controller  : 'DocumentFileDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['DocumentFile', function (DocumentFile) {
                                return DocumentFile.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('document-file', null, {reload: 'document-file'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('document-file.delete', {
                parent : 'document-file',
                url    : '/{id}/delete',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/document-file/document-file-delete-dialog.html',
                        controller  : 'DocumentFileDeleteController',
                        controllerAs: 'vm',
                        size        : 'md',
                        resolve     : {
                            entity: ['DocumentFile', function (DocumentFile) {
                                return DocumentFile.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('document-file', null, {reload: 'document-file'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function () {
  'use strict';
  angular.module('eDocumentsApp').factory('DocumentFile', DocumentFile);

  DocumentFile.$inject = ['$resource', 'DataUtils'];

  function DocumentFile($resource, DataUtils) {
    var resourceUrl = 'api/document-files/:id';

    return $resource(
      resourceUrl,
      {},
      {
        query: {
          method: 'GET',
          isArray: true,
        },
        queryByDocumentId: {
          method: 'GET',
          url: 'api/document-files-by-document/:documentId',
          isArray: true,
        },
        queryByDocumentIds: {
          method: 'GET',
          url: 'api/document-files-by-documents',
          isArray: false,
        },
        get: {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
            }
            return data;
          },
        },
        update: { method: 'PUT' },
        download: {
          url: 'api/document-filesDownload/:id',
          method: 'GET',
          responseType: 'arraybuffer',
          transformResponse: function (data, headers) {
            return {
              data: data,
              filename: DataUtils.parseHeaderFilename(headers),
            };
          },
        },
        externalDownload: {
          url: 'api/external/document-filesDownload/:hash',
          method: 'GET',
          responseType: 'arraybuffer',
          transformResponse: function (data, headers) {
            return {
              data: data,
              filename: DataUtils.parseHeaderFilename(headers),
            };
          },
        },
        addExternalDownload: {
          url: 'api/external/document-file-add-external-download',
          method: 'POST',
        },
        acknowledgeIntegrityWarning: {
          url: 'api/document-files/:id/acknowledge-integrity-warning',
          method: 'POST',
          params: { id: '@id' },
        },
      }
    );
  }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentFileController', DocumentFileController);

    DocumentFileController.$inject = ['DocumentFile'];

    function DocumentFileController(DocumentFile) {

        var vm = this;

        vm.documentFiles = [];
        var loaded = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            // EDOCS-652: GET api/document-files (every file, for any signed-in user) no longer exists. This
            // scaffold page has no menu link; it stays only as the parent of the file detail/edit states.
            loaded = [];
            vm.documentFiles = [];
            vm.searchQuery = null;
            vm.currentSearch = null;
        }

        function search() {
        if (!vm.searchQuery) {
            vm.documentFiles = loaded;
            vm.currentSearch = null;
            return;
        }
        /* There is no search endpoint for this entity. The XSearch service this used to call was
           JHipster Elasticsearch scaffolding that this application never had - injecting it threw
           "Unknown provider", which killed the whole controller, so the page rendered NOTHING at
           all. The list is loaded in full above, so the box filters what is already here. */
        var needle = String(vm.searchQuery).toLowerCase();
        vm.documentFiles = loaded.filter(function(item) {
            return Object.keys(item).some(function(key) {
                var value = item[key];
                return value !== null && value !== undefined && typeof value !== 'object' &&
                    String(value).toLowerCase().indexOf(needle) !== -1;
            });
        });
        vm.currentSearch = vm.searchQuery;
        }

        function clear() {
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.documentFiles = loaded;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .service('DocumentDownloadPdf', DocumentDownloadPdf);

    DocumentDownloadPdf.$inject = ['$uibModal', '$translate', 'DocumentFile', 'Document', 'DataUtils', 'Notification'];

    function DocumentDownloadPdf($uibModal, $translate, DocumentFile, Document, DataUtils, Notification) {
        this.download = function($event, document, fileId, fileType) {
            $event.preventDefault();
            Document.downloadNeedApproval({ id: document.id }).$promise.then(function(result) {
                var downloadNeedApproval = result.body;
                if ((isAnyDocumentOfType(document, 'SELFBILLED') || isAnyDocumentOfType(document, 'CREDITNOTE')) && !document.approved && downloadNeedApproval === 'true') {
                    $uibModal.open({
                        templateUrl: 'app/entities/document/document-approval-dialog.html',
                        controller: 'DocumentApprovalController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Document', function(Document) {
                                return Document.get({ id: document.id }).$promise;
                            }]
                        }
                    }).result.then(function() {
                        Document.get({ id: document.id }).$promise.then(function(r) {
                            document.approved = r.approved;
                            document.approvedBy = r.approvedBy;
                            document.approvedDate = r.approvedDate;
                            DocumentFile.download({ id: fileId }).$promise.then(function(result) {
                                DataUtils.viewServerFile(result);
                                Document.addDownload({
                                    documentId: document.id,
                                    fileId: fileId,
                                    fileType: fileType
                                });
                                Document.addView(document.id);
                            }, function(err) {
                                processDownloadError(err);
                            });
                        }, function() {
                            Notification.error({ message: $translate.instant('eDocumentsApp.document.message.documentNotFound') });
                        });
                    });
                } else {
                    DocumentFile.download({ id: fileId }).$promise.then(function(result) {
                        Document.addDownload({
                            documentId: document.id,
                            fileId: fileId,
                            fileType: fileType
                        });
                        Document.addView(document.id);
                        DataUtils.viewServerFile(result);
                    }, function(err) {
                        processDownloadError(err);
                    });
                }
            }, function(e) {
                Notification.error({ message: $translate.instant(e.message) });
            });
        };

        this.downloadExternal = function($event, document, fileHashedId) {
            $event.preventDefault();
            Document.downloadNeedApprovalExternal({ hash: document.hashedId }).$promise.then(function(result) {
                var downloadNeedApproval = result.body;
                if ((isAnyDocumentOfType(document, 'SELFBILLED') || isAnyDocumentOfType(document, 'CREDITNOTE')) && !document.approved && downloadNeedApproval === 'true') {
                    // No sign-in step. The recipient holds a link addressed to them; requiring an
                    // account on top of that is not something Art. 78.o n.o 5 of the CIVA asks for,
                    // and it is what stopped customers' customers acknowledging their credit notes.
                    approveExternalThen(document, function() {
                        DocumentFile.externalDownload({ hash: fileHashedId }).$promise.then(function(result) {
                            DataUtils.viewServerFile(result);
                            DocumentFile.addExternalDownload(fileHashedId);
                        }, function(err) {
                            processDownloadError(err);
                        });
                    });
                } else {
                    DocumentFile.externalDownload({ hash: fileHashedId }).$promise.then(function(result) {
                        DataUtils.viewServerFile(result);
                        DocumentFile.addExternalDownload(fileHashedId);
                    }, function(err) {
                        processDownloadError(err);
                    });
                }
            }, function(e) {
                Notification.error({ message: $translate.instant(e.message) });
            });
        };

        /**
         * Opens the approval dialog for one document and runs `onApproved` once it has been
         * approved. Shared by the single-document and bundle paths so both collect the
         * acknowledgement the same way.
         */
        function approveExternalThen(document, onApproved) {
            $uibModal.open({
                templateUrl: 'app/entities/document/document-approval-by-hashid-dialog.html',
                controller: 'DocumentApprovalByHashIdController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Document', function(Document) {
                        return Document.getByExternalHash({ hash: document.hashedId }).$promise;
                    }]
                }
            }).result.then(function() {
                Document.getByExternalHash({ hash: document.hashedId }).$promise.then(function(r) {
                    document.approved = r.approved;
                    document.approvedBy = r.approvedBy;
                    document.approvedDate = r.approvedDate;
                    onApproved();
                }, function() {
                    Notification.error({ message: $translate.instant('eDocumentsApp.document.message.documentNotFound') });
                });
            }, angular.noop);
        }

        function processDownloadError(error) {
            if (error.status === 404) {
                Notification.error({ message: $translate.instant('eDocumentsApp.document.message.documentNotFound') });
            } else {
                Notification.error({ message: $translate.instant('eDocumentsApp.document.message.errorDownloading') + ': ' + $translate.instant('error.' + DataUtils.getErrorMessageFromArrayBuffer(error.data.data)) });
            }
        }

        this.downloadAllFilesExternal = function($event, documentExternalAccessHash, documents) {
            $event.preventDefault();
            Document.downloadAllNeedApprovalExternal({ hash: documentExternalAccessHash }).$promise.then(function(result) {
                var downloadNeedApproval = result.body;

                if (downloadNeedApproval === 'true' && !areAllDocumentsApproved(documents)) {
                    // This used to show "todos os documentos tem de estar aprovados" and stop,
                    // with no way to approve them from here. The primary call to action on the
                    // bundle page was a dead end.
                    //
                    // One dialog per document rather than one for the lot: the acknowledgement
                    // Art. 78.o n.o 5 requires is per document, and each statement names its own
                    // number, value and date.
                    approveEachThen(pendingApprovals(documents), function() {
                        downloadBundle(documentExternalAccessHash);
                    });
                } else {
                    downloadBundle(documentExternalAccessHash);
                }
            }, function(e) {
                Notification.error({ message: $translate.instant(e.message) });
            });
        };

        function pendingApprovals(documents) {
            var list = angular.isArray(documents) ? documents : [documents];
            return list.filter(function(document) {
                return (isAnyDocumentOfType(document, 'SELFBILLED') || isAnyDocumentOfType(document, 'CREDITNOTE'))
                    && !document.approved;
            });
        }

        /**
         * Walks the pending documents one dialog at a time, then runs `onAllApproved`. Dismissing
         * any dialog stops the chain and runs nothing — the recipient changed their mind, and a
         * bundle must not be served with one of its credit notes unacknowledged.
         */
        function approveEachThen(pending, onAllApproved) {
            if (!pending.length) {
                onAllApproved();
                return;
            }
            approveExternalThen(pending[0], function() {
                approveEachThen(pending.slice(1), onAllApproved);
            });
        }

        function downloadBundle(documentExternalAccessHash) {
            Document.downloadAllExternalAsZip({
                hash: documentExternalAccessHash
            }, function(result) {
                if (result.filename !== null) {
                    Document.addAllExternalDownloads(documentExternalAccessHash);
                    DataUtils.viewServerFile(result);
                } else {
                    Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
                }
            }, function() {
                Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
            });
        }

        /**
         * Checks whether one of the documents (or document, if passed object is not an array) is of passed document type
         *
         * @param documents
         * @param documentType
         * @returns {boolean|*}
         */
        function isAnyDocumentOfType(documents, documentType) {
            if (documents.documentType === documentType) {
                return true;
            }
            for (var i = 0; i < documents.length; i++) {
                if (documents[i].documentType === documentType) {
                    return true;
                }
            }
            return false;
        }

        /**
         * Checks whether all documents (or document, if passed object is not an array) are (is) approved but only if from specific type
         *
         * @param documents
         * @returns {boolean|*}
         */
        function areAllDocumentsApproved(documents) {
            if (documents.documentNumber) {
                if (isAnyDocumentOfType(documents, 'SELFBILLED') || isAnyDocumentOfType(documents, 'CREDITNOTE')) {
                    return documents.approved;
                }
                return true;
            }
            for (var i = 0; i < documents.length; i++) {
                if ((isAnyDocumentOfType(documents[i], 'SELFBILLED') || isAnyDocumentOfType(documents[i], 'CREDITNOTE')) && !documents[i].approved) {
                    return false;
                }
            }
            return true;
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('SelectedDocumentsController', SelectedDocumentsController);

  SelectedDocumentsController.$inject = [
    '$state',
    '$uibModalInstance',
    '$ngConfirm',
    '$scope',
    'list',
    'selectChange',
    'exportDocumentsFiles',
    'exportSelectedDocsToCSV',
    'exportSelectedDocsToExcel',
    'Document',
    'Notification',
    'CurrencyUtils',
    '$uibModal',
    '$translate',
    '$log',
  ];

  function SelectedDocumentsController(
    $state,
    $uibModalInstance,
    $ngConfirm,
    $scope,
    list,
    selectChange,
    exportDocumentsFiles,
    exportSelectedDocsToCSV,
    exportSelectedDocsToExcel,
    Document,
    Notification,
    CurrencyUtils,
    $uibModal,
    $translate,
    $log
  ) {
    var vm = this;

    vm.documents = list;
    vm.clear = clear;
    vm.selectChangeModal = selectChangeModal;
    vm.exportSelectedDocsToExcelModal = exportSelectedDocsToExcelModal;
    vm.exportSelectedDocsToCSVModal = exportSelectedDocsToCSVModal;
    vm.exportDocumentsFilesModal = exportDocumentsFilesModal;
    $scope.selectedAll = true;
    vm.delete = deleteDocuments;
    vm.resend = resend;
    vm.isAbleToResend = isAbleToResend;
    vm.executeWaitingAction = executeWaitingAction;
    vm.isAbleToExecuteWaitingAction = isAbleToExecuteWaitingAction;
    vm.getCurrency = CurrencyUtils.getCurrency;
    vm.deselectAll = deselectAll;

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function selectChangeModal(document) {
      selectChange(document);
    }

    function exportSelectedDocsToExcelModal() {
      exportSelectedDocsToExcel();
    }

    function exportSelectedDocsToCSVModal() {
      exportSelectedDocsToCSV();
    }

    function exportDocumentsFilesModal() {
      exportDocumentsFiles();
    }

    function deselectAll() {
      $ngConfirm({
        title: 'Confirmar!',
        content: 'Esta ação irá desseleccionar todas as opções.<br>Tem a certeza que deseja continuar?',
        scope: $scope,
        buttons: {
          confirm: {
            text: 'Continuar',
            btnClass: 'btn-warning',
            action: function () {
              clear();
              $state.reload();
            },
          },
          close: {
            text: 'Cancelar',
            btnClass: 'btn-primary',
            action: function () {
              $scope.selectedAll = true;
              $scope.$apply();
            },
          },
        },
      });
    }

    function deleteDocuments() {
      var selectedIds = Object.keys(vm.documents).map(function (key) {
        return vm.documents[key].id;
      });
      $uibModal
        .open({
          templateUrl: 'app/entities/document/document-delete-selected-dialog.html',
          controller: 'DocumentDeleteSelectedController',
          controllerAs: 'vm',
          size: 'md',
          resolve: {
            documentIds: function () {
              return selectedIds;
            },
          },
        })
        .result.then(
          function () {
            var keys = Object.keys(vm.documents);
            var documentsIdsArray = [];
            for (var i = 0; i < keys.length; i++) {
              documentsIdsArray.push({ id: vm.documents[keys[i]].id });
            }
            Document.removeDocuments(
              { documentsIds: JSON.stringify({ id: documentsIdsArray }) },
              function () {
                $state.reload();
                clear();
              },
              function (e) {
                $log.error(e);
                Notification.error({ message: 'Ocorreu um erro ao remover os documentos selecionados' }); // TODO translate
              }
            );
          },
          function () {}
        );
    }

    function resend() {
      var documentsIdsArray = [];
      angular.forEach(vm.documents, function (item) {
        if (item.status === 'ERROR') {
          documentsIdsArray.push({ id: item.id });
        }
      });
      Document.redoStepForDocumentsList(
        { documentsIds: JSON.stringify({ id: documentsIdsArray }) },
        function () {
          $state.reload();
          $uibModalInstance.close();
        },
        function (e) {
          $log.error(e);
          Notification.error({ message: $translate.instant('eDocumentsApp.document.message.errorResendingSelectedDocuments') });
        }
      );
    }

    function isAbleToResend() {
      var isAbleToResend = true;
      angular.forEach(vm.documents, function (item) {
        if (item.status !== 'ERROR') {
          isAbleToResend = false;
        }
      });
      return isAbleToResend;
    }

    function executeWaitingAction() {
      var documentsIdsArray = [];
      angular.forEach(vm.documents, function (item) {
        if (item.status === 'WAITING') {
          documentsIdsArray.push({ id: item.id });
        }
      });
      Document.doStepForDocumentsList(
        { documentsIds: JSON.stringify({ id: documentsIdsArray }) },
        function () {
          $state.reload();
          $uibModalInstance.close();
        },
        function (e) {
          $log.error(e);
          Notification.error({ message: $translate.instant('eDocumentsApp.document.message.errorExecutingSelectedDocuments') });
        }
      );
    }

    function isAbleToExecuteWaitingAction() {
      var isAbleToExecuteWaitingAction = true;
      angular.forEach(vm.documents, function (item) {
        if (item.status !== 'WAITING') {
          isAbleToExecuteWaitingAction = false;
        }
      });
      return isAbleToExecuteWaitingAction;
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('FavoriteSearchesController', FavoriteSearchesController);

    FavoriteSearchesController.$inject = ['$uibModalInstance', 'DocumentSearchByUser', 'filterBy', 'documentTypes', 'documentStates'];

    function FavoriteSearchesController($uibModalInstance, DocumentSearchByUser, filterBy, documentTypes, documentStates) {
        var vm = this;

        vm.clear = clear;
        vm.apply = apply;
        vm.tabSelected = tabSelected;
        vm.saveChanges = saveChanges;
        vm.reset = reset;
        vm.deleteRecord = deleteRecord;
        vm.filters = {
            currentPage: 0,
            itemsPerPage: 20,
            filterBy: angular.copy(filterBy()),
            orderBy: undefined,
            orderReverse: undefined
        };
        vm.name = undefined;
        vm.types = documentTypes;
        vm.states = documentStates;
        vm.changeFiles = changeFiles;
        vm.changeVisualization = changeVisualization;
        vm.changeDocumentType = changeDocumentType;
        vm.changeStatus = changeStatus;
        vm.addTab = addTab;
        vm.favoriteSearches = [];
        vm.active = undefined;
        loadAll();

        function loadAll() {
            DocumentSearchByUser.query({}, function(res) {
                vm.favoriteSearches = res;
            });
        }

        function apply() {
            $uibModalInstance.close(vm.filters.filterBy);
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function tabSelected(tab) {
            vm.filters.filterBy = JSON.parse(tab.searchString);
            vm.name = tab.name;
        }

        function changeVisualization(value) {
            vm.filters.filterBy.documentViews.value = value;
        }

        function changeFiles(value) {
            vm.filters.filterBy.documentFiles.value = value;
        }

        function changeDocumentType(value) {
            vm.filters.filterBy.documentType.value = value;
        }

        function changeStatus(value) {
            vm.filters.filterBy.status.value = value;
        }

        function saveChanges(tab) {
            if (tab) {
                tab.searchString = JSON.stringify(vm.filters.filterBy);
                tab.name = vm.name;
            } else {
                tab = {
                    name: vm.name,
                    searchString: JSON.stringify(vm.filters.filterBy)
                };
            }
            DocumentSearchByUser.save(tab, function(res) {
                loadAll();
                vm.active = res.id;
            }, function() {
            });
        }

        function reset() {
            vm.filters.filterBy = angular.copy(filterBy());
        }

        function addTab() {
            vm.filters.filterBy = angular.copy(filterBy());
            vm.name = 'New';
        }

        function deleteRecord(tab) {
            DocumentSearchByUser.delete({ id: tab.id },
                function() {
                    loadAll();
                    vm.active = -1;
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ExportAllDocumentsErrorController', ExportAllDocumentsErrorController);

    ExportAllDocumentsErrorController.$inject = ['$uibModalInstance', 'numberOfDocuments'];

    function ExportAllDocumentsErrorController($uibModalInstance, numberOfDocuments) {
        var vm = this;

        vm.numberOfDocuments = numberOfDocuments.total;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('DocumentSearchByUser', DocumentSearchByUser);

    DocumentSearchByUser.$inject = ['$resource'];

    function DocumentSearchByUser($resource) {
        var resourceUrl = 'api/document-search-by-user/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'query': { method: 'GET', isArray: true },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();

/* global _:true*/

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('DocumentDetailController', DocumentDetailController);

  DocumentDetailController.$inject = [
    'Principal',
    '$ngConfirm',
    '$scope',
    '$state',
    '$translate',
    'Document',
    'previousState',
    'entity',
    'CommunicationWorkflowStep',
    'Communication',
    'DataUtils',
    'Notification',
    'DocumentDownloadPdf',
    'CommunicationEntity',
    'CurrencyUtils',
    'translationHandler',
  ];

  function DocumentDetailController(
    Principal,
    $ngConfirm,
    $scope,
    $state,
    $translate,
    Document,
    previousState,
    entity,
    CommunicationWorkflowStep,
    Communication,
    DataUtils,
    Notification,
    DocumentDownloadPdf,
    CommunicationEntity,
    CurrencyUtils,
    translationHandler
  ) {
    var vm = this;
    vm.document = entity;

    // The tab says which document this is, not merely that it is a document.
    if (vm.document && vm.document.documentNumber) {
      translationHandler.setSubject(vm.document.documentNumber, 'eDocumentsApp.document.home.title');
    }
    vm.previousState = previousState.name;
    vm.maximumOrder = undefined;
    vm.download = download;
    vm.canAdminRedoStep = canAdminRedoStep;
    vm.canRedoStep = canRedoStep;
    vm.redoStep = redoStep;
    vm.canAdminDoStep = canAdminDoStep;
    vm.canDoStep = canDoStep;
    vm.doStep = doStep;
    vm.downloaded = downloaded;
    vm.getCurrency = getCurrency;
    vm.getViewableFilename = DataUtils.getViewableFilename;
    vm.formatFileSize = DataUtils.formatFileSize;
    vm.getFileIconClass = DataUtils.getFileIconClass;
    vm.goBack = goBack;

    activate();

    function downloaded(id) {
      return vm.document.documentDownloads.filter(function (documentDownload) {
        return documentDownload.fileId === id;
      }).length;
    }

    function clear() {
      $state.go('document');
    }

    function fillObject(object, result) {
      object.companyName = result.name;
    }

    function fillInvoice(isSELFBILLED) {
      if (isSELFBILLED) {
        CommunicationEntity.get({ id: vm.document.originId }, function (result) {
          fillObject(vm.invoice.receiver, result);
          fillObject(vm.invoice.sender, result);
        });
      } else {
        if (!vm.invoice.sender.companyName) {
          CommunicationEntity.get({ id: vm.document.originId }, function (result) {
            fillObject(vm.invoice.sender, result);
          });
        }
        if (!vm.invoice.receiver.companyName) {
          CommunicationEntity.get({ id: vm.document.destinationId }, function (result) {
            fillObject(vm.invoice.receiver, result);
          });
        }
      }
    }

    function activate() {
      if (vm.document === null) {
        Notification.error({ message: 'Documento não encontrado!' }); // TODO translate
        clear();
      } else {
        vm.approvalInfo = {
          approvedBy: vm.document.approvedBy,
          approvedDate: vm.document.approvedDate,
        };

        if (vm.document.documentType === 'ORDER') {
          Document.getOrder({ id: vm.document.id }).$promise.then(function (result) {
            vm.order = result;
            CommunicationEntity.findByGln({ gln: vm.order.header.supplier.gln }, function (result) {
              vm.orderSupplier = result;
            });
            CommunicationEntity.findByGln({ gln: vm.order.header.buyer.gln }, function (result) {
              vm.orderReceiver = result;
            });
          });
        } else if (vm.document.documentType === 'DESPATCHADVICE') {
          // a despatch advice (EDOCS-662) has its own typed content: supplier, buyer, lines and pallets
          Document.getDespatchAdvice({ id: vm.document.id }).$promise.then(function (result) {
            vm.despatchAdvice = buildDespatchAdviceView(result);
          });
        } else {
          Document.getInvoice({ id: vm.document.id }).$promise.then(function (result) {
            vm.invoice = result;
            if (
              (vm.document.documentType === 'SELFBILLED' && !vm.invoice.receiver.companyName) ||
              (vm.document.documentType !== 'SELFBILLED' && (!vm.invoice.sender.companyName || !vm.invoice.receiver.companyName))
            ) {
              fillInvoice(vm.document.documentType === 'SELFBILLED');
            }
          });
        }

        Principal.identity().then(function (account) {
          vm.account = account;
          for (var i = 0; i < vm.account.userEntities.length; i++) {
            if (
              (vm.account.userEntities[i].entityId === vm.document.originId || vm.account.userEntities[i].entityId === vm.document.destinationId) &&
              vm.account.userEntities[i].manager
            ) {
              vm.manager = true;
              break;
            }
          }
        });
        Document.addView(vm.document.id);
        vm.currentWorkflow = {};
        CommunicationWorkflowStep.findByDefinition({ id: vm.document.communicationDefinitionId }).$promise.then(function (steps) {
          vm.workflow = steps;
          for (var i = 0; i < vm.workflow.length; i++) {
            vm.currentWorkflow[vm.workflow[i].id] = {
              order: vm.workflow[i].order,
              id: vm.workflow[i].id,
              executionTime: vm.workflow[i].originParameters.filter(function (originParameter) {
                return originParameter.communicationParameterType === 'EXECUTION_TIME';
              })[0],
              description: vm.workflow[i].description,
              name: vm.workflow[i].communicationActionDefinitionName,
              executionType: vm.workflow[i].executionType,
              communicationType: vm.workflow[i].communicationType,
            };
            vm.maximumOrder = angular.isUndefined(vm.maximumOrder) || vm.workflow[i].order > vm.maximumOrder ? vm.workflow[i].order : vm.maximumOrder;
          }
          Communication.findByDocument({ id: vm.document.id }).$promise.then(function (communications) {
            vm.communications = communications;
            for (var j = 0; j < vm.communications.length; j++) {
              var workflow = vm.currentWorkflow[vm.communications[j].communicationWorkflowStepId];
              workflow.status = vm.communications[j].status;
              workflow.previousStatus = vm.communications[j - 1] ? vm.communications[j - 1].status : undefined;
              workflow.message = vm.communications[j].message;
              workflow.code = vm.communications[j].code;
              workflow.time = vm.communications[j].communicationTime;
              vm.currentWorkflow[vm.communications[j].communicationWorkflowStepId] = workflow;
            }
            var array = [];
            for (var objectKey in vm.currentWorkflow) {
              if (vm.currentWorkflow.hasOwnProperty(objectKey) && angular.isObject(vm.currentWorkflow[objectKey]) && objectKey.charAt(0) !== '$') {
                array.push(vm.currentWorkflow[objectKey]);
              }
            }
            array.sort(function (a, b) {
              a = a.order ? a.order : '0';
              b = b.order ? b.order : '0';
              return parseInt(a) - parseInt(b);
            });
            vm.currentWorkflow = array;
          });
        });
      }
    }

    // ---- despatch advice preview (EDOCS-662) ----
    // Labels for the identifier, reference and quantity types papiNet and RF006 use. A type not listed here is
    // shown as the sender wrote it, so nothing the supplier sent is hidden.
    var DA_KEY = 'eDocumentsApp.document.detail.despatchAdvice.';
    var DA_PARTY_IDS = {
      VATIdentificationNumber: 'vat',
      GlobalLocationNumber: 'gln',
      AssignedBySeller: 'assignedBySeller',
      AssignedByBuyer: 'assignedByBuyer',
    };
    // product identifiers are labelled by type and by who assigned them, e.g. "Referência (fornecedor)"
    var DA_PRODUCT_TYPES = ['PartNumber', 'GradeCode', 'GradeName', 'BrandName', 'GTIN'];
    var DA_AGENCIES = ['Supplier', 'Buyer'];
    var DA_REFERENCES = ['MillOrderNumber', 'MillOrderLineItemNumber', 'SupplierCallOffNumber', 'OriginalDeliveryNumber', 'BookingNumber'];
    var DA_QUANTITIES = ['GrossWeight', 'NetWeight', 'TareWeight', 'NominalWeight', 'Count'];
    var DA_PACKAGES = ['Pallet', 'Reel', 'Box'];

    function daLabel(known, type) {
      return known ? { key: DA_KEY + known } : { text: type };
    }

    function daProductLabel(identifier) {
      var label = daLabel(DA_PRODUCT_TYPES.indexOf(identifier.type) >= 0 ? 'productType.' + identifier.type : null, identifier.type);
      if (identifier.agency) {
        label.agency = DA_AGENCIES.indexOf(identifier.agency) >= 0 ? { key: DA_KEY + 'agency.' + identifier.agency } : { text: identifier.agency };
      }
      return label;
    }

    function daParty(party) {
      if (!party) {
        return null;
      }
      var address = party.address || {};
      return {
        name: party.name,
        lines: [address.name2, address.street, [address.postalCode, address.city].filter(Boolean).join(' '), address.countryCode].filter(Boolean),
        identifiers: (party.identifiers || []).map(function (identifier) {
          return { label: daLabel(DA_PARTY_IDS[identifier.type], identifier.type), value: identifier.value };
        }),
      };
    }

    function daReference(reference) {
      var known = DA_REFERENCES.indexOf(reference.type) >= 0 ? 'reference.' + reference.type : null;
      return { label: daLabel(known, reference.type), value: reference.value };
    }

    function daQuantity(quantity) {
      var known = DA_QUANTITIES.indexOf(quantity.quantityType) >= 0 ? 'quantityType.' + quantity.quantityType : null;
      return { label: daLabel(known, quantity.quantityType), value: quantity.value, uom: quantity.uom, informational: quantity.informational };
    }

    function daIdentifier(identifiers, codeType) {
      var found = (identifiers || []).filter(function (identifier) {
        return identifier.codeType === codeType;
      })[0];
      return found ? found.value : null;
    }

    // Totals are kept per unit (kilograms never added to sheets) and count the pallets that carried the measure,
    // so a total that only some pallets contributed to says so instead of passing for the whole shipment.
    function daAdd(totals, quantity) {
      var value = quantity ? parseFloat(quantity.value) : NaN;
      if (isNaN(value)) {
        return;
      }
      var uom = quantity.uom || '';
      var total = totals[uom] || { value: 0, pallets: 0 };
      total.value = Number((total.value + value).toFixed(6));
      total.pallets++;
      totals[uom] = total;
    }

    function daTotalsList(totals, palletCount) {
      return Object.keys(totals).map(function (uom) {
        return { value: totals[uom].value, uom: uom, partial: totals[uom].pallets < palletCount ? { n: totals[uom].pallets, total: palletCount } : null };
      });
    }

    function buildDespatchAdviceView(advice) {
      var header = advice.header || {};
      var gross = {};
      var net = {};
      var items = {};
      var palletCount = 0;
      var lines = (advice.lines || []).map(function (line) {
        var pallets = (line.packages || []).map(function (pack) {
          palletCount++;
          var weights = (pack.quantities || []).filter(function (quantity) {
            return quantity.quantityType !== 'Count';
          });
          var byType = function (type) {
            // a Quantity beats an InformationalQuantity of the same type, as in the RF006 mapping
            var matches = weights.filter(function (quantity) {
              return quantity.quantityType === type;
            });
            return (
              matches.filter(function (quantity) {
                return !quantity.informational;
              })[0] || matches[0]
            );
          };
          daAdd(gross, byType('GrossWeight'));
          daAdd(net, byType('NetWeight'));
          daAdd(items, pack.itemCount);
          return {
            id: pack.id,
            type: daLabel(DA_PACKAGES.indexOf(pack.packageType) >= 0 ? 'packageType.' + pack.packageType : null, pack.packageType),
            sscc: daIdentifier(pack.identifiers, 'SerialisedShippingContainerCode'),
            uic14: daIdentifier(pack.identifiers, 'UIC14'),
            itemCount: pack.itemCount,
            quantities: (pack.quantities || []).map(daQuantity),
          };
        });
        return {
          lineNumber: line.lineNumber,
          purchaseOrderNumber: line.purchaseOrderNumber,
          purchaseOrderLineItemNumber: line.purchaseOrderLineItemNumber,
          description: line.description,
          products: (line.productIdentifiers || []).map(function (identifier) {
            return { label: daProductLabel(identifier), value: identifier.value };
          }),
          references: (line.references || []).map(daReference),
          quantities: (line.quantities || []).map(daQuantity),
          itemInstances: line.itemInstances || [],
          pallets: pallets,
        };
      });
      return {
        number: header.documentNumber,
        date: header.documentDate,
        time: header.documentTime,
        statusType: header.statusType,
        despatchDate: header.despatchDate,
        estimatedDeliveryDate: header.estimatedDeliveryDate,
        supplier: daParty(header.supplierParty),
        buyer: daParty(header.buyerParty),
        shipTo: daParty(header.shipToParty),
        shipFrom: daParty(header.shipFromParty),
        carrier: daParty(header.carrierParty),
        transport: header.transport,
        references: (header.references || []).map(daReference),
        lines: lines,
        totals: {
          lines: lines.length,
          declaredLines: header.numberOfLines,
          pallets: palletCount,
          gross: daTotalsList(gross, palletCount),
          net: daTotalsList(net, palletCount),
          items: daTotalsList(items, palletCount),
        },
      };
    }

    function getCurrency() {
      if (vm.invoice && vm.invoice.header) {
        return CurrencyUtils.getCurrency(vm.invoice.header.currencyCode);
      }
      if (vm.order && vm.order.header) {
        return CurrencyUtils.getCurrency(vm.order.header.currencyCode);
      }
      return '';
    }

    function download($event, fileId, fileType) {
      DocumentDownloadPdf.download($event, vm.document, fileId, fileType);
    }

    function canAdminRedoStep(step) {
      return (
        !canRedoStep(step) && // if we can already redo step as regular user we should not show the action again
        step.status !== 'SCHEDULED' &&
        step.order !== 1
      );
    }

    function canRedoStep(step) {
      if (
        step.order === vm.maximumOrder &&
        (step.communicationType === 'EMAIL_OUT' ||
          step.communicationType === 'UNEDIFACT_EMAIL_OUT' ||
          (step.communicationType === 'MOLONI_ORDER_INTEGRATION' && step.code === 'ERR0059'))
      ) {
        // if is a mail sending step and the last one
        return true;
      }
      if (vm.manager === true) {
        return (
          step.order !== 1 && ((vm.document.status === 'ERROR' && step.status === 'ERROR') || (vm.document.status === 'WAITING' && step.status === 'WAITING'))
        );
      }
      return false;
    }

    function redoStep(step) {
      $ngConfirm({
        title: $translate.instant('eDocumentsApp.document.detail.resend.title'),
        columnClass: 'medium',
        type: 'orange',
        animation: 'right',
        animationBounce: 1,
        closeAnimation: 'scale',
        content: $translate.instant('eDocumentsApp.document.detail.resend.message'),
        scope: $scope,
        buttons: {
          confirm: {
            text: $translate.instant('entity.action.confirm'),
            btnClass: 'btn-warning',
            keys: ['enter'],
            action: function () {
              Document.redoFromStep({
                docId: vm.document.id,
                stepId: step.id,
              }).$promise.then(function () {
                $state.reload();
              });
            },
          },
          close: {
            text: $translate.instant('entity.action.cancel'),
            btnClass: 'btn-default',
            keys: ['esc'],
            action: function () {
              // do nothing
            },
          },
        },
      });
    }

    function canAdminDoStep(step) {
      return step.executionType === 'MANUAL' && step.status === 'WAITING' && (!step.previousStatus || step.previousStatus === 'SUCCESS');
    }

    function canDoStep(step) {
      return (
        vm.document.status === 'WAITING' &&
        vm.manager === true &&
        step.executionType === 'MANUAL' &&
        step.status === 'WAITING' &&
        (!step.previousStatus || step.previousStatus === 'SUCCESS')
      );
    }

    function doStep(step) {
      $ngConfirm({
        title: $translate.instant('eDocumentsApp.document.detail.execute.title'),
        columnClass: 'medium',
        type: 'blue',
        animation: 'right',
        animationBounce: 1,
        closeAnimation: 'scale',
        content: $translate.instant('eDocumentsApp.document.detail.execute.message'),
        scope: $scope,
        buttons: {
          confirm: {
            text: $translate.instant('entity.action.confirm'),
            btnClass: 'btn-blue',
            keys: ['enter'],
            action: function () {
              Document.doFromStep({
                docId: vm.document.id,
                stepId: step.id,
              }).$promise.then(function () {
                $state.reload();
              });
            },
          },
          close: {
            text: $translate.instant('entity.action.cancel'),
            btnClass: 'btn-default',
            keys: ['esc'],
            action: function () {
              // do nothing
            },
          },
        },
      });
    }

    function goBack() {
      window.history.back();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentDeleteSelectedController', DocumentDeleteSelectedController);

    DocumentDeleteSelectedController.$inject = ['$uibModalInstance', 'documentIds', 'Document'];

    function DocumentDeleteSelectedController($uibModalInstance, documentIds, Document) {
        var vm = this;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.externalRecipients = [];
        vm.recipientsCheckFailed = false;
        vm.recipientsLoading = false;

        // Deleting these documents also deletes their external access hashes, so any link
        // already emailed stops working for good. Warn about the recipients that hold one.
        // Fails CLOSED - see document-delete-dialog.controller.js for why.
        if (documentIds && documentIds.length > 0) {
            vm.recipientsLoading = true;
            Document.externalAccessRecipients(
                { ids: documentIds },
                function (result) {
                    if (result && angular.isArray(result.emails)) {
                        vm.externalRecipients = result.emails;
                    } else {
                        vm.recipientsCheckFailed = true;
                    }
                    vm.recipientsLoading = false;
                },
                function () {
                    vm.recipientsCheckFailed = true;
                    vm.recipientsLoading = false;
                }
            );
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            $uibModalInstance.close(true);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentDeleteController',DocumentDeleteController);

    DocumentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Document'];

    function DocumentDeleteController($uibModalInstance, entity, Document) {
        var vm = this;

        vm.document = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.externalRecipients = [];
        vm.recipientsCheckFailed = false;
        vm.recipientsLoading = true;

        // Deleting the document also deletes its external access hashes, so any link already
        // emailed stops working for good. Warn about the recipients that hold one.
        // This check must fail CLOSED: if we cannot tell, an empty dialog would look exactly
        // like "never emailed" at the moment the operator is about to do something irreversible.
        Document.externalAccessRecipients(
            { ids: entity.id },
            function (result) {
                if (result && angular.isArray(result.emails)) {
                    vm.externalRecipients = result.emails;
                } else {
                    vm.recipientsCheckFailed = true;
                }
                vm.recipientsLoading = false;
            },
            function () {
                vm.recipientsCheckFailed = true;
                vm.recipientsLoading = false;
            }
        );

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Document.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentApprovalController', DocumentApprovalController);

    DocumentApprovalController.$inject = ['$uibModalInstance', '$translate', 'entity', 'Document', 'CurrencyUtils'];

    function DocumentApprovalController($uibModalInstance, $translate, entity, Document, CurrencyUtils) {
        var vm = this;

        vm.document = entity;
        vm.approving = false;
        vm.statement = null;
        vm.locale = null;
        vm.clear = clear;
        vm.confirmApproval = confirmApproval;
        vm.getCurrency = CurrencyUtils.getCurrency;

        // The wording is fetched rather than composed here, for the same reason the external dialog
        // fetches it: one server-side renderer produces both the sentence shown and the sentence
        // stored on the evidence row, so the two cannot drift apart. Until it arrives the Approve
        // button stays disabled - nobody accepts text they were not shown.
        //
        // The interface language is sent, unlike on the external path where the recipient is
        // anonymous and the server default applies. An approver reading English must not have a
        // Portuguese sentence recorded against them on a document kept ten years.
        Document.approvalStatementById({ id: vm.document.id, locale: $translate.use() })
            .$promise.then(function (result) {
                vm.statement = result.statement;
                vm.locale = result.locale;
            });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmApproval(id) {
            if (vm.approving) {
                return;
            }
            vm.approving = true;

            // locale is not part of the URL template, so $resource sends it as a query parameter.
            // It is the locale the server actually rendered in, not the one we asked for.
            Document.approve(
                { id: id, locale: vm.locale || $translate.use() },
                function () {
                    vm.approving = false;
                    $uibModalInstance.close(true);
                },
                function () {
                    vm.approving = false;
                    $uibModalInstance.dismiss('failed');
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentApprovalByHashIdController', DocumentApprovalByHashIdController);

    DocumentApprovalByHashIdController.$inject = ['$uibModalInstance', '$translate', 'entity', 'Document', 'CurrencyUtils'];

    function DocumentApprovalByHashIdController($uibModalInstance, $translate, entity, Document, CurrencyUtils) {
        var vm = this;

        vm.document = entity;
        vm.approving = false;
        vm.statement = null;
        vm.recipientEmail = null;
        vm.clear = clear;
        vm.confirmApproval = confirmApproval;
        vm.getCurrency = CurrencyUtils.getCurrency;

        // The wording is fetched rather than composed here. The same server-side renderer produces
        // the sentence shown and the sentence stored on the evidence row, so the two cannot drift.
        // Until it arrives the Approve button stays disabled: nobody accepts text they were not
        // shown.
        Document.approvalStatement({ hash: vm.document.hashedId }).$promise.then(function (result) {
            vm.statement = result.statement;
            vm.recipientEmail = result.recipientEmail;
            vm.locale = result.locale;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmApproval(hashedId) {
            // Guards the double-submit this dialog used to invite: with no error handling, a
            // failed approval left the dialog exactly as it was, so recipients pressed Approve
            // again. Production saw the same person do it up to ten times.
            if (vm.approving) {
                return;
            }
            vm.approving = true;

            Document.approveByHashId(
                { hash: hashedId, locale: vm.locale || $translate.use() },
                {},
                function () {
                    vm.approving = false;
                    $uibModalInstance.close(true);
                },
                function () {
                    vm.approving = false;
                    // No 401 branch any more - approving no longer requires a session, so there is
                    // no expired-session case to recover from. Anything that fails here has already
                    // surfaced through the global error handler; close rather than leave the
                    // recipient with a dead dialog.
                    $uibModalInstance.dismiss('failed');
                });
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider
      .state('document', {
        parent: 'app',
        url: '/document?page&sort&search',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
          pageTitle: 'eDocumentsApp.document.home.title',
        },
        views: {
          'content@': {
            templateUrl: 'app/entities/document/documents.html',
            controller: 'DocumentController',
            controllerAs: 'vm',
          },
        },
        params: {
          page: {
            value: '1',
            squash: true,
          },
          sid: null,
          eid: null,
          did: null,
          oid: null,
          sort: {
            value: 'createdDate,desc',
            squash: true,
          },
          search: null,
        },
        resolve: {
          pagingParams: [
            '$stateParams',
            'PaginationUtil',
            function ($stateParams, PaginationUtil) {
              return {
                page: PaginationUtil.parsePage($stateParams.page),
                sort: $stateParams.sort,
                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                ascending: PaginationUtil.parseAscending($stateParams.sort),
                search: $stateParams.search,
              };
            },
          ],
          communicationDefinition: [
            '$stateParams',
            'CommunicationDefinition',
            function ($stateParams, CommunicationDefinition) {
              if ($stateParams.sid) {
                return CommunicationDefinition.get({ id: $stateParams.sid }).$promise;
              }
              return undefined;
            },
          ],
          loggeduser: [
            'Principal',
            function (Principal) {
              return Principal.identity().$promise;
            },
          ],
          origin: [
            '$stateParams',
            'CommunicationEntity',
            function ($stateParams, CommunicationEntity) {
              if ($stateParams.oid) {
                return CommunicationEntity.get({ id: $stateParams.oid }).$promise;
              }
              return undefined;
            },
          ],
          destination: [
            '$stateParams',
            'CommunicationEntity',
            function ($stateParams, CommunicationEntity) {
              if ($stateParams.did) {
                return CommunicationEntity.get({ id: $stateParams.did }).$promise;
              }
              return undefined;
            },
          ],
          entity: [
            '$stateParams',
            'CommunicationEntity',
            function ($stateParams, CommunicationEntity) {
              if ($stateParams.eid) {
                return CommunicationEntity.get({ id: $stateParams.eid }).$promise;
              }
              return undefined;
            },
          ],
          translatePartialLoader: [
            '$translate',
            '$translatePartialLoader',
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart('document');
              $translatePartialLoader.addPart('documentType');
              $translatePartialLoader.addPart('documentStatus');
              $translatePartialLoader.addPart('global');
              return $translate.refresh();
            },
          ],
        },
      })
      .state('document-detail', {
        parent: 'document',
        url: '/document/{id}',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
          pageTitle: 'eDocumentsApp.document.detail.title',
        },
        views: {
          'content@': {
            templateUrl: 'app/entities/document/document-detail.html',
            controller: 'DocumentDetailController',
            controllerAs: 'vm',
          },
        },
        resolve: {
          translatePartialLoader: [
            '$translate',
            '$translatePartialLoader',
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart('document');
              $translatePartialLoader.addPart('documentType');
              $translatePartialLoader.addPart('documentStatus');
              return $translate.refresh();
            },
          ],
          loggeduser: [
            'Principal',
            function (Principal) {
              return Principal.identity().$promise;
            },
          ],
          entity: [
            '$stateParams',
            'Document',
            function ($stateParams, Document) {
              return Document.get({ id: $stateParams.id }).$promise.then(
                function (result) {
                  return result;
                },
                function () {
                  return null;
                }
              );
            },
          ],
          previousState: [
            '$state',
            function ($state) {
              return {
                name: $state.current.name || 'document',
                params: $state.params,
                url: $state.href($state.current.name, $state.params),
              };
            },
          ],
        },
      })
      .state('document.delete', {
        parent: 'document',
        url: '/{id}/delete',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
        },
        onEnter: [
          '$stateParams',
          '$state',
          '$uibModal',
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: 'app/entities/document/document-delete-dialog.html',
                controller: 'DocumentDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                  entity: [
                    'Document',
                    function (Document) {
                      return Document.get({ id: $stateParams.id }).$promise;
                    },
                  ],
                },
              })
              .result.then(
                function () {
                  $state.go('document', null, { reload: 'document' });
                },
                function () {
                  $state.go('^');
                }
              );
          },
        ],
      });
  }
})();

(function () {
  'use strict';
  angular.module('eDocumentsApp').factory('Document', Document);

  Document.$inject = ['$resource', 'DateUtils', 'DataUtils'];

  function Document($resource, DateUtils, DataUtils) {
    var resourceUrl = 'api/documents/:id';

    return $resource(
      resourceUrl,
      {},
      {
        query: {
          method: 'GET',
          isArray: true,
        },
        queryForDigitalArchive: {
          method: 'GET',
          url: 'api/document-digital-archive',
          isArray: true,
        },
        queryForAdmin: {
          method: 'GET',
          url: 'api/document-for-admin',
          isArray: true,
        },
        findByDefinition: {
          method: 'GET',
          url: 'api/documents-by-definition/:id',
          isArray: true,
        },
        findByOrigin: {
          method: 'GET',
          url: 'api/documents-by-origin/:id',
          isArray: true,
        },
        findByDestination: {
          method: 'GET',
          url: 'api/documents-by-destination/:id',
          isArray: true,
        },
        redoFromStep: {
          method: 'GET',
          url: 'api/document-step-redo/:docId/:stepId',
        },
        doFromStep: {
          method: 'GET',
          url: 'api/document-step-do/:docId/:stepId',
        },
        addView: {
          method: 'POST',
          url: 'api/document-add-view',
        },
        addExternalView: {
          method: 'POST',
          url: 'api/external/document-add-view',
        },
        addDownload: {
          method: 'POST',
          url: 'api/document-add-download',
        },
        addDownloads: {
          method: 'POST',
          url: 'api/document-add-downloads',
        },
        addExternalDownloads: {
          method: 'POST',
          url: 'api/external/document-add-external-downloads',
        },
        addAllExternalDownloads: {
          method: 'POST',
          url: 'api/external/document-add-all-external-downloads',
        },
        downloadAsZip: {
          method: 'POST',
          url: 'api/download-as-zip',
          responseType: 'arraybuffer',
          transformResponse: function (data, headers) {
            return {
              data: data,
              filename: DataUtils.parseHeaderFilename(headers),
            };
          },
        },
        downloadExternalAsZip: {
          method: 'GET',
          url: 'api/external/download-external-as-zip/:hash',
          responseType: 'arraybuffer',
          transformResponse: function (data, headers) {
            return {
              data: data,
              filename: DataUtils.parseHeaderFilename(headers),
            };
          },
        },
        downloadAllExternalAsZip: {
          method: 'GET',
          url: 'api/external/download-all-external-as-zip',
          responseType: 'arraybuffer',
          transformResponse: function (data, headers) {
            return {
              data: data,
              filename: DataUtils.parseHeaderFilename(headers),
            };
          },
        },
        downloadAllDocsCSV: {
          method: 'GET',
          url: 'api/download-all-docs-as-csv',
          responseType: 'arraybuffer',
          transformResponse: function (data, headers) {
            return {
              data: data,
              filename: DataUtils.parseHeaderFilename(headers),
            };
          },
        },
        findByEntity: {
          method: 'GET',
          url: 'api/documents-by-entity/:id',
          isArray: true,
        },
        getInvoice: {
          method: 'GET',
          url: 'api/invoice-by-document/:id',
          isArray: false,
        },
        getOrder: {
          method: 'GET',
          url: 'api/order-by-document/:id',
          isArray: false,
        },
        getDespatchAdvice: {
          method: 'GET',
          url: 'api/despatch-advice-by-document/:id',
          isArray: false,
        },
        get: {
          method: 'GET',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
              data.documentDate = DateUtils.convertLocalDateFromServer(data.documentDate);
            }
            return data;
          },
        },
        getByExternalHash: {
          method: 'GET',
          url: 'api/external/document/:hash',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
              data.documentDate = DateUtils.convertLocalDateFromServer(data.documentDate);
            }
            return data;
          },
        },
        getAllByExternalHash: {
          method: 'GET',
          url: 'api/external/documents',
          isArray: true,
        },
        update: {
          method: 'PUT',
          transformRequest: function (data) {
            var copy = angular.copy(data);
            copy.documentDate = DateUtils.convertLocalDateToServer(copy.documentDate);
            return angular.toJson(copy);
          },
        },
        save: {
          method: 'POST',
          transformRequest: function (data) {
            var copy = angular.copy(data);
            copy.documentDate = DateUtils.convertLocalDateToServer(copy.documentDate);
            return angular.toJson(copy);
          },
        },
        redoStepForDocumentsList: {
          method: 'GET',
          url: 'api/document-step-redo/from-list',
          isArray: true,
        },
        doStepForDocumentsList: {
          method: 'GET',
          url: 'api/document-step-do/from-list',
          isArray: true,
        },
        removeDocuments: {
          method: 'DELETE',
          url: 'api/documents/remove-documents',
        },
        approve: {
          method: 'GET',
          url: 'api/documents/approve/:id',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
              data.documentDate = DateUtils.convertLocalDateFromServer(data.documentDate);
            }
            return data;
          },
        },
        approveByHashId: {
          // POST, not GET. Approving is a legally binding acknowledgement that needs no credential
          // beyond the hash in the URL, so it must not be reachable by anything that merely
          // follows a link — mail scanners and prefetchers issue GETs, and the hash sits in the
          // Apache access log where a GET is trivially replayable.
          method: 'POST',
          url: 'api/documents/external/approve/:hash',
          transformResponse: function (data) {
            if (data) {
              data = angular.fromJson(data);
              data.documentDate = DateUtils.convertLocalDateFromServer(data.documentDate);
            }
            return data;
          },
        },
        approvalStatement: {
          method: 'GET',
          url: 'api/external/documents/approval-statement/:hash',
        },
        // The in-application equivalent, keyed by id. Same server-side renderer, so the sentence
        // this dialog displays is the one recorded on the evidence row. Answers 404 for a document
        // the caller may not see.
        approvalStatementById: {
          method: 'GET',
          url: 'api/documents/approval-statement/:id',
        },
        // Recipients holding an external access link for the given document ids. Deleting a
        // document drops those hashes, so the delete dialogs warn with this list first.
        // Wrapped in an object because $resource turns an array of plain strings into Resources.
        externalAccessRecipients: {
          method: 'GET',
          url: 'api/documents-external-access-recipients',
          transformResponse: function (data) {
            return { emails: data ? angular.fromJson(data) : [] };
          },
        },
        downloadNeedApproval: {
          method: 'GET',
          url: 'api/documents/download-need-approval/:id',
          transformResponse: function (data) {
            return { body: data };
          },
        },
        downloadNeedApprovalExternal: {
          method: 'GET',
          url: 'api/external/documents/download-need-approval/:hash',
          transformResponse: function (data) {
            return { body: data };
          },
        },
        downloadAllNeedApprovalExternal: {
          method: 'GET',
          url: 'api/external/documents/download-all-need-approval/:hash',
          transformResponse: function (data) {
            return { body: data };
          },
        },
      }
    );
  }
})();

/* global moment:true, _:true*/
(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('DocumentController', DocumentController);

  DocumentController.$inject = [
    '$state',
    '$scope',
    '$uibModal',
    '$translate',
    'DataUtils',
    'Document',
    'ParseLinks',
    'AlertService',
    'paginationConstants',
    'Notification',
    'PaginationUtil',
    'DocumentDownloadPdf',
    'CurrencyUtils',
    '$window',
    'Principal',
  ];

  function DocumentController(
    $state,
    $scope,
    $uibModal,
    $translate,
    DataUtils,
    Document,
    ParseLinks,
    AlertService,
    paginationConstants,
    Notification,
    PaginationUtil,
    DocumentDownloadPdf,
    CurrencyUtils,
    $window,
    Principal
  ) {
    var vm = this;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.exportDocumentsFiles = exportDocumentsFiles;
    vm.exportSelectedDocsToExcel = exportSelectedDocsToExcel;
    vm.exportSelectedDocsToCSV = exportSelectedDocsToCSV;
    vm.exportAllDocsAsCSV = exportAllDocsAsCSV;
    vm.search = search;
    vm.reset = reset;
    vm.loadAll = loadAll;
    vm.initFilters = initFilters;
    vm.totalItems = 1000;
    vm.isTableLoading = true;
    vm.deselectOne = deselectOne;
    vm.selectAll = selectAll;
    vm.selectChange = selectChange;
    vm.getTotalSelected = getTotalSelected;
    vm.viewSelectedDocuments = viewSelectedDocuments;
    vm.viewFavoriteSearches = viewFavoriteSearches;
    vm.isSearchActive = isSearchActive;
    vm.getCurrency = CurrencyUtils.getCurrency;
    vm.download = download;
    vm.changeFiles = changeFiles;
    vm.changeVisualization = changeVisualization;
    vm.changeDocumentType = changeDocumentType;
    vm.changeStatus = changeStatus;
    vm.getViewableFilename = DataUtils.getViewableFilename;
    vm.formatFileSize = DataUtils.formatFileSize;
    vm.getFileIconClass = DataUtils.getFileIconClass;
    vm.types = ['INVOICE', 'CREDITNOTE', 'DEBITNOTE', 'SELFBILLED', 'PROFORMAINVOICE', 'CONSIGNMENTNOTE', 'ORDER', 'DESPATCHADVICE'];
    vm.states = ['IN_COMMUNICATION', 'PROCESSING', 'WAITING', 'SCHEDULED', 'FINISHED', 'ERROR', 'DUPLICATED'];

    var debouncedLoadAll = _.debounce(loadAll, 300);

    vm.documentsToExport = {};

    vm.clearInputDate = clearInputDate;
    vm.startDateForCreatedDate = null;
    vm.endDateForCreatedDate = null;
    vm.startDateForDocumentDate = null;
    vm.endDateForDocumentDate = null;

    function isSmallScreen() {
      var w = angular.element($window);
      vm.width = w.width();
      $scope.$apply();
      // return document.body.clientWidth < 500;
    }

    $(window).resize(function () {
      isSmallScreen();
    });

    function isSearchActive() {
      return (
        vm.filters.filterBy.documentNumber.value ||
        vm.filters.filterBy.originName.value ||
        vm.filters.filterBy.destinationName.value ||
        vm.filters.filterBy.originVatRegistrationNumber.value ||
        vm.filters.filterBy.destinationVatRegistrationNumber.value ||
        vm.filters.filterBy.entityName.value ||
        vm.filters.filterBy.entityVatRegistrationNumber.value ||
        vm.filters.filterBy.createdDate.startDate ||
        vm.filters.filterBy.createdDate.endDate ||
        vm.filters.filterBy.documentDate.startDate ||
        vm.filters.filterBy.documentDate.endDate ||
        vm.filters.filterBy.documentValue.startValue ||
        vm.filters.filterBy.documentValue.startValue === 0 ||
        vm.filters.filterBy.documentValue.endValue ||
        vm.filters.filterBy.documentValue.endValue === 0 ||
        vm.filters.filterBy.documentType.value ||
        vm.filters.filterBy.hasViews.value ||
        vm.filters.filterBy.hasFiles.value ||
        vm.filters.filterBy.status.value
      );
    }

    function changeVisualization(value) {
      vm.filters.filterBy.hasViews.value = value;
      vm.page = 1;
      debouncedLoadAll();
    }

    function changeFiles(value) {
      vm.filters.filterBy.hasFiles.value = value;
      vm.page = 1;
      debouncedLoadAll();
    }

    function changeDocumentType(value) {
      vm.filters.filterBy.documentType.value = value;
      vm.page = 1;
      debouncedLoadAll();
    }

    function changeStatus(value) {
      vm.filters.filterBy.status.value = value;
      vm.page = 1;
      debouncedLoadAll();
    }

    function reset() {
      vm.filters = PaginationUtil.clearFilters($state.current.name, filterBy());
      loadAll();
    }

    function filterBy() {
      return {
        documentNumber: {
          name: 'documentNumber',
          value: undefined,
        },
        originName: {
          name: 'originName',
          value: undefined,
        },
        destinationName: {
          name: 'destinationName',
          value: undefined,
        },
        originVatRegistrationNumber: {
          name: 'originVatRegistrationNumber',
          value: undefined,
        },
        destinationVatRegistrationNumber: {
          name: 'destinationVatRegistrationNumber',
          value: undefined,
        },
        entityName: {
          name: 'entityName',
          value: undefined,
        },
        entityVatRegistrationNumber: {
          name: 'entityVatRegistrationNumber',
          value: undefined,
        },
        createdDate: {
          name: 'createdDate',
          startDate: undefined,
          endDate: undefined,
        },
        documentDate: {
          name: 'documentDate',
          startDate: undefined,
          endDate: undefined,
        },
        documentValue: {
          name: 'documentValue',
          startValue: undefined,
          endValue: undefined,
        },
        documentType: {
          name: 'documentType',
          value: undefined,
        },
        hasViews: {
          name: 'hasViews',
          value: undefined,
        },
        hasFiles: {
          name: 'hasFiles',
          value: undefined,
        },
        status: {
          name: 'status',
          value: undefined,
        },
      };
    }

    function initFilters() {
      vm.filters = PaginationUtil.getFilters($state.current.name, filterBy());

      vm.page = vm.filters.currentPage + 1;
      vm.predicate = vm.filters.orderBy;
      vm.reverse = vm.filters.orderReverse;
      loadAll();
    }

    vm.$onInit = function () {
      initFilters();
    };

    function loadAll() {
      vm.filters = PaginationUtil.updateFilters($state.current.name, vm.page - 1, vm.filters.filterBy, vm.predicate, vm.reverse, vm.itemsPerPage);
      Document.query(
        {
          page: vm.filters.currentPage,
          size: vm.filters.itemsPerPage,
          search: search(),
          sort: sort(),
        },
        onSuccess,
        onError
      );
    }

    function onSuccess(data, headers) {
      vm.links = ParseLinks.parse(headers('link'));
      vm.totalItems = headers('X-Total-Count');
      vm.queryCount = vm.totalItems;
      // EDOCS-652 Phase 2: each row's files come with the page (DocumentViewDTO.files); no second request.
      vm.documents = data;

      for (var i = 0; i < vm.documents.length; i++) {
        if (vm.documentsToExport[vm.documents[i].id] != null) {
          vm.documents[i].selected = true;
        }
      }
      checkSelectAll();
    }

    function onError(error) {
      AlertService.error(error.data.message);
    }

    function sort() {
      if (!vm.predicate) {
        vm.predicate = 'createdDate';
      }
      var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
      if (vm.predicate !== 'createdDate') {
        result.push('createdDate,desc');
      }
      return result;
    }

    function search() {
      var result = '';
      for (var x in vm.filters.filterBy) {
        if (x === 'hasViews') {
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
            if (vm.filters.filterBy[x].value === '1') {
              result += vm.filters.filterBy[x].name + ':true#AND,';
            } else if (vm.filters.filterBy[x].value === '0') {
              result += vm.filters.filterBy[x].name + ':false#AND,';
            }
          }
        } else if (x === 'hasFiles') {
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
            if (vm.filters.filterBy[x].value === '1') {
              result += vm.filters.filterBy[x].name + ':true#AND,';
            } else if (vm.filters.filterBy[x].value === '0') {
              result += vm.filters.filterBy[x].name + ':false#AND,';
            }
          }
        } else {
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
            result += vm.filters.filterBy[x].name + ':' + vm.filters.filterBy[x].value + '#AND,';
          }
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].startDate) {
            if (x === 'documentDate') {
              result +=
                vm.filters.filterBy[x].name +
                '>=' +
                moment(vm.filters.filterBy[x].startDate, 'DD/MM/YYYY')
                  .tz('Europe/Lisbon')
                  .set({
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                  })
                  .toISOString(true) +
                '#AND,';
            } else {
              result +=
                vm.filters.filterBy[x].name +
                '>=' +
                moment(vm.filters.filterBy[x].startDate, 'DD/MM/YYYY HH:mm')
                  .tz('Europe/Lisbon')
                  .set({
                    seconds: 0,
                  })
                  .toISOString(true) +
                '#AND,';
            }
          }
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].endDate) {
            if (x === 'documentDate') {
              result +=
                vm.filters.filterBy[x].name +
                '<=' +
                moment(vm.filters.filterBy[x].endDate, 'DD/MM/YYYY')
                  .tz('Europe/Lisbon')
                  .set({
                    hours: 23,
                    minutes: 59,
                    seconds: 59,
                  })
                  .toISOString(true) +
                '#AND,';
            } else {
              result +=
                vm.filters.filterBy[x].name +
                '<=' +
                moment(vm.filters.filterBy[x].endDate, 'DD/MM/YYYY HH:mm')
                  .tz('Europe/Lisbon')
                  .set({
                    seconds: 59,
                  })
                  .toISOString(true) +
                '#AND,';
            }
          }
          if (vm.filters.filterBy[x] && (vm.filters.filterBy[x].startValue || vm.filters.filterBy[x].startValue === 0)) {
            result += vm.filters.filterBy[x].name + '>=' + vm.filters.filterBy[x].startValue + '#AND,';
          }
          if (vm.filters.filterBy[x] && (vm.filters.filterBy[x].endValue || vm.filters.filterBy[x].endValue === 0)) {
            result += vm.filters.filterBy[x].name + '<=' + vm.filters.filterBy[x].endValue + '#AND,';
          }
        }
      }

      return result;
    }

    function download($event, document, fileId, fileType) {
      DocumentDownloadPdf.download($event, document, fileId, fileType);
    }

    function viewSelectedDocuments() {
      $uibModal.open({
        templateUrl: 'app/entities/document/selected-documents-dialog.html',
        controller: 'SelectedDocumentsController',
        controllerAs: 'vm',
        size: 'xl',
        resolve: {
          list: vm.documentsToExport,
          selectChange: function () {
            return vm.selectChange;
          },
          exportDocumentsFiles: function () {
            return vm.exportDocumentsFiles;
          },
          exportSelectedDocsToCSV: function () {
            return vm.exportSelectedDocsToCSV;
          },
          exportSelectedDocsToExcel: function () {
            return vm.exportSelectedDocsToExcel;
          },
        },
      });
    }

    function viewFavoriteSearches() {
      $uibModal
        .open({
          templateUrl: 'app/entities/document/favorite-searches-dialog.html',
          controller: 'FavoriteSearchesController',
          controllerAs: 'vm',
          size: 'xl',
          resolve: {
            documentTypes: function () {
              return vm.types;
            },
            documentStates: function () {
              return vm.states;
            },
            filterBy: function () {
              return filterBy;
            },
          },
        })
        .result.then(
          function (response) {
            vm.filters.filterBy = response;
            vm.page = 1;
            vm.loadAll();
          },
          function () {}
        );
    }

    function checkSelectAll() {
      var docsSelected = vm.documents.filter(function (doc) {
        return vm.documentsToExport[doc.id] != null;
      });
      vm.selectedAll = docsSelected.length === vm.documents.length;
    }

    function getTotalSelected() {
      var keys = Object.keys(vm.documentsToExport);
      return keys.length;
    }

    function selectChange(document) {
      if (document.selected) {
        vm.documentsToExport[document.id] = document;
        checkSelectAll();
      } else {
        delete vm.documentsToExport[document.id];
      }
    }

    function selectAll() {
      vm.documents.map(function (x) {
        x.selected = !vm.selectedAll;
        return x;
      });
      if (!vm.selectedAll) {
        for (var i = 0; i < vm.documents.length; i++) {
          vm.documentsToExport[vm.documents[i].id] = vm.documents[i];
        }
      } else {
        for (var j = 0; j < vm.documents.length; j++) {
          delete vm.documentsToExport[vm.documents[j].id];
        }
      }
    }

    function deselectOne() {
      vm.selectedAll = false;
    }

    function exportDocumentsFiles() {
      var docsSelected = [];
      Object.keys(vm.documentsToExport).forEach(function (key) {
        docsSelected.push(vm.documentsToExport[key]);
      });
      if (docsSelected.length === 0) {
        Notification.error({ message: $translate.instant('eDocumentsApp.document.message.noDocumentsSelected') });
        return;
      }
      var ids = [];
      for (var i = 0; i < docsSelected.length; i++) {
        if (docsSelected[i].files.length > 0) {
          ids.push(docsSelected[i].id);
        }
      }
      Document.downloadAsZip(ids).$promise.then(
        function (result) {
          Document.addDownloads(ids);
          DataUtils.viewServerFile(result);
          for (var i = 0; i < vm.documents.length; i++) {
            vm.documents[i].selected = false;
            selectChange(vm.documents[i]);
          }
        },
        function () {
          Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
        }
      );
    }

    var opts = {
      sheetid: $translate.instant('eDocumentsApp.document.export.title'),
      headers: true,
      columns: [
        {
          columnid: 'documentNumber',
          title: $translate.instant('eDocumentsApp.document.documentNumber'),
          width: 'auto',
        },
        {
          columnid: 'createdDate',
          title: $translate.instant('eDocumentsApp.document.createdDate'),
          width: 'auto',
        },
        {
          columnid: 'documentDate',
          title: $translate.instant('eDocumentsApp.document.documentDate'),
          width: 'auto',
        },
        {
          columnid: 'documentType',
          title: $translate.instant('eDocumentsApp.document.documentType'),
          width: 'auto',
        },
        {
          columnid: 'documentValue',
          title: $translate.instant('eDocumentsApp.document.documentValue'),
          width: 'auto',
        },
        {
          columnid: 'currency',
          title: $translate.instant('eDocumentsApp.document.currency'),
          width: 'auto',
        },
        {
          columnid: 'origin',
          title: $translate.instant('eDocumentsApp.document.origin.label'),
          width: 'auto',
        },
        {
          columnid: 'destination',
          title: $translate.instant('eDocumentsApp.document.destination.label'),
          width: 'auto',
        },
        {
          columnid: 'status',
          title: $translate.instant('eDocumentsApp.document.status'),
          width: 'auto',
        },
        {
          columnid: 'files',
          title: $translate.instant('eDocumentsApp.document.documentFiles'),
          width: 'auto',
          cell: {
            value: function (value) {
              var result = '';
              if (value.length > 0) {
                for (var i = 0; i < value.length; i++) {
                  if (i > 0) {
                    result = result + ', ';
                  }
                  result = result + value[i].filename;
                }
              }
              return result;
            },
          },
        },
      ],
      row: {
        style: function (sheet, row, rowidx) {
          return 'height:20px';
        },
      },
    };

    function exportSelectedDocsToExcel() {
      var docsSelected = [];
      Object.keys(vm.documentsToExport).forEach(function (key) {
        docsSelected.push(vm.documentsToExport[key]);
      });
      if (docsSelected.length === 0) {
        Notification.error({ message: $translate.instant('eDocumentsApp.document.message.noDocumentsSelected') });
        return;
      }
      alasql('SELECT * INTO XLS("documents_' + new Date().getTime() + '.xls",?) FROM ?', [opts, docsSelected]);
    }

    function exportSelectedDocsToCSV() {
      var docsSelected = [];
      Object.keys(vm.documentsToExport).forEach(function (key) {
        docsSelected.push(vm.documentsToExport[key]);
      });
      if (docsSelected.length === 0) {
        Notification.error({ message: $translate.instant('eDocumentsApp.document.message.noDocumentsSelected') });
        return;
      }
      alasql(
        'SELECT documentNumber, createdDate, documentDate, documentType, documentValue, currency, origin, destination, status INTO CSV("documents_' +
          new Date().getTime() +
          '.csv",{headers:true}) FROM ?',
        [docsSelected]
      );
    }

    function exportAllDocsAsCSV() {
      if (vm.totalItems > 15000) {
        $uibModal.open({
          templateUrl: 'app/entities/document/export-all-documents-error-dialog.html',
          controller: 'ExportAllDocumentsErrorController',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            numberOfDocuments: { total: vm.totalItems },
          },
        });
      } else {
        var search = { search: vm.search() };
        Document.downloadAllDocsCSV(search).$promise.then(
          function (result) {
            DataUtils.viewServerFile(result);
          },
          function () {
            Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
          }
        );
      }
    }

    function clearInputDate(input) {
      if (input === 'startDateForCreatedDate') {
        vm.startDateForCreatedDate = null;
        vm.filters.filterBy.createdDate.startDate = null;
      } else if (input === 'endDateForCreatedDate') {
        vm.endDateForCreatedDate = null;
        vm.filters.filterBy.createdDate.endDate = null;
      } else if (input === 'startDateForDocumentDate') {
        vm.startDateForDocumentDate = null;
        vm.filters.filterBy.documentDate.startDate = null;
      } else if (input === 'endDateForDocumentDate') {
        vm.endDateForDocumentDate = null;
        vm.filters.filterBy.documentDate.endDate = null;
      }
    }
  }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('digital-archive-document', {
            parent: 'app',
            url: '/digital-archive/document?page&sort&search',
            data: {
                authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_DIGITAL_ARCHIVE'],
                pageTitle: 'eDocumentsApp.digitalArchive.home.title',
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/digital-archive/document/documents.html',
                    controller: 'DigitalArchiveDocumentController',
                    controllerAs: 'vm',
                },
            },
            params: {
                page: {
                    value: '1',
                    squash: true,
                },
                sid: null,
                eid: null,
                did: null,
                oid: null,
                sort: {
                    value: 'createdDate,desc',
                    squash: true,
                },
                search: null,
            },
            resolve: {
                pagingParams: [
                    '$stateParams',
                    'PaginationUtil',
                    function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                        };
                    },
                ],
                loggeduser: [
                    'Principal',
                    function (Principal) {
                        return Principal.identity().$promise;
                    },
                ],
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('digitalArchive');
                        $translatePartialLoader.addPart('documentType');
                        $translatePartialLoader.addPart('documentStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    },
                ],
            },
        });
    }
})();

/* global moment:true, _:true*/
(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('DigitalArchiveDocumentController', DigitalArchiveDocumentController);

  DigitalArchiveDocumentController.$inject = [
    '$state',
    '$scope',
    '$uibModal',
    '$translate',
    'DataUtils',
    'Document',
    'DocumentFile',
    'ParseLinks',
    'AlertService',
    'paginationConstants',
    'Notification',
    'PaginationUtil',
    'DocumentDownloadPdf',
    'CurrencyUtils',
    '$window',
    'IntegrityWarningService',
  ];

  function DigitalArchiveDocumentController(
    $state,
    $scope,
    $uibModal,
    $translate,
    DataUtils,
    Document,
    DocumentFile,
    ParseLinks,
    AlertService,
    paginationConstants,
    Notification,
    PaginationUtil,
    DocumentDownloadPdf,
    CurrencyUtils,
    $window,
    IntegrityWarningService
  ) {
    var vm = this;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.exportDocumentsFiles = exportDocumentsFiles;
    vm.search = search;
    vm.reset = reset;
    vm.loadAll = loadAll;
    vm.initFilters = initFilters;
    vm.totalItems = 1000;
    vm.isTableLoading = true;
    vm.deselectOne = deselectOne;
    vm.selectAll = selectAll;
    vm.selectChange = selectChange;
    vm.getTotalSelected = getTotalSelected;
    vm.viewSelectedDocuments = viewSelectedDocuments;
    vm.isSearchActive = isSearchActive;
    vm.getCurrency = CurrencyUtils.getCurrency;
    vm.download = download;
    vm.changeFiles = changeFiles;
    vm.changeVisualization = changeVisualization;
    vm.changeDocumentType = changeDocumentType;
    vm.getViewableFilename = DataUtils.getViewableFilename;
    vm.formatFileSize = DataUtils.formatFileSize;
    vm.getFileIconClass = DataUtils.getFileIconClass;
    vm.types = ['INVOICE', 'CREDITNOTE', 'DEBITNOTE', 'SELFBILLED', 'PROFORMAINVOICE', 'CONSIGNMENTNOTE', 'ORDER', 'DESPATCHADVICE', 'OTHER'];

    vm.documentsToExport = {};

    vm.clearInputDate = clearInputDate;
    vm.startDateForCreatedDate = null;
    vm.endDateForCreatedDate = null;
    vm.startDateForDocumentDate = null;
    vm.endDateForDocumentDate = null;

    function isSmallScreen() {
      var w = angular.element($window);
      vm.width = w.width();
      $scope.$apply();
      // return document.body.clientWidth < 500;
    }

    $(window).resize(function () {
      isSmallScreen();
    });

    function isSearchActive() {
      return (
        vm.filters.filterBy.documentNumber.value ||
        vm.filters.filterBy.originName.value ||
        vm.filters.filterBy.createdDate.startDate ||
        vm.filters.filterBy.createdDate.endDate ||
        vm.filters.filterBy.documentDate.startDate ||
        vm.filters.filterBy.documentDate.endDate ||
        vm.filters.filterBy.documentValue.startValue ||
        vm.filters.filterBy.documentValue.startValue === 0 ||
        vm.filters.filterBy.documentValue.endValue ||
        vm.filters.filterBy.documentValue.endValue === 0 ||
        vm.filters.filterBy.documentType.value ||
        vm.filters.filterBy.hasViews.value ||
        vm.filters.filterBy.hasFiles.value
      );
    }

    function changeVisualization(value) {
      vm.filters.filterBy.hasViews.value = value;
      vm.page = 1;
      loadAll();
    }

    function changeFiles(value) {
      vm.filters.filterBy.hasFiles.value = value;
      vm.page = 1;
      loadAll();
    }

    function changeDocumentType(value) {
      vm.filters.filterBy.documentType.value = value;
      vm.page = 1;
      loadAll();
    }

    function reset() {
      vm.filters = PaginationUtil.clearFilters($state.current.name, filterBy());
      loadAll();
    }

    function filterBy() {
      return {
        documentNumber: {
          name: 'documentNumber',
          value: undefined,
        },
        originName: {
          name: 'originName',
          value: undefined,
        },
        createdDate: {
          name: 'createdDate',
          startDate: undefined,
          endDate: undefined,
        },
        documentDate: {
          name: 'documentDate',
          startDate: undefined,
          endDate: undefined,
        },
        documentValue: {
          name: 'documentValue',
          startValue: undefined,
          endValue: undefined,
        },
        documentType: {
          name: 'documentType',
          value: undefined,
        },
        hasViews: {
          name: 'hasViews',
          value: undefined,
        },
        hasFiles: {
          name: 'hasFiles',
          value: undefined,
        },
      };
    }

    function initFilters() {
      vm.filters = PaginationUtil.getFilters($state.current.name, filterBy());

      vm.page = vm.filters.currentPage + 1;
      vm.predicate = vm.filters.orderBy;
      vm.reverse = vm.filters.orderReverse;
      loadAll();
    }

    vm.$onInit = function () {
      initFilters();
    };

    function loadAll() {
      vm.filters = PaginationUtil.updateFilters($state.current.name, vm.page - 1, vm.filters.filterBy, vm.predicate, vm.reverse, vm.itemsPerPage);
      Document.queryForDigitalArchive(
        {
          page: vm.filters.currentPage,
          size: vm.filters.itemsPerPage,
          search: search(),
          sort: sort(),
        },
        onSuccess,
        onError
      );
    }

    function onSuccess(data, headers) {
      vm.links = ParseLinks.parse(headers('link'));
      vm.totalItems = headers('X-Total-Count');
      vm.queryCount = vm.totalItems;
      vm.documents = data;

      loadFilesForDocuments(vm.documents);

      for (var i = 0; i < vm.documents.length; i++) {
        if (vm.documentsToExport[vm.documents[i].id] != null) {
          vm.documents[i].selected = true;
        }
      }
      checkSelectAll();
    }

    function onError(error) {
      AlertService.error(error.data.message);
    }

    function loadFilesForDocuments(documents) {
      var docIdsWithFiles = [];
      for (var i = 0; i < documents.length; i++) {
        if (documents[i].hasFiles) {
          docIdsWithFiles.push(documents[i].id);
        }
      }
      if (docIdsWithFiles.length === 0) {
        return;
      }
      // EDOCS-652: integrity=true asks the server to verify the checksum of the Digital Archive files;
      // only this page shows the verdict, so the main Documents list never sends it.
      DocumentFile.queryByDocumentIds({ documentIds: docIdsWithFiles, integrity: true })
        .$promise.then(function (filesByDocId) {
          for (var i = 0; i < documents.length; i++) {
            if (documents[i].hasFiles) {
              // A document absent from the answer has no files left: an empty list ends its spinner.
              documents[i].files = filesByDocId[String(documents[i].id)] || [];
            }
          }
        })
        .catch(function (error) {
          // EDOCS-652: without this the file cell spins forever; show that the files could not be loaded.
          for (var i = 0; i < documents.length; i++) {
            if (documents[i].hasFiles && !documents[i].files) {
              documents[i].filesUnavailable = true;
            }
          }
          console.error('Error retrieving document files:', error);
        });
    }

    function sort() {
      if (!vm.predicate) {
        vm.predicate = 'createdDate';
      }
      var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
      if (vm.predicate !== 'createdDate') {
        result.push('createdDate,desc');
      }
      return result;
    }

    function search() {
      var result = '';
      for (var x in vm.filters.filterBy) {
        if (x === 'hasViews') {
          if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
            if (vm.filters.filterBy[x].value === '1') {
              result += vm.filters.filterBy[x].name + ':true#AND,';
            } else if (vm.filters.filterBy[x].value === '0') {
              result += vm.filters.filterBy[x].name + ':false#AND,';
            }
          }
        } else {
          if (x === 'hasFiles') {
            if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
              if (vm.filters.filterBy[x].value === '1') {
                result += vm.filters.filterBy[x].name + ':true#AND,';
              } else if (vm.filters.filterBy[x].value === '0') {
                result += vm.filters.filterBy[x].name + ':false#AND,';
              }
            }
          } else {
            if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
              result += vm.filters.filterBy[x].name + ':' + vm.filters.filterBy[x].value + '#AND,';
            }
            if (vm.filters.filterBy[x] && vm.filters.filterBy[x].startDate) {
              if (x === 'documentDate') {
                result +=
                  vm.filters.filterBy[x].name +
                  '>=' +
                  moment(vm.filters.filterBy[x].startDate, 'DD/MM/YYYY')
                    .tz('Europe/Lisbon')
                    .set({
                      hours: 0,
                      minutes: 0,
                      seconds: 0,
                    })
                    .toISOString(true) +
                  '#AND,';
              } else {
                result +=
                  vm.filters.filterBy[x].name +
                  '>=' +
                  moment(vm.filters.filterBy[x].startDate, 'DD/MM/YYYY HH:mm')
                    .tz('Europe/Lisbon')
                    .set({
                      seconds: 0,
                    })
                    .toISOString(true) +
                  '#AND,';
              }
            }
            if (vm.filters.filterBy[x] && vm.filters.filterBy[x].endDate) {
              if (x === 'documentDate') {
                result +=
                  vm.filters.filterBy[x].name +
                  '<=' +
                  moment(vm.filters.filterBy[x].endDate, 'DD/MM/YYYY')
                    .tz('Europe/Lisbon')
                    .set({
                      hours: 23,
                      minutes: 59,
                      seconds: 59,
                    })
                    .toISOString(true) +
                  '#AND,';
              } else {
                result +=
                  vm.filters.filterBy[x].name +
                  '<=' +
                  moment(vm.filters.filterBy[x].endDate, 'DD/MM/YYYY HH:mm')
                    .tz('Europe/Lisbon')
                    .set({
                      seconds: 59,
                    })
                    .toISOString(true) +
                  '#AND,';
              }
            }
            if (vm.filters.filterBy[x] && (vm.filters.filterBy[x].startValue || vm.filters.filterBy[x].startValue === 0)) {
              result += vm.filters.filterBy[x].name + '>=' + vm.filters.filterBy[x].startValue + '#AND,';
            }
            if (vm.filters.filterBy[x] && (vm.filters.filterBy[x].endValue || vm.filters.filterBy[x].endValue === 0)) {
              result += vm.filters.filterBy[x].name + '<=' + vm.filters.filterBy[x].endValue + '#AND,';
            }
          }
        }
      }

      return result;
    }

    function download($event, document, fileId, fileType) {
      // Find the file object to check for integrity issues
      var file = null;
      if (document.files && document.files.length > 0) {
        for (var i = 0; i < document.files.length; i++) {
          if (document.files[i].id === fileId) {
            file = document.files[i];
            break;
          }
        }
      }

      // Check if file has integrity issues (checksumValid explicitly false)
      if (file && file.checksumValid === false) {
        // Show integrity warning dialog
        IntegrityWarningService.checkAndWarn([file], function () {
          // User acknowledged - record the acknowledgment and proceed with download
          // For POST, first arg is URL params, second arg is request body (empty in this case)
          DocumentFile.acknowledgeIntegrityWarning({ id: fileId }, {}).$promise.then(
            function () {
              // Acknowledgment recorded, proceed with download
              DocumentDownloadPdf.download($event, document, fileId, fileType);
            },
            function () {
              // Failed to record acknowledgment, but still allow download
              DocumentDownloadPdf.download($event, document, fileId, fileType);
            }
          );
        });
      } else {
        // No integrity issues, proceed with normal download
        DocumentDownloadPdf.download($event, document, fileId, fileType);
      }
    }

    function viewSelectedDocuments() {
      $uibModal.open({
        templateUrl: 'app/entities/digital-archive/document/selected-documents-dialog.html',
        controller: 'SelectedDocumentsController',
        controllerAs: 'vm',
        size: 'xl',
        resolve: {
          list: vm.documentsToExport,
          selectChange: function () {
            return vm.selectChange;
          },
          exportDocumentsFiles: function () {
            return vm.exportDocumentsFiles;
          },
          exportSelectedDocsToCSV: function () {
            return vm.exportSelectedDocsToCSV;
          },
          exportSelectedDocsToExcel: function () {
            return vm.exportSelectedDocsToExcel;
          },
        },
      });
    }

    function checkSelectAll() {
      var docsSelected = vm.documents.filter(function (doc) {
        return vm.documentsToExport[doc.id] != null;
      });
      vm.selectedAll = docsSelected.length === vm.documents.length;
    }

    function getTotalSelected() {
      var keys = Object.keys(vm.documentsToExport);
      return keys.length;
    }

    function selectChange(document) {
      if (document.selected) {
        vm.documentsToExport[document.id] = document;
        checkSelectAll();
      } else {
        delete vm.documentsToExport[document.id];
      }
    }

    function selectAll() {
      vm.documents.map(function (x) {
        x.selected = !vm.selectedAll;
        return x;
      });
      if (!vm.selectedAll) {
        for (var i = 0; i < vm.documents.length; i++) {
          vm.documentsToExport[vm.documents[i].id] = vm.documents[i];
        }
      } else {
        for (var j = 0; j < vm.documents.length; j++) {
          delete vm.documentsToExport[vm.documents[j].id];
        }
      }
    }

    function deselectOne() {
      vm.selectedAll = false;
    }

    function exportDocumentsFiles() {
      var docsSelected = [];
      Object.keys(vm.documentsToExport).forEach(function (key) {
        docsSelected.push(vm.documentsToExport[key]);
      });
      if (docsSelected.length === 0) {
        Notification.error({ message: $translate.instant('eDocumentsApp.document.message.noDocumentsSelected') });
        return;
      }
      var ids = [];
      for (var i = 0; i < docsSelected.length; i++) {
        if (docsSelected[i].files.length > 0) {
          ids.push(docsSelected[i].id);
        }
      }
      Document.downloadAsZip(ids).$promise.then(
        function (result) {
          Document.addDownloads(ids);
          DataUtils.viewServerFile(result);
          for (var i = 0; i < vm.documents.length; i++) {
            vm.documents[i].selected = false;
            selectChange(vm.documents[i]);
          }
        },
        function () {
          Notification.error({ message: $translate.instant('eDocumentsApp.document.message.fileRetrievalError') });
        }
      );
    }

    function clearInputDate(input) {
      if (input === 'startDateForCreatedDate') {
        vm.startDateForCreatedDate = null;
        vm.filters.filterBy.createdDate.startDate = null;
      } else if (input === 'endDateForCreatedDate') {
        vm.endDateForCreatedDate = null;
        vm.filters.filterBy.createdDate.endDate = null;
      } else if (input === 'startDateForDocumentDate') {
        vm.startDateForDocumentDate = null;
        vm.filters.filterBy.documentDate.startDate = null;
      } else if (input === 'endDateForDocumentDate') {
        vm.endDateForDocumentDate = null;
        vm.filters.filterBy.documentDate.endDate = null;
      }
    }
  }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('CommunicationWorkflowStepDialogController', CommunicationWorkflowStepDialogController);

    CommunicationWorkflowStepDialogController.$inject = [
        'communicationDefinition',
        '$state',
        'readOnly',
        'previousState',
        '$timeout',
        '$scope',
        '$uibModal',
        'entity',
        'CommunicationWorkflowStep',
        'CommunicationDefinition',
        'CommunicationActionDefinition',
        'CommunicationParameter'
    ];

    function CommunicationWorkflowStepDialogController(
        communicationDefinition,
        $state,
        readOnly,
        previousState,
        $timeout,
        $scope,
        $uibModal,
        entity,
        CommunicationWorkflowStep,
        CommunicationDefinition,
        CommunicationActionDefinition,
        CommunicationParameter
    ) {
        var vm = this;
        vm.communicationWorkflowStep = entity;
        vm.communicationDefinition = communicationDefinition;
        if (!vm.communicationWorkflowStep.communicationDefinitionId) {
            vm.communicationWorkflowStep.communicationDefinitionId = vm.communicationDefinition.id;
        }
        vm.selectOriginCommunicationType = undefined;
        vm.selectOriginCommunicationParameterType = undefined;
        vm.selectDestinationCommunicationType = undefined;
        vm.selectDestinationCommunicationParameterType = undefined;
        vm.readOnly = readOnly;
        vm.previousState = previousState;
        vm.clear = clear;
        vm.save = save;
        vm.communicationactiondefinitions = CommunicationActionDefinition.queryAllOrdered();
        vm.addOriginParameter = addOriginParameter;
        vm.addDestinationParameter = addDestinationParameter;
        vm.deleteCommunicationDestinationParameter = deleteCommunicationDestinationParameter;
        vm.deleteCommunicationOriginParameter = deleteCommunicationOriginParameter;
        vm.changeOriginParameter = changeOriginParameter;
        vm.changeDestinationParameter = changeDestinationParameter;
        vm.viewEntitiesParameters = viewEntitiesParameters;
        vm.changeExecutionType = changeExecutionType;
        vm.communicationTypes = CommunicationParameter.getCommunicationTypes();

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function checkTimeParams(communicationWorkflowStep) {
            if (communicationWorkflowStep.originParameters) {
                communicationWorkflowStep.originParameters.forEach(function(parameter) {
                    if (
                        parameter.communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
                        parameter.communicationParameterType === 'EXECUTION_TIME' ||
                        parameter.communicationParameterType === 'SUSPENSION_START_TIME' ||
                        parameter.communicationParameterType === 'SUSPENSION_END_TIME'
                    ) {
                        if (parameter.disableExecutionTime) {
                            parameter.value = -1;
                        }
                    }
                });
            }
            if (communicationWorkflowStep.destinationParameters) {
                communicationWorkflowStep.destinationParameters.forEach(function(parameter) {
                    if (
                        parameter.communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
                        parameter.communicationParameterType === 'EXECUTION_TIME' ||
                        parameter.communicationParameterType === 'SUSPENSION_START_TIME' ||
                        parameter.communicationParameterType === 'SUSPENSION_END_TIME'
                    ) {
                        if (parameter.disableExecutionTime) {
                            parameter.value = -1;
                        }
                    }
                });
            }
        }

        function save() {
            vm.isSaving = true;
            checkTimeParams(vm.communicationWorkflowStep);
            if (angular.isDefined(vm.communicationWorkflowStep.id) && vm.communicationWorkflowStep.id !== null) {
                CommunicationWorkflowStep.update(vm.communicationWorkflowStep, onSaveSuccess, onSaveError);
            } else {
                CommunicationWorkflowStep.save(vm.communicationWorkflowStep, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('eDocumentsApp:communicationWorkflowStepUpdate', result);
            $state.go(previousState.name, previousState.params, {
                reload: true
            });
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function changeOriginParameter() {
            vm.communicationParameterTypes = vm.communicationTypes[vm.selectOriginCommunicationType];
        }

        function changeDestinationParameter() {
            vm.communicationParameterTypes = vm.communicationTypes[vm.selectDestinationCommunicationType];
        }

        function deleteCommunicationOriginParameter(communicationParameter) {
            for (var i = 0, len = vm.communicationWorkflowStep.originParameters.length; i < len; i++) {
                if (vm.communicationWorkflowStep.originParameters[i] === communicationParameter) {
                    vm.communicationWorkflowStep.originParameters.splice(i, 1);
                }
            }
        }

        function deleteCommunicationDestinationParameter(communicationParameter) {
            for (var i = 0, len = vm.communicationWorkflowStep.destinationParameters.length; i < len; i++) {
                if (vm.communicationWorkflowStep.destinationParameters[i] === communicationParameter) {
                    vm.communicationWorkflowStep.destinationParameters.splice(i, 1);
                }
            }
        }

        function addOriginParameter() {
            if (vm.selectOriginCommunicationType && vm.selectOriginCommunicationParameterType) {
                var communicationParameter = {
                    communicationType: vm.selectOriginCommunicationType,
                    communicationParameterType: vm.selectOriginCommunicationParameterType,
                    value: ''
                };
                if (!isCommunicationParameterInCommunicationWorkflowStepOriginParametersArray(communicationParameter)) {
                    vm.communicationWorkflowStep.originParameters.push(communicationParameter);
                }
            }
        }

        function addDestinationParameter() {
            if (vm.selectDestinationCommunicationType && vm.selectDestinationCommunicationParameterType) {
                var communicationParameter = {
                    communicationType: vm.selectDestinationCommunicationType,
                    communicationParameterType: vm.selectDestinationCommunicationParameterType,
                    value: ''
                };
                if (!isCommunicationParameterInCommunicationWorkflowStepDestinationParametersArray(communicationParameter)) {
                    vm.communicationWorkflowStep.destinationParameters.push(communicationParameter);
                }
            }
        }

        function isCommunicationParameterInCommunicationWorkflowStepOriginParametersArray(communicationParameter) {
            if (angular.isUndefined(vm.communicationWorkflowStep.originParameters)) {
                vm.communicationWorkflowStep.originParameters = [];
            }
            for (var i = 0, len = vm.communicationWorkflowStep.originParameters.length; i < len; i++) {
                if (
                    vm.communicationWorkflowStep.originParameters[i].communicationType === communicationParameter.communicationType &&
                    vm.communicationWorkflowStep.originParameters[i].communicationParameterType === communicationParameter.communicationParameterType
                ) {
                    return true;
                }
            }
            return false;
        }

        function isCommunicationParameterInCommunicationWorkflowStepDestinationParametersArray(communicationParameter) {
            if (angular.isUndefined(vm.communicationWorkflowStep.destinationParameters)) {
                vm.communicationWorkflowStep.destinationParameters = [];
            }
            for (var i = 0, len = vm.communicationWorkflowStep.destinationParameters.length; i < len; i++) {
                if (
                    vm.communicationWorkflowStep.destinationParameters[i].communicationType === communicationParameter.communicationType &&
                    vm.communicationWorkflowStep.destinationParameters[i].communicationParameterType === communicationParameter.communicationParameterType
                ) {
                    return true;
                }
            }
            return false;
        }

        function viewEntitiesParameters() {
            var temp = CommunicationDefinition.get({ id: vm.communicationWorkflowStep.communicationDefinitionId }).$promise;
            $uibModal.open({
                templateUrl: 'app/entities/communication-parameter/view-parameters-details-dialog.html',
                controller: 'ViewParametersDetailsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    communicationEntityOrigin: undefined, // CommunicationEntity.get({id: vm.communicationDefinition.originId}).$promise,
                    communicationEntityDestination: undefined, // CommunicationEntity.get({id: vm.communicationDefinition.destinationId}).$promise,
                    communicationDefinition: temp
                }
            });
        }

        function changeExecutionType(value) {
            vm.communicationWorkflowStep.executionType = value;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationWorkflowStepDeleteController',CommunicationWorkflowStepDeleteController);

    CommunicationWorkflowStepDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationWorkflowStep'];

    function CommunicationWorkflowStepDeleteController($uibModalInstance, entity, CommunicationWorkflowStep) {
        var vm = this;

        vm.communicationWorkflowStep = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationWorkflowStep.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication-workflow-step', {
                parent: 'app',
                url: '/communication-workflow-step/{sid}',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                    pageTitle: 'eDocumentsApp.communicationWorkflowStep.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-workflow-step/communication-workflow-steps.html',
                        controller: 'CommunicationWorkflowStepController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    workflows: [
                        '$stateParams',
                        'CommunicationWorkflowStep',
                        function($stateParams, CommunicationWorkflowStep) {
                            return CommunicationWorkflowStep.findByDefinition({ id: $stateParams.sid }).$promise;
                        }
                    ],
                    communicationDefinition: [
                        '$stateParams',
                        'CommunicationDefinition',
                        function($stateParams, CommunicationDefinition) {
                            return CommunicationDefinition.get({ id: $stateParams.sid }).$promise;
                        }
                    ],
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationWorkflowStep');
                            $translatePartialLoader.addPart('communicationType');
                            $translatePartialLoader.addPart('communicationDefinition');
                            $translatePartialLoader.addPart('communicationParameter');
                            $translatePartialLoader.addPart('communicationParameterType');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('communication-workflow-step-detail', {
                parent: 'communication-workflow-step',
                url: '/communication-workflow-step/{id}',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                    pageTitle: 'eDocumentsApp.communicationWorkflowStep.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-workflow-step/communication-workflow-step-dialog.html',
                        controller: 'CommunicationWorkflowStepDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationWorkflowStep');
                            return $translate.refresh();
                        }
                    ],
                    entity: [
                        '$stateParams',
                        'CommunicationWorkflowStep',
                        function($stateParams, CommunicationWorkflowStep) {
                            return CommunicationWorkflowStep.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return true;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-workflow-step',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-workflow-step-detail.edit', {
                parent: 'communication-workflow-step-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-workflow-step/communication-workflow-step-dialog.html',
                        controller: 'CommunicationWorkflowStepDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationWorkflowStep',
                        function($stateParams, CommunicationWorkflowStep) {
                            return CommunicationWorkflowStep.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'workflow-step',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-workflow-step.new', {
                parent: 'communication-workflow-step',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-workflow-step/communication-workflow-step-dialog.html',
                        controller: 'CommunicationWorkflowStepDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        'CommunicationWorkflowStep',
                        function(CommunicationWorkflowStep) {
                            return new CommunicationWorkflowStep();
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-workflow-step',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-workflow-step.edit', {
                parent: 'communication-workflow-step',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-workflow-step/communication-workflow-step-dialog.html',
                        controller: 'CommunicationWorkflowStepDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationWorkflowStep',
                        function($stateParams, CommunicationWorkflowStep) {
                            return CommunicationWorkflowStep.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-workflow-step',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-workflow-step.delete', {
                parent: 'communication-workflow-step',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                onEnter: [
                    '$stateParams',
                    '$state',
                    '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'app/entities/communication-workflow-step/communication-workflow-step-delete-dialog.html',
                                controller: 'CommunicationWorkflowStepDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: [
                                        'CommunicationWorkflowStep',
                                        function(CommunicationWorkflowStep) {
                                            return CommunicationWorkflowStep.get({ id: $stateParams.id }).$promise;
                                        }
                                    ]
                                }
                            })
                            .result.then(
                            function() {
                                $state.go('communication-workflow-step', null, { reload: 'communication-workflow-step' });
                            },
                            function() {
                                $state.go('^');
                            }
                        );
                    }
                ]
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('CommunicationWorkflowStep', CommunicationWorkflowStep);

    CommunicationWorkflowStep.$inject = ['$resource', 'DateUtils'];

    function CommunicationWorkflowStep($resource, DateUtils) {
        var resourceUrl = 'api/communication-workflow-steps/:id';

        return $resource(resourceUrl, {}, {
            'query'           : {
                method : 'GET',
                isArray: true
            },
            'findByDefinition': {
                method : 'GET',
                url    : 'api/communication-workflow-steps-by-definition/:id',
                isArray: true
            },
            'get'             : {
                method           : 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.originParameters) {
                            for (var i = 0; i < data.originParameters.length; i++) {
                                if (data.originParameters[i].communicationParameterType === 'EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
                                    data.originParameters[i].communicationParameterType === 'SUSPENSION_START_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_END_TIME') {
                                    if(data.originParameters[i].value !== -1 && data.originParameters[i].value !== '-1') {
                                        data.originParameters[i].value = DateUtils.convertStringToTime(data.originParameters[i].value);
                                    } else {
                                        data.originParameters[i].value = undefined;
                                        data.originParameters[i].disableExecutionTime = true;
                                    }
                                }
                            }
                        }
                        if (data.destinationParameters) {
                            for (var j = 0; j < data.destinationParameters.length; j++) {
                                if (data.destinationParameters[j].communicationParameterType === 'EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
                                    data.destinationParameters[j].communicationParameterType === 'SUSPENSION_START_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_END_TIME') {
                                    if(data.destinationParameters[j].value !== -1 && data.destinationParameters[j].value !== '-1') {
                                        data.destinationParameters[j].value = DateUtils.convertStringToTime(data.destinationParameters[j].value);
                                    } else {
                                        data.destinationParameters[j].value = undefined;
                                        data.destinationParameters[j].disableExecutionTime = true;
                                    }
                                }
                            }
                        }
                    }
                    return data;
                }
            },
            'update'          : {
                method          : 'PUT',
                transformRequest: function (data) {
                    if (data && data.originParameters) {
                        for (var i = 0; i < data.originParameters.length; i++) {
                            if (data.originParameters[i].communicationParameterType === 'EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
                                data.originParameters[i].communicationParameterType === 'SUSPENSION_START_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_END_TIME') {
                                if(data.originParameters[i].value !== -1) {
                                    data.originParameters[i].value = DateUtils.convertTimeToString(data.originParameters[i].value);
                                }
                            }
                        }
                    }
                    if (data && data.destinationParameters) {
                        for (var j = 0; j < data.destinationParameters.length; j++) {
                            if (data.destinationParameters[j].communicationParameterType === 'EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
                                data.destinationParameters[j].communicationParameterType === 'SUSPENSION_START_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_END_TIME') {
                                if(data.destinationParameters[j].value !== -1) {
                                    data.destinationParameters[j].value = DateUtils.convertTimeToString(data.destinationParameters[j].value);
                                }
                            }
                        }
                    }
                    return angular.toJson(data);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationWorkflowStepController', CommunicationWorkflowStepController);

    CommunicationWorkflowStepController.$inject = ['workflows', 'communicationDefinition'];

    function CommunicationWorkflowStepController(workflows, communicationDefinition) {
        var vm                        = this;
        vm.communicationDefinition    = communicationDefinition;
        vm.communicationWorkflowSteps = workflows;

    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ViewParametersDetailsDialogController', ViewParametersDetailsDialogController);

    ViewParametersDetailsDialogController.$inject = ['$uibModalInstance', 'communicationDefinition', 'communicationEntityDestination', 'communicationEntityOrigin', 'CommunicationEntity'];

    function ViewParametersDetailsDialogController($uibModalInstance, communicationDefinition, communicationEntityDestination, communicationEntityOrigin, CommunicationEntity) {
        var vm = this;

        vm.communicationDefinition = communicationDefinition;
        if (vm.communicationDefinition) {
            CommunicationEntity.get({ id: vm.communicationDefinition.originId }, function(result) {
                vm.communicationEntityOrigin = result;
            });
            CommunicationEntity.get({ id: vm.communicationDefinition.destinationId }, function(result) {
                vm.communicationEntityDestination = result;
            });
        } else {
            vm.communicationEntityOrigin = communicationEntityOrigin;
            vm.communicationEntityDestination = communicationEntityDestination;
        }
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationParameterDialogController', CommunicationParameterDialogController);

    CommunicationParameterDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'CommunicationParameter'];

    function CommunicationParameterDialogController($timeout, $scope, $uibModalInstance, entity, CommunicationParameter) {
        var vm = this;

        vm.communicationParameter = entity;
        vm.clear                  = clear;
        vm.save                   = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (angular.isDefined(vm.communicationParameter.id) && vm.communicationParameter.id !== null) {
                CommunicationParameter.update(vm.communicationParameter, onSaveSuccess, onSaveError);
            } else {
                CommunicationParameter.save(vm.communicationParameter, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('eDocumentsApp:communicationParameterUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationParameterDetailController', CommunicationParameterDetailController);

    CommunicationParameterDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function CommunicationParameterDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.communicationParameter = entity;
        vm.previousState          = previousState.name;
        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:communicationParameterUpdate', function (event, result) {
            vm.communicationParameter = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationParameterDeleteController',CommunicationParameterDeleteController);

    CommunicationParameterDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationParameter'];

    function CommunicationParameterDeleteController($uibModalInstance, entity, CommunicationParameter) {
        var vm = this;

        vm.communicationParameter = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationParameter.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication-parameter', {
                parent : 'entity',
                url    : '/communication-parameter',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.communicationParameter.home.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/communication-parameter/communication-parameters.html',
                        controller  : 'CommunicationParameterController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communicationParameter');
                        $translatePartialLoader.addPart('communicationType');
                        $translatePartialLoader.addPart('communicationParameterType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-parameter-detail', {
                parent : 'communication-parameter',
                url    : '/communication-parameter/{id}',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.communicationParameter.detail.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/communication-parameter/communication-parameter-detail.html',
                        controller  : 'CommunicationParameterDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communicationParameter');
                        $translatePartialLoader.addPart('communicationType');
                        $translatePartialLoader.addPart('communicationParameterType');
                        return $translate.refresh();
                    }],
                    entity                : ['$stateParams', 'CommunicationParameter', function ($stateParams, CommunicationParameter) {
                        return CommunicationParameter.get({id: $stateParams.id}).$promise;
                    }],
                    previousState         : ["$state", function ($state) {
                        return {
                            name  : $state.current.name || 'communication-parameter',
                            params: $state.params,
                            url   : $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('communication-parameter-detail.edit', {
                parent : 'communication-parameter-detail',
                url    : '/detail/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/communication-parameter/communication-parameter-dialog.html',
                        controller  : 'CommunicationParameterDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['CommunicationParameter', function (CommunicationParameter) {
                                return CommunicationParameter.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('communication-parameter.new', {
                parent : 'communication-parameter',
                url    : '/new',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/communication-parameter/communication-parameter-dialog.html',
                        controller  : 'CommunicationParameterDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: function () {
                                return {
                                    communicationType         : null,
                                    communicationParameterType: null,
                                    value                     : null,
                                    id                        : null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('communication-parameter', null, {reload: 'communication-parameter'});
                    }, function () {
                        $state.go('communication-parameter');
                    });
                }]
            })
            .state('communication-parameter.edit', {
                parent : 'communication-parameter',
                url    : '/{id}/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/communication-parameter/communication-parameter-dialog.html',
                        controller  : 'CommunicationParameterDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['CommunicationParameter', function (CommunicationParameter) {
                                return CommunicationParameter.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('communication-parameter', null, {reload: 'communication-parameter'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('communication-parameter.delete', {
                parent : 'communication-parameter',
                url    : '/{id}/delete',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/communication-parameter/communication-parameter-delete-dialog.html',
                        controller  : 'CommunicationParameterDeleteController',
                        controllerAs: 'vm',
                        size        : 'md',
                        resolve     : {
                            entity: ['CommunicationParameter', function (CommunicationParameter) {
                                return CommunicationParameter.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('communication-parameter', null, {reload: 'communication-parameter'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function () {
    'use strict';
    angular.module('eDocumentsApp').factory('CommunicationParameter', CommunicationParameter);

    CommunicationParameter.$inject = ['$resource'];

    function CommunicationParameter($resource) {
        var resourceUrl = 'api/communication-parameters/:id';

        return $resource(resourceUrl, {}, {
            'query'                         : {
                method : 'GET',
                isArray: true
            },
            'get'                           : {
                method           : 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update'                        : {
                method: 'PUT'
            },
            'getCommunicationTypesForCommunicationEntity'         : {
                method           : 'GET',
                isArray          : false,
                url              : 'api/communication-types-for-communication-entity/:id'
            },
            'getCommunicationTypes'         : {
                method           : 'GET',
                isArray          : false,
                url              : 'api/communication-types'
            },
            'getCommunicationParameterTypes': {
                method           : 'GET',
                isArray          : true,
                url              : 'api/communication-parameter-types',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationParameterController', CommunicationParameterController);

    CommunicationParameterController.$inject = ['CommunicationParameter'];

    function CommunicationParameterController(CommunicationParameter) {

        var vm = this;

        vm.communicationParameters = [];
        var loaded = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            CommunicationParameter.query(function(result) {
                loaded = result;
                vm.communicationParameters = result;
                vm.searchQuery = null;
                vm.currentSearch = null;
            });
        }

        function search() {
        if (!vm.searchQuery) {
            vm.communicationParameters = loaded;
            vm.currentSearch = null;
            return;
        }
        /* There is no search endpoint for this entity. The XSearch service this used to call was
           JHipster Elasticsearch scaffolding that this application never had - injecting it threw
           "Unknown provider", which killed the whole controller, so the page rendered NOTHING at
           all. The list is loaded in full above, so the box filters what is already here. */
        var needle = String(vm.searchQuery).toLowerCase();
        vm.communicationParameters = loaded.filter(function(item) {
            return Object.keys(item).some(function(key) {
                var value = item[key];
                return value !== null && value !== undefined && typeof value !== 'object' &&
                    String(value).toLowerCase().indexOf(needle) !== -1;
            });
        });
        vm.currentSearch = vm.searchQuery;
        }

        function clear() {
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.communicationParameters = loaded;
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('CommunicationEntityUserDeleteController', CommunicationEntityUserDeleteController);

  CommunicationEntityUserDeleteController.$inject = ['$uibModalInstance', '$translate', 'communicationEntity', 'user', 'User', 'Notification'];

  function CommunicationEntityUserDeleteController($uibModalInstance, $translate, communicationEntity, user, User, Notification) {
    var vm = this;

    vm.communicationEntity = communicationEntity;
    vm.user = user;
    vm.clear = clear;
    vm.confirmDelete = confirmDelete;

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmDelete() {
      User.removeEntityFromUser(
        {
          userId: user.id,
          entityId: vm.communicationEntity.id,
        },
        function () {
          Notification.success({ message: $translate.instant('userManagement.message.userRemovedFromEntity') });
          $uibModalInstance.close(true);
        },
        function () {
          Notification.error({ message: $translate.instant('userManagement.message.errorRemovingUserFromEntity') });
          $uibModalInstance.close(true);
        }
      );
    }
  }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('CommunicationEntityUserDialogController', CommunicationEntityUserDialogController);

    CommunicationEntityUserDialogController.$inject = ['$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function CommunicationEntityUserDialogController($uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_SUPERADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (angular.isDefined(vm.user.id) && vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('CommunicationEntityDialogController', CommunicationEntityDialogController);

  CommunicationEntityDialogController.$inject = [
    'Notification',
    '$ngConfirm',
    '$uibModal',
    '$state',
    'readOnly',
    '$timeout',
    '$scope',
    '$translate',
    'entity',
    'CommunicationEntity',
    'CommunicationParameter',
    'User',
    'AmaSafeCredential',
    'ExternalAuthKey',
    'Principal',
    'ContactUsService',
    'translationHandler',
  ];

  function CommunicationEntityDialogController(
    Notification,
    $ngConfirm,
    $uibModal,
    $state,
    readOnly,
    $timeout,
    $scope,
    $translate,
    entity,
    CommunicationEntity,
    CommunicationParameter,
    User,
    AmaSafeCredential,
    ExternalAuthKey,
    Principal,
    ContactUsService,
    translationHandler
  ) {
    var vm = this;
    vm.currentAccount = null;
    vm.communicationEntity = entity;

    // An entity page is about one company; the tab should say which.
    if (vm.communicationEntity && vm.communicationEntity.name) {
      translationHandler.setSubject(vm.communicationEntity.name, 'eDocumentsApp.communicationEntity.home.title');
    }
    vm.readOnly = readOnly;
    vm.selectOriginCommunicationType = undefined;
    vm.selectOriginCommunicationParameterType = undefined;
    vm.selectDestinationCommunicationType = undefined;
    vm.selectDestinationCommunicationParameterType = undefined;
    vm.showMissingVatRegistrationNumber = false;
    vm.selectCommunicationEntityConnectorParametersNames = undefined;
    vm.isUserAllowedToEditVATRegistrationNumber = isUserAllowedToEditVATRegistrationNumber;
    vm.isUserAllowedToEditExternalAuthKeys = isUserAllowedToEditExternalAuthKeys;
    vm.seesOwnExternalAuthKeysOnly = seesOwnExternalAuthKeysOnly;
    vm.clear = clear;
    vm.save = save;
    vm.editUser = editUser;
    vm.communicationDefinitionAuthority = communicationDefinitionAuthority;
    vm.changeOriginParameter = changeOriginParameter;
    vm.changeDestinationParameter = changeDestinationParameter;
    vm.addUser = addUser;
    vm.removeUserFromEntity = removeUserFromEntity;
    vm.contactUs = contactUs;
    vm.addCredential = addCredential;
    vm.deleteCredential = deleteCredential;
    vm.addExternalAuthKey = addExternalAuthKey;
    vm.revokeExternalAuthKey = revokeExternalAuthKey;
    vm.addOriginParameter = addOriginParameter;
    vm.addDestinationParameter = addDestinationParameter;
    vm.addcommunicationEntityConnectorParameter = addcommunicationEntityConnectorParameter;
    vm.toggleManager = toggleManager;
    vm.toggleEmailReceiver = toggleEmailReceiver;

    vm.communicationEntityConnectorParametersNames = [
      'USERNAME',
      'PASSWORD',
      'COMPANY',
      'CLIENT',
      'SECRET',
      'API_URL',
      'INSTANCE',
      'LINE',
      'NUMBEROFDAYS',
      'DOCTYPES',
      'DOCUMENTLISTAPI',
      'DOCUMENTDETAILAPI',
      'DOCUMENTPDFAPI',
      'NUMBERINGSERIES',
      'ATCERTIFICATENUMBER',
    ];
    vm.changeExternalConnector = changeExternalConnector;

    vm.findUser = findUser;
    vm.deleteCommunicationDestinationParameter = deleteCommunicationDestinationParameter;
    vm.deleteCommunicationOriginParameter = deleteCommunicationOriginParameter;
    vm.deleteCommunicationEntityConnectorParameter = deleteCommunicationEntityConnectorParameter;
    vm.goBack = goBack;

    activate();

    vm.communicationEntityConnectorType = vm.communicationEntity ? vm.communicationEntity.entityConnector : null;

    Principal.identity().then(function (account) {
      vm.currentAccount = account;
      // SUP-12293: the keys are asked for only by who may manage them (the server answers 403 to anyone else)
      if (vm.communicationEntity && vm.communicationEntity.id && isUserAllowedToEditExternalAuthKeys()) {
        getExternalAuthKeys();
      }
    });

    function activate() {
      if (!vm.communicationEntity) {
        clear();
      } else {
        vm.communicationTypes = CommunicationParameter.getCommunicationTypesForCommunicationEntity({ id: vm.communicationEntity.id });
        getEntityUsers();
        getAmaSafeCredentials();
      }
    }

    function getEntityUsers() {
      User.findByEntity({ id: vm.communicationEntity.id }).$promise.then(function (res) {
        vm.users = [];
        for (var i = 0; i < res.length; i++) {
          for (var j = 0; j < res[i].userEntities.length; j++) {
            if (res[i].userEntities[j].entityId === vm.communicationEntity.id) {
              res[i].manager = res[i].userEntities[j].manager == null ? false : res[i].userEntities[j].manager;
              res[i].emitter = res[i].userEntities[j].emitter == null ? false : res[i].userEntities[j].emitter;
              res[i].receptor = res[i].userEntities[j].receptor == null ? false : res[i].userEntities[j].receptor;
              res[i].emailReceiver = res[i].userEntities[j].emailReceiver == null ? false : res[i].userEntities[j].emailReceiver;
              res[i].hasRestrictions = res[i].userEntities[j].hasRestrictions == null ? false : res[i].userEntities[j].hasRestrictions;
              vm.users.push(res[i]);
            }
          }
        }
      });
    }

    function getAmaSafeCredentials() {
      AmaSafeCredential.findByEntity({ communicationEntityId: vm.communicationEntity.id }).$promise.then(function (res) {
        vm.amaSafeCredentials = res;
      });
    }

    function getExternalAuthKeys() {
      ExternalAuthKey.findByEntity({ communicationEntityId: vm.communicationEntity.id }).$promise.then(function (res) {
        vm.externalAuthKeys = res;
      });
    }

    function clear() {
      $state.go('communication-entity');
    }

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function isUserAllowedToEditVATRegistrationNumber() {
      if (vm.currentAccount) {
        return (
          vm.currentAccount.authorities.includes('ROLE_SUPERADMIN') ||
          vm.currentAccount.authorities.includes('ROLE_ADMIN') ||
          vm.currentAccount.authorities.includes('ROLE_PARTNER')
        );
      }
      return false;
    }

    // SUP-12293: the server's rule (APIKeyAuthorization) - SUPERADMIN, or a manager of this entity holding the archive role
    // SUP-12293: the server's rule (APIKeyAuthorization) — SUPERADMIN and a manager with the archive role deal with every
    // key; a member with the archive role and an ordinary role creates keys and deals with its own; nobody else
    function isUserAllowedToEditExternalAuthKeys() {
      if (vm.currentAccount) {
        return Principal.hasAnyAuthority(['ROLE_SUPERADMIN']) || isManagerWithArchiveRole() || seesOwnExternalAuthKeysOnly();
      }
      return false;
    }

    function isManagerWithArchiveRole() {
      return Principal.hasAnyAuthority(['ROLE_DIGITAL_ARCHIVE']) && Principal.isUserEntityManager(vm.communicationEntity.id);
    }

    function seesOwnExternalAuthKeysOnly() {
      return (
        !!vm.currentAccount &&
        !Principal.hasAnyAuthority(['ROLE_SUPERADMIN']) &&
        !isManagerWithArchiveRole() &&
        Principal.hasAnyAuthority(['ROLE_DIGITAL_ARCHIVE']) &&
        !Principal.isArchiveOnly() &&
        Principal.isUserEntityMember(vm.communicationEntity.id)
      );
    }

    function checkTimeParams(communicationEntity) {
      if (communicationEntity.originParameters) {
        communicationEntity.originParameters.forEach(function (parameter) {
          if (
            parameter.communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
            parameter.communicationParameterType === 'EXECUTION_TIME' ||
            parameter.communicationParameterType === 'SUSPENSION_START_TIME' ||
            parameter.communicationParameterType === 'SUSPENSION_END_TIME'
          ) {
            if (parameter.disableExecutionTime) {
              parameter.value = -1;
            }
          }
        });
      }
      if (communicationEntity.destinationParameters) {
        communicationEntity.destinationParameters.forEach(function (parameter) {
          if (
            parameter.communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
            parameter.communicationParameterType === 'EXECUTION_TIME' ||
            parameter.communicationParameterType === 'SUSPENSION_START_TIME' ||
            parameter.communicationParameterType === 'SUSPENSION_END_TIME'
          ) {
            if (parameter.disableExecutionTime) {
              parameter.value = -1;
            }
          }
        });
      }
    }

    function save() {
      vm.isSaving = true;
      checkTimeParams(vm.communicationEntity);
      if (vm.communicationEntity.entityConnector === 'NO_CONNECTOR') {
        vm.communicationEntity.communicationEntityConnectorParameters = [];
      }
      if (angular.isDefined(vm.communicationEntity.id) && vm.communicationEntity.id !== null) {
        CommunicationEntity.update(vm.communicationEntity, onSaveSuccess, onSaveError);
      } else {
        CommunicationEntity.save(vm.communicationEntity, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
      $scope.$emit('eDocumentsApp:communicationEntityUpdate', result);
      $state.go('communication-entity');
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function toggleManager(user) {
      User.updateUserEntity(
        {
          userId: user.id,
          entityId: vm.communicationEntity.id,
          manager: !user.manager,
          emitter: user.emitter,
          receptor: user.receptor,
          emailReceiver: user.emailReceiver,
        },
        function () {
          Notification.success({ message: $translate.instant('userManagement.message.userUpdated') });
          getEntityUsers();
        },
        function () {
          Notification.error({ message: $translate.instant('userManagement.message.errorUpdatingUser') });
        }
      );
    }

    function toggleEmailReceiver(user) {
      User.updateUserEntity(
        {
          userId: user.id,
          entityId: vm.communicationEntity.id,
          manager: user.manager,
          emitter: user.emitter,
          receptor: user.receptor,
          emailReceiver: !user.emailReceiver,
        },
        function () {
          Notification.success({ message: $translate.instant('userManagement.message.userUpdated') });
          getEntityUsers();
        },
        function () {
          Notification.error({ message: $translate.instant('userManagement.message.errorUpdatingUser') });
        }
      );
    }

    function addUser(email) {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/entities/communication-entity/communication-entity-user.modal.html',
        controller: 'CommunicationEntityUserDialogController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: function () {
            var user = new User({
              email: email,
            });
            user.activated = true;
            user.id = null;
            user.authorities = ['ROLE_USER'];
            user.langKey = 'pt-pt';
            return user;
          },
        },
      });
      modalInstance.result.then(
        function (user) {
          Notification.success({ message: $translate.instant('userManagement.message.createdUserAddedToEntity') });
          addUserToEntity(user.id);
          getEntityUsers();
        },
        function () {
          Notification.error({ message: $translate.instant('userManagement.message.errorAddingCreatedUserToEntity') });
        }
      );
    }

    function editUser(user) {
      $uibModal.open({
        templateUrl: 'app/entities/communication-entity/communication-entity-user.modal.html',
        controller: 'CommunicationEntityUserDialogController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          entity: function () {
            return user;
          },
        },
      });
    }

    function communicationDefinitionAuthority(user) {
      $uibModal
        .open({
          templateUrl: 'app/entities/communication-entity/communication-authorities-dialog.html',
          controller: 'CommunicationAuthoritiesDialogController',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            user: function () {
              return user;
            },
            entity: function () {
              return vm.communicationEntity.id;
            },
            readOnly: function () {
              return vm.readOnly;
            },
          },
        })
        .result.then(
          function () {
            getEntityUsers();
          },
          function () {
            getEntityUsers();
          }
        );
    }

    function removeUserFromEntity(user) {
      $uibModal
        .open({
          templateUrl: 'app/entities/communication-entity/communication-entity-user-delete-dialog.html',
          controller: 'CommunicationEntityUserDeleteController',
          controllerAs: 'vm',
          size: 'md',
          resolve: {
            communicationEntity: vm.communicationEntity,
            user: user,
          },
        })
        .result.then(
          function () {
            // deletion, if confirmed, is executed by the dialog
            getEntityUsers();
          },
          function () {}
        );
    }

    function addUserToEntity(id) {
      User.addEntityToUser(
        {
          userId: id,
          entityId: vm.communicationEntity.id,
          manager: false,
          emailReceiver: false,
        },
        function () {
          Notification.success({ message: $translate.instant('userManagement.message.userAddedToEntity') });
          getEntityUsers();
        },
        function () {
          Notification.error({ message: $translate.instant('userManagement.message.errorAddingUserToEntity') });
        }
      );
    }

    function findUser() {
      // noinspection JSUnusedGlobalSymbols
      $ngConfirm({
        title: $translate.instant('userManagement.creationDialog.question'),
        type: 'blue',
        animation: 'zoom',
        closeAnimation: 'scale',
        contentUrl: 'app/entities/communication-entity/user-question.html',
        buttons: {
          cancel: {
            text: $translate.instant('entity.action.cancel'),
            disabled: false,
            btnClass: 'btn-default',
            action: function () {},
          },
          search: {
            text: $translate.instant('entity.action.search'),
            disabled: true,
            btnClass: 'btn-primary',
            action: function (scope) {
              User.findByEmail({ email: scope.email }).$promise.then(
                function (res) {
                  if (res.id) {
                    if (!res.userEntities) {
                      res.userEntities = [];
                    } else {
                      for (var idx in res.userEntities) {
                        if (res.userEntities[idx].entityId === vm.communicationEntity.id) {
                          Notification.error({ message: $translate.instant('userManagement.creationDialog.userAlreadyInEntity') });
                          return;
                        }
                      }
                    }
                    addUserToEntity(res.id);
                  } else {
                    Notification.warning({
                      title: $translate.instant('userManagement.creationDialog.userNotFound'),
                      message: $translate.instant('userManagement.creationDialog.shouldCreateUser'),
                    });
                    addUser(scope.email);
                  }
                },
                function () {
                  Notification.warning({
                    title: $translate.instant('userManagement.creationDialog.userNotFound'),
                    message: $translate.instant('userManagement.creationDialog.shouldCreateUser'),
                  });
                  addUser(scope.email);
                }
              );
            },
          },
        },
        onScopeReady: function (scope) {
          // eslint-disable-next-line angular/controller-as-vm
          var self = this;
          scope.textChange = function () {
            if (scope.email) {
              self.buttons.search.setDisabled(false);
            } else {
              self.buttons.search.setDisabled(true);
            }
          };
        },
      });
    }

    function contactUs() {
      ContactUsService.open();
    }

    function addCredential() {
      if (!vm.communicationEntity || !vm.communicationEntity.vatRegistrationNumber || vm.communicationEntity.vatRegistrationNumber === '') {
        vm.showMissingVatRegistrationNumber = true;
      } else {
        if (vm.amaSafeCredentials[0] && vm.amaSafeCredentials[0].status === 'ACTIVE') {
          // if there is any active credential, it's always the first one
          $uibModal
            .open({
              templateUrl: 'app/entities/ama-safe-credential/ama-safe-credential-add-confirmation-dialog.html',
              controller: 'AmaSafeCredentialAddConfirmationDialogController',
              controllerAs: 'vm',
              size: 'md',
            })
            .result.then(
              function () {
                $state.go('ama-safe-credential-new', { communicationEntityId: vm.communicationEntity.id });
              },
              function () {}
            );
        } else {
          $state.go('ama-safe-credential-new', { communicationEntityId: vm.communicationEntity.id });
        }
      }
    }

    function deleteCredential(amaSafeCredential) {
      $uibModal
        .open({
          templateUrl: 'app/entities/ama-safe-credential/ama-safe-credential-delete-dialog.html',
          controller: 'AmaSafeCredentialDeleteController',
          controllerAs: 'vm',
          size: 'md',
          resolve: {
            amaSafeCredential: amaSafeCredential,
          },
        })
        .result.then(
          function () {
            AmaSafeCredential.delete(
              {
                id: amaSafeCredential.id,
              },
              function () {
                Notification.success({ message: $translate.instant('eDocumentsApp.amaSafeCredential.message.success.delete') });
                getAmaSafeCredentials();
              },
              function () {
                Notification.error({ message: $translate.instant('eDocumentsApp.amaSafeCredential.message.error.delete') });
                getAmaSafeCredentials();
              }
            );
          },
          function () {}
        );
    }

    function addExternalAuthKey() {
      if (vm.communicationEntity) {
        $state.go('external-auth-key-new', { communicationEntityId: vm.communicationEntity.id });
      }
    }

    function revokeExternalAuthKey(externalAuthKey) {
      $uibModal
        .open({
          templateUrl: 'app/entities/external-auth-key/external-auth-key-revoke-dialog.html',
          controller: 'ExternalAuthKeyRevokeController',
          controllerAs: 'vm',
          size: 'md',
          resolve: {
            externalAuthKey: externalAuthKey,
          },
        })
        .result.then(
          function () {
            ExternalAuthKey.revoke(
              {
                id: externalAuthKey.id,
              },
              function () {
                Notification.success({ message: $translate.instant('eDocumentsApp.externalAuthKey.message.success.revoke') });
                getExternalAuthKeys();
              },
              function () {
                Notification.error({ message: $translate.instant('eDocumentsApp.externalAuthKey.message.error.revoke') });
                getExternalAuthKeys();
              }
            );
          },
          function () {}
        );
    }

    function changeOriginParameter() {
      vm.communicationParameterTypes = vm.communicationTypes[vm.selectOriginCommunicationType];
    }

    function changeDestinationParameter() {
      vm.communicationParameterTypes = vm.communicationTypes[vm.selectDestinationCommunicationType];
    }

    function deleteCommunicationOriginParameter(communicationParameter) {
      for (var i = 0, len = vm.communicationEntity.originParameters.length; i < len; i++) {
        if (vm.communicationEntity.originParameters[i] === communicationParameter) {
          vm.communicationEntity.originParameters.splice(i, 1);
        }
      }
    }

    function deleteCommunicationDestinationParameter(communicationParameter) {
      for (var i = 0, len = vm.communicationEntity.destinationParameters.length; i < len; i++) {
        if (vm.communicationEntity.destinationParameters[i] === communicationParameter) {
          vm.communicationEntity.destinationParameters.splice(i, 1);
        }
      }
    }

    function addOriginParameter() {
      if (vm.selectOriginCommunicationType && vm.selectOriginCommunicationParameterType) {
        var communicationParameter = {
          communicationType: vm.selectOriginCommunicationType,
          communicationParameterType: vm.selectOriginCommunicationParameterType,
          value: '',
        };
        if (!isCommunicationParameterInCommunicationEntityOriginParametersArray(communicationParameter)) {
          vm.communicationEntity.originParameters.push(communicationParameter);
        }
      }
    }

    function addDestinationParameter() {
      if (vm.selectDestinationCommunicationType && vm.selectDestinationCommunicationParameterType) {
        var communicationParameter = {
          communicationType: vm.selectDestinationCommunicationType,
          communicationParameterType: vm.selectDestinationCommunicationParameterType,
          value: '',
        };
        if (!isCommunicationParameterInCommunicationEntityDestinationParametersArray(communicationParameter)) {
          vm.communicationEntity.destinationParameters.push(communicationParameter);
        }
      }
    }

    function isCommunicationParameterInCommunicationEntityOriginParametersArray(communicationParameter) {
      if (angular.isUndefined(vm.communicationEntity.originParameters)) {
        vm.communicationEntity.originParameters = [];
      }
      for (var i = 0, len = vm.communicationEntity.originParameters.length; i < len; i++) {
        if (
          vm.communicationEntity.originParameters[i].communicationType === communicationParameter.communicationType &&
          vm.communicationEntity.originParameters[i].communicationParameterType === communicationParameter.communicationParameterType
        ) {
          return true;
        }
      }
      return false;
    }

    function isCommunicationParameterInCommunicationEntityDestinationParametersArray(communicationParameter) {
      if (angular.isUndefined(vm.communicationEntity.destinationParameters)) {
        vm.communicationEntity.destinationParameters = [];
      }
      for (var i = 0, len = vm.communicationEntity.destinationParameters.length; i < len; i++) {
        if (
          vm.communicationEntity.destinationParameters[i].communicationType === communicationParameter.communicationType &&
          vm.communicationEntity.destinationParameters[i].communicationParameterType === communicationParameter.communicationParameterType
        ) {
          return true;
        }
      }
      return false;
    }

    function addcommunicationEntityConnectorParameter() {
      if (vm.communicationEntityConnectorType && vm.selectCommunicationEntityConnectorParametersNames) {
        var communicationEntityConnectorParameter = {
          parameterName: vm.selectCommunicationEntityConnectorParametersNames,
          parameterValue: '',
          comminicationEntityId: vm.communicationEntity.id,
        };
        if (!isConnectorParameterInCommunicationEntityConnectorParametersArray(communicationEntityConnectorParameter)) {
          vm.communicationEntity.communicationEntityConnectorParameters.push(communicationEntityConnectorParameter);
        }
      }
    }

    function isConnectorParameterInCommunicationEntityConnectorParametersArray(communicationEntityConnectorParameter) {
      if (angular.isUndefined(vm.communicationEntity.communicationEntityConnectorParameters)) {
        vm.communicationEntity.communicationEntityConnectorParameters = [];
      }
      for (var i = 0, len = vm.communicationEntity.communicationEntityConnectorParameters.length; i < len; i++) {
        if (
          vm.communicationEntity.communicationEntityConnectorParameters[i].parameterName === communicationEntityConnectorParameter.parameterName &&
          vm.communicationEntity.communicationEntityConnectorParameters[i].comminicationEntityId === communicationEntityConnectorParameter.comminicationEntityId
        ) {
          return true;
        }
      }
      return false;
    }

    function deleteCommunicationEntityConnectorParameter(communicationEntityConnectorParameters) {
      for (var i = 0, len = vm.communicationEntity.communicationEntityConnectorParameters.length; i < len; i++) {
        if (vm.communicationEntity.communicationEntityConnectorParameters[i] === communicationEntityConnectorParameters) {
          vm.communicationEntity.communicationEntityConnectorParameters.splice(i, 1);
        }
      }
    }

    function changeExternalConnector() {
      vm.communicationEntityConnectorType = event.target.value;
    }

    function goBack() {
      window.history.back();
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationEntityDeleteController',CommunicationEntityDeleteController);

    CommunicationEntityDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationEntity', 'Notification'];

    function CommunicationEntityDeleteController($uibModalInstance, entity, CommunicationEntity, Notification) {
        var vm = this;

        vm.communicationEntity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationEntity.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                },
                function (error) {
                    Notification.error({ message: error.data.detail });
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').config(stateConfig);

  stateConfig.$inject = ['$stateProvider'];

  function stateConfig($stateProvider) {
    $stateProvider
      .state('communication-entity', {
        parent: 'entity',
        url: '/communication-entity?page&sort&search',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
          pageTitle: 'eDocumentsApp.communicationEntity.home.title',
        },
        views: {
          'content@': {
            templateUrl: 'app/entities/communication-entity/communication-entities.html',
            controller: 'CommunicationEntityController',
            controllerAs: 'vm',
          },
        },
        params: {
          page: {
            value: '1',
            squash: true,
          },
          sort: {
            value: 'id,asc',
            squash: true,
          },
          search: null,
        },
        resolve: {
          pagingParams: [
            '$stateParams',
            'PaginationUtil',
            function ($stateParams, PaginationUtil) {
              return {
                page: PaginationUtil.parsePage($stateParams.page),
                sort: $stateParams.sort,
                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                ascending: PaginationUtil.parseAscending($stateParams.sort),
                search: $stateParams.search,
              };
            },
          ],
          translatePartialLoader: [
            '$translate',
            '$translatePartialLoader',
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart('communicationEntity');
              $translatePartialLoader.addPart('communicationType');
              $translatePartialLoader.addPart('communicationParameterType');
              $translatePartialLoader.addPart('communicationWorkflowStep');
              $translatePartialLoader.addPart('user-management');
              $translatePartialLoader.addPart('communicationDefinitionAuthority');
              $translatePartialLoader.addPart('amaSafeCredential');
              $translatePartialLoader.addPart('amaSafeCredentialStatus');
              $translatePartialLoader.addPart('amaSafeCredentialReason');
              $translatePartialLoader.addPart('externalAuthKey');
              $translatePartialLoader.addPart('externalAuthKeyStatus');
              $translatePartialLoader.addPart('communicationEntityConnectorParametersNames');
              $translatePartialLoader.addPart('global');
              return $translate.refresh();
            },
          ],
        },
      })
      .state('communication-entity-detail', {
        parent: 'communication-entity',
        url: '/communication-entity',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
          pageTitle: 'eDocumentsApp.communicationEntity.detail.title',
        },
        views: {
          'content@': {
            templateUrl: 'app/entities/communication-entity/communication-entity-dialog.html',
            controller: 'CommunicationEntityDialogController',
            controllerAs: 'vm',
          },
        },
        params: {
          id: null,
        },
        resolve: {
          translatePartialLoader: [
            '$translate',
            '$translatePartialLoader',
            function ($translate, $translatePartialLoader) {
              $translatePartialLoader.addPart('communicationEntity');
              return $translate.refresh();
            },
          ],
          entity: [
            '$stateParams',
            'CommunicationEntity',
            function ($stateParams, CommunicationEntity) {
              if ($stateParams.id !== null) {
                return CommunicationEntity.get({ id: $stateParams.id }).$promise;
              }
              return null;
            },
          ],
          readOnly: function () {
            return true;
          },
          previousState: [
            '$state',
            function ($state) {
              return {
                name: $state.current.name || 'communication-entity',
                params: $state.params,
                url: $state.href($state.current.name, $state.params),
              };
            },
          ],
        },
      })
      .state('communication-entity-detail.edit', {
        parent: 'communication-entity-detail',
        url: '/detail/edit',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
        },
        views: {
          'content@': {
            templateUrl: 'app/entities/communication-entity/communication-entity-dialog.html',
            controller: 'CommunicationEntityDialogController',
            controllerAs: 'vm',
          },
        },
        resolve: {
          entity: [
            '$stateParams',
            'CommunicationEntity',
            function ($stateParams, CommunicationEntity) {
              return CommunicationEntity.get({ id: $stateParams.id }).$promise;
            },
          ],
          readOnly: function () {
            return false;
          },
          previousState: [
            '$state',
            function ($state) {
              return {
                name: $state.current.name || 'communication-entity',
                params: $state.params,
                url: $state.href($state.current.name, $state.params),
              };
            },
          ],
        },
      })
      .state('communication-entity.new', {
        parent: 'communication-entity',
        url: '/new',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
        },

        views: {
          'content@': {
            templateUrl: 'app/entities/communication-entity/communication-entity-dialog.html',
            controller: 'CommunicationEntityDialogController',
            controllerAs: 'vm',
          },
        },
        resolve: {
          entity: [
            'CommunicationEntity',
            function (CommunicationEntity) {
              return new CommunicationEntity({
                entityConnector: 'NO_CONNECTOR',
              });
            },
          ],
          readOnly: function () {
            return false;
          },
          previousState: [
            '$state',
            function ($state) {
              return {
                name: $state.current.name || 'communication-entity',
                params: $state.params,
                url: $state.href($state.current.name, $state.params),
              };
            },
          ],
        },
      })
      .state('communication-entity.edit', {
        parent: 'communication-entity',
        url: '/edit',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
        },
        views: {
          'content@': {
            templateUrl: 'app/entities/communication-entity/communication-entity-dialog.html',
            controller: 'CommunicationEntityDialogController',
            controllerAs: 'vm',
          },
        },
        params: {
          id: null,
        },
        resolve: {
          entity: [
            '$stateParams',
            'CommunicationEntity',
            function ($stateParams, CommunicationEntity) {
              if ($stateParams.id !== null) {
                return CommunicationEntity.get({ id: $stateParams.id }).$promise;
              }
              return null;
            },
          ],
          readOnly: function () {
            return false;
          },
          previousState: [
            '$state',
            function ($state) {
              return {
                name: $state.current.name || 'communication-entity',
                params: $state.params,
                url: $state.href($state.current.name, $state.params),
              };
            },
          ],
        },
      })
      .state('communication-entity.delete', {
        parent: 'communication-entity',
        url: '/{id}/delete',
        data: {
          authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
        },
        onEnter: [
          '$stateParams',
          '$state',
          '$uibModal',
          function ($stateParams, $state, $uibModal) {
            $uibModal
              .open({
                templateUrl: 'app/entities/communication-entity/communication-entity-delete-dialog.html',
                controller: 'CommunicationEntityDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                  entity: [
                    'CommunicationEntity',
                    function (CommunicationEntity) {
                      return CommunicationEntity.get({ id: $stateParams.id }).$promise;
                    },
                  ],
                },
              })
              .result.then(
                function () {
                  $state.go('communication-entity', null, { reload: 'communication-entity' });
                },
                function () {
                  $state.go('^');
                }
              );
          },
        ],
      });
  }
})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('CommunicationEntity', CommunicationEntity);

    CommunicationEntity.$inject = ['$resource', 'DateUtils'];

    function CommunicationEntity($resource, DateUtils) {
        var resourceUrl = 'api/communication-entities/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET', isArray: true
            }, 'queryAll': {
                url: 'api/communication-entities-all/', method: 'GET', isArray: true
            }, 'queryForSelect': {
                url: 'api/communication-entities-for-select/', method: 'GET', isArray: true
            }, 'findAllByUser': {
                url: 'api/communication-entities-by-user/', method: 'GET', isArray: true
            }, 'searchByName': {
                url: 'api/communication-entities-by-name/', method: 'GET', isArray: true
            }, 'findByGln': {
                url: 'api/communication-entities/gln/', method: 'GET', isArray: false
            }, 'get': {
                method: 'GET', transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.originParameters) {
                            for (var i = 0; i < data.originParameters.length; i++) {
                                if (data.originParameters[i].communicationParameterType === 'EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'EMAIL_EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_START_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_END_TIME') {
                                    if (data.originParameters[i].value !== -1 && data.originParameters[i].value !== '-1') {
                                        data.originParameters[i].value = DateUtils.convertStringToTime(data.originParameters[i].value);
                                    } else {
                                        data.originParameters[i].value = undefined;
                                        data.originParameters[i].disableExecutionTime = true;
                                    }
                                }
                            }
                        }
                        if (data.destinationParameters) {
                            for (var j = 0; j < data.destinationParameters.length; j++) {
                                if (data.destinationParameters[j].communicationParameterType === 'EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'EMAIL_EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_START_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_END_TIME') {
                                    if (data.destinationParameters[j].value !== -1 && data.destinationParameters[j].value !== '-1') {
                                        data.destinationParameters[j].value = DateUtils.convertStringToTime(data.destinationParameters[j].value);
                                    } else {
                                        data.destinationParameters[j].value = undefined;
                                        data.destinationParameters[j].disableExecutionTime = true;
                                    }
                                }
                            }
                        }
                    }
                    return data;
                }
            }, 'update': {
                method: 'PUT', transformRequest: function(data) {
                    if (data && data.originParameters) {
                        for (var i = 0; i < data.originParameters.length; i++) {
                            if (data.originParameters[i].communicationParameterType === 'EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'EMAIL_EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_START_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_END_TIME') {
                                if (data.originParameters[i].value !== -1) {
                                    data.originParameters[i].value = DateUtils.convertTimeToString(data.originParameters[i].value);
                                }
                            }
                        }
                    }
                    if (data && data.destinationParameters) {
                        for (var j = 0; j < data.destinationParameters.length; j++) {
                            if (data.destinationParameters[j].communicationParameterType === 'EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'EMAIL_EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_START_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_END_TIME') {
                                if (data.destinationParameters[j].value !== -1) {
                                    data.destinationParameters[j].value = DateUtils.convertTimeToString(data.destinationParameters[j].value);
                                }
                            }
                        }
                    }
                    return angular.toJson(data);
                }
            }, 'omniboxSearch': {
                method: 'GET', isArray: true, url: 'api/communication-entities/omniboxSearch'
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('CommunicationEntityController', CommunicationEntityController);

    CommunicationEntityController.$inject = [
        'Principal',
        '$state',
        'CommunicationEntity',
        'ParseLinks',
        'AlertService',
        'paginationConstants',
        'pagingParams',
        'PaginationUtil'
    ];

    function CommunicationEntityController(
        Principal,
        $state,
        CommunicationEntity,
        ParseLinks,
        AlertService,
        paginationConstants,
        pagingParams,
        PaginationUtil
    ) {
        var vm = this;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.reset = reset;
        vm.loadAll = loadAll;

        vm.totalItems = 1000;

        vm.changeActive = changeActive;
        vm.isSearchActive = isSearchActive;

        function loadAll() {
            vm.filters = PaginationUtil.updateFilters($state.current.name, vm.page - 1, vm.filters.filterBy, vm.predicate, vm.reverse, vm.itemsPerPage);
            Principal.identity().then(function(account) {
                vm.account = account;
                CommunicationEntity.query(
                    {
                        page: vm.filters.currentPage,
                        size: vm.filters.itemsPerPage,
                        search: search(),
                        sort: sort()
                    },
                    onSuccess,
                    onError
                );
            });

            function sort() {
                if (!vm.predicate) {
                    vm.predicate = 'id';
                }
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                angular.forEach(data, function(item) {
                    if (
                        vm.account.authorities.indexOf('ROLE_SUPERADMIN') !== -1 ||
                        vm.account.authorities.indexOf('ROLE_ADMIN') !== -1 ||
                        vm.account.authorities.indexOf('ROLE_PARTNER') !== -1
                    ) {
                        item.manager = true;
                    } else {
                        for (var i = 0; i < item.userEntities.length; i++) {
                            if (item.userEntities[i].entityId === item.id && vm.account.id === item.userEntities[i].userId) {
                                item.manager = item.userEntities[i].manager;
                                break;
                            } else {
                                item.manager = false;
                            }
                        }
                    }
                });
                vm.communicationEntities = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function search() {
            var result = '';
            for (var x in vm.filters.filterBy) {
                if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
                    result += vm.filters.filterBy[x].name + ':' + vm.filters.filterBy[x].value + '#AND,';
                }
            }
            return result;
        }

        function changeActive(value) {
            vm.filters.filterBy.active.value = value;
            vm.page = 1;
            loadAll();
        }

        function isSearchActive() {
            return (
                vm.filters.filterBy.name.value ||
                angular.isDefined(vm.filters.filterBy.active.value) ||
                vm.filters.filterBy.vatRegistrationNumber.value ||
                vm.filters.filterBy.gln.value ||
                vm.filters.filterBy.email.value
            );
        }

        function reset() {
            vm.filters = PaginationUtil.clearFilters($state.current.name, filterBy());
            loadAll();
        }

        function initFilters() {
            vm.filters = PaginationUtil.getFilters($state.current.name, filterBy());

            vm.page = vm.filters.currentPage + 1;
            vm.predicate = vm.filters.orderBy;
            vm.reverse = vm.filters.orderReverse;
            loadAll();
        }

        initFilters();

        function filterBy() {
            return {
                name: {
                    name: 'name',
                    value: undefined
                },
                active: {
                    name: 'active',
                    value: undefined
                },
                vatRegistrationNumber: {
                    name: 'vatRegistrationNumber',
                    value: undefined
                },
                gln: {
                    name: 'gln',
                    value: undefined
                },
                email: {
                    name: 'email',
                    value: undefined
                }
            };
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('CommunicationAuthoritiesDialogController', CommunicationAuthoritiesDialogController);

  CommunicationAuthoritiesDialogController.$inject = [
    '$scope',
    '$uibModalInstance',
    'user',
    'entity',
    'readOnly',
    'CommunicationDefinitionAuthority',
    'CommunicationDefinition',
    'Notification',
    'User',
  ];

  function CommunicationAuthoritiesDialogController(
    $scope,
    $uibModalInstance,
    user,
    entity,
    readOnly,
    CommunicationDefinitionAuthority,
    CommunicationDefinition,
    Notification,
    User
  ) {
    var vm = this;

    vm.readOnly = readOnly;

    vm.entity = entity;
    vm.user = user;

    vm.communicationDefinitionAuthority = {
      userEntity: {
        entityId: vm.entity,
        userId: vm.user.id,
      },
      communicationDefinitionId: null,
    };

    vm.clear = clear;
    vm.save = save;
    vm.userentities = [];
    vm.communicationdefinitions = [];

    vm.loadAll = loadAll;
    vm.deleteCommunicationDefinitionAuthority = deleteCommunicationDefinitionAuthority;
    vm.toggleEmitter = toggleEmitter;
    vm.toggleReceptor = toggleReceptor;

    loadAll();

    function loadAll() {
      CommunicationDefinitionAuthority.queryByUserAndEntity(
        {
          userId: vm.user.id,
          entityId: vm.entity,
        },
        function (result) {
          vm.communicationDefinitionAuthorities = result;
        }
      );
    }

    $scope.refreshSelectModel = function (query) {
      if (vm.lastQuery !== query) {
        vm.lastQuery = query;

        var searchObj = buildSearch(query);

        CommunicationDefinition.searchList({ search: searchObj }, function (result) {
          if (result.length > 50) {
            Notification.warning({
              message: 'O número de resultados é superior a 50 registos. Por questões de performance, refine a sua pesquisa', // TODO translate
              delay: 5000,
            });
          } else {
            vm.communicationdefinitions = result;
          }
        });
      }
    };

    function buildSearch(query) {
      var result = '';

      result += 'origin.id' + ':' + vm.entity + '#OR,';
      result += 'destination.id' + ':' + vm.entity + '#AND,';
      result += 'description' + ':' + query + '#AND,';

      return result;
    }

    function clear() {
      $uibModalInstance.dismiss('cancel');
    }

    function save() {
      vm.isSaving = true;
      CommunicationDefinitionAuthority.save(vm.communicationDefinitionAuthority, onSaveSuccess, onSaveError);
    }

    function onSaveSuccess(result) {
      $scope.$emit('eDocumentsApp:communicationDefinitionAuthorityUpdate', result);
      loadAll();
      Notification.success({ message: 'Registo adicionado com sucesso', delay: 5000 }); // TODO translate
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function deleteCommunicationDefinitionAuthority(id) {
      CommunicationDefinitionAuthority.delete({ id: id }, function () {
        loadAll();
        Notification.success({ message: 'Registo apagado com sucesso', delay: 5000 }); // TODO translate
      });
    }

    function toggleEmitter(emitter) {
      User.updateUserEntity(
        {
          userId: vm.user.id,
          entityId: vm.entity,
          manager: vm.user.manager,
          emitter: !emitter,
          receptor: vm.user.receptor,
          emailReceiver: vm.user.emailReceiver,
        },
        function () {
          Notification.success({ message: 'Utilizador atualizado!' }); // TODO translate
          vm.user.emitter = !emitter;
        },
        function () {
          Notification.error({ message: 'Ocorreu um erro ao atualizar o utilizador!' }); // TODO translate
        }
      );
    }

    function toggleReceptor(receptor) {
      User.updateUserEntity(
        {
          userId: vm.user.id,
          entityId: vm.entity,
          manager: vm.user.manager,
          emitter: vm.user.emitter,
          receptor: !receptor,
          emailReceiver: vm.user.emailReceiver,
        },
        function () {
          Notification.success({ message: 'Utilizador atualizado!' }); // TODO translate
          vm.user.receptor = !receptor;
        },
        function () {
          Notification.error({ message: 'Ocorreu um erro ao atualizar o utilizador!' }); // TODO translate
        }
      );
    }
  }
})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('CommunicationDefinitionAuthority', CommunicationDefinitionAuthority);

    CommunicationDefinitionAuthority.$inject = ['$resource'];

    function CommunicationDefinitionAuthority ($resource) {
        var resourceUrl =  'api/communication-definition-authorities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByUserAndEntity': { method: 'GET', isArray: true, url: 'api/communication-definition-authorities/:userId/:entityId'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('CommunicationDefinitionDialogController', CommunicationDefinitionDialogController);

  CommunicationDefinitionDialogController.$inject = [
    '$translate',
    '$state',
    'readOnly',
    '$timeout',
    '$scope',
    '$uibModal',
    '$log',
    'entity',
    'CommunicationDefinition',
    'CommunicationEntity',
    'CommunicationParameter',
    'Notification',
    'translationHandler',
  ];

  function CommunicationDefinitionDialogController(
    $translate,
    $state,
    readOnly,
    $timeout,
    $scope,
    $uibModal,
    $log,
    entity,
    CommunicationDefinition,
    CommunicationEntity,
    CommunicationParameter,
    Notification,
    translationHandler
  ) {
    var vm = this;
    vm.communicationDefinition = entity;
    if (vm.communicationDefinition && vm.communicationDefinition.description) {
      translationHandler.setSubject(vm.communicationDefinition.description, 'eDocumentsApp.communicationDefinition.home.title');
    }
    vm.readOnly = readOnly;
    vm.selectOriginCommunicationType = undefined;
    vm.selectOriginCommunicationParameterType = undefined;
    vm.selectDestinationCommunicationType = undefined;
    vm.selectDestinationCommunicationParameterType = undefined;
    vm.clear = clear;
    vm.save = save;
    vm.addOriginParameter = addOriginParameter;
    vm.addDestinationParameter = addDestinationParameter;
    vm.deleteCommunicationDestinationParameter = deleteCommunicationDestinationParameter;
    vm.deleteCommunicationOriginParameter = deleteCommunicationOriginParameter;
    vm.changeOriginParameter = changeOriginParameter;
    vm.changeDestinationParameter = changeDestinationParameter;
    vm.viewEntitiesParameters = viewEntitiesParameters;
    vm.communicationTypes = CommunicationParameter.getCommunicationTypes();

    activate();

    function activate() {
      if (!vm.communicationDefinition) {
        clear();
      } else {
        vm.communicationentitiesForOrigin = [
          {
            id: vm.communicationDefinition.originId,
            name: vm.communicationDefinition.originName,
          },
        ];

        vm.communicationentitiesForDestination = [
          {
            id: vm.communicationDefinition.destinationId,
            name: vm.communicationDefinition.destinationName,
          },
        ];
      }
    }

    $timeout(function () {
      angular.element('.form-group:eq(1)>input').focus();
    });

    function clear() {
      $state.go('communication-definition');
    }

    function checkTimeParams(communicationDefinition) {
      if (communicationDefinition.originParameters) {
        communicationDefinition.originParameters.forEach(function (parameter) {
          if (
            parameter.communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
            parameter.communicationParameterType === 'EXECUTION_TIME' ||
            parameter.communicationParameterType === 'SUSPENSION_START_TIME' ||
            parameter.communicationParameterType === 'SUSPENSION_END_TIME'
          ) {
            if (parameter.disableExecutionTime) {
              parameter.value = -1;
            }
          }
        });
      }
      if (communicationDefinition.destinationParameters) {
        communicationDefinition.destinationParameters.forEach(function (parameter) {
          if (
            parameter.communicationParameterType === 'EMAIL_EXECUTION_TIME' ||
            parameter.communicationParameterType === 'EXECUTION_TIME' ||
            parameter.communicationParameterType === 'SUSPENSION_START_TIME' ||
            parameter.communicationParameterType === 'SUSPENSION_END_TIME'
          ) {
            if (parameter.disableExecutionTime) {
              parameter.value = -1;
            }
          }
        });
      }
    }

    function save() {
      vm.isSaving = true;
      checkTimeParams(vm.communicationDefinition);
      if (angular.isDefined(vm.communicationDefinition.id) && vm.communicationDefinition.id !== null) {
        CommunicationDefinition.update(vm.communicationDefinition, onSaveSuccess, onSaveError);
      } else {
        CommunicationDefinition.save(vm.communicationDefinition, onSaveSuccess, onSaveError);
      }
    }

    function onSaveSuccess(result) {
      if (!result.body) {
        Notification.error({ message: $translate.instant('eDocumentsApp.communicationDefinition.errors.communicationDefinitionBetweenEntitiesAlreadyExists') });
      }
      $scope.$emit('eDocumentsApp:communicationDefinitionUpdate', result);
      $state.go('communication-definition');
      vm.isSaving = false;
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function changeOriginParameter() {
      vm.communicationParameterTypes = vm.communicationTypes[vm.selectOriginCommunicationType];
    }

    function changeDestinationParameter() {
      vm.communicationParameterTypes = vm.communicationTypes[vm.selectDestinationCommunicationType];
    }

    function deleteCommunicationOriginParameter(communicationParameter) {
      for (var i = 0, len = vm.communicationDefinition.originParameters.length; i < len; i++) {
        if (vm.communicationDefinition.originParameters[i] === communicationParameter) {
          vm.communicationDefinition.originParameters.splice(i, 1);
        }
      }
    }

    function deleteCommunicationDestinationParameter(communicationParameter) {
      for (var i = 0, len = vm.communicationDefinition.destinationParameters.length; i < len; i++) {
        if (vm.communicationDefinition.destinationParameters[i] === communicationParameter) {
          vm.communicationDefinition.destinationParameters.splice(i, 1);
        }
      }
    }

    function addOriginParameter() {
      if (vm.selectOriginCommunicationType && vm.selectOriginCommunicationParameterType) {
        var communicationParameter = {
          communicationType: vm.selectOriginCommunicationType,
          communicationParameterType: vm.selectOriginCommunicationParameterType,
          value: '',
        };
        if (!isCommunicationParameterInCommunicationEntityOriginParametersArray(communicationParameter)) {
          vm.communicationDefinition.originParameters.push(communicationParameter);
        }
      }
    }

    function addDestinationParameter() {
      if (vm.selectDestinationCommunicationType && vm.selectDestinationCommunicationParameterType) {
        var communicationParameter = {
          communicationType: vm.selectDestinationCommunicationType,
          communicationParameterType: vm.selectDestinationCommunicationParameterType,
          value: '',
        };
        if (!isCommunicationParameterInCommunicationEntityDestinationParametersArray(communicationParameter)) {
          vm.communicationDefinition.destinationParameters.push(communicationParameter);
        }
      }
    }

    function isCommunicationParameterInCommunicationEntityOriginParametersArray(communicationParameter) {
      if (angular.isUndefined(vm.communicationDefinition.originParameters)) {
        vm.communicationDefinition.originParameters = [];
      }
      for (var i = 0, len = vm.communicationDefinition.originParameters.length; i < len; i++) {
        if (
          vm.communicationDefinition.originParameters[i].communicationType === communicationParameter.communicationType &&
          vm.communicationDefinition.originParameters[i].communicationParameterType === communicationParameter.communicationParameterType
        ) {
          return true;
        }
      }
      return false;
    }

    function isCommunicationParameterInCommunicationEntityDestinationParametersArray(communicationParameter) {
      if (angular.isUndefined(vm.communicationDefinition.destinationParameters)) {
        vm.communicationDefinition.destinationParameters = [];
      }
      for (var i = 0, len = vm.communicationDefinition.destinationParameters.length; i < len; i++) {
        if (
          vm.communicationDefinition.destinationParameters[i].communicationType === communicationParameter.communicationType &&
          vm.communicationDefinition.destinationParameters[i].communicationParameterType === communicationParameter.communicationParameterType
        ) {
          return true;
        }
      }
      return false;
    }

    $scope.refreshSelectModelForOrigin = function (query) {
      if (vm.lastQuery !== query) {
        vm.lastQuery = query;
        CommunicationEntity.queryForSelect({ search: query }, onSearchOriginSuccess, onSearchOriginError);
      }
    };

    function onSearchOriginSuccess(result) {
      if (result.length > 50) {
        Notification.warning({
          message: 'O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa', // TODO translate
          delay: 5000,
        });
      } else {
        vm.communicationentitiesForOrigin = result;
      }
    }

    function onSearchOriginError(e) {
      $log.error(e);
    }

    $scope.refreshSelectModelForDestination = function (query) {
      if (vm.lastQuery !== query) {
        vm.lastQuery = query;
        CommunicationEntity.queryForSelect({ search: query }, onSearchDestinationSuccess, onSearchDestinationError);
      }
    };

    function onSearchDestinationSuccess(result) {
      if (result.length > 50) {
        Notification.warning({
          message: 'O número de resultados é superior a 500 registos. Por questões de performance, refine a sua pesquisa', // TODO translate
          delay: 5000,
        });
      } else {
        vm.communicationentitiesForDestination = result;
      }
    }

    function onSearchDestinationError(e) {
      $log.error(e);
    }

    function viewEntitiesParameters() {
      $uibModal.open({
        templateUrl: 'app/entities/communication-parameter/view-parameters-details-dialog.html',
        controller: 'ViewParametersDetailsDialogController',
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          communicationEntityOrigin: CommunicationEntity.get({ id: vm.communicationDefinition.originId }).$promise,
          communicationEntityDestination: CommunicationEntity.get({ id: vm.communicationDefinition.destinationId }).$promise,
          communicationDefinition: undefined,
        },
      });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationDefinitionDeleteController',CommunicationDefinitionDeleteController);

    CommunicationDefinitionDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationDefinition'];

    function CommunicationDefinitionDeleteController($uibModalInstance, entity, CommunicationDefinition) {
        var vm = this;

        vm.communicationDefinition = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationDefinition.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication-definition', {
                parent: 'app',
                url: '/communication-definition?page&sort&search',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                    pageTitle: 'eDocumentsApp.communicationDefinition.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definitions.html',
                        controller: 'CommunicationDefinitionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: [
                        '$stateParams',
                        'PaginationUtil',
                        function($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                search: $stateParams.search
                            };
                        }
                    ],
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationDefinition');
                            $translatePartialLoader.addPart('communicationType');
                            $translatePartialLoader.addPart('communicationParameterType');
                            $translatePartialLoader.addPart('communicationParameter');
                            $translatePartialLoader.addPart('communicationWorkflowStep');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('communication-definition-detail', {
                parent: 'communication-definition',
                url: '/communication-definition',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                    pageTitle: 'eDocumentsApp.communicationDefinition.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definition-dialog.html',
                        controller: 'CommunicationDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: null
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationDefinition');
                            return $translate.refresh();
                        }
                    ],
                    entity: [
                        '$stateParams',
                        'CommunicationDefinition',
                        function($stateParams, CommunicationDefinition) {
                            if ($stateParams.id !== null) {
                                return CommunicationDefinition.get({ id: $stateParams.id }).$promise;
                            }
                            return null;
                        }
                    ],
                    readOnly: function() {
                        return true;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-definition-detail.edit', {
                parent: 'communication-definition-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definition-dialog.html',
                        controller: 'CommunicationDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationDefinition',
                        function($stateParams, CommunicationDefinition) {
                            return CommunicationDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-definition.new', {
                parent: 'communication-definition',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definition-dialog.html',
                        controller: 'CommunicationDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        'CommunicationDefinition',
                        function(CommunicationDefinition) {
                            return new CommunicationDefinition();
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-definition.edit', {
                parent: 'communication-definition',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-definition/communication-definition-dialog.html',
                        controller: 'CommunicationDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationDefinition',
                        function($stateParams, CommunicationDefinition) {
                            return CommunicationDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-definition.delete', {
                parent: 'communication-definition',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER']
                },
                onEnter: [
                    '$stateParams',
                    '$state',
                    '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'app/entities/communication-definition/communication-definition-delete-dialog.html',
                                controller: 'CommunicationDefinitionDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: [
                                        'CommunicationDefinition',
                                        function(CommunicationDefinition) {
                                            return CommunicationDefinition.get({ id: $stateParams.id }).$promise;
                                        }
                                    ]
                                }
                            })
                            .result.then(
                            function() {
                                $state.go('communication-definition', null, { reload: 'communication-definition' });
                            },
                            function() {
                                $state.go('^');
                            }
                        );
                    }
                ]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('CommunicationDefinition', CommunicationDefinition);

    CommunicationDefinition.$inject = ['$resource', 'DateUtils'];

    function CommunicationDefinition($resource, DateUtils) {
        var resourceUrl = 'api/communication-definitions/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET', isArray: true
            },
            'searchList': {
                method: 'GET',
                isArray: true,
                url: 'api/communication-definitions/list'
            }, 'get': {
                method: 'GET', transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.originParameters) {
                            for (var i = 0; i < data.originParameters.length; i++) {
                                if (data.originParameters[i].communicationParameterType === 'EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'EMAIL_EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_START_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_END_TIME') {
                                    if (data.originParameters[i].value !== -1 && data.originParameters[i].value !== '-1') {
                                        data.originParameters[i].value = DateUtils.convertStringToTime(data.originParameters[i].value);
                                    } else {
                                        data.originParameters[i].value = undefined;
                                        data.originParameters[i].disableExecutionTime = true;
                                    }
                                }
                            }
                        }
                        if (data.destinationParameters) {
                            for (var j = 0; j < data.destinationParameters.length; j++) {
                                if (data.destinationParameters[j].communicationParameterType === 'EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'EMAIL_EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_START_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_END_TIME') {
                                    if (data.destinationParameters[j].value !== -1 && data.destinationParameters[j].value !== '-1') {
                                        data.destinationParameters[j].value = DateUtils.convertStringToTime(data.destinationParameters[j].value);
                                    } else {
                                        data.destinationParameters[j].value = undefined;
                                        data.destinationParameters[j].disableExecutionTime = true;
                                    }
                                }
                            }
                        }
                    }
                    return data;
                }
            }, 'copy': {
                method: 'GET', isArray: false, url: 'api/communication-definition-copy/:id'
            }, 'update': {
                method: 'PUT', responseType: 'text', transformRequest: function(data) {
                    if (data && data.originParameters) {
                        for (var i = 0; i < data.originParameters.length; i++) {
                            if (data.originParameters[i].communicationParameterType === 'EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'EMAIL_EXECUTION_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_START_TIME' || data.originParameters[i].communicationParameterType === 'SUSPENSION_END_TIME') {
                                if (data.originParameters[i].value !== -1) {
                                    data.originParameters[i].value = DateUtils.convertTimeToString(data.originParameters[i].value);
                                }
                            }
                        }
                    }
                    if (data && data.destinationParameters) {
                        for (var j = 0; j < data.destinationParameters.length; j++) {
                            if (data.destinationParameters[j].communicationParameterType === 'EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'EMAIL_EXECUTION_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_START_TIME' || data.destinationParameters[j].communicationParameterType === 'SUSPENSION_END_TIME') {
                                if (data.destinationParameters[j].value !== -1) {
                                    data.destinationParameters[j].value = DateUtils.convertTimeToString(data.destinationParameters[j].value);
                                }
                            }
                        }
                    }
                    return angular.toJson(data);
                }, transformResponse: function(data) {
                    var flag = data === 'true';
                    return { body: flag };
                }
            }, 'save': {
                method: 'POST', responseType: 'text', transformResponse: function(data) {
                    var flag = data === 'true';
                    return { body: flag };
                }
            }
        });
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('CommunicationDefinitionController', CommunicationDefinitionController);

  CommunicationDefinitionController.$inject = [
    '$state',
    'CommunicationDefinition',
    'ParseLinks',
    'AlertService',
    'paginationConstants',
    'pagingParams',
    'Notification',
    'PaginationUtil',
  ];

  function CommunicationDefinitionController(
    $state,
    CommunicationDefinition,
    ParseLinks,
    AlertService,
    paginationConstants,
    pagingParams,
    Notification,
    PaginationUtil
  ) {
    var vm = this;
    vm.predicate = pagingParams.predicate;
    vm.reverse = pagingParams.ascending;
    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.search = search;
    vm.copy = copy;
    vm.loadAll = loadAll;

    vm.totalItems = 1000;

    vm.reset = reset;
    vm.isSearchActive = isSearchActive;
    vm.changeActive = changeActive;
    vm.changeDefaultForOrigin = changeDefaultForOrigin;
    vm.changeDefaultForDestination = changeDefaultForDestination;

    function loadAll() {
      vm.filters = PaginationUtil.updateFilters($state.current.name, vm.page - 1, vm.filters.filterBy, vm.predicate, vm.reverse, vm.itemsPerPage);

      CommunicationDefinition.query(
        {
          page: vm.filters.currentPage,
          size: vm.filters.itemsPerPage,
          search: search(),
          sort: sort(),
        },
        onSuccess,
        onError
      );

      function sort() {
        if (!vm.predicate) {
          vm.predicate = 'id';
        }
        var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        if (vm.predicate !== 'id') {
          result.push('id');
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers('link'));
        vm.totalItems = headers('X-Total-Count');
        vm.queryCount = vm.totalItems;
        vm.communicationDefinitions = data;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function copy(definition) {
      CommunicationDefinition.copy({ id: definition.id }).$promise.then(
        function () {
          Notification.success({ message: 'Copiado com sucesso' }); // TODO translate
          loadAll();
        },
        function () {
          Notification.error({ message: 'Ocorreu um erro ao copiar a definição' }); // TODO translate
        }
      );
    }

    function search() {
      var result = '';
      for (var x in vm.filters.filterBy) {
        if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
          result += vm.filters.filterBy[x].name + ':' + vm.filters.filterBy[x].value + '#AND,';
        }
      }
      return result;
    }

    function isSearchActive() {
      return (
        vm.filters.filterBy.description.value ||
        angular.isDefined(vm.filters.filterBy.active.value) ||
        angular.isDefined(vm.filters.filterBy.defaultForOrigin.value) ||
        angular.isDefined(vm.filters.filterBy.defaultForDestination.value) ||
        vm.filters.filterBy.originName.value ||
        vm.filters.filterBy.originGln.value ||
        vm.filters.filterBy.destinationName.value ||
        vm.filters.filterBy.destinationGln.value
      );
    }

    function reset() {
      vm.filters = PaginationUtil.clearFilters($state.current.name, filterBy());
      loadAll();
    }

    function changeActive(value) {
      vm.filters.filterBy.active.value = value;
      vm.page = 1;
      loadAll();
    }

    function changeDefaultForOrigin(value) {
      vm.filters.filterBy.defaultForOrigin.value = value;
      vm.page = 1;
      loadAll();
    }

    function changeDefaultForDestination(value) {
      vm.filters.filterBy.defaultForDestination.value = value;
      vm.page = 1;
      loadAll();
    }

    function initFilters() {
      vm.filters = PaginationUtil.getFilters($state.current.name, filterBy());

      vm.page = vm.filters.currentPage + 1;
      vm.predicate = vm.filters.orderBy;
      vm.reverse = vm.filters.orderReverse;
      loadAll();
    }

    initFilters();

    function filterBy() {
      return {
        description: {
          name: 'description',
          value: undefined,
        },
        active: {
          name: 'active',
          value: undefined,
        },
        defaultForOrigin: {
          name: 'defaultForOrigin',
          value: undefined,
        },
        defaultForDestination: {
          name: 'defaultForDestination',
          value: undefined,
        },
        originName: {
          name: 'origin.name',
          value: undefined,
        },
        originGln: {
          name: 'origin.gln',
          value: undefined,
        },
        destinationName: {
          name: 'destination.name',
          value: undefined,
        },
        destinationGln: {
          name: 'destination.gln',
          value: undefined,
        },
      };
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationActionDefinitionDialogController', CommunicationActionDefinitionDialogController);

    CommunicationActionDefinitionDialogController.$inject = ['$state', 'translationHandler', 'readOnly', '$timeout', '$scope', 'entity', 'CommunicationActionDefinition', 'CommunicationParameter'];

    function CommunicationActionDefinitionDialogController($state, translationHandler, readOnly, $timeout, $scope, entity, CommunicationActionDefinition, CommunicationParameter) {
        var vm                           = this;
        vm.communicationActionDefinition = entity;
        vm.readOnly                      = readOnly;
        vm.clear                         = clear;
        vm.save                          = save;

        // This controller serves the modal AND the full detail page. Only the page owns the
        // browser tab, so the record names itself there and nowhere else.
        if ($state.current.name === 'communication-action-definition-detail' &&
            vm.communicationActionDefinition && vm.communicationActionDefinition.name) {
            translationHandler.setSubject(vm.communicationActionDefinition.name,
                'eDocumentsApp.communicationActionDefinition.detail.title');
        }

        activate();

        function activate() {
            var ids = [];
            if (vm.communicationActionDefinition.requiredParameters && vm.communicationActionDefinition.requiredParameters.length > 0) {
                for (var j = 0; j < vm.communicationActionDefinition.requiredParameters.length; j++) {
                    ids.push(vm.communicationActionDefinition.requiredParameters[j]);
                }
            } else {
                vm.communicationActionDefinition.requiredParameters = [];
            }
            vm.communicationTypes = CommunicationParameter.getCommunicationTypes();
            CommunicationParameter.getCommunicationParameterTypes().$promise.then(function (res) {
                vm.communicationParameterTypes = [];
                for (var i = 0; i < res.length; i++) {
                    if (!ids.includes(res[i])) {
                        vm.communicationParameterTypes.push(res[i]);
                    }
                }
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go('communication-action-definition');
        }

        function save() {
            vm.isSaving = true;
            if (angular.isDefined( vm.communicationActionDefinition.id) && vm.communicationActionDefinition.id !== null) {
                CommunicationActionDefinition.update(vm.communicationActionDefinition, onSaveSuccess, onSaveError);
            } else {
                CommunicationActionDefinition.save(vm.communicationActionDefinition, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('eDocumentsApp:communicationActionDefinitionUpdate', result);
            $state.go('communication-action-definition');
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationActionDefinitionDeleteController',CommunicationActionDefinitionDeleteController);

    CommunicationActionDefinitionDeleteController.$inject = ['$uibModalInstance', 'entity', 'CommunicationActionDefinition'];

    function CommunicationActionDefinitionDeleteController($uibModalInstance, entity, CommunicationActionDefinition) {
        var vm = this;

        vm.communicationActionDefinition = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CommunicationActionDefinition.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication-action-definition', {
                parent: 'entity',
                url: '/communication-action-definition?page&sort&search',
                data: {
                    authorities: ['ROLE_SUPERADMIN'],
                    pageTitle: 'eDocumentsApp.communicationActionDefinition.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definitions.html',
                        controller: 'CommunicationActionDefinitionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: [
                        '$stateParams',
                        'PaginationUtil',
                        function($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                search: $stateParams.search
                            };
                        }
                    ],
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationActionDefinition');
                            $translatePartialLoader.addPart('communicationType');
                            $translatePartialLoader.addPart('communicationParameterType');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('communication-action-definition-detail', {
                parent: 'communication-action-definition',
                url: '/communication-action-definition/{id}',
                data: {
                    authorities: ['ROLE_SUPERADMIN'],
                    pageTitle: 'eDocumentsApp.communicationActionDefinition.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definition-dialog.html',
                        controller: 'CommunicationActionDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationActionDefinition');
                            $translatePartialLoader.addPart('communicationType');
                            $translatePartialLoader.addPart('communicationParameterType');
                            return $translate.refresh();
                        }
                    ],
                    readOnly: function() {
                        return true;
                    },
                    entity: [
                        '$stateParams',
                        'CommunicationActionDefinition',
                        function($stateParams, CommunicationActionDefinition) {
                            return CommunicationActionDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-action-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-action-definition-detail.edit', {
                parent: 'communication-action-definition-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definition-dialog.html',
                        controller: 'CommunicationActionDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationActionDefinition',
                        function($stateParams, CommunicationActionDefinition) {
                            return CommunicationActionDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-action-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-action-definition.new', {
                parent: 'communication-action-definition',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definition-dialog.html',
                        controller: 'CommunicationActionDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        'CommunicationActionDefinition',
                        function(CommunicationActionDefinition) {
                            return new CommunicationActionDefinition();
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-action-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-action-definition.edit', {
                parent: 'communication-action-definition',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definition-dialog.html',
                        controller: 'CommunicationActionDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationActionDefinition',
                        function($stateParams, CommunicationActionDefinition) {
                            return CommunicationActionDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-action-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-action-definition.delete', {
                parent: 'communication-action-definition',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                onEnter: [
                    '$stateParams',
                    '$state',
                    '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'app/entities/communication-action-definition/communication-action-definition-delete-dialog.html',
                                controller: 'CommunicationActionDefinitionDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: [
                                        'CommunicationActionDefinition',
                                        function(CommunicationActionDefinition) {
                                            return CommunicationActionDefinition.get({ id: $stateParams.id }).$promise;
                                        }
                                    ]
                                }
                            })
                            .result.then(
                            function() {
                                $state.go('communication-action-definition', null, { reload: 'communication-action-definition' });
                            },
                            function() {
                                $state.go('^');
                            }
                        );
                    }
                ]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('CommunicationActionDefinition', CommunicationActionDefinition);

    CommunicationActionDefinition.$inject = ['$resource'];

    function CommunicationActionDefinition ($resource) {
        var resourceUrl =  'api/communication-action-definitions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryAllOrdered' : {
                url: 'api/communication-action-definitions-all-ordered/',
                method : 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationActionDefinitionController', CommunicationActionDefinitionController);

    CommunicationActionDefinitionController.$inject = ['CommunicationActionDefinition', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CommunicationActionDefinitionController(CommunicationActionDefinition, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.getAbbreviation = getAbbreviation;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function getAbbreviation(str) {
            return str.substring(str.lastIndexOf('.') + 1);
        }

        function loadAll() {

            CommunicationActionDefinition.query({
                search: vm.currentSearch,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);


            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.communicationActionDefinitions = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            loadAll();
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationDialogController', CommunicationDialogController);

    CommunicationDialogController.$inject = ['$timeout', '$scope',  '$uibModalInstance', 'entity', 'Communication', 'Document', 'CommunicationWorkflowStep'];

    function CommunicationDialogController ($timeout, $scope,  $uibModalInstance, entity, Communication, Document, CommunicationWorkflowStep) {
        var vm = this;

        vm.communication = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.documents = Document.query();
        vm.communicationworkflowsteps = CommunicationWorkflowStep.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (angular.isDefined(vm.communication.id) && vm.communication.id !== null) {
                Communication.update(vm.communication, onSaveSuccess, onSaveError);
            } else {
                Communication.save(vm.communication, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('eDocumentsApp:communicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.communicationTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationDetailController', CommunicationDetailController);

    CommunicationDetailController.$inject = ['$scope', '$rootScope', 'previousState', 'entity'];

    function CommunicationDetailController($scope, $rootScope, previousState, entity) {
        var vm = this;

        vm.communication = entity;
        vm.previousState = previousState.name;
        // eslint-disable-next-line
        var unsubscribe = $rootScope.$on('eDocumentsApp:communicationUpdate', function (event, result) {
            vm.communication = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationDeleteController',CommunicationDeleteController);

    CommunicationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Communication'];

    function CommunicationDeleteController($uibModalInstance, entity, Communication) {
        var vm = this;

        vm.communication = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Communication.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication', {
                parent : 'app',
                url    : '/communication',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.communication.home.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/communication/communications.html',
                        controller  : 'CommunicationController',
                        controllerAs: 'vm'
                    }
                },
                params : {
                    page  : {
                        value : '1',
                        squash: true
                    },
                    wid   : null,
                    did   : null,
                    sort  : {
                        value : 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams           : ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page     : PaginationUtil.parsePage($stateParams.page),
                            sort     : $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search   : $stateParams.search
                        };
                    }],
                    communicationDefinition: ['$stateParams', 'CommunicationDefinition', function ($stateParams, CommunicationDefinition) {
                        if ($stateParams.did) {
                            return CommunicationDefinition.get({id: $stateParams.did}).$promise;
                        }
                        return undefined;
                    }],
                    workflowStep                 : ['$stateParams', 'CommunicationWorkflowStep', function ($stateParams, CommunicationWorkflowStep) {
                        if ($stateParams.wid) {
                            return CommunicationWorkflowStep.get({id: $stateParams.wid}).$promise;
                        }
                        return undefined;
                    }],
                    translatePartialLoader : ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('communicationStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('communication-detail', {
                parent : 'communication',
                url    : '/communication/{id}',
                data   : {
                    authorities: ['ROLE_USER'],
                    pageTitle  : 'eDocumentsApp.communication.detail.title'
                },
                views  : {
                    'content@': {
                        templateUrl : 'app/entities/communication/communication-detail.html',
                        controller  : 'CommunicationDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('communication');
                        $translatePartialLoader.addPart('communicationStatus');
                        return $translate.refresh();
                    }],
                    entity                : ['$stateParams', 'Communication', function ($stateParams, Communication) {
                        return Communication.get({id: $stateParams.id}).$promise;
                    }],
                    previousState         : ["$state", function ($state) {
                        return {
                            name  : $state.current.name || 'communication',
                            params: $state.params,
                            url   : $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('communication-detail.edit', {
                parent : 'communication-detail',
                url    : '/detail/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/communication/communication-dialog.html',
                        controller  : 'CommunicationDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['Communication', function (Communication) {
                                return Communication.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^', {}, {reload: false});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('communication.new', {
                parent : 'communication',
                url    : '/new',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/communication/communication-dialog.html',
                        controller  : 'CommunicationDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: function () {
                                return {
                                    communicationTime: null,
                                    status           : null,
                                    message          : null,
                                    id               : null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('communication', null, {reload: 'communication'});
                    }, function () {
                        $state.go('communication');
                    });
                }]
            })
            .state('communication.edit', {
                parent : 'communication',
                url    : '/{id}/edit',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/communication/communication-dialog.html',
                        controller  : 'CommunicationDialogController',
                        controllerAs: 'vm',
                        backdrop    : 'static',
                        size        : 'lg',
                        resolve     : {
                            entity: ['Communication', function (Communication) {
                                return Communication.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('communication', null, {reload: 'communication'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('communication.delete', {
                parent : 'communication',
                url    : '/{id}/delete',
                data   : {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl : 'app/entities/communication/communication-delete-dialog.html',
                        controller  : 'CommunicationDeleteController',
                        controllerAs: 'vm',
                        size        : 'md',
                        resolve     : {
                            entity: ['Communication', function (Communication) {
                                return Communication.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('communication', null, {reload: 'communication'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();

(function () {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('Communication', Communication);

    Communication.$inject = ['$resource', 'DateUtils'];

    function Communication($resource, DateUtils) {
        var resourceUrl = 'api/communications/:id';

        return $resource(resourceUrl, {}, {
            'query'             : {
                method : 'GET',
                isArray: true
            },
            'findByWorkflowStep': {
                method : 'GET',
                url    : 'api/communication-by-workflow-step/:id',
                isArray: true
            },
            'findByDefinition'  : {
                method : 'GET',
                url    : 'api/communication-by-definition/:id',
                isArray: true
            },
            'findByDocument'  : {
                method : 'GET',
                url    : 'api/communication-by-document/:id',
                isArray: true
            },
            'get'               : {
                method           : 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data                   = angular.fromJson(data);
                        data.communicationTime = DateUtils.convertDateTimeFromServer(data.communicationTime);
                    }
                    return data;
                }
            },
            'update'            : {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('CommunicationController', CommunicationController);

    CommunicationController.$inject = ['Communication', 'ParseLinks', 'Notification', '$state', 'communicationDefinition', 'paginationConstants', 'workflowStep', 'pagingParams', '$translate'];

    function CommunicationController(Communication, ParseLinks, Notification, $state, communicationDefinition, paginationConstants, workflowStep, pagingParams, $translate) {
        var vm = this;
        vm.communications = [];
        vm.communicationDefinition = communicationDefinition;
        vm.workflowStep = workflowStep;
        vm.predicate = pagingParams.predicate;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.reverse = pagingParams.ascending;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.loadPage = loadPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            if (vm.workflowStep) {
                Communication.findByWorkflowStep({
                    id: vm.workflowStep.id,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else if (vm.communicationDefinition) {
                Communication.findByDefinition({
                    id: vm.communicationDefinition.id,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Notification.warning({
                    message: $translate.instant('eDocumentsApp.communication.messages.noContextDefined'),
                    delay: 5000
                });
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.communications = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                Notification.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('AmaSafeUtilDialogController', AmaSafeUtilDialogController);

    AmaSafeUtilDialogController.$inject = ['$uibModalInstance', 'responseStatus', 'message'];

    function AmaSafeUtilDialogController($uibModalInstance, responseStatus, message) {
        var vm = this;
        vm.responseStatus = responseStatus;
        vm.message = message;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ama-safe-util', {
            parent: 'admin',
            url: '/ama-safe-utils',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'eDocumentsApp.amaSafeUtil.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ama-safe-util/ama-safe-util.html',
                    controller: 'AmaSafeUtilController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('amaSafeUtil');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('AmaSafeUtilService', AmaSafeUtilService);

    AmaSafeUtilService.$inject = ['$resource', 'DataUtils'];

    function AmaSafeUtilService($resource, DataUtils) {
        var resourceUrl = 'api/ama-safe-utils';

        return $resource(resourceUrl, {}, {
            'callAuthTest': {
                method: 'GET',
                url: 'api/ama-safe-utils/callAuthTest',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getCredentialID': {
                method: 'GET',
                url: 'api/ama-safe-utils/getCredentialID',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'generateExample': {
                method: 'POST',
                url: 'api/ama-safe-utils/generateExample',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    return {
                        data: data,
                        filename: DataUtils.parseHeaderFilename(headers),
                    };
                }
            }
        });
    }
})();

/* global saveAs:true */
(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('AmaSafeUtilController', AmaSafeUtilController);

    AmaSafeUtilController.$inject = ['$scope', '$uibModal', '$timeout', 'DataUtils', 'AmaSafeUtilService'];

    function AmaSafeUtilController($scope, $uibModal, $timeout, DataUtils, AmaSafeUtilService) {
        var vm = this;
        vm.isSaving = false;
        vm.responseStatus = false;

        vm.authFormBody = {};
        vm.callAuthTest = callAuthTest;
        vm.clearAuthForm = clearAuthForm;

        vm.credentialFormBody = {};
        vm.callCredentialForm = callCredentialForm;
        vm.clearCredentialForm = clearCredentialForm;

        vm.signatureFormBody = { color: '#00FF00' };
        vm.setFile = setFile;
        vm.resetFile = resetFile;
        vm.callSignatureForm = callSignatureForm;
        vm.clearSignatureForm = clearSignatureForm;

        vm.goBack = goBack;

        function goBack() {
            window.history.back();
        }

        function openDialog(message) {
            $uibModal.open({
                templateUrl: 'app/entities/ama-safe-util/ama-safe-util-dialog.html',
                controller: 'AmaSafeUtilDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    responseStatus: vm.responseStatus,
                    message: message,
                },
            });
        }

        function callAuthTest() {
            vm.isSaving = true;
            AmaSafeUtilService.callAuthTest(vm.authFormBody, onSuccess, onError);
        }

        function clearAuthForm(form) {
            vm.authFormBody = {};
            form.$setPristine();
            $timeout(function () {
                angular.element('#authForm .form-group:eq(0)>input').focus();
            });
        }

        function callCredentialForm() {
            vm.isSaving = true;
            AmaSafeUtilService.getCredentialID(vm.credentialFormBody, onSuccess, onError);
        }

        function clearCredentialForm(form) {
            vm.credentialFormBody = {};
            form.$setPristine();
            $timeout(function () {
                angular.element('#credentialForm .form-group:eq(0)>input').focus();
            });
        }

        function onSuccess(data) {
            vm.isSaving = false;
            vm.responseStatus = true;
            openDialog(data);
        }

        function onError(err) {
            vm.isSaving = false;
            vm.responseStatus = false;
            openDialog(err.data);
        }

        function clearSignatureForm(form) {
            vm.signatureFormBody = { color: '#00FF00' };
            form.$setPristine();
            $timeout(function () {
                angular.element('#signatureForm .form-group:eq(0)>input').focus();
            });
        }

        function setFile($file) {
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function (e) {
                    vm.signatureFormBody.file = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                    vm.signatureFormBody.filename = $file.name;
                    $scope.$apply();
                };
            }
        }

        function resetFile() {
            vm.signatureFormBody.file = null;
            vm.signatureFormBody.filename = null;
        }

        function callSignatureForm() {
            var postObject = {
                file: vm.signatureFormBody.file,
                filename: vm.signatureFormBody.filename,
                color: vm.signatureFormBody.color,
                signXCoord: vm.signatureFormBody.signXCoord,
                signYCoord: vm.signatureFormBody.signYCoord,
                signWidth: vm.signatureFormBody.signWidth,
                signHeight: vm.signatureFormBody.signHeight,
            };

            AmaSafeUtilService.generateExample(postObject).$promise.then(function (result) {
                DataUtils.viewServerFile(result);
            });
        }

        $timeout(function () {
            angular.element('.color-picker-wrapper').css('padding', '0');
            angular.element('.color-picker-input').css('width', '300px');
            angular.element('.color-picker-input-wrapper').css('height', 'calc(1.5em + 0.45rem)');
            angular.element('.color-picker-input-wrapper > span').css('border-right-width', '1px');
            angular.element('.color-picker-input-wrapper > span').css('border-radius', '0.2rem');
            angular.element('.color-picker-grid-inner').css('background-color', 'transparent');
        });

        vm.colorPickerOptions = {
            required: true,
            disabled: false,
            inputClass: 'ng-hide',
            id: 'field_color',
            name: 'color',
            format: 'hexString',
            hue: false,
            alpha: false,
            round: true,
        };
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('AmaSafeCredentialReasonDialogController', AmaSafeCredentialReasonDialogController);

    AmaSafeCredentialReasonDialogController.$inject = ['$uibModalInstance'];

    function AmaSafeCredentialReasonDialogController($uibModalInstance) {
        var vm = this;
        vm.reasons = [
            'PROOF_OF_ORIGIN',
            'PROOF_OF_APPROVAL',
            'PROOF_OF_CREATION',
            'DATA_AUTHENTICATION',
            'ENTITY_AUTHENTICATION',
            'AUTHORSHIP',
            'REVIEW',
            'COPY',
            'SIGNATURE_WITNESS',
            'BOUND_TO_DATA_SIGNED',
            'INTERMEDIATE_APPROVAL'
        ];

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('AmaSafeCredentialDisclaimerDialogController', AmaSafeCredentialDisclaimerDialogController);

    AmaSafeCredentialDisclaimerDialogController.$inject = ['$uibModalInstance'];

    function AmaSafeCredentialDisclaimerDialogController($uibModalInstance) {
        var vm = this;
        vm.clear = clear;
        vm.accept = accept;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function accept() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('AmaSafeCredentialDialogController', AmaSafeCredentialDialogController);

    AmaSafeCredentialDialogController.$inject = [
        '$state',
        '$timeout',
        '$scope',
        '$translate',
        '$uibModal',
        'entity',
        'AmaSafeCredential',
        'Notification',
        'DocumentationUtils'
    ];

    function AmaSafeCredentialDialogController($state, $timeout, $scope, $translate, $uibModal, entity, AmaSafeCredential, Notification, DocumentationUtils) {
        var vm = this;
        vm.communicationEntity = entity;
        vm.clear = clear;
        vm.save = save;
        vm.setAccessTokenFile = setAccessTokenFile;
        vm.setRefreshTokenFile = setRefreshTokenFile;
        vm.openReasonDetail = openReasonDetail;
        vm.downloadAMASAFEUserManual = downloadAMASAFEUserManual;

        vm.accessToken = undefined;
        vm.refreshToken = undefined;

        vm.reasons = [
            'PROOF_OF_ORIGIN',
            'PROOF_OF_APPROVAL',
            'PROOF_OF_CREATION',
            'DATA_AUTHENTICATION',
            'ENTITY_AUTHENTICATION',
            'AUTHORSHIP',
            'REVIEW',
            'COPY',
            'SIGNATURE_WITNESS',
            'BOUND_TO_DATA_SIGNED',
            'INTERMEDIATE_APPROVAL'
        ];

        activate();

        function activate() {
            if (!entity || !entity.id) {
                $state.go('communication-entity');
                Notification.error({
                    message: $translate.instant('eDocumentsApp.amaSafeCredential.message.error.communicationEntityUndefined')
                });
            } else {
                vm.amaSafeCredential = {};
                vm.amaSafeCredential.communicationEntityId = entity.id;
                $uibModal
                    .open({
                        templateUrl: 'app/entities/ama-safe-credential/ama-safe-credential-disclaimer-dialog.html',
                        controller: 'AmaSafeCredentialDisclaimerDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    })
                    .result.then(
                    function() {
                        // do nothing
                    },
                    function() {
                        $state.go('communication-entity-detail.edit', { id: vm.communicationEntity.id });
                    }
                );
            }
        }

        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go('communication-entity-detail.edit', { id: vm.communicationEntity.id });
        }

        function downloadAMASAFEUserManual() {
            DocumentationUtils.downloadAMASAFEUserManual();
        }

        function save() {
            vm.isSaving = true;
            if (angular.isDefined(vm.amaSafeCredential.id) && vm.amaSafeCredential.id !== null) {
                Notification.error({ message: $translate.instant('eDocumentsApp.amaSafeCredential.message.error.idDefined') });
            } else {
                var postObject = {
                    amaSafeCredential: vm.amaSafeCredential,
                    accessToken: vm.accessToken,
                    refreshToken: vm.refreshToken
                };
                AmaSafeCredential.create(postObject, onSaveSuccess, onSaveError);
            }
        }

        function setAccessTokenFile($file, invalid) {
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function(e) {
                    vm.accessToken = e.target.result.substring(e.target.result.indexOf('base64,') + 'base64,'.length);
                    $scope.$apply();
                };
            }
            if (invalid.length > 0) {
                Notification.error({
                    title: $translate.instant('error.invalidFile'),
                    message: $translate.instant('error.onlyTextFilesAllowed')
                });
            }
        }

        function setRefreshTokenFile($file, invalid) {
            if ($file) {
                var fileReader = new FileReader();
                fileReader.readAsDataURL($file);
                fileReader.onload = function(e) {
                    vm.refreshToken = e.target.result.substring(e.target.result.indexOf('base64,') + 'base64,'.length);
                    $scope.$apply();
                };
            }
            if (invalid.length > 0) {
                Notification.error({
                    title: $translate.instant('error.invalidFile'),
                    message: $translate.instant('error.onlyTextFilesAllowed')
                });
            }
        }

        function openReasonDetail() {
            $uibModal.open({
                templateUrl: 'app/entities/ama-safe-credential/ama-safe-credential-reason-dialog.html',
                controller: 'AmaSafeCredentialReasonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            });
        }

        function onSaveSuccess(result) {
            $scope.$emit('eDocumentsApp:amaSafeCredentialUpdate', result);
            $state.go('communication-entity-detail.edit', { id: vm.communicationEntity.id });
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error.data.detail) {
                Notification.error({ message: $translate.instant(error.data.detail) });
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('AmaSafeCredentialDeleteController', AmaSafeCredentialDeleteController);

    AmaSafeCredentialDeleteController.$inject = ['$uibModalInstance', 'amaSafeCredential'];

    function AmaSafeCredentialDeleteController($uibModalInstance, amaSafeCredential) {
        var vm = this;

        vm.amaSafeCredential = amaSafeCredential;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            $uibModalInstance.close(true);
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('AmaSafeCredentialAddConfirmationDialogController', AmaSafeCredentialAddConfirmationDialogController);

    AmaSafeCredentialAddConfirmationDialogController.$inject = ['$uibModalInstance'];

    function AmaSafeCredentialAddConfirmationDialogController($uibModalInstance) {
        var vm = this;
        vm.clear = clear;
        vm.accept = accept;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function accept() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ama-safe-credential-new', {
            parent: 'entity',
            url: '/ama-safe-credential/new',
            data: {
                authorities: ['ROLE_SUPERADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ama-safe-credential/ama-safe-credential-dialog.html',
                    controller: 'AmaSafeCredentialDialogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                communicationEntityId: null
            },
            resolve: {
                entity: [
                    '$stateParams',
                    'CommunicationEntity',
                    function($stateParams, CommunicationEntity) {
                        if ($stateParams.communicationEntityId !== null) {
                            return CommunicationEntity.get({ id: $stateParams.communicationEntityId }).$promise;
                        }
                        return null;
                    }
                ],
                previousState: [
                    '$state',
                    function($state) {
                        return {
                            name: $state.current.name || 'ama-safe-credential',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }
                ],
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('amaSafeCredential');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }
                ]
            }
        });
        // .state('ama-safe-credential.delete', {
        //   parent: 'ama-safe-credential',
        //   url: '/{id}/delete',
        //   data: {
        //     authorities: ['ROLE_SUPERADMIN'],
        //   },
        //   onEnter: [
        //     '$stateParams',
        //     '$state',
        //     '$uibModal',
        //     function ($stateParams, $state, $uibModal) {
        //       $uibModal
        //         .open({
        //           templateUrl: 'app/entities/ama-safe-credential/ama-safe-credential-delete-dialog.html',
        //           controller: 'AmaSafeCredentialDeleteController',
        //           controllerAs: 'vm',
        //           size: 'md',
        //           resolve: {
        //             entity: [
        //               'AmaSafeCredential',
        //               function (AmaSafeCredential) {
        //                 return AmaSafeCredential.get({ id: $stateParams.id }).$promise;
        //               },
        //             ],
        //           },
        //         })
        //         .result.then(
        //           function () {
        //             $state.go('ama-safe-credential', null, { reload: 'ama-safe-credential' });
        //           },
        //           function () {
        //             $state.go('^');
        //           }
        //         );
        //     },
        //   ],
        // });
    }
})();

(function() {
    'use strict';
    angular.module('eDocumentsApp').factory('AmaSafeCredential', AmaSafeCredential);

    AmaSafeCredential.$inject = ['$resource'];

    function AmaSafeCredential($resource) {
        var resourceUrl = 'api/ama-safe-credentials/:id';

        return $resource(resourceUrl, {}, {
            query: { method: 'GET', isArray: true }, create: {
                method: 'POST'
            }, findByEntity: {
                method: 'GET',
                url: 'api/ama-safe-credentials-for-communication-entity/:communicationEntityId',
                isArray: true
            }, delete: { method: 'DELETE' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        return {
            restrict: 'A',
            scope   : false,
            require : '^jhSort',
            link    : linkFunc
        };
        // eslint-disable-next-line
        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        return {
            restrict        : 'A',
            scope           : {
                predicate: '=jhSort',
                ascending: '=',
                callback : '&'
            },
            controller      : SortController,
            controllerAs    : 'vm',
            bindToController: true
        };
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('i.fas'),
                sortIcon = 'fa-sort',
                sortAsc = 'fa-sort-amount-down',
                sortDesc = 'fa-sort-amount-up',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('i.sort'),
                sortIcon = 'fa-sort',
                sortAsc = 'fa-sort-amount-down',
                sortDesc = 'fa-sort-amount-up';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .filter('prettyJson', prettyJson);

    function prettyJson() {
        return prettyJsonFilter;

        function prettyJsonFilter(obj, pretty) {
            if (!obj) {
                return '';
            }
            var json = angular.toJson(obj, pretty);
            if (!pretty) {
                return json;
            }
            return json
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
                    var cls;
                    if (/^"/.test(match)) {
                        cls = /:$/.test(match) ? 'key' : 'string';
                    } else if (/true|false/.test(match)) {
                        cls = 'boolean';
                    } else if (/null/.test(match)) {
                        cls = 'null';
                    } else {
                        cls = 'number';
                    }
                    return '<span class="json-' + cls + '">' + match + '</span>';
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks() {

        return {
            parse: parse
        };

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url         = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                // eslint-disable-next-line
                url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
                    queryString[$1] = $3;
                });
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name    = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').factory('PaginationUtil', PaginationUtil);

  PaginationUtil.$inject = ['$localStorage', 'MyUtil', 'LIST_STATE_VERSION'];

  function PaginationUtil($localStorage, MyUtil, LIST_STATE_VERSION) {
    return {
      parseAscending: parseAscending,
      parsePage: parsePage,
      parsePredicate: parsePredicate,
      clearFilters: clearFilters,
      getFilters: getFilters,
      resetFilters: resetFilters,
      updateFilters: updateFilters,
    };

    function parseAscending(sort) {
      var sortArray = sort.split(',');
      if (sortArray.length > 1) {
        return sort.split(',').slice(-1)[0] === 'asc';
      } else {
        // default to true if no sort defined
        return true;
      }
    }

    // query params are strings, and need to be parsed
    function parsePage(page) {
      return parseInt(page);
    }

    // sort can be in the format `id,asc` or `id`
    function parsePredicate(sort) {
      var sortArray = sort.split(',');
      if (sortArray.length > 1) {
        sortArray.pop();
      }
      return sortArray.join(',');
    }

    function resetFilters() {
      delete $localStorage[LIST_STATE_VERSION];
    }

    function clearFilters(state, emptySearch) {
      var filters = {
        currentPage: 0,
        itemsPerPage: 20,
        filterBy: angular.copy(emptySearch),
        orderBy: undefined,
        orderReverse: undefined,
      };
      $localStorage[LIST_STATE_VERSION][state] = filters;
      return angular.copy(filters);
    }

    function getFilters(state, emptySearch) {
      if (!$localStorage[LIST_STATE_VERSION]) {
        $localStorage[LIST_STATE_VERSION] = {};
      }
      var query = $localStorage[LIST_STATE_VERSION][state];
      if (!MyUtil.isEmpty(query)) {
        return query;
      }
      return clearFilters(state, emptySearch);
    }

    function updateFilters(state, currentPage, filter, orderBy, orderReverse, itemsPerPage) {
      var filters = {
        currentPage: currentPage,
        filterBy: angular.copy(filter),
        itemsPerPage: itemsPerPage,
        orderBy: angular.copy(orderBy),
        orderReverse: angular.copy(orderReverse),
      };
      $localStorage[LIST_STATE_VERSION][state] = filters;
      return angular.copy(filters);
    }
  }
})();

/* global Uint8Array:true, moment:true, momentBusiness:true */
(function() {
    'use strict';

    angular.module('eDocumentsApp').service('MyUtil', MyUtil);

    MyUtil.$inject = [];

    function MyUtil() {

        this.isEmpty = function(data) {
            return (angular.isUndefined(data) || data == null || data.length === 0);
        };

    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('eDocumentsApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'https://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            };
        })());
})();

/* global saveAs:true */
(function() {
    'use strict';

    angular.module('eDocumentsApp').factory('DocumentationUtils', DocumentationUtils);

    DocumentationUtils.$inject = ['$http', '$sce', '$translate', '$window', 'Notification'];

    function DocumentationUtils($http, $sce, $translate, $window, Notification) {
        var MANUAL_BASE = '/content/documentation/manual';

        return {
            userManualUrl: userManualUrl,
            openUserManual: openUserManual,
            downloadAMASAFEUserManual: downloadAMASAFEUserManual
        };

        /**
         * The user manual is a static page under /content/, which SecurityConfiguration puts in
         * web.ignoring(). That matters: this link is offered on the sign-in screen, so it has to
         * work for someone who is not authenticated.
         *
         * It previously called /api/documentation/userManual/downloadPdf, which falls under
         * /api/** -> authenticated(), so anonymous visitors got a 401. See docs/manual/ADR-001.
         */
        function userManualUrl(languageKey) {
            var language = languageKey || $translate.use() || 'pt-pt';
            return MANUAL_BASE + '/' + language + '.html';
        }

        function openUserManual(languageKey) {
            $window.open(userManualUrl(languageKey), '_blank', 'noopener');
        }

        function downloadAMASAFEUserManual() {
            $http.get('/api/documentation/amaSafeUserManual/downloadPdf', { responseType: 'arraybuffer' }).then(
                function successCallback(response) {
                    var blob = new Blob([response.data], { type: 'application/pdf' });
                    var fileURL = URL.createObjectURL(blob);
                    $window.open($sce.trustAsResourceUrl(fileURL), '_blank');
                    saveAs(blob, 'amaSafeCredential_userManual.pdf', true);
                },
                function errorCallback() {
                    // Notification was previously used here without being injected, so this
                    // handler threw a ReferenceError and the user saw nothing at all.
                    Notification.error({ message: $translate.instant('error.errorGeneratingFile'), delay: '' });
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        return {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertStringToTime       : convertStringToTime,
            convertTimeToString       : convertTimeToString,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer  : convertLocalDateToServer,
            dateformat                : dateformat
        };

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertStringToTime(date) {
            if (date) {
                var time = date.split(':');
                var d    = new Date();
                d.setHours(+time[0]);
                d.setMinutes(time[1]);
                d.setSeconds(0);
                d.setMilliseconds(0);
                return d;
            } else {
                return null;
            }
        }

        function convertTimeToString(date) {
            if (angular.isDefined(date) && angular.isDefined(date.getHours()) && angular.isDefined(date.getMinutes())) {
                return date.getHours() + ":" + pad(date.getMinutes(), 2);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
    }

})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils($window) {
        var JSON_TYPE = 'JSON';
        var STRING_TYPE = 'STRING';
        var XML_TYPE = 'XML';

        return {
            abbreviate: abbreviate,
            viewServerFile: viewServerFile,
            byteSize: byteSize,
            formatFileSize: formatFileSize,
            openFile: openFile,
            toBase64: toBase64,
            parseHeaderFilename: parseHeaderFilename,
            getInputType: getInputType,
            getErrorMessageFromArrayBuffer: getErrorMessageFromArrayBuffer,
            getViewableFilename: getViewableFilename,
            getFileIconClass: getFileIconClass,
            JSON_TYPE: JSON_TYPE,
            STRING_TYPE: STRING_TYPE,
            XML_TYPE: XML_TYPE,
        };

        function viewServerFile(result) {
            var url = URL.createObjectURL(new Blob([result.data]));
            var link = document.createElement('a');
            link.href = url;
            link.style = 'visibility:hidden';
            if (result.filename.length > 6 && result.filename.substring(5, 6) === '_') {
                result.filename = result.filename.substring(6);
            }
            link.download = result.filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? text.substring(0, 15) + '...' + text.slice(-10) : '';
        }

        function parseHeaderFilename(headers) {
            var header = headers('content-disposition');
            if (!header) {
                return null;
            }
            if (header === null) {
                return null;
            }
            var result = header.split(';')[1].trim().split('=')[1];
            return result.replace(/"/g, '');
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return (base64String.length / 4) * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function formatFileSize(bytes) {
            if (bytes < 1024) {
                return bytes + ' B';
            } else if (bytes < Math.pow(1024, 2)) {
                return (bytes / 1024).toFixed(2) + ' KB';
            } else if (bytes < Math.pow(1024, 3)) {
                return (bytes / Math.pow(1024, 2)).toFixed(2) + ' MB';
            } else if (bytes < Math.pow(1024, 4)) {
                return (bytes / Math.pow(1024, 3)).toFixed(2) + ' GB';
            } else if (bytes < Math.pow(1024, 5)) {
                return (bytes / Math.pow(1024, 4)).toFixed(2) + ' TB';
            } else {
                return (bytes / Math.pow(1024, 5)).toFixed(2) + ' PB';
            }
        }

        function openFile(type, data) {
            var fileURL = 'data:' + type + ';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
        '<iframe src="' + fileURL + '" frameborder="0" style="border:0; top:0; left:0; bottom:0; right:0; width:100%; height:100%;" allowfullscreen></iframe>'
      );
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substring(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }

        function getInputType(input) {
            try {
        //try to parse via json
                angular.fromJson(input);
                return JSON_TYPE;
            } catch (e) {
                try {
                    $.parseXML(input); //is valid XML
                    return XML_TYPE;
                } catch (err) {
          // was not XML
                    return STRING_TYPE;
                }
            }
        }

        function getErrorMessageFromArrayBuffer(data) {
            var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
            var obj = JSON.parse(decodedString);
            return obj['message'];
        }

        function getViewableFilename(filename) {
      // Define the regex pattern: 2 alphanumeric chars, "_", 2 alphanumeric chars, "_"
            var pattern = /^[a-zA-Z0-9]{2}_[a-zA-Z0-9]{2}_/;

      // Check if the filename starts with the pattern and remove the first 6 characters if true
            if (pattern.test(filename)) {
                return filename.substring(6);
            }

      // Return the original filename if the pattern doesn't match
            return filename;
        }

        function getFileIconClass(fileType) {
            var fileTypeIconMap = {
        // Text Files
                PLAIN_TEXT: 'fa-file-alt', // Plain Text
                HTML: 'fa-file-code', // HTML
                CSS: 'fa-file-code', // CSS
                JAVASCRIPT: 'fa-file-code', // JavaScript
                JSON: 'fa-file-code', // JSON
                XML: 'fa-file-code', // XML
                MARKDOWN: 'fa-file-alt', // Markdown

        // Document Files
                PDF: 'fa-file-pdf', // PDF
                DOC: 'fa-file-word', // DOC
                DOCX: 'fa-file-word', // DOCX
                ODT: 'fa-file-word', // ODT
                RTF: 'fa-file-alt', // RTF

        // Spreadsheet Files
                XLS: 'fa-file-excel', // XLS
                XLSX: 'fa-file-excel', // XLSX
                ODS: 'fa-file-excel', // ODS

        // Presentation Files
                PPT: 'fa-file-powerpoint', // PPT
                PPTX: 'fa-file-powerpoint', // PPTX
                ODP: 'fa-file-powerpoint', // ODP

        // Image Files
                JPEG: 'fa-file-image', // JPEG
                PNG: 'fa-file-image', // PNG
                GIF: 'fa-file-image', // GIF
                BMP: 'fa-file-image', // BMP
                TIFF: 'fa-file-image', // TIFF
                SVG: 'fa-file-image', // SVG

        // Audio Files
                MP3: 'fa-file-audio', // MP3
                WAV: 'fa-file-audio', // WAV
                AAC: 'fa-file-audio', // AAC
                OGG: 'fa-file-audio', // OGG
                FLAC: 'fa-file-audio', // FLAC

        // Video Files
                MP4: 'fa-file-video', // MP4
                AVI: 'fa-file-video', // AVI
                MKV: 'fa-file-video', // MKV
                MOV: 'fa-file-video', // MOV
                WEBM: 'fa-file-video', // WEBM

        // Compressed Files
                ZIP: 'fa-file-archive', // ZIP
                RAR: 'fa-file-archive', // RAR
                GZIP: 'fa-file-archive', // GZIP
                TAR: 'fa-file-archive', // TAR

        // Binary and Executable Files
                EXE: 'fa-file', // EXE
                DLL: 'fa-file', // DLL
                BIN: 'fa-file', // BIN (default for unknown binary files)

        // Custom Application Files
                UNEDIFACT: 'fa-file-invoice', // UNEDIFACT

        // Default Type for Unknown MIME Types
                UNKNOWN: 'fa-file',
            };

      // Return the icon class based on the file type, or default if not found
            return fileTypeIconMap[fileType.toUpperCase()] || fileTypeIconMap['UNKNOWN'];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('CurrencyUtils', CurrencyUtils);

    CurrencyUtils.$inject = [];

    function CurrencyUtils() {

        return {
            getCurrency: getCurrency
        };

        function getCurrency(currencyCode) {
            switch (currencyCode) {
            case 'USD':
                return '$';
            case 'EUR':
                return '€';
            case 'GBP':
                return '£';
            case 'AOA':
                return 'Kz';
            case 'MZN':
                return 'MT';
            case 'CHF':
                return 'CHF';
            case null:
                return '€';
            default:
                return currencyCode;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        return {
            decode: decode,
            encode: encode
        };

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while
                (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function () {
  'use strict';

  /**
   * Reveals one stored secret to a SUPERADMIN (EDOCS-627). The server checks the role, the password and the reason,
   * and records every attempt in the audit log; the value is shown for VISIBLE_SECONDS and then wiped.
   */
  angular.module('eDocumentsApp').controller('SecretRevealController', SecretRevealController);

  SecretRevealController.$inject = ['$uibModalInstance', '$http', '$interval', '$scope', 'target'];

  var VISIBLE_SECONDS = 30;
  var MIN_REASON_LENGTH = 10;

  function SecretRevealController($uibModalInstance, $http, $interval, $scope, target) {
    var vm = this;
    var timer = null;

    vm.minReasonLength = MIN_REASON_LENGTH;
    vm.reason = '';
    vm.password = '';
    vm.value = null;
    vm.secondsLeft = 0;
    vm.errorKey = null;
    vm.copied = false;
    vm.isRevealing = false;

    vm.canSubmit = canSubmit;
    vm.submit = submit;
    vm.copy = copy;
    vm.close = close;

    $scope.$on('$destroy', wipe);

    function canSubmit() {
      return !vm.isRevealing && vm.password && vm.reason && vm.reason.trim().length >= MIN_REASON_LENGTH;
    }

    function submit() {
      if (!canSubmit()) {
        return;
      }
      vm.isRevealing = true;
      vm.errorKey = null;
      $http
        .post('api/secrets/reveal', { source: target.source, id: target.id, reason: vm.reason, password: vm.password })
        .then(
          function (response) {
            vm.password = '';
            vm.value = response.data.value;
            vm.secondsLeft = VISIBLE_SECONDS;
            timer = $interval(
              function () {
                vm.secondsLeft--;
                if (vm.secondsLeft <= 0) {
                  close();
                }
              },
              1000,
              VISIBLE_SECONDS
            );
          },
          function (response) {
            vm.password = '';
            var message = response && response.data && response.data.message;
            vm.errorKey = message && message.indexOf('error.') === 0 ? message.substring('error.'.length) : 'failed';
          }
        )
        .finally(function () {
          vm.isRevealing = false;
        });
    }

    function copy() {
      if (vm.value === null || !navigator.clipboard) {
        return;
      }
      navigator.clipboard.writeText(vm.value).then(function () {
        $scope.$apply(function () {
          vm.copied = true;
        });
      });
    }

    function wipe() {
      if (timer) {
        $interval.cancel(timer);
        timer = null;
      }
      vm.value = null;
      vm.password = '';
    }

    function close() {
      wipe();
      $uibModalInstance.dismiss('closed');
    }
  }
})();

(function () {
  'use strict';

  /**
   * A write-only secret input (EDOCS-627).
   *
   * The server never sends a stored secret back, for any role: the field starts empty, a placeholder says when a
   * value is kept, and saving it blank keeps that value. A SUPERADMIN gets an eye button that reveals the stored
   * value through POST /api/secrets/reveal, which asks for their password and a reason and records the read.
   *
   * <ed-secret-field model="row.value" secret-id="row.id" source="COMMUNICATION_PARAMETER"
   *                  stored="row.secretStored" read-only="vm.readOnly === true"></ed-secret-field>
   */
  angular.module('eDocumentsApp').directive('edSecretField', edSecretField);

  edSecretField.$inject = ['Principal', '$uibModal'];

  function edSecretField(Principal, $uibModal) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        secretId: '<',
        source: '@',
        stored: '<',
        readOnly: '<',
        fieldName: '@',
      },
      templateUrl: 'app/components/secret/secret-field.html',
      link: function (scope) {
        scope.canReveal = false;
        Principal.hasAuthority('ROLE_SUPERADMIN').then(function (result) {
          scope.canReveal = result;
        });
        scope.reveal = function () {
          $uibModal.open({
            templateUrl: 'app/components/secret/secret-reveal.html',
            controller: 'SecretRevealController',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
              target: function () {
                return { source: scope.source, id: scope.secretId };
              },
            },
          });
        };
      },
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService($uibModal) {
        var service = {
            open: open,
            reset: reset
        };

        var modalInstance = null;
        var modalInstance2 = null;
        var resetModal = function () {
            modalInstance = null;
            modalInstance2 = null;
        };

        return service;

        /**
         * Opens the sign-in modal and returns its result promise: it resolves once the user is
         * signed in and rejects if they close it. Callers that interrupted something to ask for a
         * sign-in use that to pick the interrupted action back up, instead of leaving the user
         * signed in but staring at the page they started from.
         *
         * The promise is returned on both paths, the already-open one included — a second caller
         * that got `undefined` there had no way to know when the sign-in finished, and simply
         * gave up.
         */
        function open() {
            if (modalInstance2 !== null) modalInstance2.close();
            if (modalInstance !== null) return modalInstance.result;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            // modalInstance2 is null on the normal path (no reset dialog open), so dereferencing
            // it unconditionally threw a TypeError after the login modal had already been shown.
            var opened = modalInstance;
            opened.result.then(resetModal, resetModal);
            if (modalInstance2 !== null) modalInstance2.result.then(resetModal, resetModal);
            // Read from the local: resetModal has already nulled the field by the time anything
            // awaits this, and returning modalInstance.result would then throw.
            return opened.result;
        }

        function reset() {
            if (modalInstance !== null) modalInstance.close();
            if (modalInstance2 !== null) return;
            modalInstance2 = $uibModal.open({
                animation: true,
                templateUrl: 'app/account/reset/request/reset.request.html',
                controller: 'RequestResetController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reset');
                        $translatePartialLoader.addPart('login');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(resetModal, resetModal);
            modalInstance2.result.then(resetModal, resetModal);
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('LoginController', LoginController);

    LoginController.$inject = [
        '$rootScope',
        '$state',
        '$timeout',
        'Auth',
        '$uibModalInstance',
        'LoginService',
        'ContactUsService',
        'DocumentationUtils',
        '$sessionStorage',
        'UserAccessWindow'
    ];

    function LoginController($rootScope, $state, $timeout, Auth, $uibModalInstance, LoginService, ContactUsService, DocumentationUtils, $sessionStorage, UserAccessWindow) {
        var vm = this;
        vm.authenticationError = false;
        // SUP-12293: the account's access has ended. Only ever set after the server accepted the password (or a token),
        // so it tells nothing to someone who cannot sign in as the account.
        vm.accessExpired = false;
        vm.accessExpiredDay = null;
        showAccessExpired($sessionStorage.accessExpired);

        function showAccessExpired(notice) {
            if (!notice) {
                return;
            }
            delete $sessionStorage.accessExpired;
            vm.accessExpired = true;
            vm.authenticationError = false;
            vm.accessExpiredDay = UserAccessWindow.lastDay(notice.accessValidUntil);
        }
        vm.credentials = {};
        vm.username = null;
        vm.password = null;
        vm.rememberMe = true;
        vm.isSaving = false;
        vm.cancel = cancel;
        vm.login = login;
        vm.contactUs = contactUs;
        vm.downloadManual = downloadManual;
        vm.requestResetPassword = requestResetPassword;

        $timeout(function() {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            vm.isSaving = true;
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            })
                .then(function() {
                    vm.isSaving = false;
                    vm.authenticationError = false;
                    $uibModalInstance.close();
                    if ($state.current.name === 'activate' || $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                        $state.go(Auth.homeState());
                    }

                    $rootScope.$broadcast('authenticationSuccess');

                    if (Auth.getPreviousState()) {
                        Auth.goToPreviousState();
                    }
                })
                .catch(function(err) {
                    vm.isSaving = false;
                    if (err && err.data && err.data.title === 'accessExpired') {
                        showAccessExpired({ accessValidUntil: err.data.accessValidUntil });
                    } else {
                        vm.accessExpired = false;
                        vm.authenticationError = true;
                    }
                });
        }

        function contactUs() {
            $uibModalInstance.dismiss('cancel');
            ContactUsService.open();
        }

        function downloadManual() {
            DocumentationUtils.openUserManual();
        }

        function requestResetPassword() {
            LoginService.reset();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$translate', 'LANGUAGES'];

    function JhiLanguageService($q, $translate, LANGUAGES) {
        return {
            getAll: getAll,
            getCurrent: getCurrent,
            getCurrentLanguageIcon: getCurrentLanguageIcon,
            findLanguageIcon: findLanguageIcon
        };

        function getAll() {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent() {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }

        function getCurrentLanguageIcon() {
            return findLanguageIcon($translate.use());
        }

        function findLanguageIcon(languageKey) {
            var code = languageKey.substr(0, 2).toLowerCase();
            if (code === 'en') {
                return 'gb';
            }
            return code;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'en': { name: 'English' },
        'pt-pt': { name: 'Português' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.findLanguageIcon = findLanguageIcon;
        vm.getCurrentLanguageIcon = getCurrentLanguageIcon;
        vm.getCurrentLanguage = getCurrentLanguage;
        vm.languages = null;
        JhiLanguageService.getAll().then(function(languages) {
            vm.languages = languages;
        });

        function getCurrentLanguage() {
            return JhiLanguageService.getCurrent();
        }

        // translateService.currentLang
        function changeLanguage(languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }

        function getCurrentLanguageIcon() {
            return JhiLanguageService.getCurrentLanguageIcon();
        }

        function findLanguageIcon(languageKey) {
            return JhiLanguageService.findLanguageIcon(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'pt-pt',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').factory('IntegrityWarningService', IntegrityWarningService);

    IntegrityWarningService.$inject = ['$uibModal', '$q'];

    function IntegrityWarningService($uibModal, $q) {
        var service = {
            checkAndWarn: checkAndWarn,
            hasIntegrityIssues: hasIntegrityIssues,
            getFailedFiles: getFailedFiles
        };

        return service;

        /**
         * Checks if any files have integrity issues and shows a warning dialog if needed.
         * Returns a promise that resolves if the user proceeds or if there are no issues,
         * and rejects if the user cancels.
         *
         * @param files Array of file objects with checksumValid property
         * @param onProceed Callback function to execute when user acknowledges and proceeds
         * @returns Promise
         */
        function checkAndWarn(files, onProceed) {
            var deferred = $q.defer();

            if (!hasIntegrityIssues(files)) {
                // No issues, proceed immediately
                deferred.resolve();
                return deferred.promise;
            }

            var failedFiles = getFailedFiles(files);

            $uibModal.open({
                templateUrl: 'app/components/integrity-warning/integrity-warning.dialog.html',
                controller: 'IntegrityWarningDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                resolve: {
                    failedFiles: function () {
                        return failedFiles;
                    },
                    onProceed: function () {
                        return onProceed;
                    }
                }
            }).result.then(
                function (result) {
                    // User acknowledged and proceeded
                    deferred.resolve(result);
                },
                function () {
                    // User cancelled
                    deferred.reject('cancelled');
                }
            );

            return deferred.promise;
        }

        /**
         * Checks if any files in the array have integrity issues.
         *
         * @param files Array of file objects with checksumValid property
         * @returns Boolean
         */
        function hasIntegrityIssues(files) {
            if (!files || !Array.isArray(files)) {
                return false;
            }
            return files.some(function (file) {
                return file.checksumValid === false;
            });
        }

        /**
         * Gets the list of files that failed integrity validation.
         *
         * @param files Array of file objects with checksumValid property
         * @returns Array of failed files
         */
        function getFailedFiles(files) {
            if (!files || !Array.isArray(files)) {
                return [];
            }
            return files.filter(function (file) {
                return file.checksumValid === false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('IntegrityWarningDialogController', IntegrityWarningDialogController);

    IntegrityWarningDialogController.$inject = ['$uibModalInstance', 'failedFiles', 'onProceed'];

    function IntegrityWarningDialogController($uibModalInstance, failedFiles, onProceed) {
        var vm = this;

        vm.failedFiles = failedFiles;
        vm.userAcknowledged = false;
        vm.cancel = cancel;
        vm.proceed = proceed;
        vm.getStatusTranslationKey = getStatusTranslationKey;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function proceed() {
            if (vm.userAcknowledged) {
                if (onProceed && typeof onProceed === 'function') {
                    onProceed();
                }
                $uibModalInstance.close('proceed');
            }
        }

        /**
         * Returns the translation key for the file's validation status message.
         * Maps backend messages to i18n keys.
         */
        function getStatusTranslationKey(file) {
            var message = file.checksumValidationMessage || '';
            var baseKey = 'eDocumentsApp.digitalArchive.integrityWarning.';

            if (message.indexOf('modified') !== -1 || message.indexOf('modified since archival') !== -1) {
                return baseKey + 'fileModified';
            } else if (message.indexOf('not found') !== -1 || message.indexOf('File not found') !== -1) {
                return baseKey + 'fileNotFound';
            } else if (message.indexOf('Error') !== -1 || message.indexOf('error') !== -1) {
                return baseKey + 'validationError';
            } else {
                return baseKey + 'fileModified'; // Default for checksum failures
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        return {
            restrict: 'A',
            require : 'form',
            link    : linkFunc
        };
        // eslint-disable-next-line
        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        return {
            restrict: 'A',
            require : '?ngModel',
            link    : linkFunc
        };
        // eslint-disable-next-line
        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('maxbytes', maxbytes);

    function maxbytes() {
        return {
            restrict: 'A',
            require : '?ngModel',
            link    : linkFunc
        };
        // eslint-disable-next-line
        function linkFunc(scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('faqs', {
            parent: 'app',
            url: '/faqs',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.faqs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/faqs/faqs.html',
                    controller: 'FAQsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('landingPage');
                        $translatePartialLoader.addPart('faqs');
                        return $translate.refresh();
                    }
                ]
            }
        }).state('faqsExternalAccess', {
            parent: 'external',
            url: '/external/faqs',
            data: {
                authorities: [],
                pageTitle: 'global.faqs'
            },
            onEnter: ['$state', 'Principal', function($state, Principal) {
                if (Principal.isAuthenticated()) {
                    $state.go('faqs');
                } else {
                    $state.go('landing-page', { section: 'faqs' });
                }
            }]
        });
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('FAQsController', FAQsController);

    FAQsController.$inject = ['ContactUsService', 'JhiLanguageService'];

    function FAQsController(ContactUsService, JhiLanguageService) {
        var vm = this;
        vm.contactUs = contactUs;
        vm.animateToCardHeader = animateToCardHeader;
        vm.getCurrentLanguageIcon = getCurrentLanguageIcon;

        function contactUs() {
            ContactUsService.open();
        }

        function animateToCardHeader() {
            $('.collapse').on('shown.bs.collapse', function() {
                var $card = $(this).closest('.card');
                $('html,body').animate(
                    {
                        scrollTop: $card.offset().top - 82
                    },
                    250
                );
            });
        }

        angular.element(document).ready(function() {
            setTimeout(animateToCardHeader, 500);
        });

        function getCurrentLanguageIcon() {
            return JhiLanguageService.getCurrentLanguageIcon();
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').component('faqsComponent', {
        templateUrl: 'app/components/faqs/faqs.html',
        controller: 'FAQsController',
        controllerAs: 'vm'
    });
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').factory('ContactUsService', ContactUsService);

    ContactUsService.$inject = ['$uibModal'];

    function ContactUsService($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function() {
            modalInstance = null;
        };

        return service;

        function open() {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                backdrop: 'static',
                size: 'lg',
                animation: true,
                templateUrl: 'app/components/contact-us/contact-us.html',
                controller: 'ContactUsController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('login');
                            $translatePartialLoader.addPart('contactUs');
                            return $translate.refresh();
                        }
                    ]
                }
            });
            modalInstance.result.then(resetModal, resetModal);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ContactUsController', ContactUsController);

    ContactUsController.$inject = ['$uibModalInstance', '$translate', 'Account', 'Notification'];

    function ContactUsController($uibModalInstance, $translate, Account, Notification) {
        var vm = this;

        vm.save = save;
        vm.cancel = cancel;
        vm.isSaving = false;
        vm.name = null;
        vm.email = null;
        vm.phone = null;
        vm.company = null;
        vm.subject = null;
        vm.message = null;
        vm.acceptPrivacyPolicy = false;
        vm.acceptMarketingDataUsage = false;
        vm.receiveEmailCommunication = false;

        function save() {
            vm.isSaving = true;
            Account.contactUs({
                name: vm.name,
                email: vm.email,
                phone: vm.phone,
                company: vm.company,
                subject: vm.subject,
                message: vm.message,
                acceptPrivacyPolicy: vm.acceptPrivacyPolicy,
                acceptMarketingDataUsage: vm.acceptMarketingDataUsage,
                receiveEmailCommunication: vm.receiveEmailCommunication
            }, function() {
                vm.isSaving = false;
                Notification.success({ message: $translate.instant('global.knowMore.success.message'), delay: 5000 });
                vm.cancel();
            }, function() {
                Notification.error({ message: $translate.instant('global.knowMore.error.message'), delay: 5000 });
                vm.isSaving = false;
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('characteresValidation', function() {
            var myregex = '^[_\'.A-Za-z0-9-]*$';

            function link(scope, elem, attrs, ngModel) {
                myregex = angular.isDefined(attrs.myregex) ? attrs.myregex : myregex;
                ngModel.$parsers.push(function(viewValue) {
                    // var reg = /^[^`~!@#$%\^&*()+={}|[\]\\:';"<>?,/]*$/;
                    var reg = new RegExp(myregex);
                    // if view values matches regexp, update model value
                    if (viewValue.match(reg)) {
                        return viewValue;
                    }
                    // keep the model value as it is
                    var transformedValue = ngModel.$modelValue;
                    ngModel.$setViewValue(transformedValue);
                    ngModel.$render();
                    return transformedValue;
                });
            }

            return {
                restrict: 'A',
                require: 'ngModel',
                link: link
            };
        });
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' + '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' + '<div uib-alert ng-cloak="" class="alert alert-{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></div>' + '</div>' + '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('eDocumentsApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', '$rootScope', '$translate', 'Notification'];

    function jhiAlertErrorController($scope, $rootScope, $translate, Notification) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert(message, key, data) {
            key = key ? key : message;
            var msg = $translate.instant(key, data);
            if (key.data && key.data.title) {
                msg = $translate.instant(key.data.title, data);
            }
            Notification.error({
                message: msg
            });
            // vm.alerts.push(
            //     AlertService.add(
            //         {
            //             type: 'danger',
            //             msg: key,
            //             params: data,
            //             timeout: 5000,
            //             toast: AlertService.isToast(),
            //             scoped: true
            //         },
            //         vm.alerts
            //     )
            // );
        }

        var cleanHttpErrorListener = $rootScope.$on('eDocumentsApp.httpError', function(event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
                // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable', 'error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function(header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, { entityName: entityName });
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*]/g, '[]');
                        var fieldName = $translate.instant('eDocumentsApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, { fieldName: fieldName });
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found', 'error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    var headers1 = Object.keys(httpResponse.headers()).filter(function(header) {
                        return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                    }).sort();
                    var alertKey = httpResponse.headers(headers1[0]);
                    if (angular.isString(alertKey)) {
                        var msg = $translate.instant(alertKey, httpResponse.headers(headers1[1]));
                        Notification.error({
                            message: msg
                        });
                            // AlertService.error(alertKey, {param: });
                    } else {
                        addErrorAlert(httpResponse);
                    }
                }
            }
        });

        $scope.$on('$destroy', function() {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .provider('AlertService', AlertService);

    function AlertService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function (isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$translate'];

        function getService($timeout, $translate) {
            var toast = true, alertId = 0, // unique id for each alert. Starts from 0.
                alerts                = [], timeout  = 0; // default timeout

            return {
                factory          : factory,
                isToast          : isToast,
                add              : addAlert,
                closeAlert       : closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear            : clear,
                get              : get,
                success          : success,
                error            : error,
                info             : info,
                warning          : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type    : 'success',
                    msg     : msg,
                    params  : params,
                    timeout : timeout,
                    toast   : toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type    : 'danger',
                    msg     : msg,
                    params  : params,
                    timeout : timeout,
                    toast   : toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type    : 'warning',
                    msg     : msg,
                    params  : params,
                    timeout : timeout,
                    toast   : toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type    : 'info',
                    msg     : msg,
                    params  : params,
                    timeout : timeout,
                    toast   : toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type    : alertOptions.type,
                    msg     : alertOptions.msg,
                    id      : alertOptions.alertId,
                    timeout : alertOptions.timeout,
                    toast   : alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped  : alertOptions.scoped,
                    close   : function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if (!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg     = $translate.instant(alertOptions.msg, alertOptions.params);
                var that             = this;
                var alert            = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function (e) {
                    return e.id;
                }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function () {
    'use strict';

    var jhiAlert = {
        // template: '<div class="alerts" ng-cloak="" role="alert">' +
        //                 '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
        //                     '<div uib-alert ng-cloak="" class="alert alert-{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></div>' +
        //                 '</div>' +
        //           '</div>',
        controller: jhiAlertController
    };

    angular
        .module('eDocumentsApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService', 'Notification'];

    function jhiAlertController($scope, AlertService, Notification) {
        var vm = this;

        vm.alerts = AlertService.get();
        for (var i in vm.alerts) {
            switch (vm.alerts[i].type) {
            case 'success':
                Notification.success({
                    message: vm.alerts[i].msg,
                    delay  : 3000
                });
                break;
            case 'danger':
                Notification.error({
                    message: vm.alerts[i].msg,
                    delay  : 3000
                });
                break;
            case 'warning':
                Notification.warning({
                    message: vm.alerts[i].msg,
                    delay  : 3000
                });
                break;
            case 'info':
                Notification.info({
                    message: vm.alerts[i].msg,
                    delay  : 3000
                });
                break;
            default           :
                Notification.primary    ({
                    message: vm.alerts[i].msg,
                    delay  : 3000
                });
                break;
            }

        }
        AlertService.clear();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = [ 'AlertService'];

    function notificationInterceptor ( AlertService) {
        return {
            response: response
        };

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        return {
            responseError: responseError
        };

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('eDocumentsApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($q, $injector, $localStorage, $sessionStorage) {
        return {
            responseError: responseError
        };

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                // SUP-12293: the access of this account has ended; the sign-in dialog says so instead of a generic error
                if (response.data && response.data.title === 'accessExpired') {
                    $sessionStorage.accessExpired = { accessValidUntil: response.data.accessValidUntil || null };
                }
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            } else if (response.status === 403 && response.data &&
                (response.data.title === 'archiveOnly' || response.data.title === 'noAccessRole')) {
                // SUP-12293: the account's roles changed while this screen was open; reload them and go where they lead
                // instead of leaving an empty list or a generic error on screen
                reloadIdentity();
            }
            return $q.reject(response);
        }

        function reloadIdentity() {
            var Principal = $injector.get('Principal');
            var $state = $injector.get('$state');
            Principal.identity(true).then(function () {
                var home = Principal.homeState();
                if ($state.current.name !== home) {
                    $state.go(home);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$localStorage', '$sessionStorage'];

    function authInterceptor($localStorage, $sessionStorage) {
        return {
            request: request
        };

        function request(config) {
            if (!config || !config.url || /^http/.test(config.url)) {
                return config;
            }

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token      = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        /* The browser tab reads "<what this page is about> - eDocuments.biz".
         *
         * MOST SPECIFIC FIRST, BRAND LAST, and that order is the whole point. A Chrome tab shows
         * roughly a dozen characters before it truncates, so with the brand in front every tab in
         * the strip reads "eDocuments.b..." and none can be told from another - worse than no scheme
         * at all, and worst exactly when many tabs are open. The favicon already carries the
         * identity visually; the title spends its characters on what the favicon cannot say.
         *
         * `subject` is a record's OWN name - a document number, an entity's name - announced by a
         * detail controller once its record resolves. It is held here rather than written straight
         * to document.title because this factory re-titles on every $translateChangeSuccess: set
         * it and forget it, and switching language would silently revert the tab from
         * "FT 2026/1612" back to the generic "Documento". */
        var BRAND = 'eDocuments.biz';
        var SEP = ' ' + String.fromCharCode(0xB7) + ' ';  // middle dot, kept out of the source bytes

        var subject = null;           // "FT 2026/1612"
        var subjectContextKey = null; // translation key for what follows it, e.g. the section

        return {
            initialize: initialize,
            updateTitle: updateTitle,
            setSubject: setSubject,
            clearSubject: clearSubject
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        /**
         * Name the record this page is about. Outranks the state's static title until the next
         * navigation clears it.
         *
         * @param text        the record's own identity, already in its final form
         * @param contextKey  optional translation key for the segment after it; the brand when omitted
         */
        function setSubject(text, contextKey) {
            subject = text || null;
            subjectContextKey = contextKey || null;
            updateTitle();
        }

        function clearSubject() {
            subject = null;
            subjectContextKey = null;
        }

        // update the window title using params in the following
        // precedence
        // 1. a record subject set by the page's own controller
        // 2. titleKey parameter
        // 3. $state.$current.data.pageTitle (current state page title)
        // 4. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }

            if (subject) {
                if (!subjectContextKey) {
                    return write(subject + SEP + BRAND);
                }
                // A record already names itself, so its section takes the second slot and the
                // brand is dropped: three segments only push the useful part out of the tab.
                return $translate(subjectContextKey).then(function (context) {
                    write(subject + SEP + context);
                }, function () {
                    // an unresolved key must not cost the tab its identity
                    write(subject + SEP + BRAND);
                });
            }

            // A section page: its name, then the brand - unless its name IS the brand, as on the
            // landing page, which would otherwise read "eDocuments.biz - eDocuments.biz".
            $translate(titleKey || 'global.title').then(function (title) {
                write(title === BRAND ? BRAND : title + SEP + BRAND);
            });
        }

        function write(title) {
            $window.document.title = title;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$translate', 'JhiLanguageService', 'translationHandler', '$window', 'Auth', 'Principal', 'VERSION', 'RELEASE_YEAR'];

    function stateHandler($rootScope, $translate, JhiLanguageService, translationHandler, $window, Auth, Principal, VERSION, RELEASE_YEAR) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;
            $rootScope.RELEASE_YEAR = RELEASE_YEAR;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function(language) {
                    $translate.use(language);
                });
            });


            // log();
            // eslint-disable-next-line
            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
                // A state with no pageTitle is a modal or a layout shell opened OVER the page the
                // reader is on - the .new / .edit / .delete states all are. Leave the tab alone:
                // re-titling here is what used to turn "Entidades" into a bare brand the moment
                // someone clicked Editar. The page underneath has not changed.
                if (!toState.data || !toState.data.pageTitle) {
                    return;
                }

                // A real navigation: whatever record the previous page named is no longer the
                // subject, so drop it before the new page's own controller announces its own.
                translationHandler.clearSubject();
                translationHandler.updateTitle(toState.data.pageTitle);
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "pt-pt"');
                $cookies.putObject(name, 'pt-pt');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('pt-pt');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(html5ModeConfig);

    html5ModeConfig.$inject = ['$locationProvider'];

    function html5ModeConfig($locationProvider) {
        $locationProvider.html5Mode({ enabled: true, requireBase: true });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider', 'NotificationProvider'];

    function alertServiceConfig(AlertServiceProvider, NotificationProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
        NotificationProvider.setOptions({
            delay            : 10000,
            startTop         : 20,
            startRight       : 10,
            verticalSpacing  : 20,
            horizontalSpacing: 20,
            positionX        : 'right',
            positionY        : 'top'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('main-index', {
                abstract: true,
                views   : {
                    'main@': {
                        templateUrl: 'app/layouts/main-index.html'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'FooterController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('main', {
                abstract: true,
                views   : {
                    'main@': {
                        templateUrl: 'app/layouts/main.html'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'FooterController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app', {
                parent  : 'main',
                abstract: true,
                views   : {
                    'main@': {
                        templateUrl: 'app/layouts/main.html'
                    },
                    'navbar@' : {
                        templateUrl : 'app/layouts/navbar/navbar.html',
                        controller  : 'NavbarController',
                        controllerAs: 'vm'
                    },
                    'sidebar@': {
                        templateUrl : 'app/layouts/sidebar/sidebar.html',
                        controller  : 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'FooterController',
                        controllerAs: 'vm'
                    }
                },
                resolve : {
                    authorize             : ['Auth', function (Auth) {
                        return Auth.authorize();
                    }],
                    translatePartialLoader: ['$translatePartialLoader', function ($translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                    }]
                }
            });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('eDocumentsApp')
        .constant('VERSION', "2026.10d-papinet")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1792884873295)
        .constant('LIST_STATE_VERSION', "listState202610d-papinet")
        .constant('RELEASE_YEAR', "2026")
;
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('UserManagementDialogController', UserManagementDialogController);

  UserManagementDialogController.$inject = [
    '$state',
    'entity',
    'User',
    'JhiLanguageService',
    'DataUtils',
    '$scope',
    'CommunicationEntity',
    'Notification',
    'Principal',
    'translationHandler',
    'UserAccessWindow',
  ];

  function UserManagementDialogController($state, entity, User, JhiLanguageService, DataUtils, $scope, CommunicationEntity, Notification, Principal, translationHandler, UserAccessWindow) {
    var vm = this;
    vm.clear = clear;
    vm.setDocumentFile = setDocumentFile;
    vm.removeUserFromEntity = removeUserFromEntity;
    vm.addUserToEntity = addUserToEntity;
    vm.toggleManager = toggleManager;
      vm.toggleEmailReceiver = toggleEmailReceiver;
    vm.isManagerForEntity = isManagerForEntity;
      vm.isEmailReceiverForEntity = isEmailReceiverForEntity;
    vm.isUserAllowedToChangeAuthorities = isUserAllowedToChangeAuthorities;
    vm.languages = null;
    vm.save = save;
    vm.clearImage = clearImage;
    vm.user = entity;
    vm.accessLastDay = UserAccessWindow.lastDay(vm.user && vm.user.accessValidUntil);
    // SUP-12293: an account with no role that opens the application (an external auditor) must end, at most 90 days ahead
    vm.isRestricted = function () {
      return UserAccessWindow.isRestricted(vm.user && vm.user.authorities);
    };
    vm.hasArchiveRole = function () {
      return !!(vm.user && vm.user.authorities && vm.user.authorities.indexOf('ROLE_DIGITAL_ARCHIVE') !== -1);
    };
    vm.maxAccessDay = UserAccessWindow.isoDay(UserAccessWindow.maxLastDay());
    vm.entityNames = function () {
      return (vm.user && vm.user.entities ? vm.user.entities : []).map(function (entity) {
        return entity.name;
      }).join(', ');
    };
    if (vm.user && vm.user.login) {
      translationHandler.setSubject(vm.user.login, 'userManagement.home.title');
    }
    vm.tmpCropedImgURL = '';
    vm.tmpImageBlob = '';
    vm.tmpImageCropped = undefined;

    vm.clearFilter = clearFilter;
    vm.search = search;

    activate();
    Principal.identity().then(function (account) {
      vm.currentAccount = account;
    });

    function activate() {
      var ids = [];
      if (vm.user.authorities && vm.user.authorities.length > 0) {
        for (var j = 0; j < vm.user.authorities.length; j++) {
          ids.push(vm.user.authorities[j]);
        }
      } else {
        vm.user.authorities = [];
      }
      var authoritiesTmp = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_SUPERADMIN', 'ROLE_BETATESTER', 'ROLE_INTEGRATION', 'ROLE_DIGITAL_ARCHIVE'];
      vm.authorities = [];
      for (var i = 0; i < authoritiesTmp.length; i++) {
        if (!ids.includes(authoritiesTmp[i])) {
          vm.authorities.push(authoritiesTmp[i]);
        }
      }

      if (vm.user && vm.user.id) {
        CommunicationEntity.findAllByUser({ user: vm.user.id }).$promise.then(function (res) {
          vm.user.entities = res;
        });
      }

      if (vm.user.image && vm.user.imageContentType) {
        vm.user.imageURL = 'data:' + vm.user.imageContentType + ';base64,' + vm.user.image;
      }
    }

    function clearFilter() {
      vm.searchQuery = undefined;
    }

    function search() {
      var idsEntities = [];
      if (vm.user.entities && vm.user.entities.length > 0) {
        for (var j = 0; j < vm.user.entities.length; j++) {
          idsEntities.push(vm.user.entities[j].id);
          idsEntities[vm.user.entities[j].id] = vm.user.entities[j].manager == null ? false : vm.user.entities[j].manager;
        }
      }
      CommunicationEntity.searchByName({ search: vm.searchQuery }).$promise.then(
        function (res) {
          vm.entities = [];
          for (var i = 0; i < res.length; i++) {
            if (!idsEntities.includes(res[i].id)) {
              vm.entities.push(res[i]);
            }
          }
        },
        function () {
          Notification.error({ message: 'Pesquisa inválida!' }); // TODO translate
        }
      );
    }

    JhiLanguageService.getAll().then(function (languages) {
      vm.languages = languages;
    });

    function clear() {
      $state.go('user-management');
    }

    function onSaveSuccess() {
      vm.isSaving = false;
      $state.go('user-management');
    }

    function onSaveError() {
      vm.isSaving = false;
    }

    function toggleManager(item) {
      var itemForUserAndEntity = item.userEntities.filter(function (userEntity) {
        return userEntity.userId === vm.user.id && userEntity.entityId === item.id;
      });
      User.updateUserEntity(
        {
          userId: vm.user.id,
          entityId: item.id,
          manager: !vm.isManagerForEntity(item),
          emitter: itemForUserAndEntity[0].emitter,
          receptor: itemForUserAndEntity[0].receptor,
          emailReceiver: itemForUserAndEntity[0].emailReceiver,
        },
        function () {
          Notification.success({ message: 'Utilizador atualizado!' }); // TODO translate
        },
        function () {
          Notification.error({ message: 'Ocorreu um erro ao atualizar o utilizador!' }); // TODO translate
        }
      );
      itemForUserAndEntity[0].manager = !itemForUserAndEntity[0].manager;
    }

      function toggleEmailReceiver(item) {
          var itemForUserAndEntity = item.userEntities.filter(function (userEntity) {
              return userEntity.userId === vm.user.id && userEntity.entityId === item.id;
          });
          User.updateUserEntity(
              {
                  userId: vm.user.id,
                  entityId: item.id,
                  manager: itemForUserAndEntity[0].manager,
                  emitter: itemForUserAndEntity[0].emitter,
                  receptor: itemForUserAndEntity[0].receptor,
                  emailReceiver: !vm.isEmailReceiverForEntity(item),
              },
              function () {
                  Notification.success({ message: 'Utilizador atualizado!' }); // TODO translate
              },
              function () {
                  Notification.error({ message: 'Ocorreu um erro ao atualizar o utilizador!' }); // TODO translate
              }
          );
          itemForUserAndEntity[0].emailReceiver = !itemForUserAndEntity[0].emailReceiver;
      }

    function isManagerForEntity(item) {
      var itemForUserAndEntity = item.userEntities.filter(function (userEntity) {
        return userEntity.userId === vm.user.id && userEntity.entityId === item.id;
      });
      return itemForUserAndEntity[0].manager;
    }

      function isEmailReceiverForEntity(item) {
          var itemForUserAndEntity = item.userEntities.filter(function (userEntity) {
              return userEntity.userId === vm.user.id && userEntity.entityId === item.id;
          });
          return itemForUserAndEntity[0].emailReceiver;
      }

      function removeUserFromEntity(item) {
          User.removeEntityFromUser(
              {
                  userId: vm.user.id,
                  entityId: item.id,
              },
              function () {
                  Notification.success({ message: 'O utilizador removido da entidade!' }); // TODO translate
              },
              function () {
                  Notification.error({ message: 'Ocorreu um erro ao remover o utilizador da entidade!' }); // TODO translate
              }
          );
          item.manager = false;
          return item;
      }

    function addUserToEntity(item) {
      var userEntityObject = {
        userId: vm.user.id,
        entityId: item.id,
        manager: false,
        emitter: true,
        receptor: true,
          emailReceiver: false,
      };

      User.addEntityToUser(
        userEntityObject,
        function () {
          Notification.success({ message: 'Utilizador associado à entidade!' });
        },
        function () {
          Notification.error({ message: 'Ocorreu um erro ao associar o utilizador à entidade!' });
        }
      );
      item.userEntities.push(userEntityObject);
      return item;
    }

    function clearImage() {
      vm.tmpImageURL = undefined;
      vm.tmpImageCropped = null;
      vm.user.imageURL = null;
      vm.user.image = null;
      vm.user.imageContentType = null;
    }

    function save() {
      vm.isSaving = true;
      vm.user.accessValidUntil = UserAccessWindow.endOf(vm.accessLastDay);
      if (vm.tmpImageCropped && vm.tmpImageCropped !== null) {
        vm.user.image = vm.tmpImageCropped.substr(vm.tmpImageCropped.indexOf('base64,') + 'base64,'.length);
        vm.user.imageContentType = vm.tmpImageBlob.type;
        vm.tmpImageURL = undefined;
      }

      if (vm.user.image && vm.user.imageContentType) {
        vm.entidadeImageURL = 'data:' + vm.user.imageContentType + ';base64,' + vm.user.image;
      }
      if (angular.isDefined(vm.user.id) && vm.user.id !== null) {
        User.update(vm.user, onSaveSuccess, onSaveError);
      } else {
        User.save(vm.user, onSaveSuccess, onSaveError);
      }
    }

    function setDocumentFile($file, invalid) {
      if ($file) {
        DataUtils.toBase64($file, function (base64Data) {
          $scope.$apply(function () {
            vm.tmpImage = base64Data;
            vm.tmpImageContentType = $file.type;
            vm.tmpImageURL = 'data:' + vm.tmpImageContentType + ';base64,' + vm.tmpImage;
          });
        });
      }
      if (invalid.length > 0) {
        Notification.error({
            title: 'Ficheiro Inválido!', // TODO translate
            message: 'Apenas imagens!', // TODO translate
        });
      }
    }

    function isUserAllowedToChangeAuthorities() {
      if (vm.currentAccount) {
        return vm.currentAccount.authorities.includes('ROLE_SUPERADMIN');
      }
      return false;
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('user-management', {
                parent: 'admin',
                url: '/user-management?page&sort',
                data: {
                    authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN'],
                    pageTitle: 'userManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: [
                        '$stateParams',
                        'PaginationUtil',
                        function($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                search: $stateParams.search
                            };
                        }
                    ],
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('user-management');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('user-management.edit', {
                url: '/{login}/edit',
                data: {
                    authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'User',
                        function($stateParams, User) {
                            return User.get({ login: $stateParams.login }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'user-management',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })

            .state('user-management.new', {
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        'User',
                        function(User) {
                            return new User();
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'user-management',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('user-management.delete', {
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
                },
                onEnter: [
                    '$stateParams',
                    '$state',
                    '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                                controller: 'UserManagementDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: [
                                        'User',
                                        function(User) {
                                            return User.get({ login: $stateParams.login }).$promise;
                                        }
                                    ]
                                }
                            })
                            .result.then(
                            function() {
                                $state.go('user-management', null, { reload: true });
                            },
                            function() {
                                $state.go('^');
                            }
                        );
                    }
                ]
            });
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'UserAccessWindow'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, UserAccessWindow) {
        var vm = this;

        // SUP-12293: when an account's access ends (external auditors)
        vm.accessHasEnded = function (user) {
            return UserAccessWindow.hasEnded(user.accessValidUntil);
        };
        vm.accessLastDay = function (user) {
            return UserAccessWindow.lastDay(user.accessValidUntil);
        };

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_SUPERADMIN', 'ROLE_BETATESTER', 'ROLE_INTEGRATION', 'ROLE_DIGITAL_ARCHIVE'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.searchQuery = pagingParams.search;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll() {
            User.query(
                {
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    search: search(),
                    sort: sort(),
                },
        onSuccess,
        onError
      );
        }

        function search() {
            return vm.searchQuery;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.searchQuery = undefined;
            vm.loadAll();
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: search(),
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('parameterization-docs', {
            parent: 'admin',
            url: '/parameterization-docs',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_SUPERADMIN'],
                pageTitle: 'parameterizationDocs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/parameterization-docs/parameterization-docs.html',
                    controller: 'ParameterizationDocsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('parameterizationDocs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('ParameterizationDocsService', ParameterizationDocsService);

    ParameterizationDocsService.$inject = ['$http'];

    function ParameterizationDocsService($http) {
        var service = {
            getFullDocumentation: getFullDocumentation,
            getActionDefinitions: getActionDefinitions,
            getCommunicationDefinitions: getCommunicationDefinitions,
            getParameterResolution: getParameterResolution,
            getDefinitionSummaries: getDefinitionSummaries,
            getDefinitionSteps: getDefinitionSteps,
            getStepResolution: getStepResolution
        };

        return service;

        function getFullDocumentation() {
            return $http.get('/api/parameterization-docs').then(function(response) {
                return response.data;
            });
        }

        function getActionDefinitions() {
            return $http.get('/api/parameterization-docs/action-definitions').then(function(response) {
                return response.data;
            });
        }

        function getCommunicationDefinitions() {
            return $http.get('/api/parameterization-docs/communication-definitions').then(function(response) {
                return response.data;
            });
        }

        function getParameterResolution() {
            return $http.get('/api/parameterization-docs/parameter-resolution').then(function(response) {
                return response.data;
            });
        }

        function getDefinitionSummaries(search, page, size) {
            return $http.get('/api/parameterization-docs/definition-summaries', {
                params: {
                    search: search || '',
                    page: page || 0,
                    size: size || 20,
                    sort: 'description,asc'
                }
            }).then(function(response) {
                return {
                    data: response.data,
                    totalCount: parseInt(response.headers('X-Total-Count'), 10) || 0
                };
            });
        }

        function getDefinitionSteps(definitionId) {
            return $http.get('/api/parameterization-docs/definitions/' + definitionId + '/steps').then(function(response) {
                return response.data;
            });
        }

        function getStepResolution(stepId) {
            return $http.get('/api/parameterization-docs/steps/' + stepId + '/resolution').then(function(response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ParameterizationDocsController', ParameterizationDocsController);

    ParameterizationDocsController.$inject = ['ParameterizationDocsService', '$translate'];

    function ParameterizationDocsController(ParameterizationDocsService, $translate) {
        var vm = this;

        // State
        vm.loading = true;
        vm.error = false;
        vm.searchQuery = '';
        vm.activeTab = 'actions';
        vm.selectedAction = null;
        vm.selectedDefinition = null;
        vm.expandedDefinitions = {};
        vm.categoryFilter = '';

        // Action definitions tab state
        vm.actionDefinitions = [];
        vm.actionsLoaded = false;

        // Communication definitions tab state (paginated)
        vm.commDefinitions = [];
        vm.commDefinitionsTotal = 0;
        vm.commDefinitionsPage = 0;
        vm.commDefinitionsLoading = false;
        vm.commDefinitionsLoaded = false;
        vm.commDefinitionsSearch = '';

        // Resolution tab state
        vm.definitionFilter = '';
        vm.definitionSummaries = [];
        vm.definitionSummariesTotal = 0;
        vm.definitionSummariesPage = 0;
        vm.definitionSummariesLoading = false;
        vm.resolutionDefinition = null;
        vm.resolutionSteps = [];
        vm.resolutionStepsLoading = false;
        vm.resolutionStep = null;
        vm.resolutionDetail = null;
        vm.resolutionDetailLoading = false;
        vm.showLevelDetail = false;

        // Parameter resolution info
        vm.parameterResolution = null;

        // Methods
        vm.setActiveTab = setActiveTab;
        vm.selectAction = selectAction;
        vm.selectDefinition = selectDefinition;
        vm.toggleDefinitionExpand = toggleDefinitionExpand;
        vm.filteredActionDefinitions = filteredActionDefinitions;
        vm.getParameterCategories = getParameterCategories;
        vm.setCategoryFilter = setCategoryFilter;
        vm.getFilteredParameters = getFilteredParameters;
        vm.getCategoryIcon = getCategoryIcon;
        vm.formatAuthority = formatAuthority;
        vm.getUsageLabel = getUsageLabel;
        vm.getSimpleClassName = getSimpleClassName;
        vm.selectResolutionDefinition = selectResolutionDefinition;
        vm.selectResolutionStep = selectResolutionStep;
        vm.searchDefinitionSummaries = searchDefinitionSummaries;
        vm.loadMoreDefinitions = loadMoreDefinitions;
        vm.getStepParameterSummary = getStepParameterSummary;
        vm.isSensitiveParam = isSensitiveParam;
        vm.searchCommDefinitions = searchCommDefinitions;
        vm.loadMoreCommDefinitions = loadMoreCommDefinitions;
        vm.retryLoad = loadActionDefinitions;

        // Init - only load action definitions (first tab)
        loadActionDefinitions();

        function loadActionDefinitions() {
            vm.loading = true;
            vm.error = false;
            ParameterizationDocsService.getActionDefinitions().then(
                function(data) {
                    vm.actionDefinitions = data;
                    vm.actionsLoaded = true;
                    vm.loading = false;
                },
                function() {
                    vm.error = true;
                    vm.loading = false;
                }
            );
        }

        function loadCommDefinitions() {
            if (vm.commDefinitionsLoaded) return;
            vm.commDefinitionsLoading = true;
            vm.commDefinitionsPage = 0;
            ParameterizationDocsService.getDefinitionSummaries(vm.commDefinitionsSearch, 0, 50).then(
                function(result) {
                    vm.commDefinitions = result.data;
                    vm.commDefinitionsTotal = result.totalCount;
                    vm.commDefinitionsLoading = false;
                    vm.commDefinitionsLoaded = true;
                },
                function() {
                    vm.commDefinitionsLoading = false;
                }
            );
        }

        var commSearchTimeout = null;
        function searchCommDefinitions() {
            if (commSearchTimeout) clearTimeout(commSearchTimeout);
            commSearchTimeout = setTimeout(function() {
                vm.commDefinitionsPage = 0;
                vm.commDefinitionsLoading = true;
                vm.commDefinitionsLoaded = false;
                vm.selectedDefinition = null;
                ParameterizationDocsService.getDefinitionSummaries(vm.commDefinitionsSearch, 0, 50).then(
                    function(result) {
                        vm.commDefinitions = result.data;
                        vm.commDefinitionsTotal = result.totalCount;
                        vm.commDefinitionsLoading = false;
                        vm.commDefinitionsLoaded = true;
                    },
                    function() {
                        vm.commDefinitionsLoading = false;
                    }
                );
            }, 300);
        }

        function loadMoreCommDefinitions() {
            if (vm.commDefinitionsLoading) return;
            if (vm.commDefinitions.length >= vm.commDefinitionsTotal) return;
            vm.commDefinitionsPage++;
            vm.commDefinitionsLoading = true;
            ParameterizationDocsService.getDefinitionSummaries(vm.commDefinitionsSearch, vm.commDefinitionsPage, 50).then(
                function(result) {
                    vm.commDefinitions = vm.commDefinitions.concat(result.data);
                    vm.commDefinitionsLoading = false;
                },
                function() {
                    vm.commDefinitionsLoading = false;
                }
            );
        }

        function setActiveTab(tab) {
            vm.activeTab = tab;
            vm.selectedAction = null;
            vm.selectedDefinition = null;
            vm.categoryFilter = '';
            if (tab === 'definitions' && !vm.commDefinitionsLoaded) {
                loadCommDefinitions();
            }
            if (tab === 'resolution' && vm.definitionSummaries.length === 0) {
                searchDefinitionSummaries();
            }
        }

        function selectAction(action) {
            vm.selectedAction = action;
            vm.categoryFilter = '';
        }

        function selectDefinition(definition) {
            vm.selectedDefinition = definition;
            vm.expandedDefinitions = {};
            // Lazy-load workflow steps for this definition
            if (definition && !definition.workflowSteps) {
                definition.workflowStepsLoading = true;
                ParameterizationDocsService.getDefinitionSteps(definition.id).then(
                    function(steps) {
                        definition.workflowSteps = steps;
                        definition.workflowStepsLoading = false;
                    },
                    function() {
                        definition.workflowSteps = [];
                        definition.workflowStepsLoading = false;
                    }
                );
            }
        }

        function toggleDefinitionExpand(defId) {
            vm.expandedDefinitions[defId] = !vm.expandedDefinitions[defId];
        }

        function filteredActionDefinitions() {
            if (!vm.actionDefinitions) return [];
            if (!vm.searchQuery) return vm.actionDefinitions;

            var query = vm.searchQuery.toLowerCase();
            return vm.actionDefinitions.filter(function(ad) {
                return (ad.name && ad.name.toLowerCase().indexOf(query) !== -1) ||
                       (ad.communicationType && ad.communicationType.toLowerCase().indexOf(query) !== -1) ||
                       (ad.classname && ad.classname.toLowerCase().indexOf(query) !== -1) ||
                       hasMatchingParameter(ad, query);
            });
        }

        function hasMatchingParameter(actionDef, query) {
            if (!actionDef.parameters) return false;
            return actionDef.parameters.some(function(p) {
                return p.parameterType && p.parameterType.toLowerCase().indexOf(query) !== -1;
            });
        }

        function getParameterCategories() {
            if (!vm.selectedAction || !vm.selectedAction.parameters) return [];
            var categories = {};
            vm.selectedAction.parameters.forEach(function(p) {
                if (p.category) {
                    categories[p.category] = true;
                }
            });
            return Object.keys(categories).sort();
        }

        function setCategoryFilter(category) {
            vm.categoryFilter = (vm.categoryFilter === category) ? '' : category;
        }

        function getFilteredParameters() {
            if (!vm.selectedAction || !vm.selectedAction.parameters) return [];
            if (!vm.categoryFilter) return vm.selectedAction.parameters;
            return vm.selectedAction.parameters.filter(function(p) {
                return p.category === vm.categoryFilter;
            });
        }

        function getCategoryIcon(category) {
            var icons = {
                'connection': 'fas fa-plug',
                'file': 'fas fa-file',
                'filtering': 'fas fa-filter',
                'security': 'fas fa-shield-alt',
                'signature': 'fas fa-pen-nib',
                'email': 'fas fa-envelope',
                'scheduling': 'fas fa-clock',
                'business': 'fas fa-briefcase'
            };
            return icons[category] || 'fas fa-cog';
        }

        function formatAuthority(auth) {
            if (!auth) return '';
            return auth.replace('ROLE_', '');
        }

        function getUsageLabel(count) {
            var label = $translate.instant('parameterizationDocs.actions.usageCountHint');
            return count + ' ' + label;
        }

        function getSimpleClassName(classname) {
            if (!classname) return '';
            var parts = classname.split('.');
            return parts[parts.length - 1];
        }

        function getStepParameterSummary(step) {
            var total = (step.originParameterCount || 0) + (step.destinationParameterCount || 0);
            if (total === 0) return '';
            var parts = [];
            if (step.originParameterCount > 0) parts.push(step.originParameterCount + ' orig.');
            if (step.destinationParameterCount > 0) parts.push(step.destinationParameterCount + ' dest.');
            return parts.join(', ');
        }

        function isSensitiveParam(paramType) {
            return paramType === 'PASSWORD' || paramType === 'KEYSTORE_PASSWORD' || paramType === 'PUBLIC_KEY';
        }

        // === Resolution tab: lazy-loaded definition/step picker ===

        var searchTimeout = null;
        function searchDefinitionSummaries() {
            if (searchTimeout) clearTimeout(searchTimeout);
            searchTimeout = setTimeout(function() {
                vm.definitionSummariesPage = 0;
                vm.definitionSummariesLoading = true;
                vm.resolutionDefinition = null;
                vm.resolutionSteps = [];
                vm.resolutionStep = null;
                vm.resolutionDetail = null;
                ParameterizationDocsService.getDefinitionSummaries(vm.definitionFilter, 0, 20).then(
                    function(result) {
                        vm.definitionSummaries = result.data;
                        vm.definitionSummariesTotal = result.totalCount;
                        vm.definitionSummariesLoading = false;
                    },
                    function() {
                        vm.definitionSummariesLoading = false;
                    }
                );
            }, 300);
        }

        function loadMoreDefinitions() {
            if (vm.definitionSummariesLoading) return;
            if (vm.definitionSummaries.length >= vm.definitionSummariesTotal) return;
            vm.definitionSummariesPage++;
            vm.definitionSummariesLoading = true;
            ParameterizationDocsService.getDefinitionSummaries(vm.definitionFilter, vm.definitionSummariesPage, 20).then(
                function(result) {
                    vm.definitionSummaries = vm.definitionSummaries.concat(result.data);
                    vm.definitionSummariesLoading = false;
                },
                function() {
                    vm.definitionSummariesLoading = false;
                }
            );
        }

        function selectResolutionDefinition(def) {
            vm.resolutionDefinition = def;
            vm.resolutionStep = null;
            vm.resolutionDetail = null;
            vm.resolutionSteps = [];
            vm.resolutionStepsLoading = true;
            ParameterizationDocsService.getDefinitionSteps(def.id).then(
                function(steps) {
                    vm.resolutionSteps = steps;
                    vm.resolutionStepsLoading = false;
                },
                function() {
                    vm.resolutionStepsLoading = false;
                }
            );
        }

        function selectResolutionStep(step) {
            vm.resolutionStep = step;
            vm.resolutionDetail = null;
            vm.resolutionDetailLoading = true;
            vm.showLevelDetail = false;
            ParameterizationDocsService.getStepResolution(step.id).then(
                function(detail) {
                    vm.resolutionDetail = detail;
                    vm.resolutionDetailLoading = false;
                },
                function() {
                    vm.resolutionDetailLoading = false;
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/appmetrics',
            data: {
                authorities: ['ROLE_SUPERADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$http'];

    function JhiMetricsService($http) {
        return {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        function getMetrics() {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump() {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope', 'JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function(newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function(value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function(value, key) {
                if (key.includes('jcache.statistics')) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substring(18),
                        'value': value
                    };
                }
            });
        });

        function refresh() {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function(promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function(promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData() {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_SUPERADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        return $resource('management/logs', {}, {
            'findAll'    : {
                method : 'GET',
                isArray: true
            },
            'changeLevel': {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/apphealth',
            data: {
                authorities: ['ROLE_SUPERADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$http'];

    function JhiHealthService($http) {
        var separator = '.';
        return {
            checkHealth        : checkHealth,
            transformHealthData: transformHealthData,
            getBaseName        : getBaseName,
            getSubSystemName   : getSubSystemName
        };

        function checkHealth() {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData(data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName(name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName(name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData(result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject(result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details    = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails   = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, {'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName(path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            } else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem(healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject(healthObject) {
            var result = false;
            // eslint-disable-next-line
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_SUPERADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_SUPERADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        return {
            get   : get,
            getEnv: getEnv
        };

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['JhiConfigurationService'];

    function JhiConfigurationController(JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration    = null;

        JhiConfigurationService.get().then(function (configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_SUPERADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        return $resource('management/audits/:id', {}, {
            'get'  : {
                method : 'GET',
                isArray: true
            },
            'query': {
                method : 'GET',
                isArray: true,
                params : {
                    search: null
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$state', 'AuditsService', 'ParseLinks', 'PaginationUtil'];

    function AuditsController($state, AuditsService, ParseLinks, PaginationUtil) {
        var vm = this;

        vm.audits = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.totalItems = null;
        vm.loadAll = loadAll;
        vm.isSearchActive = isSearchActive;
        vm.reset = reset;

        function loadAll() {
            vm.filters = PaginationUtil.updateFilters($state.current.name, vm.page - 1, vm.filters.filterBy, vm.predicate, vm.reverse, vm.itemsPerPage);

            AuditsService.query(
                {
                    page: vm.filters.currentPage,
                    size: vm.filters.itemsPerPage,
                    search: search(),
                    sort: sort()
                },
                function(result, headers) {
                    vm.audits = result;
                    vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                }
            );

            function sort() {
                if (!vm.predicate) {
                    vm.predicate = 'auditEventDate';
                }
                return [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            }
        }

        function search() {
            var result = '';
            for (var x in vm.filters.filterBy) {
                if (vm.filters.filterBy[x] && vm.filters.filterBy[x].fromDate) {
                    result +=
                        vm.filters.filterBy[x].name +
                        '>' +
                        moment(vm.filters.filterBy[x].fromDate)
                            .tz('Europe/Lisbon')
                            .set({
                                hours: 0,
                                minutes: 0,
                                seconds: 0
                            })
                            .toISOString(true) +
                        '#AND,';
                }
                if (vm.filters.filterBy[x] && vm.filters.filterBy[x].to_date) {
                    result +=
                        vm.filters.filterBy[x].name +
                        '<' +
                        moment(vm.filters.filterBy[x].to_date)
                            .tz('Europe/Lisbon')
                            .set({
                                hours: 0,
                                minutes: 0,
                                seconds: 0
                            })
                            .toISOString(true) +
                        '#AND,';
                }
                if (vm.filters.filterBy[x] && vm.filters.filterBy[x].value) {
                    result += vm.filters.filterBy[x].name + ':' + vm.filters.filterBy[x].value + '#AND,';
                }
            }
            return result;
        }

        function isSearchActive() {
            return (
                vm.filters.filterBy.user.value || vm.filters.filterBy.auditDate.fromDate || vm.filters.filterBy.auditDate.to_date || vm.filters.filterBy.status.value
            );
        }

        function reset() {
            vm.filters = PaginationUtil.clearFilters($state.current.name, filterBy());
            loadAll();
        }

        function filterBy() {
            return {
                user: {
                    name: 'principal',
                    value: undefined
                },
                auditDate: {
                    name: 'auditEventDate',
                    fromDate: undefined,
                    to_date: undefined
                },
                status: {
                    name: 'auditEventType',
                    value: undefined
                }
            };
        }

        function initFilters() {
            vm.filters = PaginationUtil.getFilters($state.current.name, filterBy());

            vm.page = vm.filters.currentPage + 1;
            vm.predicate = vm.filters.orderBy;
            vm.reverse = vm.filters.orderReverse;
            loadAll();
        }

        vm.$onInit = function() {
            initFilters();
        };

        function loadPage(page) {
            vm.page = page;
            vm.loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin-documents', {
            parent: 'admin',
            url: '/admin-documents?page&sort',
            data: {
                authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                pageTitle: 'document.home.title',
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/admin-documents/admin-documents.html',
                    controller: 'AdminDocumentsController',
                    controllerAs: 'vm',
                },
            },
            params: {
                page: {
                    value: '1',
                    squash: true,
                },
                sort: {
                    value: 'id,asc',
                    squash: true,
                },
                search: null,
            },
            resolve: {
                pagingParams: [
                    '$stateParams',
                    'PaginationUtil',
                    function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                        };
                    },
                ],
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('document');
                        $translatePartialLoader.addPart('documentType');
                        $translatePartialLoader.addPart('documentInternalType');
                        $translatePartialLoader.addPart('documentStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    },
                ],
            },
        });
    }
})();

/* global moment:true, _:true*/
(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('AdminDocumentsController', AdminDocumentsController);

  AdminDocumentsController.$inject = [
    '$state',
    '$scope',
    'DataUtils',
    'Document',
    'ParseLinks',
    'AlertService',
    'paginationConstants',
    'PaginationUtil',
    'DocumentDownloadPdf',
    'CurrencyUtils',
    '$window',
  ];

  function AdminDocumentsController(
    $state,
    $scope,
    DataUtils,
    Document,
    ParseLinks,
    AlertService,
    paginationConstants,
    PaginationUtil,
    DocumentDownloadPdf,
    CurrencyUtils,
    $window
  ) {
    var vm = this;

    vm.itemsPerPage = paginationConstants.itemsPerPage;
    vm.downloaded = downloaded;
    vm.download = download;
    vm.search = search;
    vm.reset = reset;
    vm.loadAll = loadAll;
    vm.initFilters = initFilters;
    vm.totalItems = 1000;
    vm.isTableLoading = true;
    vm.isSearchActive = isSearchActive;
    vm.getCurrency = CurrencyUtils.getCurrency;
    vm.changeInternalType = changeInternalType;
    vm.getViewableFilename = DataUtils.getViewableFilename;
    vm.formatFileSize = DataUtils.formatFileSize;
    vm.getFileIconClass = DataUtils.getFileIconClass;
    vm.internalTypes = ['GENERIC', 'ELECTRONIC_BILLING', 'DIGITAL_ARCHIVE'];

    vm.documentsToExport = {};

    function isSmallScreen() {
      var w = angular.element($window);
      vm.width = w.width();
      $scope.$apply();
      // return document.body.clientWidth < 500;
    }

    $(window).resize(function () {
      isSmallScreen();
    });

    function isSearchActive() {
      return (
        vm.filters.filterBy.documentNumber.value ||
        angular.isDefined(vm.filters.filterBy.internalType.value) ||
        vm.filters.filterBy.origin.value ||
        vm.filters.filterBy.destination.value ||
        vm.filters.filterBy.month.value ||
        vm.filters.filterBy.year.value
      );
    }

    function changeInternalType(value) {
      if (angular.isUndefined(value)) {
        vm.filters.filterBy.internalType.value = value;
      } else {
        vm.filters.filterBy.internalType.value = '' + value;
      }
      vm.page = 1;
      loadAll();
    }

    function reset() {
      vm.filters = PaginationUtil.clearFilters($state.current.name, filterBy());
      loadAll();
    }

    function filterBy() {
      return {
        documentNumber: {
          name: 'documentNumber',
          value: undefined,
        },
        internalType: {
          name: 'internalType',
          value: undefined,
        },
        origin: {
          name: 'origin.name',
          value: undefined,
        },
        destination: {
          name: 'communicationDefinition.destination.name',
          value: undefined,
        },
        year: {
          name: 'createdDate',
          value: undefined,
        },
        month: {
          name: 'createdDate',
          value: undefined,
        },
      };
    }

    function initFilters() {
      vm.filters = PaginationUtil.getFilters($state.current.name, filterBy());

      vm.page = vm.filters.currentPage + 1;
      vm.predicate = vm.filters.orderBy;
      vm.reverse = vm.filters.orderReverse;
      loadAll();
    }

    vm.$onInit = function () {
      initFilters();
    };

    function loadAll() {
      vm.filters = PaginationUtil.updateFilters($state.current.name, vm.page - 1, vm.filters.filterBy, vm.predicate, vm.reverse, vm.itemsPerPage);
      Document.queryForAdmin(
        {
          page: vm.filters.currentPage,
          size: vm.filters.itemsPerPage,
          search: search(),
          sort: sort(),
        },
        onSuccess,
        onError
      );

      function sort() {
        if (!vm.predicate) {
          vm.predicate = 'createdDate';
        }
        var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
        if (vm.predicate !== 'createdDate') {
          result.push('createdDate,desc');
        }
        return result;
      }

      function onSuccess(data, headers) {
        vm.links = ParseLinks.parse(headers('link'));
        vm.totalItems = headers('X-Total-Count');
        vm.queryCount = vm.totalItems;
        vm.documents = data;
      }

      function onError(error) {
        AlertService.error(error.data.message);
      }
    }

    function search() {
      var result = '';
      for (var x in vm.filters.filterBy) {
        if (x !== 'year' && x !== 'month') {
          if (vm.filters.filterBy[x] && angular.isDefined(vm.filters.filterBy[x].value) && vm.filters.filterBy[x].value.length > 0) {
            result += vm.filters.filterBy[x].name + ':' + vm.filters.filterBy[x].value + '#AND,';
          }
        }
      }
      var tempInit;
      var beginDate;
      var endDate;
      if (angular.isDefined(vm.filters.filterBy.year && vm.filters.filterBy.year.value)) {
        if (angular.isDefined(vm.filters.filterBy.month && vm.filters.filterBy.month.value) && vm.filters.filterBy.month.value !== 0) {
          tempInit = vm.filters.filterBy.year.value + '/' + vm.filters.filterBy.month.value + '/' + '15';
          beginDate = moment(tempInit).tz('Europe/Lisbon').startOf('month');
          if (beginDate.isDST()) {
            beginDate.add(1, 'hour');
          }
          endDate = moment(tempInit).tz('Europe/Lisbon').endOf('month');
          if (endDate.isDST()) {
            endDate.add(1, 'hour');
          }
          result += vm.filters.filterBy.month.name + '>=' + beginDate.toISOString(true) + '#AND,';
          result += vm.filters.filterBy.month.name + '<=' + endDate.toISOString(true) + '#AND,';
        } else {
          tempInit = vm.filters.filterBy.year.value + '/06/15';

          beginDate = moment(tempInit).tz('Europe/Lisbon').startOf('year');
          if (beginDate.isDST()) {
            beginDate.add(1, 'hour');
          }
          endDate = moment(tempInit).tz('Europe/Lisbon').endOf('year');
          if (endDate.isDST()) {
            endDate.add(1, 'hour');
          }

          result += vm.filters.filterBy.month.name + '>=' + beginDate.toISOString(true) + '#AND,';
          result += vm.filters.filterBy.month.name + '<=' + endDate.toISOString(true) + '#AND,';
        }
      } else {
        if (angular.isDefined(vm.filters.filterBy.month && vm.filters.filterBy.month.value) && vm.filters.filterBy.month.value !== 0) {
          var date = new Date();
          var year = date.getFullYear();
          tempInit = year + '/' + vm.filters.filterBy.month.value + '/' + '15';

          beginDate = moment(tempInit).tz('Europe/Lisbon').startOf('month');
          if (beginDate.isDST()) {
            beginDate.add(1, 'hour');
          }
          endDate = moment(tempInit).tz('Europe/Lisbon').endOf('month');
          if (endDate.isDST()) {
            endDate.add(1, 'hour');
          }
          result += vm.filters.filterBy.month.name + '>=' + beginDate.toISOString(true) + '#AND,';
          result += vm.filters.filterBy.month.name + '<=' + endDate.toISOString(true) + '#AND,';

          vm.filters.filterBy.year.value = year;
        }
      }
      return result;
    }

    function downloaded(document, id) {
      return document.documentDownloads.filter(function (documentDownload) {
        return documentDownload.fileId === id;
      }).length;
    }

    function download($event, document, fileId, fileType) {
      DocumentDownloadPdf.download($event, document, fileId, fileType);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settings');
                        return $translate.refresh();
                    }
                ]
            }
        });
    }
})();

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('SettingsController', SettingsController);

  SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', 'CommunicationEntity', '$translate', 'DataUtils', '$scope', '$rootScope'];

  function SettingsController(Principal, Auth, JhiLanguageService, CommunicationEntity, $translate, DataUtils, $scope, $rootScope) {
    var vm = this;
    vm.error = null;
    vm.save = save;
    vm.setDocumentFile = setDocumentFile;
    vm.settingsAccount = null;
    vm.userId = null;
    vm.entities = [];
    vm.isManagerForEntity = isManagerForEntity;
    vm.isEmailReceiverForEntity = isEmailReceiverForEntity;
    vm.success = null;
    vm.tmpCropedImgURL = '';
    vm.tmpImageBlob = '';
    vm.tmpImageCropped = undefined;
    vm.clearImage = clearImage;
    /**
     * Store the "settings account" in a separate variable, and not in the shared "account" variable.
     */
    var copyAccount = function (account) {
      return {
        activated: account.activated,
        email: account.email,
        firstName: account.firstName,
        langKey: account.langKey,
        image: account.image,
        imageContentType: account.imageContentType,
        lastName: account.lastName,
        login: account.login,
      };
    };

    Principal.identity(true).then(function (account) {
      vm.settingsAccount = copyAccount(account);
      vm.userId = account.id;
      if (vm.settingsAccount.image && vm.settingsAccount.imageContentType) {
        vm.settingsAccount.imageURL = 'data:' + vm.settingsAccount.imageContentType + ';base64,' + vm.settingsAccount.image;
      }
      if (account && account.id) {
        CommunicationEntity.findAllByUser({ user: account.id }).$promise.then(function (res) {
          vm.entities = res;
        });
      }
    });

    function clearImage() {
      vm.tmpImageURL = undefined;
      vm.tmpImageCropped = null;
      vm.settingsAccount.imageURL = null;
      vm.settingsAccount.image = null;
      vm.settingsAccount.imageContentType = null;
    }

    function save() {
      if (vm.tmpImageCropped && vm.tmpImageCropped !== null) {
        vm.settingsAccount.image = vm.tmpImageCropped.substr(vm.tmpImageCropped.indexOf('base64,') + 'base64,'.length);
        vm.settingsAccount.imageContentType = vm.tmpImageBlob.type;
        vm.tmpImageURL = undefined;
      }

      if (vm.settingsAccount.image && vm.settingsAccount.imageContentType) {
        vm.entidadeImageURL = 'data:' + vm.settingsAccount.imageContentType + ';base64,' + vm.settingsAccount.image;
      }
      vm.tmpImageCropped = undefined;
      Auth.updateAccount(vm.settingsAccount)
        .then(function () {
          vm.error = null;
          vm.success = 'OK';
          Principal.identity(true).then(function (account) {
            vm.settingsAccount = copyAccount(account);
            if (vm.settingsAccount.image && vm.settingsAccount.imageContentType) {
              vm.settingsAccount.imageURL = 'data:' + vm.settingsAccount.imageContentType + ';base64,' + vm.settingsAccount.image;
            }
          });
          JhiLanguageService.getCurrent().then(function (current) {
            if (vm.settingsAccount.langKey !== current) {
              $translate.use(vm.settingsAccount.langKey);
            }
          });
          $rootScope.$broadcast('updateAccountSuccess');
        })
        .catch(function () {
          vm.success = null;
          vm.error = 'ERROR';
        });
    }

    function setDocumentFile($file, invalid) {
      if ($file) {
        DataUtils.toBase64($file, function (base64Data) {
          $scope.$apply(function () {
            vm.tmpImage = base64Data;
            vm.tmpImageContentType = $file.type;
            vm.tmpImageURL = 'data:' + vm.tmpImageContentType + ';base64,' + vm.tmpImage;
          });
        });
      }
      if (invalid.length > 0) {
        Notification.error({
          title: 'Ficheiro Inválido!', // TODO translate
          message: 'Apenas imagens!', // TODO translate
        });
      }
    }

    function isManagerForEntity(item) {
      var itemForUserAndEntity = item.userEntities.filter(function (userEntity) {
        return userEntity.userId === vm.userId && userEntity.entityId === item.id;
      });
      return itemForUserAndEntity[0].manager;
    }

    function isEmailReceiverForEntity(item) {
      var itemForUserAndEntity = item.userEntities.filter(function (userEntity) {
        return userEntity.userId === vm.userId && userEntity.entityId === item.id;
      });
      return itemForUserAndEntity[0].emailReceiver;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants', '$uibModalInstance'];

    function RequestResetController($timeout, Auth, errorConstants, $uibModalInstance) {
        var vm = this;
        vm.errorEmailNotExists = null;
        vm.email = null;
        vm.success = null;
        vm.isSaving = false;
        vm.cancel = cancel;
        vm.requestReset = requestReset;

        $timeout(function () {
            angular.element('#email').focus();
        });

        function cancel() {
            vm.email = null;
            $uibModalInstance.dismiss('cancel');
        }

        function requestReset() {
            vm.errorEmailNotExists = null;
            vm.isSaving = true;
            Auth.resetPasswordInit(vm.email).then(function () {
                vm.isSaving = false;
                vm.success = 'OK';
                vm.email = null;
            }).catch(function (response) {
                vm.isSaving = false;
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('finishReset', {
                parent: 'main-index',
                url: '/reset/finish?key',
                data: {
                    authorities: []
                },
                onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/account/reset/finish/reset.finish.html',
                        controller: 'ResetFinishController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        resolve: {}
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }],
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reset');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', '$state', '$uibModalInstance', 'Auth', 'LoginService'];

    function ResetFinishController($stateParams, $timeout, $state, $uibModalInstance, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.resetAccount = {};
        vm.success = null;
        vm.login = login;
        vm.cancel = cancel;
        vm.finishReset = finishReset;

        $timeout(function () {
            angular.element('#password').focus();
        });

        function login() {
            $uibModalInstance.dismiss('cancel');
            $state.go('landing-page');
            LoginService.open();
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
            $state.go('landing-page');
        }

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({
                    key: $stateParams.key,
                    newPassword: vm.resetAccount.password
                }).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        return {
            replace : true,
            restrict: 'E',
            template: '<div id="strength">' + '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' + '<ul id="strengthBar">' + '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' + '</ul>' + '</div>',
            scope   : {
                passwordToCheck: '='
            },
            link    : linkFunc
        };

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER', 'ROLE_SUPERADMIN', 'ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_DIGITAL_ARCHIVE'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('password');
                        return $translate.refresh();
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('eDocumentsApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div id="homepage" ng-cloak><div class="container-fluid"><div class="row d-flex"><div class="col"><div class="btn-group"><button type="button" class="btn btn-secondary" data-translate="home.dashboard.entity">Entidade</button> <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span ng-if="vm.company != \'all\'">{{vm.company}}</span> <span ng-if="vm.company == \'all\'" data-translate="home.dashboard.all">Todas</span></button><div class="dropdown-menu"><a class="dropdown-item" ng-repeat="company in vm.companies" ng-click="vm.changeCompany(company)"><span ng-if="company != \'all\'">{{company}}</span> <span ng-if="company == \'all\'" data-translate="home.dashboard.all">Todas</span></a></div></div></div></div></div><section class="dashboard-counts section-padding"><div class="container-fluid"><div class="row d-flex"><div class="col-lg-6"><div class="card income text-center"><div class="row"><div class="col"><div class="text-center"><strong class="text-primary" style="font-size: 1.5em;font-weight: bolder;margin: 20px 0" data-translate="home.dashboard.sentTitle">Documentos enviados atrav\xE9s da plataforma</strong></div></div></div><div class="row ml-2 d-flex"><div class="col"><div class="wrapper count-title d-flex" ui-sref="communication-entity"><div class="icon"><i class="fas fa-user"></i></div><div class="name text-center"><strong class="text-uppercase" data-translate="home.dashboard.entities">Entidades</strong><span>&nbsp;</span><div class="count-number">{{vm.clients.origin}}</div></div></div></div><div class="col"><div class="wrapper count-title d-flex" ui-sref="document"><div class="icon"><i class="fas fa-sticky-note"></i></div><div class="name text-left"><strong class="text-uppercase" data-translate="home.dashboard.documents">Documentos</strong><span>&nbsp;</span><div class="count-number" ng-if="vm.documents.origin.INVOICE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.INVOICE\' | translate}}:</span> {{vm.documents.origin.INVOICE}}</div><div class="count-number" ng-if="vm.documents.origin.CREDITNOTE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.CREDITNOTE\' | translate}}:</span> {{vm.documents.origin.CREDITNOTE}}</div><div class="count-number" ng-if="vm.documents.origin.DEBITNOTE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.DEBITNOTE\' | translate}}:</span> {{vm.documents.origin.DEBITNOTE}}</div><span class="badge badge-danger" ng-if="vm.status.origin.ERROR > 0">{{vm.status.origin.ERROR}} {{\'home.dashboard.inError\' | translate}}</span></div></div></div><div class="col"><div class="wrapper count-title d-flex"><div class="icon"><i class="fas fa-list-alt"></i></div><div class="name text-right"><strong class="text-uppercase" data-translate="home.dashboard.total">Total (\u20AC)</strong><span>&nbsp;</span><div class="count-number" ng-if="vm.documents.origin.INVOICE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.INVOICE\' | translate}}:</span> {{vm.values.origin.INVOICE ? vm.values.origin.INVOICE : 0 | number : 2}}</div><div class="count-number" ng-if="vm.documents.origin.CREDITNOTE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.CREDITNOTE\' | translate}}:</span> {{vm.values.origin.CREDITNOTE ? vm.values.origin.CREDITNOTE : 0| number : 2}}</div><div class="count-number" ng-if="vm.documents.origin.DEBITNOTE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.DEBITNOTE\' | translate}}:</span> {{vm.values.origin.DEBITNOTE ? vm.values.origin.DEBITNOTE : 0| number : 2}}</div></div></div></div></div></div></div><div class="col-lg-6"><div class="card income text-center"><div class="row"><div class="col"><div class="text-center"><p class="text-primary" style="font-size: 1.5em;font-weight: bolder;margin: 20px 0" data-translate="home.dashboard.receivedTitle">Documentos recebidos atrav\xE9s da plataforma</p></div></div></div><div class="row ml-2 d-flex"><div class="col"><div class="wrapper count-title d-flex" ui-sref="communication-entity"><div class="icon"><i class="fas fa-user"></i></div><div class="name text-center"><strong class="text-uppercase" data-translate="home.dashboard.entities">Entidades</strong><span>&nbsp;</span><div class="count-number">{{vm.clients.destination}}</div></div></div></div><div class="col"><div class="wrapper count-title d-flex" ui-sref="document"><div class="icon"><i class="fas fa-sticky-note"></i></div><div class="name text-left"><strong class="text-uppercase" data-translate="home.dashboard.documents">Documentos</strong><span>&nbsp;</span><div class="count-number" ng-if="vm.documents.destination.INVOICE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.INVOICE\' | translate}}:</span> {{vm.documents.destination.INVOICE}}</div><div class="count-number" ng-if="vm.documents.destination.CREDITNOTE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.CREDITNOTE\' | translate}}:</span> {{vm.documents.destination.CREDITNOTE}}</div><div class="count-number" ng-if="vm.documents.destination.DEBITNOTE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.DEBITNOTE\' | translate}}:</span> {{vm.documents.destination.DEBITNOTE}}</div><span class="badge badge-danger" ng-if="vm.status.destination.ERROR > 0">{{vm.status.destination.ERROR}} {{\'home.dashboard.inError\' | translate}}</span></div></div></div><div class="col"><div class="wrapper count-title d-flex"><div class="icon"><i class="fas fa-list-alt"></i></div><div class="name text-right"><strong class="text-uppercase" data-translate="home.dashboard.total">Total (\u20AC)</strong><span>&nbsp;</span><div class="count-number" ng-if="vm.documents.destination.INVOICE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.INVOICE\' | translate}}:</span> {{vm.values.destination.INVOICE ? vm.values.destination.INVOICE : 0 | number : 2}}</div><div class="count-number" ng-if="vm.documents.destination.CREDITNOTE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.CREDITNOTE\' | translate}}:</span> {{vm.values.destination.CREDITNOTE ? vm.values.destination.CREDITNOTE : 0| number : 2}}</div><div class="count-number" ng-if="vm.documents.destination.DEBITNOTE > 0"><span style="font-size: 12px;line-height: 20px;vertical-align: middle">{{\'eDocumentsApp.DocumentType.DEBITNOTE\' | translate}}:</span> {{vm.values.destination.DEBITNOTE ? vm.values.destination.DEBITNOTE : 0| number : 2}}</div></div></div></div></div></div></div></div></div></section><section class="statistics"><div class="container-fluid"><div class="row d-flex"><div class="col-lg-6"><div class="card income text-center"><div class="icon"><i class="icon-line-chart"></i></div><!--<div class="number">{{vm.valuesSent | currency}}</div>--><div class="number">{{vm.valuesSent | number:2}} \u20AC</div><strong class="text-primary" data-translate="home.dashboard.totalSent">Total enviado</strong></div></div><div class="col-lg-6"><div class="card income text-center"><div class="icon"><i class="icon-line-chart"></i></div><!--<div class="number">{{vm.valuesReceived | currency}}</div>--><div class="number">{{vm.valuesReceived | number:2}} \u20AC</div><strong class="text-primary" data-translate="home.dashboard.totalReceived">Total recebido</strong></div></div></div></div></section><section class="mt-30px mb-30px"><div class="container-fluid"><div class="row"><div class="col-lg-6 col-md-12"><div id="new-updates" class="card updates recent-updated"><div id="updates-header" class="card-header d-flex justify-content-between align-items-center"><h2 class="h5 display"><a data-toggle="collapse" data-parent="#new-updates" href="#updates-box" aria-expanded="true" aria-controls="updates-box">{{\'home.last10Sent\' | translate}}</a></h2><a data-toggle="collapse" data-parent="#new-updates" href="#updates-box" aria-expanded="true" aria-controls="updates-box"><i class="fa fa-angle-down"></i></a></div><div id="updates-box" role="tabpanel" class="collapse show"><ul class="news list-unstyled"><li class="d-flex justify-content-between" ng-repeat="document in vm.last10Sent"><div class="left-col d-flex"><div class="icon"><span class="btn bg-{{document.status}}"></span></div><a ui-sref="document-detail({id:document.id})"><div class="title"><span class="badge badge-{{document.documentType}}">{{\'eDocumentsApp.DocumentType.\' + document.documentType | translate}}</span> <span ng-if="(document.documentType == \'SELFBILLED\' || document.documentType == \'CREDITNOTE\') && document.approved" uib-tooltip="{{ \'eDocumentsApp.document.approve.tooltip\' | translate:document }}"><i class="fas fa-check text-success"></i> </span><strong>{{document.documentNumber}}</strong><p>{{document.destination}} - <span class="badge">{{\'eDocumentsApp.DocumentStatus.\' + document.status | translate}}</span></p><p>{{document.documentValue | currency : vm.getCurrency(document.currency) :2 }}</p></div></a></div><div class="right-col text-right"><div class="update-date">{{document.documentDate | date:\'dd\'}}<span class="month">{{document.documentDate | date:\'MMM\'}}</span></div><button class="btn btn-primary btn-sm" uib-tooltip=" Download {{file.fileType}}" ng-click="vm.download($event,document, file.id,file.fileType)" ng-repeat="file in document.files"><i class="far" ng-class="vm.getFileIconClass(file.fileType)"></i></button></div></li></ul></div></div></div><div class="col-lg-6 col-md-12"><div id="daily-feeds" class="card updates daily-feeds"><div id="feeds-header" class="card-header d-flex justify-content-between align-items-center"><h2 class="h5 display"><a data-toggle="collapse" data-parent="#daily-feeds" href="#feeds-box" aria-expanded="true" aria-controls="feeds-box">{{\'home.last10Received\' | translate}}</a></h2><a data-toggle="collapse" data-parent="#new-updates" href="#feeds-box" aria-expanded="true" aria-controls="feeds-box"><i class="fa fa-angle-down"></i></a></div><div id="feeds-box" role="tabpanel" class="collapse show"><div class="feed-box"><ul class="news list-unstyled"><li class="d-flex justify-content-between" ng-repeat="document in vm.last10Received"><div class="left-col d-flex"><div class="icon"><span class="btn bg-{{document.status}}"></span></div><a ui-sref="document-detail({id:document.id})"><div class="title"><span class="badge badge-{{document.documentType}}">{{\'eDocumentsApp.DocumentType.\' + document.documentType | translate}}</span><strong>{{document.documentNumber}}</strong><p>{{document.destination}} - <span class="badge">{{\'eDocumentsApp.DocumentStatus.\' + document.status | translate}}</span></p><p>{{document.documentValue | currency : vm.getCurrency(document.currency) :2 }}</p></div></a></div><div class="right-col text-right"><div class="update-date">{{document.documentDate | date:\'dd\'}}<span class="month">{{document.documentDate | date:\'MMM\'}}</span></div><button class="btn btn-primary btn-sm" uib-tooltip=" Download {{file.fileType}}" ng-click="vm.download($event,document, file.id,file.fileType)" ng-repeat="file in document.files"><i class="far" ng-class="vm.getFileIconClass(file.fileType)"></i></button></div></li></ul></div></div></div></div></div></div></section></div>');
$templateCache.put('app/layouts/main-index.html','<div id="content" style="padding-bottom: 50px"><div ui-view="navbar@" id="navbar" class="active" ng-cloak></div><div ui-view="content@" class="p-4 pt-lg-0"><script>var isIE = /*@cc_on!@*/false || !!document.documentMode;\n            if (isIE === true) {\n                alert(\'O Internet Explorer n\xE3o \xE9 suportado. Para uma melhor experi\xEAncia de navega\xE7\xE3o, por favor aceda utilizando outro navegador.\');\n            }</script></div></div>');
$templateCache.put('app/layouts/main.html','<!-- The sidebar scrolls natively. It used to carry ng-scrollbars (the malihu plugin), which\n     wraps these children in boxes of its own; no layout rule applied from _sidebar.scss reached\n     past that wrapper, so the nav could not be made to scroll and its last items were\n     unreachable on a short viewport. See the flex column in scss/_sidebar.scss. --><nav id="sidebar" ui-view="sidebar@"></nav><div id="content" style="padding-bottom: 50px"><div ui-view="navbar@" id="navbar" class="active" ng-cloak></div><div ui-view="content@" class="p-4 pt-lg-0"><script>var isIE = /*@cc_on!@*/false || !!document.documentMode;\n            if (isIE === true) {\n                alert(\'O Internet Explorer n\xE3o \xE9 suportado. Para uma melhor experi\xEAncia de navega\xE7\xE3o, por favor aceda utilizando outro navegador.\');\n            }</script></div></div>');
$templateCache.put('app/smart-search/smart-search.html','<div><jhi-alert></jhi-alert><form><div class="form-group row"><div class="col-md-3"><h2><span data-translate="eDocumentsApp.smart-search.home.title">Smart Search</span> <strong><sup data-translate="global.beta">BETA</sup></strong></h2></div><div class="col-md-6"><input type="text" class="form-control" ng-model="vm.omniboxSearchValue"></div><div class="col-md-3 btn-group"><button class="btn btn-primary btn-sm col-sm-6" ng-click="vm.page = 1; vm.loadAll()"><i class="fas fa-search"></i> <span data-translate="entity.action.search">Pesquisar</span></button> <button class="btn btn-dark btn-sm col-sm-6" ng-if="vm.omniboxSearchValue" ng-click="vm.reset()"><i class="fas fa-trash-alt"></i> <span data-translate="entity.action.clear">Limpar</span></button></div></div></form><div ng-if="vm.emptySearchBox"><p data-translate="eDocumentsApp.smart-search.writeToSearch">Write to search</p></div><div ng-if="!vm.emptySearchBox && vm.invoiceHeaders.length == 0 && vm.invoiceLines.length == 0 && vm.communicationEntities.length == 0"><p data-translate="eDocumentsApp.smart-search.noInformationFoundForKeyword">No information found for keyword</p></div><!-- Invoice Headers --><div class="accordion card" ng-if="vm.invoiceHeaders && vm.invoiceHeaders.length > 0"><h5 class="card-header" data-toggle="collapse" data-target="#collapseInvoiceHeaders" aria-expanded="true" aria-controls="collapseInvoiceHeaders" id="invoiceHeadersHeader" ng-click="vm.isCollapseInvoiceHeadersOpen = !vm.isCollapseInvoiceHeadersOpen;" style="cursor: pointer"><span data-translate="eDocumentsApp.invoiceHeader.home.title">Invoice Headers</span> <span class="badge badge-pill badge-secondary">{{vm.pagination.invoiceHeader.totalItems}}</span> <span ng-if="!vm.isCollapseInvoiceHeadersOpen" style="float: right"><i class="fas fa-angle-right"></i> </span><span ng-if="vm.isCollapseInvoiceHeadersOpen" style="float: right"><i class="fas fa-angle-down"></i></span></h5><div class="card-body collapse" id="collapseInvoiceHeaders" aria-labelledby="invoiceHeadersHeader" data-parent="#invoiceHeadersHeader"><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate.invoiceHeader" ascending="vm.reverse.invoiceHeader" callback="vm.loadInvoiceHeaders()"><th jh-sort-by="documentType"><span data-translate="eDocumentsApp.invoiceHeader.documentType">Document Type</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentSeries"><span data-translate="eDocumentsApp.invoiceHeader.documentSeries">Document Series</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentNumber"><span data-translate="eDocumentsApp.invoiceHeader.documentNumber">Document Number</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="salesOrderNumber"><span data-translate="eDocumentsApp.invoiceHeader.salesOrderNumber">Sales Order Number</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="salesOrderDate"><span data-translate="eDocumentsApp.invoiceHeader.salesOrderDate">Sales Order Date</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="customerOrderReference"><span data-translate="eDocumentsApp.invoiceHeader.customerOrderReference">Customer Order Reference</span><!--  should be PurchaseOrderNumber --> <i class="fas sort fa-sort"></i></th><th jh-sort-by="currencyCode"><span data-translate="eDocumentsApp.invoiceHeader.currencyCode">Currency Code</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="totalAmount"><span data-translate="eDocumentsApp.invoiceHeader.totalAmount">Total Amount</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="salesReference"><span data-translate="eDocumentsApp.invoiceHeader.salesReference">Sales Reference</span> <i class="fas sort fa-sort"></i></th><th></th></tr></thead><tbody><tr ng-repeat="invoiceHeader in vm.invoiceHeaders track by invoiceHeader.id"><td>{{\'eDocumentsApp.InvoiceType.\' + invoiceHeader.documentType | translate}}{{}}</td><td>{{invoiceHeader.documentSeries}}</td><td>{{invoiceHeader.documentNumber}}</td><td>{{invoiceHeader.salesOrderNumber}}</td><td>{{invoiceHeader.salesOrderDate | date:\'mediumDate\'}}</td><td>{{invoiceHeader.customerOrderReference}}</td><td>{{invoiceHeader.currencyCode}}</td><td>{{invoiceHeader.totalAmount}}</td><td>{{invoiceHeader.salesReference}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="document-detail({id:invoiceHeader.documentId})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="eDocumentsApp.smart-search.action.viewDocument">View Document</span></a></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.invoiceHeaders.length > 0"><jhi-item-count page="vm.pagination.invoiceHeader.page" total="vm.pagination.invoiceHeader.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.pagination.invoiceHeader.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.pagination.invoiceHeader.page" ng-change="vm.loadInvoiceHeaders()"></div></div></div></div><!-- Invoice Lines --><div class="accordion card" ng-if="vm.invoiceLines && vm.invoiceLines.length > 0"><h5 class="card-header" data-toggle="collapse" data-target="#collapseInvoiceLines" aria-expanded="true" aria-controls="collapseInvoiceLines" id="InvoiceLines" ng-click="vm.isCollapseInvoiceLinesOpen = !vm.isCollapseInvoiceLinesOpen;" style="cursor: pointer"><span data-translate="eDocumentsApp.invoiceLine.smartSearch.title">Linhas de documentos comerciais</span> <span class="badge badge-pill badge-secondary">{{vm.pagination.invoiceLine.totalItems}}</span> <span ng-if="!vm.isCollapseInvoiceLinesOpen" style="float: right"><i class="fas fa-angle-right"></i> </span><span ng-if="vm.isCollapseInvoiceLinesOpen" style="float: right"><i class="fas fa-angle-down"></i></span></h5><div class="card-body collapse" id="collapseInvoiceLines" aria-labelledby="invoiceLines" data-parent="#InvoiceLines"><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate.invoiceLine" ascending="vm.reverse.invoiceLine" callback="vm.loadInvoiceLines()"><th jh-sort-by="lineNumber"><span data-translate="eDocumentsApp.invoiceLine.lineNumber">Line number</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="itemCode"><span data-translate="eDocumentsApp.invoiceLine.itemCode">Item code</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="itemDescription"><span data-translate="eDocumentsApp.invoiceLine.itemDescription">Item description</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="supplierLotCode"><span data-translate="eDocumentsApp.invoiceLine.supplierLotCode">Supplier lot code</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="document.documentNumber"><span data-translate="eDocumentsApp.invoiceLine.document">Document Number</span> <i class="fas sort fa-sort"></i></th><th></th></tr></thead><tbody><tr ng-repeat="invoiceLine in vm.invoiceLines track by invoiceLine.id"><td>{{invoiceLine.lineNumber}}</td><td>{{invoiceLine.itemCode}}</td><td>{{invoiceLine.itemDescription}}</td><td>{{invoiceLine.supplierLotCode}}</td><td>{{invoiceLine.documentNumber}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="document-detail({id:invoiceLine.documentId})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="eDocumentsApp.smart-search.action.viewDocument">View Document</span></a></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.invoiceLines.length > 0"><jhi-item-count page="vm.pagination.invoiceLine.page" total="vm.pagination.invoiceLine.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.pagination.invoiceLine.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.pagination.invoiceLine.page" ng-change="vm.loadinvoiceLines()"></div></div></div></div><!-- Communication Entities --><div class="accordion card" ng-if="vm.communicationEntities && vm.communicationEntities.length > 0"><h5 class="card-header" data-toggle="collapse" data-target="#collapseCommunicationEntities" aria-expanded="true" aria-controls="collapsedCommunicationEntities" id="communicationEntitiesHeader" ng-click="vm.isCollapsedCommunicationEntitiesOpen = !vm.isCollapsedCommunicationEntitiesOpen;" style="cursor: pointer"><span data-translate="eDocumentsApp.communicationEntity.home.title">Communication Entities</span> <span class="badge badge-pill badge-secondary">{{vm.pagination.communicationEntity.totalItems}}</span> <span ng-if="!vm.isCollapsedCommunicationEntitiesOpen" style="float: right"><i class="fas fa-angle-right"></i> </span><span ng-if="vm.isCollapsedCommunicationEntitiesOpen" style="float: right"><i class="fas fa-angle-down"></i></span></h5><div class="card-body collapse" id="collapseCommunicationEntities" aria-labelledby="communicationEntitiesHeader" data-parent="#communicationEntitiesHeader"><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate.communicationEntity" ascending="vm.reverse.communicationEntity" callback="vm.loadCommunicationEntities()"><th jh-sort-by="name"><span data-translate="eDocumentsApp.communicationEntity.name">Name</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="gln"><span data-translate="eDocumentsApp.communicationEntity.gln">Gln</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="company"><span data-translate="eDocumentsApp.communicationEntity.company">Company</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="society"><span data-translate="eDocumentsApp.communicationEntity.society">Society</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="email"><span data-translate="eDocumentsApp.communicationEntity.email">Email</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="cc"><span data-translate="eDocumentsApp.communicationEntity.cc">Cc</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="bcc"><span data-translate="eDocumentsApp.communicationEntity.bcc">Bcc</span> <i class="fas sort fa-sort"></i></th><th></th></tr></thead><tbody><tr ng-repeat="communicationEntity in vm.communicationEntities track by communicationEntity.id"><td>{{communicationEntity.name}}</td><td>{{communicationEntity.gln}}</td><td>{{communicationEntity.company}}</td><td>{{communicationEntity.society}}</td><td>{{communicationEntity.email}}</td><td>{{communicationEntity.cc}}</td><td>{{communicationEntity.bcc}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="communication-entity-detail({id:communicationEntity.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="eDocumentsApp.smart-search.action.viewCommunicationEntity">View Entity</span></a></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.communicationEntities.length > 0"><jhi-item-count page="vm.pagination.communicationEntity.page" total="vm.pagination.communicationEntity.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.pagination.communicationEntity.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.pagination.communicationEntity.page" ng-change="vm.loadCommunicationEntities()"></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.email}}\'}">Password for [<b>{{vm.account.email}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5 data-translate="settings.title">title</h5><hr></div><div class="container-fluid"><jhi-alert-error></jhi-alert-error><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><div class="row"><div class="col-sm-6"><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control form-control-sm" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-class="{\'is-invalid\': form.firstName.$dirty && form.firstName.$invalid}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div class="invalid-feedback" ng-show="form.firstName.$dirty &&  form.firstName.$invalid && form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</div><div class="invalid-feedback" ng-show="form.firstName.$dirty &&  form.firstName.$invalid && form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</div><div class="invalid-feedback" ng-show="form.firstName.$dirty &&  form.firstName.$invalid && form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control form-control-sm" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-class="{\'is-invalid\': form.lastName.$dirty && form.lastName.$invalid}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div class="invalid-feedback" ng-show="form.lastName.$dirty && form.lastName.$invalid && form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</div><div class="invalid-feedback" ng-show="form.lastName.$dirty && form.lastName.$invalid && form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</div><div class="invalid-feedback" ng-show="form.lastName.$dirty && form.lastName.$invalid && form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control form-control-sm" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-class="{\'is-invalid\': form.email.$dirty && form.email.$invalid}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div class="invalid-feedback" ng-show="form.email.$dirty && form.email.$invalid && form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</div><div class="invalid-feedback" ng-show="form.email.$dirty && form.email.$invalid && form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</div><div class="invalid-feedback" ng-show="form.email.$dirty && form.email.$invalid && form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</div><div class="invalid-feedback" ng-show="form.email.$dirty && form.email.$invalid && form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control form-control-sm" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div></div><div class="col-sm-6"><div class="form-row align-items-center"><div class="card align-items-center" ng-class="{\'col-md-12\':  !vm.tmpImageURL, \'col-md-6\' :vm.tmpImageURL}"><img class="card-img-top card-img-top img-fluid" style="height: 200px;width: 200px" ng-if="vm.tmpImageCropped" ng-src="{{vm.tmpImageCropped}}"> <img class="card-img-top card-img-top img-fluid" style="height: 200px;width: 200px" ng-if="!vm.tmpImageCropped && vm.settingsAccount.imageURL" ng-src="{{vm.settingsAccount.imageURL}}"><p class="card-text text-center mt-2 text-black-50" ng-if="!vm.settingsAccount.imageURL && !vm.tmpImageCropped" data-translate="settings.messages.noImageDefined">noImageDefined</p><div class="card-body text-center"><h5 class="card-title" data-translate="settings.form.profileImage">profileImage</h5><p class="card-text text-black-50" data-translate="settings.messages.pleaseChooseProfileImage">pleaseChooseProfileImage</p><button ng-if="!vm.tmpImageURL && vm.readOnly !== true" ngf-select class="btn btn-primary" ngf-pattern="\'image/*\'" ngf-change="vm.setDocumentFile($file,$invalidFiles)" ng-disabled=""><i class="fa fa-upload"></i>&nbsp;<span data-translate="settings.form.uploadImage">uploadImage</span></button> <button ng-if="vm.tmpImageURL" class="btn btn-danger" type="button" ng-click="vm.tmpImageURL = undefined;vm.tmpImageCropped=undefined;"><i class="fa fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">cancel</span></button> <button class="btn btn-dark" type="button" ng-if="vm.settingsAccount.imageURL || vm.tmpImageCropped" ng-click="vm.clearImage()"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="settings.form.removeImage">removeImage</span></button></div></div><div class="cropArea card col-md-6 text-center" ng-show="vm.tmpImageURL"><ui-cropper class="card-img-top card-img-top img-fluid" init-max-area="true" image="vm.tmpImageURL" area-type="circle" chargement="\'Loading\'" result-blob="vm.tmpImageBlob" result-image="vm.tmpImageCropped" canvas-scalemode="true"></ui-cropper><div class="card-body"><p class="card-text" data-translate="settings.form.cutImage">cutImage</p></div></div></div></div></div><h5 class="mt-4"><span data-translate="settings.communicationEntity.title">entities</span></h5><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th><span data-translate="settings.communicationEntity.name">name</span></th><th></th><th class="text-center"><span data-translate="settings.communicationEntity.isEmailReceiver">Is Email Receiver</span></th></tr></thead><tbody><tr ng-repeat="entity in vm.entities"><td>{{entity.name}}</td><td>{{(vm.isManagerForEntity(entity) ? \'settings.communicationEntity.manager\' : \'settings.communicationEntity.user\') | translate }}</td><td class="text-center"><i class="fas fa-check text-success" ng-if="vm.isEmailReceiverForEntity(entity)"></i> <i class="fas fa-times text-danger" ng-if="!vm.isEmailReceiverForEntity(entity)"></i></td></tr></tbody></table><hr><button type="submit" ng-disabled="form.$invalid" class="btn btn-success"><i class="fas fa-save"></i> <span data-translate="settings.form.button">Save</span></button></div></div></form>');
$templateCache.put('app/admin/admin-documents/admin-documents.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.document.home.title">Documents</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-sm" ng-if="vm.searchVisible != true" ng-click="vm.searchVisible = !vm.searchVisible" ng-class="{\'btn-primary\':  !vm.searchVisible, \'btn-warning\' :vm.searchVisible}"><em class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></em> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.search">Pesquisar</span></span></button> <button class="btn btn-sm btn-dark ml-2" ng-if="vm.searchVisible != true && vm.isSearchActive()" ng-click="vm.reset()"><em class="fas fa-trash-alt"></em> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.clear">Limpar</span></span></button></form></div></div></div><div class="card text-white bg-primary mb-3" ng-if="vm.searchVisible == true"><div class="card-header"><span data-translate="entity.action.search">Pesquisar</span> <button class="btn btn-sm btn-secondary float-right" ng-click="vm.searchVisible = !vm.searchVisible"><em class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></em>&nbsp;<span class="d-none d-sm-inline-block" data-translate="entity.action.hide"></span></button></div><div class="card-body bg-white text-primary"><form><div class="form-row"><div class="form-group col-sm-4 col-lg-4"><label data-translate="eDocumentsApp.document.documentNumber">Document Number</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.documentNumber.value"></div><div class="form-group col-sm-8 col-lg-8"><label data-translate="eDocumentsApp.document.internalType">Document Internal Type</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.internalType.value == null || angular.isUndefined(vm.filters.filterBy.internalType.value)}" ng-click="vm.changeInternalType(undefined)"><input type="radio" name="options" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.documentType.all">Todos</span></label><label ng-repeat="internalType in vm.internalTypes" class="btn btn-outline-primary col" ng-class="{\'active\': angular.isDefined(vm.filters.filterBy.internalType.value) && vm.filters.filterBy.internalType.value == angular.uppercase(\'\' + internalType)}" ng-click="vm.changeInternalType(internalType)"><input type="radio" name="options" autocomplete="off"> <span>{{\'eDocumentsApp.DocumentInternalType.\' + internalType | translate}}</span></label></div></div></div><div class="form-row"><div class="form-group col-sm-6 col-md-6 col-lg-6"><label data-translate="eDocumentsApp.document.origin.label">Origin</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.origin.value"></div><div class="form-group col-sm-6 col-md-6 col-lg-6"><label data-translate="eDocumentsApp.document.destination.label">Destination</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.destination.value"></div></div><div class="form-row"><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.period.period">Period</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.period.year">Ano</span></div><input type="number" ng-model="vm.filters.filterBy.year.value" class="form-control form-control-sm" min="0"></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label>&nbsp;</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.period.month">M\xEAs</span></div><input type="number" ng-model="vm.filters.filterBy.month.value" class="form-control form-control-sm" min="1" max="12"></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label>&nbsp;</label><br><div class="btn-group col flex-btn-group-container" role="group"><button class="btn btn-primary btn-sm col-sm-6" ng-click="vm.page = 1; vm.loadAll()"><em class="fas fa-search"></em> <span data-translate="entity.action.search">Pesquisar</span></button> <button class="btn btn-dark btn-sm col-sm-6" ng-if="vm.isSearchActive()" ng-click="vm.reset()"><em class="fas fa-trash-alt"></em> <span data-translate="entity.action.clear">Limpar</span></button></div></div></div></form></div></div><!-- Invoice Headers --><div class="accordion card"><h5 class="card-header" data-toggle="collapse" data-target="#collapseInvoiceHeaders" aria-expanded="true" aria-controls="collapseInvoiceHeaders" id="invoiceHeadersHeader"><span data-translate="eDocumentsApp.document.home.title">Invoice Headers</span> <span class="badge badge-pill badge-secondary">{{vm.totalItems}}</span></h5><div class="card-body collapse" id="collapseInvoiceHeaders" aria-labelledby="invoiceHeadersHeader" data-parent="#invoiceHeadersHeader"><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th></th><th jh-sort-by="documentNumber"><span data-translate="eDocumentsApp.document.documentNumber">Document Number</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="createdDate"><span data-translate="eDocumentsApp.document.createdDate">Created Date</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentDate"><span data-translate="eDocumentsApp.document.documentDate">Document Date</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentType"><span data-translate="eDocumentsApp.document.documentType">Document Type</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentValue"><span data-translate="eDocumentsApp.document.documentValue">Document Value</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="origin.name"><span data-translate="eDocumentsApp.document.origin.label">Origin</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="communicationDefinition.destination.name"><span data-translate="eDocumentsApp.document.destination.label">Destination</span> <i class="fas sort fa-sort"></i></th><th><span data-translate="eDocumentsApp.document.documentFiles">documentFiles</span></th><th class="text-right"></th></tr></thead><tbody><tr ng-repeat="document in vm.documents track by document.id"><td><span ng-if="!document.documentViews || document.documentViews.length< 1" class="fa-layers fa-fw text-secondary"><i class="fas fa-certificate fa-fw"></i> <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-11.5 rotate--30" style="font-weight: 900" data-translate="global.new">Novo</span> </span><span ng-if="document.documentViews && document.documentViews.length >= 1"><i class="fas fa-fw" style="visibility: hidden"></i> </span><span uib-tooltip="{{\'eDocumentsApp.DocumentStatus.\' + document.status | translate}}" class="btn bg-{{document.status}}"></span></td><td>{{document.documentNumber}}</td><td>{{document.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{document.documentDate | date:\'dd/MM/yyyy\'}}</td><td><span class="badge badge-{{document.documentType}}">{{\'eDocumentsApp.DocumentType.\' + document.documentType | translate}}</span> <span ng-if="(document.documentType == \'SELFBILLED\' || document.documentType == \'CREDITNOTE\') && document.approved" uib-tooltip="{{ \'eDocumentsApp.document.approve.tooltip\' | translate:document }}"><i class="fas fa-check text-success"></i></span></td><td class="text-right nowrap">{{document.documentValue | currency: vm.getCurrency(document.currency) :2 }}</td><td>{{document.origin}}</td><td>{{document.destination}}</td><td><span style="color: #0071ff; cursor: pointer; outline: none" ng-repeat="file in document.files | orderBy : \'fileType\'" ng-click="vm.download($event,document, file.id,file.fileType)" class="fa-layers fa-fw" uib-tooltip="{{ \'eDocumentsApp.document.message.downloaded\' | translate:{filename: vm.getViewableFilename(file.filename), sizeString: vm.formatFileSize(file.size), numberOfDownloads: vm.downloaded(document,file.id)} }}"><i class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></i> <span class="fa-layers-counter fa-2x bg-dark" ng-show="vm.downloaded(document,file.id ) > 0" style="top: -5px; right: -1px">{{vm.downloaded(document, file.id)}}</span></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="document-detail({id:document.id})" class="btn btn-info btn-sm"><em class="far fa-eye"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.view"></span> </a><a has-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="document.delete({id:document.id})" class="btn btn-danger btn-sm"><em class="fas fa-trash-alt"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.delete"></span></a></div></td></tr></tbody></table></div></div><div class="card-footer text-center" ng-show="vm.documents.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-click="vm.loadAll()"></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="audits.title">Audits</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-sm" ng-if="vm.searchVisible != true" ng-click="vm.searchVisible = !vm.searchVisible" ng-class="{\'btn-primary\':  !vm.searchVisible, \'btn-warning\' :vm.searchVisible}"><i class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></i> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.search">Pesquisar</span></span></button> <button class="btn btn-sm btn-dark ml-2" ng-if="vm.searchVisible != true && vm.isSearchActive()" ng-click="vm.reset()"><i class="fas fa-trash-alt"></i> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.clear">Limpar</span></span></button></form></div></div></div><div class="card text-white bg-primary mb-3" ng-if="vm.searchVisible == true"><div class="card-header"><span data-translate="entity.action.search">Pesquisar</span> <button class="btn btn-sm btn-secondary float-right" ng-click="vm.searchVisible = !vm.searchVisible"><i class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></i>&nbsp;<span class="d-none d-sm-inline-block" data-translate="entity.action.hide"></span></button></div><div class="card-body bg-white text-primary"><form><div class="form-row"><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="audits.filter.title">Date</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 30px" class="input-group-text bg-primary text-white" data-translate="global.from">De</span></div><input ng-value="vm.filters.filterBy.auditDate.fromDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.auditDate.fromDate" locale="pt" format="YYYY-MM-DD" max-view="day" start-view="month" today="true"></div><br><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 30px" class="input-group-text bg-primary text-white">A</span></div><input ng-value="vm.filters.filterBy.auditDate.to_date" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.auditDate.to_date" locale="pt" format="YYYY-MM-DD" max-view="day" start-view="month" today="true"></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="audits.filter.user">Origin</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.user.value"></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="audits.filter.status">Status</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.status.value"></div></div><div class="form-row"><div class="form-group col-sm-6 col-md-8 col-lg-8"></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label>&nbsp;</label><br><div class="btn-group col flex-btn-group-container" role="group"><button class="btn btn-primary btn-sm col-sm-6" ng-click="vm.page = 1; vm.loadAll()"><i class="fas fa-search"></i> <span data-translate="entity.action.search">Pesquisar</span></button> <button class="btn btn-dark btn-sm col-sm-6" ng-if="vm.isSearchActive()" ng-click="vm.reset()"><i class="fas fa-trash-alt"></i> <span data-translate="entity.action.clear">Limpar</span></button></div></div></div></form></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tbody><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp | date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></tbody></table></div><div class="text-center"><div uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></div></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control form-control-sm"><h3 ng-hide="filteredConfig.length === 0" data-translate="global.springConfiguration">Configura\xE7\xE3o Spring</h3><table class="jh-table table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="jh-table table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4" data-translate="global.property">Propriedade</th><th class="col-sm-8" data-translate="global.value">Valor</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><i class="fas fa-sync"></i>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="jh-table tabletable-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="far fa-eye"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="{{\'entity.action.close\' | translate}}" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="jh-table tabletable-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()" data-translate="global.done">Conclu\xEDdo</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control form-control-sm"><table class="jh-table table table-condensed table-striped table-bordered"><thead><tr title="{{\'global.a11y.clickToOrder\' | translate}}"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-sm">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-sm">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-sm">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-sm">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-sm">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><i class="fas fa-sync"></i>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="far fa-eye"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="jh-table tabletable-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="jh-table tabletable-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="jh-table tabletable-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="jh-table tabletable-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}" data-translate="global.all">Todos&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div><span data-translate="global.filter">Filtrar</span> <input type="text" ng-model="threadDumpFilter" class="form-control form-control-sm"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="jh-table table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()" data-translate="global.done">Conclu\xEDdo</button></div>');
$templateCache.put('app/admin/parameterization-docs/parameterization-docs.html','<div><h2 data-translate="parameterizationDocs.title">Parameterization Documentation</h2><p class="text-muted" data-translate="parameterizationDocs.subtitle">Reference documentation for communication definitions, workflows, actions and parameters.</p><!-- Loading --><div ng-if="vm.loading" class="text-center" style="padding: 40px 0"><i class="fas fa-spinner fa-spin fa-2x"></i><p data-translate="parameterizationDocs.loading">Loading documentation...</p></div><!-- Error --><div ng-if="vm.error" class="alert alert-danger"><span data-translate="parameterizationDocs.error">Failed to load documentation.</span> <button class="btn btn-sm btn-outline-danger ml-2" ng-click="vm.retryLoad()"><i class="fas fa-sync"></i></button></div><!-- Content --><div ng-if="!vm.loading && !vm.error"><!-- Tabs and content styles --><style>.param-docs-tabs { border-bottom: none; margin-bottom: 0; }\n            .param-docs-tabs > li { margin-bottom: 0; }\n            .param-docs-tabs > li > a {\n                border-radius: 4px 4px 0 0;\n                border: 1px solid transparent;\n                margin-right: 2px;\n                padding: 10px 18px;\n                color: #777;\n                cursor: pointer;\n            }\n            .param-docs-tabs > li > a:hover { border-color: #ddd #ddd transparent; background-color: #f5f5f5; }\n            .param-docs-tabs > li.active > a,\n            .param-docs-tabs > li.active > a:hover,\n            .param-docs-tabs > li.active > a:focus {\n                color: #333;\n                font-weight: 600;\n                background-color: #fff;\n                border: 1px solid #ddd;\n                border-bottom-color: #fff;\n                position: relative;\n                z-index: 1;\n            }\n            .param-docs-tab-content {\n                border: 1px solid #ddd;\n                border-radius: 0 0 4px 4px;\n                padding: 20px;\n                background: #fff;\n                margin-top: -1px;\n            }\n            /* Fix #3: selected item text visibility */\n            .param-docs-tab-content .list-group-item.active,\n            .param-docs-tab-content .list-group-item.active:hover,\n            .param-docs-tab-content .list-group-item.active:focus {\n                background-color: #337ab7;\n                border-color: #337ab7;\n                color: #fff;\n            }\n            .param-docs-tab-content .list-group-item.active small,\n            .param-docs-tab-content .list-group-item.active .text-muted,\n            .param-docs-tab-content .list-group-item.active strong,\n            .param-docs-tab-content .list-group-item.active span {\n                color: #fff !important;\n            }\n            .param-docs-tab-content .list-group-item.active .label {\n                opacity: 0.9;\n            }</style><ul class="nav nav-tabs param-docs-tabs"><li ng-class="{\'active\': vm.activeTab === \'actions\'}"><a ng-click="vm.setActiveTab(\'actions\')"><i class="fas fa-cogs"></i>&nbsp; <span data-translate="parameterizationDocs.tabs.actions">Action Definitions</span> <span class="badge" style="margin-left: 4px" ng-if="vm.actionDefinitions.length">{{vm.actionDefinitions.length}}</span></a></li><li ng-class="{\'active\': vm.activeTab === \'definitions\'}"><a ng-click="vm.setActiveTab(\'definitions\')"><i class="fas fa-project-diagram"></i>&nbsp; <span data-translate="parameterizationDocs.tabs.definitions">Communication Definitions</span> <span class="badge" style="margin-left: 4px" ng-if="vm.commDefinitionsTotal">{{vm.commDefinitionsTotal}}</span></a></li><li ng-class="{\'active\': vm.activeTab === \'resolution\'}"><a ng-click="vm.setActiveTab(\'resolution\')"><i class="fas fa-layer-group"></i>&nbsp; <span data-translate="parameterizationDocs.tabs.resolution">Parameter Resolution</span></a></li></ul><!-- Tab content area with border continuation --><div class="tab-content param-docs-tab-content"><!-- ===== TAB: ACTION DEFINITIONS ===== --><div ng-if="vm.activeTab === \'actions\'" class="row"><div class="col-md-4"><div class="panel panel-default" style="margin-bottom: 0"><div class="panel-heading" style="background: #f8f9fa"><strong data-translate="parameterizationDocs.actions.listTitle">Actions</strong> <span class="pull-right text-muted" style="font-size: 12px" ng-if="vm.actionDefinitions.length">{{vm.filteredActionDefinitions().length}}/{{vm.actionDefinitions.length}}</span></div><div style="padding: 8px; border-bottom: 1px solid #ddd"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-search"></i></span> <input type="text" class="form-control" ng-model="vm.searchQuery" placeholder="{{\'parameterizationDocs.searchPlaceholder\' | translate}}"> <span class="input-group-btn" ng-if="vm.searchQuery"><button class="btn btn-default btn-sm" ng-click="vm.searchQuery = \'\'"><i class="fas fa-times"></i></button></span></div></div><div class="list-group" style="max-height: 65vh; overflow-y: auto"><a class="list-group-item hand" ng-repeat="action in vm.filteredActionDefinitions() track by action.id" ng-class="{\'active\': vm.selectedAction.id === action.id}" ng-click="vm.selectAction(action)"><div><strong>{{action.name}}</strong> <span class="pull-right text-muted" style="font-size: 11px">{{vm.getUsageLabel(action.usageCount)}}</span></div><small class="text-muted">{{action.communicationTypeI18nKey ? (action.communicationTypeI18nKey | translate) : action.communicationType}}</small></a><div class="list-group-item text-muted text-center" ng-if="vm.filteredActionDefinitions().length === 0"><span data-translate="parameterizationDocs.noResults">No results found.</span></div></div></div></div><div class="col-md-8"><div ng-if="!vm.selectedAction" class="text-center text-muted" style="padding: 60px 0"><i class="fas fa-hand-point-left fa-2x" style="margin-bottom: 10px; display: block"></i><p data-translate="parameterizationDocs.actions.selectPrompt">Select an action to view its details.</p></div><div ng-if="vm.selectedAction"><h4 style="margin-top: 0">{{vm.selectedAction.name}}</h4><dl class="dl-horizontal"><dt data-translate="parameterizationDocs.actions.communicationType">Communication Type</dt><dd><span class="label label-info">{{vm.selectedAction.communicationTypeI18nKey ? (vm.selectedAction.communicationTypeI18nKey | translate) : vm.selectedAction.communicationType}}</span></dd><dt data-translate="parameterizationDocs.actions.className">Service Class</dt><dd><code title="{{vm.selectedAction.classname}}">{{vm.getSimpleClassName(vm.selectedAction.classname)}}</code></dd><dt data-translate="parameterizationDocs.actions.usageCount">Usage Count</dt><dd>{{vm.getUsageLabel(vm.selectedAction.usageCount)}}</dd></dl><hr><h5><i class="fas fa-sliders-h"></i>&nbsp; <span data-translate="parameterizationDocs.actions.parameters">Parameters</span> <span class="badge">{{vm.selectedAction.parameters.length}}</span></h5><div style="margin-bottom: 10px" ng-if="vm.getParameterCategories().length > 1"><span class="btn btn-xs" ng-class="vm.categoryFilter === \'\' ? \'btn-primary\' : \'btn-default\'" ng-click="vm.setCategoryFilter(\'\')" data-translate="parameterizationDocs.categories.all">All</span> <span class="btn btn-xs" ng-repeat="cat in vm.getParameterCategories()" ng-class="vm.categoryFilter === cat ? \'btn-primary\' : \'btn-default\'" ng-click="vm.setCategoryFilter(cat)"><i ng-class="vm.getCategoryIcon(cat)"></i>&nbsp; {{(\'parameterizationDocs.categories.\' + cat) | translate}}</span></div><table class="table table-striped table-condensed" ng-if="vm.selectedAction.parameters.length > 0"><thead><tr><th data-translate="parameterizationDocs.params.name">Parameter</th><th data-translate="parameterizationDocs.params.category">Category</th><th data-translate="parameterizationDocs.params.required">Required</th><th data-translate="parameterizationDocs.params.authorities">Authorities</th><th data-translate="parameterizationDocs.params.description">Description</th></tr></thead><tbody><tr ng-repeat="param in vm.getFilteredParameters() track by param.parameterType"><td><code>{{param.parameterType}}</code></td><td><span class="label label-default"><i ng-class="vm.getCategoryIcon(param.category)"></i>&nbsp; {{(\'parameterizationDocs.categories.\' + param.category) | translate}}</span></td><td class="text-center"><i ng-if="param.required" class="fas fa-check text-success"></i> <i ng-if="!param.required" class="fas fa-minus text-muted"></i></td><td><span class="label label-warning" ng-repeat="auth in param.authorities" style="margin-right: 2px; font-size: 10px">{{vm.formatAuthority(auth)}}</span></td><td>{{param.i18nKey | translate}}</td></tr></tbody></table><div ng-if="vm.selectedAction.parameters.length === 0" class="text-muted"><span data-translate="parameterizationDocs.actions.noParameters">This action has no configurable parameters.</span></div></div></div></div><!-- ===== TAB: COMMUNICATION DEFINITIONS ===== --><div ng-if="vm.activeTab === \'definitions\'" class="row"><div class="col-md-4"><div class="panel panel-default" style="margin-bottom: 0"><div class="panel-heading" style="background: #f8f9fa"><strong data-translate="parameterizationDocs.definitions.listTitle">Definitions</strong> <span class="pull-right text-muted" style="font-size: 12px" ng-if="vm.commDefinitionsTotal">{{vm.commDefinitions.length}}/{{vm.commDefinitionsTotal}}</span></div><!-- Search within definitions --><div style="padding: 8px; border-bottom: 1px solid #ddd"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-search"></i></span> <input type="text" class="form-control" ng-model="vm.commDefinitionsSearch" ng-change="vm.searchCommDefinitions()" placeholder="{{\'parameterizationDocs.searchPlaceholder\' | translate}}"> <span class="input-group-btn" ng-if="vm.commDefinitionsSearch"><button class="btn btn-default btn-sm" ng-click="vm.commDefinitionsSearch = \'\'; vm.searchCommDefinitions()"><i class="fas fa-times"></i></button></span></div></div><div class="list-group" style="max-height: 65vh; overflow-y: auto; border-top: 1px solid #ddd"><a class="list-group-item hand" ng-repeat="def in vm.commDefinitions track by def.id" ng-class="{\'active\': vm.selectedDefinition.id === def.id}" ng-click="vm.selectDefinition(def)"><div><strong>{{def.description}}</strong> <span class="pull-right"><span class="label" ng-class="def.active ? \'label-success\' : \'label-default\'">{{def.active ? (\'parameterizationDocs.active\' | translate) : (\'parameterizationDocs.inactive\' | translate)}}</span></span></div><small class="text-muted">{{def.originEntityName}}<span ng-if="def.originGln"> ({{def.originGln}})</span> <i class="fas fa-arrow-right"></i> {{def.destinationEntityName}}<span ng-if="def.destinationGln"> ({{def.destinationGln}})</span></small></a><div class="text-center" style="padding: 8px" ng-if="vm.commDefinitionsLoading"><i class="fas fa-spinner fa-spin"></i></div><a class="list-group-item text-center hand text-primary" style="padding: 6px; font-size: 12px" ng-if="!vm.commDefinitionsLoading && vm.commDefinitions.length < vm.commDefinitionsTotal" ng-click="vm.loadMoreCommDefinitions()"><span data-translate="parameterizationDocs.loadMore">Load more</span> ({{vm.commDefinitions.length}}/{{vm.commDefinitionsTotal}})...</a><div class="list-group-item text-muted text-center" ng-if="!vm.commDefinitionsLoading && vm.commDefinitions.length === 0"><span data-translate="parameterizationDocs.noResults">No results found.</span></div></div></div></div><div class="col-md-8"><div ng-if="!vm.selectedDefinition" class="text-center text-muted" style="padding: 60px 0"><i class="fas fa-hand-point-left fa-2x" style="margin-bottom: 10px; display: block"></i><p data-translate="parameterizationDocs.definitions.selectPrompt">Select a definition to view its workflow.</p></div><div ng-if="vm.selectedDefinition"><h4 style="margin-top: 0">{{vm.selectedDefinition.description}}</h4><dl class="dl-horizontal"><dt data-translate="parameterizationDocs.definitions.origin">Origin</dt><dd>{{vm.selectedDefinition.originEntityName}}</dd><dt data-translate="parameterizationDocs.definitions.destination">Destination</dt><dd>{{vm.selectedDefinition.destinationEntityName}}</dd><dt data-translate="parameterizationDocs.definitions.status">Status</dt><dd><span class="label" ng-class="vm.selectedDefinition.active ? \'label-success\' : \'label-default\'">{{vm.selectedDefinition.active ? (\'parameterizationDocs.active\' | translate) : (\'parameterizationDocs.inactive\' | translate)}}</span></dd></dl><hr><!-- Loading steps --><div ng-if="vm.selectedDefinition.workflowStepsLoading" class="text-center" style="padding: 20px 0"><i class="fas fa-spinner fa-spin"></i> <span data-translate="parameterizationDocs.loading">Loading...</span></div><!-- Steps loaded --><div ng-if="vm.selectedDefinition.workflowSteps"><h5><i class="fas fa-stream"></i>&nbsp; <span data-translate="parameterizationDocs.definitions.workflowSteps">Workflow Steps</span> <span class="badge">{{vm.selectedDefinition.workflowSteps.length}}</span></h5><div ng-if="vm.selectedDefinition.workflowSteps.length === 0" class="text-muted"><span data-translate="parameterizationDocs.definitions.noSteps">No workflow steps defined.</span></div><div class="panel panel-default" style="margin-bottom: 5px" ng-repeat="step in vm.selectedDefinition.workflowSteps | orderBy:\'order\' track by step.id"><div class="panel-heading hand" ng-click="vm.toggleDefinitionExpand(step.id)" style="padding: 8px 12px"><span class="label label-primary" style="margin-right: 6px">{{step.order}}</span> <strong>{{step.actionDefinitionName}}</strong> <span class="label label-info" style="margin-left: 6px">{{step.communicationTypeI18nKey ? (step.communicationTypeI18nKey | translate) : step.communicationType}}</span> <span class="label" style="margin-left: 4px" ng-class="{\'label-success\': step.executionType === \'AUTOMATIC\', \'label-warning\': step.executionType === \'MANUAL\', \'label-default\': step.executionType === \'PASSIVE\'}">{{step.executionType}}</span> <span class="pull-right text-muted" style="font-size: 11px; margin-top: 2px" ng-if="vm.getStepParameterSummary(step)"><i class="fas fa-sliders-h"></i> {{vm.getStepParameterSummary(step)}}</span> <i class="fas pull-right" ng-class="vm.expandedDefinitions[step.id] ? \'fa-chevron-up\' : \'fa-chevron-down\'" style="margin-top: 3px"></i></div><div class="panel-body" ng-if="vm.expandedDefinitions[step.id]"><dl class="dl-horizontal"><dt ng-if="step.description" data-translate="parameterizationDocs.steps.description">Description</dt><dd ng-if="step.description">{{step.description}}</dd><dt data-translate="parameterizationDocs.steps.retries">Retries</dt><dd>{{step.numberOfRetries}}<span ng-if="step.retryDelay"> ({{step.retryDelay}}s <span data-translate="parameterizationDocs.steps.delay">delay</span>)</span></dd><dt data-translate="parameterizationDocs.steps.errorNotification">Error Notification</dt><dd><span ng-if="step.sendEmailToOriginOnError" class="label label-warning" style="margin-right: 3px"><span data-translate="parameterizationDocs.definitions.origin">Origin</span></span> <span ng-if="step.sendEmailToDestinationOnError" class="label label-warning" style="margin-right: 3px"><span data-translate="parameterizationDocs.definitions.destination">Destination</span></span> <span ng-if="step.sendEmailToSuperAdminOnError" class="label label-danger">SuperAdmin</span> <span ng-if="!step.sendEmailToOriginOnError && !step.sendEmailToDestinationOnError && !step.sendEmailToSuperAdminOnError" class="text-muted">-</span></dd></dl></div></div></div></div></div></div><!-- ===== TAB: PARAMETER RESOLUTION ===== --><div ng-if="vm.activeTab === \'resolution\'"><div class="row"><!-- Left sidebar: cascading definition > step picker --><div class="col-md-3"><!-- Definition panel with search --><div class="panel panel-default" style="margin-bottom: 12px"><div class="panel-heading" style="background: #f8f9fa; padding: 8px 12px"><strong data-translate="parameterizationDocs.definitions.listTitle">Definitions</strong> <span class="pull-right text-muted" style="font-size: 12px" ng-if="vm.definitionSummariesTotal">{{vm.definitionSummaries.length}}/{{vm.definitionSummariesTotal}}</span></div><div style="padding: 8px; border-bottom: 1px solid #ddd"><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fas fa-search"></i></span> <input type="text" class="form-control" ng-model="vm.definitionFilter" ng-change="vm.searchDefinitionSummaries()" placeholder="{{\'parameterizationDocs.searchPlaceholder\' | translate}}"> <span class="input-group-btn" ng-if="vm.definitionFilter"><button class="btn btn-default btn-sm" ng-click="vm.definitionFilter = \'\'; vm.searchDefinitionSummaries()"><i class="fas fa-times"></i></button></span></div></div><div class="list-group" style="max-height: 30vh; overflow-y: auto; margin-bottom: 0"><a class="list-group-item hand" style="padding: 6px 10px; font-size: 12px" ng-repeat="def in vm.definitionSummaries track by def.id" ng-class="{\'active\': vm.resolutionDefinition.id === def.id}" ng-click="vm.selectResolutionDefinition(def)"><strong>{{def.description}}</strong><br><small class="text-muted">{{def.originEntityName}}<span ng-if="def.originGln"> ({{def.originGln}})</span> <i class="fas fa-arrow-right"></i> {{def.destinationEntityName}}<span ng-if="def.destinationGln"> ({{def.destinationGln}})</span></small></a><div class="text-center" style="padding: 8px" ng-if="vm.definitionSummariesLoading"><i class="fas fa-spinner fa-spin"></i></div><a class="list-group-item text-center hand text-primary" style="padding: 6px; font-size: 12px" ng-if="!vm.definitionSummariesLoading && vm.definitionSummaries.length < vm.definitionSummariesTotal" ng-click="vm.loadMoreDefinitions()"><span data-translate="parameterizationDocs.loadMore">Load more</span> ({{vm.definitionSummaries.length}}/{{vm.definitionSummariesTotal}})...</a></div></div><!-- Step list (appears when definition is selected) --><div ng-if="vm.resolutionDefinition" style="margin-top: 0"><div class="panel panel-default" style="margin-bottom: 0"><div class="panel-heading" style="background: #f8f9fa; padding: 8px 12px"><strong><i class="fas fa-stream"></i>&nbsp; <span data-translate="parameterizationDocs.definitions.workflowSteps">Workflow Steps</span></strong></div><div class="list-group" style="max-height: 25vh; overflow-y: auto; margin-bottom: 0"><a class="list-group-item hand" style="padding: 6px 10px; font-size: 12px" ng-repeat="step in vm.resolutionSteps track by step.id" ng-class="{\'active\': vm.resolutionStep.id === step.id}" ng-click="vm.selectResolutionStep(step)"><span class="label label-primary" style="font-size: 10px; margin-right: 3px">{{step.order}}</span> <strong>{{step.actionDefinitionName}}</strong> <span class="pull-right text-muted" style="font-size: 10px" ng-if="vm.getStepParameterSummary(step)"><i class="fas fa-sliders-h"></i> {{vm.getStepParameterSummary(step)}}</span></a><div class="text-center" style="padding: 8px" ng-if="vm.resolutionStepsLoading"><i class="fas fa-spinner fa-spin"></i></div></div><div class="text-muted text-center" style="padding: 8px; font-size: 12px" ng-if="!vm.resolutionStepsLoading && vm.resolutionSteps.length === 0"><span data-translate="parameterizationDocs.resolution.noStepsAvailable">No workflow steps.</span></div></div></div></div><!-- Main content area --><div class="col-md-9"><!-- Empty states --><div ng-if="!vm.resolutionDefinition" class="text-center text-muted" style="padding: 80px 0"><i class="fas fa-layer-group fa-3x" style="margin-bottom: 15px; display: block; opacity: 0.3"></i><p data-translate="parameterizationDocs.resolution.selectDefinition">Select a communication definition to explore its parameter resolution.</p></div><div ng-if="vm.resolutionDefinition && !vm.resolutionStep && !vm.resolutionStepsLoading" class="text-center text-muted" style="padding: 80px 0"><i class="fas fa-hand-point-left fa-3x" style="margin-bottom: 15px; display: block; opacity: 0.3"></i><p data-translate="parameterizationDocs.resolution.selectStep">Select a workflow step to see how its parameters are resolved.</p></div><div ng-if="vm.resolutionDetailLoading" class="text-center" style="padding: 80px 0"><i class="fas fa-spinner fa-spin fa-2x"></i></div><!-- Resolution detail --><div ng-if="vm.resolutionStep && vm.resolutionDetail && !vm.resolutionDetailLoading"><!-- Breadcrumb header --><div style="margin-bottom: 15px; padding-bottom: 10px; border-bottom: 1px solid #eee"><h4 style="margin: 0 0 4px 0">{{vm.resolutionDetail.definitionDescription}}</h4><span class="text-muted">{{vm.resolutionDetail.originEntityName}} <i class="fas fa-arrow-right"></i> {{vm.resolutionDetail.destinationEntityName}} &nbsp;&bull;&nbsp; <span data-translate="parameterizationDocs.definitions.workflowSteps">Step</span> <span class="label label-primary">{{vm.resolutionDetail.stepOrder}}</span> {{vm.resolutionDetail.stepActionName}}</span></div><!-- EFFECTIVE VALUES: Origin --><div style="margin-bottom: 20px"><h5 style="margin: 0 0 8px 0"><i class="fas fa-arrow-right text-primary"></i>&nbsp; <span data-translate="parameterizationDocs.resolution.originResolution">Origin Parameters</span> <span class="badge">{{vm.resolutionDetail.effectiveOriginParameters.length}}</span></h5><table class="table table-condensed table-striped" style="font-size: 13px" ng-if="vm.resolutionDetail.effectiveOriginParameters.length > 0"><thead><tr><th style="width: 30%" data-translate="parameterizationDocs.resolution.parameterType">Parameter</th><th style="width: 40%" data-translate="parameterizationDocs.resolution.value">Value</th><th style="width: 30%" data-translate="parameterizationDocs.resolution.sourceLabel">Source</th></tr></thead><tbody><tr ng-repeat="p in vm.resolutionDetail.effectiveOriginParameters"><td><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span> <span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td><td><span class="label" ng-class="{\'label-success\': p.source === \'step\', \'label-info\': p.source === \'definition\', \'label-default\': p.source === \'entity\'}">{{p.sourceI18nKey | translate}}</span></td></tr></tbody></table><p class="text-muted" style="font-size: 13px" ng-if="vm.resolutionDetail.effectiveOriginParameters.length === 0"><i class="fas fa-info-circle"></i>&nbsp; <span data-translate="parameterizationDocs.resolution.noEffectiveParams">No parameters configured at any level.</span></p></div><!-- EFFECTIVE VALUES: Destination --><div style="margin-bottom: 20px"><h5 style="margin: 0 0 8px 0"><i class="fas fa-arrow-left text-success"></i>&nbsp; <span data-translate="parameterizationDocs.resolution.destinationResolution">Destination Parameters</span> <span class="badge">{{vm.resolutionDetail.effectiveDestinationParameters.length}}</span></h5><table class="table table-condensed table-striped" style="font-size: 13px" ng-if="vm.resolutionDetail.effectiveDestinationParameters.length > 0"><thead><tr><th style="width: 30%" data-translate="parameterizationDocs.resolution.parameterType">Parameter</th><th style="width: 40%" data-translate="parameterizationDocs.resolution.value">Value</th><th style="width: 30%" data-translate="parameterizationDocs.resolution.sourceLabel">Source</th></tr></thead><tbody><tr ng-repeat="p in vm.resolutionDetail.effectiveDestinationParameters"><td><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span> <span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td><td><span class="label" ng-class="{\'label-success\': p.source === \'step\', \'label-info\': p.source === \'definition\', \'label-default\': p.source === \'destEntity\', \'label-warning\': p.source === \'originEntityFallback\'}">{{p.sourceI18nKey | translate}}</span></td></tr></tbody></table><p class="text-muted" style="font-size: 13px" ng-if="vm.resolutionDetail.effectiveDestinationParameters.length === 0"><i class="fas fa-info-circle"></i>&nbsp; <span data-translate="parameterizationDocs.resolution.noEffectiveParams">No parameters configured at any level.</span></p></div><!-- Collapsible: Detail by Level --><div style="border-top: 1px solid #eee; padding-top: 12px"><a class="hand text-muted" ng-click="vm.showLevelDetail = !vm.showLevelDetail" style="font-size: 13px"><i class="fas" ng-class="vm.showLevelDetail ? \'fa-chevron-down\' : \'fa-chevron-right\'"></i>&nbsp; <span data-translate="parameterizationDocs.resolution.detailByLevel">Detail by Level</span> &mdash; <span data-translate="parameterizationDocs.resolution.allParameters">All parameters</span></a><div ng-if="vm.showLevelDetail" style="margin-top: 12px"><!-- Origin levels --><h6 style="font-weight: 600; color: #337ab7"><i class="fas fa-arrow-right"></i>&nbsp; <span data-translate="parameterizationDocs.resolution.originTitle">Origin Context</span></h6><div class="well well-sm" style="padding: 8px 12px; margin-bottom: 8px"><strong>1. </strong><span data-translate="parameterizationDocs.resolution.origin.level1.name">Workflow Step</span> <span class="badge pull-right">{{vm.resolutionDetail.stepOriginParameters.length}}</span><table class="table table-condensed table-striped" style="font-size: 12px; margin: 6px 0 0 0" ng-if="vm.resolutionDetail.stepOriginParameters.length > 0"><tr ng-repeat="p in vm.resolutionDetail.stepOriginParameters"><td style="width: 40%"><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span><span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td></tr></table></div><div class="well well-sm" style="padding: 8px 12px; margin-bottom: 8px"><strong>2. </strong><span data-translate="parameterizationDocs.resolution.origin.level2.name">Communication Definition</span> <span class="badge pull-right">{{vm.resolutionDetail.definitionOriginParameters.length}}</span><table class="table table-condensed table-striped" style="font-size: 12px; margin: 6px 0 0 0" ng-if="vm.resolutionDetail.definitionOriginParameters.length > 0"><tr ng-repeat="p in vm.resolutionDetail.definitionOriginParameters"><td style="width: 40%"><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span><span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td></tr></table></div><div class="well well-sm" style="padding: 8px 12px; margin-bottom: 12px"><strong>3. </strong><span data-translate="parameterizationDocs.resolution.origin.level3.name">Entity</span> <small class="text-muted">({{vm.resolutionDetail.originEntityName}})</small> <span class="badge pull-right">{{vm.resolutionDetail.entityOriginParameters.length}}</span><table class="table table-condensed table-striped" style="font-size: 12px; margin: 6px 0 0 0" ng-if="vm.resolutionDetail.entityOriginParameters.length > 0"><tr ng-repeat="p in vm.resolutionDetail.entityOriginParameters"><td style="width: 40%"><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span><span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td></tr></table></div><!-- Destination levels --><h6 style="font-weight: 600; color: #5cb85c"><i class="fas fa-arrow-left"></i>&nbsp; <span data-translate="parameterizationDocs.resolution.destinationTitle">Destination Context</span></h6><div class="well well-sm" style="padding: 8px 12px; margin-bottom: 8px"><strong>1. </strong><span data-translate="parameterizationDocs.resolution.destination.level1.name">Workflow Step</span> <span class="badge pull-right">{{vm.resolutionDetail.stepDestinationParameters.length}}</span><table class="table table-condensed table-striped" style="font-size: 12px; margin: 6px 0 0 0" ng-if="vm.resolutionDetail.stepDestinationParameters.length > 0"><tr ng-repeat="p in vm.resolutionDetail.stepDestinationParameters"><td style="width: 40%"><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span><span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td></tr></table></div><div class="well well-sm" style="padding: 8px 12px; margin-bottom: 8px"><strong>2. </strong><span data-translate="parameterizationDocs.resolution.destination.level2.name">Communication Definition</span> <span class="badge pull-right">{{vm.resolutionDetail.definitionDestinationParameters.length}}</span><table class="table table-condensed table-striped" style="font-size: 12px; margin: 6px 0 0 0" ng-if="vm.resolutionDetail.definitionDestinationParameters.length > 0"><tr ng-repeat="p in vm.resolutionDetail.definitionDestinationParameters"><td style="width: 40%"><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span><span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td></tr></table></div><div class="well well-sm" style="padding: 8px 12px; margin-bottom: 8px"><strong>3. </strong><span data-translate="parameterizationDocs.resolution.destination.level3.name">Destination Entity</span> <small class="text-muted">({{vm.resolutionDetail.destinationEntityName}})</small> <span class="badge pull-right">{{vm.resolutionDetail.destEntityDestinationParameters.length}}</span><table class="table table-condensed table-striped" style="font-size: 12px; margin: 6px 0 0 0" ng-if="vm.resolutionDetail.destEntityDestinationParameters.length > 0"><tr ng-repeat="p in vm.resolutionDetail.destEntityDestinationParameters"><td style="width: 40%"><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span><span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td></tr></table></div><div class="well well-sm" style="padding: 8px 12px; margin-bottom: 0"><strong>4. </strong><span data-translate="parameterizationDocs.resolution.destination.level4.name">Origin Entity (Fallback)</span> <small class="text-muted">({{vm.resolutionDetail.originEntityName}})</small> <span class="badge pull-right">{{vm.resolutionDetail.originEntityDestinationParameters.length}}</span><table class="table table-condensed table-striped" style="font-size: 12px; margin: 6px 0 0 0" ng-if="vm.resolutionDetail.originEntityDestinationParameters.length > 0"><tr ng-repeat="p in vm.resolutionDetail.originEntityDestinationParameters"><td style="width: 40%"><code>{{p.parameterType}}</code></td><td><span ng-if="!p.masked">{{p.value}}</span><span ng-if="p.masked" class="text-muted"><i class="fas fa-lock"></i> ********</span></td></tr></table></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span data-translate="userManagement.home.createOrEditLabel">Create or edit a User</span></h5><hr></div><div class="container-fluid"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-sm-6"><div class="form-group"><label data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control form-control-sm" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control form-control-sm" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.email">Email</label><input type="email" class="form-control form-control-sm" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null || vm.user.id === undefined || vm.currentAccount.login === vm.user.login || vm.user.authorities.indexOf(\'ROLE_SUPERADMIN\') !== -1" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select id="langKey" name="langKey" class="form-control form-control-sm" ng-model="vm.user.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><!-- SUP-12293: when the account stops working, e.g. an external auditor\'s --><div class="form-group"><label for="accessValidUntil" data-translate="userManagement.accessValidUntil">Access valid until</label><input type="date" class="form-control form-control-sm" id="accessValidUntil" name="accessValidUntil" ng-model="vm.accessLastDay" ng-disabled="!vm.isUserAllowedToChangeAuthorities()" ng-required="vm.isRestricted() && vm.isUserAllowedToChangeAuthorities()" max="{{vm.maxAccessDay}}" aria-describedby="accessValidUntilHint"> <small id="accessValidUntilHint" class="form-text text-muted" data-translate="userManagement.accessValidUntilHint" ng-if="!vm.isRestricted()">Leave empty for no end. After this day the account can no longer sign in, and anyone signed in with it is signed out. </small><small class="form-text text-muted" data-translate="userManagement.accessValidUntilRequiredHint" ng-if="vm.isRestricted()">Required for an account without the User role (external access), at most 90 days ahead.</small><div ng-show="editForm.accessValidUntil.$invalid"><p class="help-block" ng-show="editForm.accessValidUntil.$error.required" data-translate="userManagement.accessValidUntilRequired">An account without the User role needs an end date.</p><p class="help-block" ng-show="editForm.accessValidUntil.$error.max" data-translate="userManagement.accessValidUntilTooFar">At most 90 days from today.</p></div><!-- SUP-12293: what this account can see in the Digital Archive right now --><p class="small mt-2 mb-0" ng-if="vm.hasArchiveRole()"><i class="fas fa-archive fa-fw"></i> <span ng-if="vm.entityNames()" data-translate="userManagement.archiveAccessSummary" translate-values="{entities: vm.entityNames()}">Digital Archive of</span> <span ng-if="!vm.entityNames()" data-translate="userManagement.archiveAccessNoEntity">Digital Archive: no entity yet</span></p></div></div><div class="col-sm-6" ng-if="vm.user.id"><div class="form-row align-items-center"><div class="card align-items-center" ng-class="{\'col-md-12\':  !vm.tmpImageURL, \'col-md-6\' :vm.tmpImageURL}"><img class="card-img-top card-img-top img-fluid" style="height: 200px; width: 200px" ng-if="vm.tmpImageCropped" ng-src="{{vm.tmpImageCropped}}"> <img class="card-img-top card-img-top img-fluid" style="height: 200px; width: 200px" ng-if="!vm.tmpImageCropped && vm.user.imageURL" ng-src="{{vm.user.imageURL}}"><p class="card-text text-center mt-2 text-black-50" ng-if="!vm.user.imageURL && !vm.tmpImageCropped" data-translate="userManagement.noImage">Sem imagem definida</p><div class="card-body text-center"><h5 class="card-title" data-translate="userManagement.profileImage">Imagem de perfil</h5><p class="card-text text-black-50" data-translate="userManagement.profileImageHint">Defina aqui a imagem de perfil, vis\xEDvel ao longo da aplica\xE7\xE3o</p><button ng-if="!vm.tmpImageURL && vm.readOnly !== true" ngf-select class="btn btn-primary" ngf-pattern="\'image/*\'" ngf-change="vm.setDocumentFile($file,$invalidFiles)" ng-disabled=""><i class="fa fa-upload"></i> <span data-translate="userManagement.uploadImage">Carregar imagem</span></button> <button ng-if="vm.tmpImageURL" class="btn btn-danger" type="button" ng-click="vm.tmpImageURL = undefined;vm.tmpImageCropped=undefined;"><i class="fa fa-ban"></i> <span data-translate="entity.action.cancel">Cancelar</span></button> <button class="btn btn-dark" type="button" ng-if="vm.user.imageURL || vm.tmpImageCropped" ng-click="vm.clearImage()"><i class="fas fa-trash-alt"></i> <span data-translate="userManagement.removeImage">Remover imagem</span></button></div></div><div class="cropArea card col-md-6" ng-show="vm.tmpImageURL"><ui-cropper class="card-img-top card-img-top img-fluid" style="height: 200px;width: 200px" init-max-area="true" image="vm.tmpImageURL" area-type="circle" chargement="\'Loading\'" result-blob="vm.tmpImageBlob" result-image="vm.tmpImageCropped" canvas-scalemode="true"></ui-cropper><div class="card-body"><p class="card-text" data-translate="userManagement.cropImage">Recorte a imagem</p></div></div></div></div></div><div ng-if="vm.user.id"><hr><label class="control-label"><span data-translate="userManagement.profiles">Profiles</span> <span style="font-size: 12px" ng-if="!vm.isUserAllowedToChangeAuthorities()" uib-tooltip="{{\'userManagement.message.userNotAllowedToChangeAuthorities\' | translate }}" tooltip-placement="right" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></label><div class="row"><div class="col"><div class="card"><div class="card-header bg-secondary text-white" data-translate="global.available">Dispon\xEDveis</div><ul class="list-group list-group-flush" dnd-disable-if="!vm.isUserAllowedToChangeAuthorities()" dnd-list="vm.authorities" dnd-allowed-types="[\'auth\']"><li dnd-draggable="authority" dnd-type="\'auth\'" dnd-moved="vm.authorities.splice($index, 1)" dnd-effect-allowed="move" ng-repeat="authority in vm.authorities" class="list-group-item">{{\'userManagement.authorities.\' + authority | translate}}</li></ul></div></div><div class="col"><div class="card"><div class="card-header bg-secondary text-white" data-translate="global.selected">Selecionados</div><ul class="list-group" dnd-disable-if="!vm.isUserAllowedToChangeAuthorities()" dnd-list="vm.user.authorities" dnd-allowed-types="[\'auth\']"><li dnd-draggable="authority" dnd-type="\'auth\'" dnd-moved="vm.user.authorities.splice($index, 1)" dnd-effect-allowed="move" ng-repeat="authority in vm.user.authorities" class="list-group-item">{{\'userManagement.authorities.\' + authority | translate}}</li></ul></div></div></div><hr><label class="control-label" data-translate="userManagement.entities">Entidades</label><div class="row"><div class="col"><div class="card"><div class="card-header bg-secondary text-white"><div class="form-group row"><label class="col-sm-4 col-form-label" data-translate="global.available">Dispon\xEDveis</label><div class="col-sm-6"><input type="text" class="form-control form-control-md" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'entity.action.search\' | translate}}"></div><button type="button" class="btn btn-sm btn-info col-sm m-0 p-0" ng-click="vm.search()" ng-disabled="!vm.searchQuery"><i class="fas fa-search"></i></button> <button type="button" class="btn btn-sm btn-danger col-sm m-0 p-0" ng-if="vm.searchQuery" ng-click="vm.clearFilter()"><i class="fas fa-trash-alt"></i></button></div><p class="text-center" data-translate="userManagement.maxItemsHint">Apenas ser\xE3o listados, no m\xE1ximo, 20 itens. Se n\xE3o encontrar o pretendido, refine a sua pesquisa.</p></div><ul dnd-drop="vm.removeUserFromEntity(item)" class="list-group list-group-flush" dnd-list="vm.entities" dnd-allowed-types="[\'entity\']"><li dnd-draggable="entity" dnd-type="\'entity\'" dnd-moved="vm.entities.splice($index, 1)" dnd-effect-allowed="move" ng-repeat="entity in vm.entities" class="list-group-item">{{ entity.name }} <button type="button" class="btn btn-outline-success float-right" ng-click="vm.addUserToEntity(entity); vm.entities.splice($index, 1); vm.user.entities.push(entity)"><i class="fas fa-arrow-alt-circle-right"></i></button></li></ul></div></div><div class="col"><div class="card"><div class="card-header bg-secondary text-white" data-translate="global.selected">Selecionados</div><ul dnd-drop="vm.addUserToEntity(item)" class="list-group" dnd-list="vm.user.entities" dnd-allowed-types="[\'entity\']"><li dnd-draggable="entity" dnd-type="\'entity\'" dnd-moved="vm.user.entities.splice($index, 1)" dnd-effect-allowed="move" ng-repeat="entity in vm.user.entities" class="list-group-item"><button type="button" class="btn btn-outline-danger float-left" ng-click="vm.removeUserFromEntity(entity); vm.user.entities.splice($index, 1); vm.entities.push(entity)"><i class="fas fa-arrow-alt-circle-left"></i></button> <span class="ml-3">{{ entity.name }}</span> <button class="btn btn-sm btn-primary float-right ml-2" type="button" ng-click="vm.toggleEmailReceiver(entity);">{{vm.isEmailReceiverForEntity(entity) ? \'Recebe email\' : \'N\xE3o recebe email\'}}</button> <button class="btn btn-sm btn-primary float-right" type="button" ng-click="vm.toggleManager(entity);">{{vm.isManagerForEntity(entity) ? \'Gestor\' : \'Utilizador\'}}</button></li></ul></div></div></div></div><hr><div class="col-auto"><button type="button" class="btn btn-default" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-if="vm.readOnly !== true" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="userManagement.home.title">Users</h2></div><div class="col"><form class="form-inline float-right" ng-submit="vm.loadAll()"><button type="button" class="btn btn-sm btn-success mx-2 mb-2" ui-sref="user-management.new"><i class="far fa-plus-square"></i> <span class="d-none d-sm-inline-block">{{\'entity.action.add\' | translate}}</span></button><div class="form-group mx-2 mb-2"><input type="text" class="form-control form-control-sm" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'entity.action.search\' | translate}}"></div><button type="submit" class="btn btn-sm btn-info mx-2 mb-2" ng-click="vm.loadAll()"><i class="fas fa-search"></i></button> <button class="btn btn-sm btn-dark mx-2 mb-2" ng-if="vm.searchQuery" ng-click="vm.clear()"><i class="fas fa-trash-alt"></i></button></form></div></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <i class="fas sort fa-sort"></i></th><th></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <i class="fas sort fa-sort"></i></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td>{{user.email}}</td><td><button class="btn btn-danger btn-sm" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-sm" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login || user.authorities.indexOf(\'ROLE_SUPERADMIN\') !== -1" data-translate="userManagement.activated">Activated</button><div ng-if="user.accessValidUntil" class="mt-1"><span class="badge badge-danger" ng-if="vm.accessHasEnded(user)" data-translate="userManagement.accessExpired" translate-values="{day: (vm.accessLastDay(user) | date:\'dd/MM/yyyy\')}">Access expired</span> <span class="badge badge-warning" ng-if="!vm.accessHasEnded(user)" data-translate="userManagement.accessUntil" translate-values="{day: (vm.accessLastDay(user) | date:\'dd/MM/yyyy\')}">Access until</span></div></td><td><div ng-repeat="authority in user.authorities"><span class="badge badge-info">{{\'userManagement.authorities.\' + authority | translate}}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login || user.authorities.indexOf(\'ROLE_SUPERADMIN\') !== -1"><i class="fas fa-trash-alt"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></div></div></div>');
$templateCache.put('app/components/contact-us/contact-us.html','<div class="card bg-white shadow border-0"><div class="card-header bg-white border-bottom-0"><button type="button" class="close" data-dismiss="modal" ng-click="vm.cancel()">&times;</button></div><div class="card-body"><div class="card border-0"><div class="row no-gutters"><div class="col-sm-4 col-lg-3 d-flex align-items-start flex-column"><div class="mb-auto p-2 bd-highlight mx-auto"><div class="d-flex justify-content-center m-3"><h3 class="align-self-end"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--md">eDocuments<span class="ed-wordmark__dot">.biz</span></span></h3></div><p class="text-center small" data-translate="contactUs.description1">description1</p><p class="text-center small" data-translate="contactUs.description2">description2</p></div><div class="p-2 bd-highlight mx-auto d-flex flex-column ptext"><div class="p-2"><i class="text-primary fa fa-phone-alt" fixedwidth="true"></i>&nbsp; <a target="_blank" href="tel:+351 212 483 800">+351 212 483 800</a></div><div class="p-2"><i class="text-primary fa fa-envelope" fixedwidth="true"></i>&nbsp; <a target="_blank" href="mailto:clientes@flowinn.biz">clientes@flowinn.biz</a></div><div class="p-2"><i class="text-primary fa fa-home" [icon]="\'home\'" fixedwidth="true"></i>&nbsp; <a target="_blank" href="https://www.flowinn.biz">www.flowinn.biz</a></div></div></div><div class="d-none d-lg-block col-lg-1 border-right"></div><div class="col-lg-8"><div class="card-body"><form name="contactForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="d-flex flex-row mb-2"><div class="form-group col-sm-5"><label class="form-control-label text-primary font-weight-bold" for="field_name"><span data-translate="contactUs.name">name</span>*</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.name" required></div><div class="form-group col-sm"><label class="form-control-label text-primary font-weight-bold" for="field_email"><span data-translate="contactUs.email">email</span>*</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.email" required></div></div><div class="d-flex flex-row mb-2"><div class="form-group col-sm-5"><label class="form-control-label text-primary font-weight-bold" for="field_phone"><span data-translate="contactUs.phone">phone</span>*</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.phone" required></div><div class="form-group col-sm"><label class="form-control-label text-primary font-weight-bold" for="field_company"><span data-translate="contactUs.company">company</span>*</label><input type="text" class="form-control" name="company" id="field_company" ng-model="vm.company" required></div></div><div class="d-flex flex-row mb-2"><div class="form-group col-sm"><label class="form-control-label text-primary font-weight-bold" for="field_subject" data-translate="contactUs.subject">subject</label><input type="text" class="form-control" name="subject" id="field_subject" ng-model="vm.subject"></div></div><div class="d-flex flex-row mb-2"><div class="form-group col-sm"><label class="form-control-label text-primary font-weight-bold" for="field_message" data-translate="contactUs.message">message</label><textarea type="text" class="form-control" name="message" rows="4" id="field_message" ng-model="vm.message"></textarea></div></div><div class="d-flex flex-row mb-2"><div class="col-sm"><div class="custom-control custom-control-alternative custom-checkbox"><input class="custom-control-input" id="field_acceptPrivacyPolicy" type="checkbox" name="acceptPrivacyPolicy" ng-model="vm.acceptPrivacyPolicy"><label class="custom-control-label" for="field_acceptPrivacyPolicy" data-translate="contactUs.readAndAccepted">readAndAccepted</label><a href="https://www.flowinn.biz/politica-privacidade/" target="_blank"><u data-translate="contactUs.termsAndPrivacyPolicy">termsAndPrivacyPolicy</u></a></div></div></div><div class="d-flex flex-row mb-2"><div class="col-sm"><div class="custom-control custom-control-alternative custom-checkbox"><input class="custom-control-input" id="field_acceptMarketingDataUsage" type="checkbox" name="acceptMarketingDataUsage" ng-model="vm.acceptMarketingDataUsage"><label class="custom-control-label" for="field_acceptMarketingDataUsage" data-translate="contactUs.marketingAcceptance">marketingAcceptance</label></div></div></div><div class="d-flex flex-row mb-2"><div class="col-sm"><div class="custom-control custom-control-alternative custom-checkbox"><input class="custom-control-input" id="field_receiveEmailCommunication" type="checkbox" name="receiveEmailCommunication" ng-model="vm.receiveEmailCommunication"><label class="custom-control-label" for="field_receiveEmailCommunication" data-translate="contactUs.emailContactAcceptance">emailContactAcceptance</label></div></div></div><div class="text-center"><button type="button" class="btn btn-default my-4" data-dismiss="modal" ng-click="vm.cancel()" data-translate="entity.action.close">Close</button> <button type="submit" ng-disabled="contactForm.$invalid || vm.isSaving" class="btn btn-primary my-4" data-translate="entity.action.send">Enviar</button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/components/faqs/faqs.html','<!--\n    One FAQ, three entry points: the landing page embeds <faqs-component> for anonymous\n    visitors, the \'faqs\' state renders this same template for signed-in ones, and every\n    notification e-mail links to /external/faqs, which routes to whichever applies. There is\n    no second copy to keep in step - if you change a question here, it changes everywhere.\n\n    Images live in content/images/faqs/<flag>/, where <flag> is the CURRENT LANGUAGE\'S FLAG\n    ICON ("pt" / "gb"), not its language key ("pt-pt" / "en"). That is what\n    getCurrentLanguageIcon() returns; a third language needs a folder named after its flag.\n\n    Every <img> carries width and height: the real pixel size of the file, so the browser\n    reserves the right box before it arrives and nothing reflows as an accordion opens.\n    .faq-figure then caps it to the column (max-width:100%, height:auto), so a figure is drawn\n    at its own resolution or smaller and is never magnified.\n\n    ONE NUMBER SERVES BOTH LANGUAGES, and that is not luck. There is one <img> per image but two\n    files behind it, pt/ and gb/, and the browser is handed the numbers before it knows which.\n    tools/faqs/capture-faqs.js therefore captures both languages into ONE FIXED BOX per image,\n    declared in tools/faqs/targets.js. Every pair below is identical in size because of that.\n    (The 2022 captures it replaced were not: faq2_4 was 260px wide in Portuguese and 179px in\n    English, so one of the two was always drawn to the other\'s box.)\n\n    Captures are at deviceScaleFactor 2, so each PNG is twice the numbers here.\n\n    If you replace a file, re-measure it and update the numbers in the same commit. A stale width\n    is worse than none: it reserves a box the image does not fill.\n--><ul id="accordion" class="p-0"><li class="card"><div class="" id="headingOne"><button class="btn btn-default btn-block text-left collapsed p-3" data-toggle="collapse" data-target="#collapseOne"><strong data-translate="faqs.title1">title1</strong></button></div><div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion"><div class="card-body"><p data-translate="faqs.description1_1">description1_1</p><img class="faq-figure" width="600" height="880" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq1_1.png" alt="{{\'faqs.a11y.notificationEmail\' | translate}}"><p data-translate="faqs.description1_2">description1_2</p><ol><li><span data-translate="faqs.description1_2_1">description1_2_1</span> <img class="faq-figure faq-figure--inline" width="220" height="60" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq1_2.png" alt="{{\'faqs.a11y.viewDocumentButton\' | translate}}"><ul style="list-style-type: lower-alpha"><li data-translate="faqs.description1_2_1_1">description1_2_1_1</li><li data-translate="faqs.description1_2_1_2">description1_2_1_2</li></ul></li><li><span data-translate="faqs.description1_2_2">description1_2_2</span> <img class="faq-figure faq-figure--inline" width="220" height="60" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq1_3.png" alt="{{\'faqs.a11y.openApplicationButton\' | translate}}"><ul style="list-style-type: lower-alpha"><li data-translate="faqs.description1_2_2_1">description1_2_2_1</li><li data-translate="faqs.description1_2_2_2">description1_2_2_2</li></ul></li></ol></div></div></li><li class="card"><div class="" id="headingTwo"><button class="btn btn-default btn-block text-left collapsed p-3" data-toggle="collapse" data-target="#collapseTwo"><strong data-translate="faqs.title2">title2</strong></button></div><div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion"><div class="card-body"><p data-translate="faqs.description2_1">description2_1</p><p><span data-translate="faqs.description2_2_1">description2_2_1</span> <img class="faq-icon" width="40" height="34" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq2_1.png" alt="{{\'faqs.a11y.editIcon\' | translate}}"> <span data-translate="faqs.description2_2_2">description2_2_2</span> <img class="faq-icon" width="36" height="36" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq2_2.png" alt="{{\'faqs.a11y.removeIcon\' | translate}}"> <span data-translate="faqs.description2_2_3">description2_2_3</span></p><p data-translate="faqs.description2_3_1">description2_3_1</p><img class="faq-figure" width="250" height="300" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq2_3.png" alt="{{\'faqs.a11y.entitiesMenu\' | translate}}"><p data-translate="faqs.description2_3_2">description2_3_2</p><p><span data-translate="faqs.description2_4">description2_4</span> <img class="faq-figure faq-figure--inline" width="300" height="52" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq2_4.png" alt="{{\'faqs.a11y.addUserButton\' | translate}}"></p><img class="faq-figure" width="1000" height="620" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq2_5.png" alt="{{\'faqs.a11y.entityEdit\' | translate}}"><p data-translate="faqs.description2_5">description2_5</p><img class="faq-figure" width="520" height="260" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq2_6.png" alt="{{\'faqs.a11y.addUserPrompt\' | translate}}"><p data-translate="faqs.description2_6">description2_6</p><img class="faq-figure" width="900" height="560" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq2_7.png" alt="{{\'faqs.a11y.createUser\' | translate}}"><p data-translate="faqs.description2_7">description2_7</p><p data-translate="faqs.description2_8">description2_8</p><p><span data-translate="faqs.description2_9">description2_9</span> <a href="" ng-click="vm.contactUs()" data-translate="faqs.description2_10">description2_10</a></p></div></div></li><li class="card"><div class="" id="headingThree"><button class="btn btn-default btn-block text-left collapsed p-3" data-toggle="collapse" data-target="#collapseThree"><strong data-translate="faqs.title3">title3</strong></button></div><!--\n            This entry used to be two: "how do I reset my password" and "why did I receive an\n            account-creation e-mail". Their answers were the same five steps with five\n            byte-identical screenshots, so they are one question now, opening with the part\n            that was genuinely different - why the e-mail arrived at all.\n        --><div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion"><div class="card-body"><p><span data-translate="faqs.description3_0_1">description3_0_1</span><a href="https://www.edocuments.biz/" target="_blank" rel="noopener" data-translate="faqs.description3_0_2">description3_0_2</a><span data-translate="faqs.description3_0_3">description3_0_3</span></p><p data-translate="faqs.description3_0_4">description3_0_4</p><p data-translate="faqs.description3_1">description3_1</p><img class="faq-figure" width="640" height="480" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq3_1.png" alt="{{\'faqs.a11y.forgotPassword\' | translate}}"><p data-translate="faqs.description3_2">description3_2</p><img class="faq-figure" width="640" height="420" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq3_2.png" alt="{{\'faqs.a11y.resetRequest\' | translate}}"><p data-translate="faqs.description3_3">description3_3</p><img class="faq-figure" width="640" height="420" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq3_3.png" alt="{{\'faqs.a11y.checkYourInbox\' | translate}}"><p data-translate="faqs.description3_4">description3_4</p><img class="faq-figure" width="600" height="790" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq3_4.png" alt="{{\'faqs.a11y.resetEmail\' | translate}}"><p data-translate="faqs.description3_5">description3_5</p><img class="faq-figure" width="640" height="520" loading="lazy" src="/content/images/faqs/{{vm.getCurrentLanguageIcon()}}/faq3_5.png" alt="{{\'faqs.a11y.newPassword\' | translate}}"><p data-translate="faqs.description3_6">description3_6</p></div></div></li><li class="card"><div class="" id="headingFour"><button class="btn btn-default btn-block text-left collapsed p-3" data-toggle="collapse" data-target="#collapseFour"><strong data-translate="faqs.title4">title4</strong></button></div><div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion"><div class="card-body"><p data-translate="faqs.description4_0">description4_0</p><p><a href="" ng-click="vm.contactUs()" data-translate="faqs.description4_1">description4_1</a></p></div></div></li></ul>');
$templateCache.put('app/components/integrity-warning/integrity-warning.dialog.html','<div class="modal-header bg-danger"><h5 class="modal-title text-white"><i class="fa fa-exclamation-triangle"></i> {{ \'eDocumentsApp.digitalArchive.integrityWarning.title\' | translate }}</h5><button type="button" class="close text-white" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div class="alert alert-danger"><strong>{{ \'eDocumentsApp.digitalArchive.integrityWarning.warningLabel\' | translate }}</strong> {{ \'eDocumentsApp.digitalArchive.integrityWarning.warning\' | translate }}</div><table class="table table-striped table-bordered"><thead><tr><th>{{ \'eDocumentsApp.digitalArchive.integrityWarning.filename\' | translate }}</th><th>{{ \'eDocumentsApp.digitalArchive.integrityWarning.status\' | translate }}</th></tr></thead><tbody><tr ng-repeat="file in vm.failedFiles"><td>{{ file.filename || file.name }}</td><td class="text-danger"><i class="fa fa-times-circle"></i> <span>{{ vm.getStatusTranslationKey(file) | translate }}</span></td></tr></tbody></table><div class="alert alert-warning"><strong>{{ \'eDocumentsApp.digitalArchive.integrityWarning.legalNoticeLabel\' | translate }}</strong> {{ \'eDocumentsApp.digitalArchive.integrityWarning.legalNotice\' | translate }}</div><div class="checkbox"><label><input type="checkbox" ng-model="vm.userAcknowledged"> <strong>{{ \'eDocumentsApp.digitalArchive.integrityWarning.acknowledge\' | translate }}</strong></label></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><i class="fas fa-ban"></i>&nbsp;<span>{{ \'eDocumentsApp.digitalArchive.integrityWarning.cancel\' | translate }}</span></button></div><div class="float-right"><button type="button" class="btn btn-danger" ng-click="vm.proceed()" ng-disabled="!vm.userAcknowledged"><i class="fas fa-download"></i>&nbsp;<span>{{ \'eDocumentsApp.digitalArchive.integrityWarning.downloadAnyway\' | translate }}</span></button></div></div>');
$templateCache.put('app/components/login/login.html','<div class="card bg-light shadow border-0"><div class="card-header bg-white border-0 text-center"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="m-3"><div class="login-logo-text"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--lg">eDocuments<span class="ed-wordmark__dot">.biz</span></span></div></h4></div><div class="card-body p-4 pb-0"><form class="form" name="loginForm" ng-submit="vm.login($event)"><div class="text-center text-muted mb-4" data-translate="login.title">Sign in</div><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div><!-- SUP-12293: the password was right, but the account\'s access has ended --><div class="alert alert-warning" role="alert" ng-show="vm.accessExpired && vm.accessExpiredDay" data-translate="login.messages.error.accessExpired" translate-values="{day: (vm.accessExpiredDay | date:\'dd/MM/yyyy\')}"><strong>This account\'s access expired.</strong> Contact the administrator of your account.</div><div class="alert alert-warning" role="alert" ng-show="vm.accessExpired && !vm.accessExpiredDay" data-translate="login.messages.error.accessEnded"><strong>This account\'s access has ended.</strong> Contact the administrator of your account.</div><div class="form-group"><label for="username" class="sr-only" data-translate="login.form.username">Username</label><div class="input-group input-group-alternative"><div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-user"></i></span></div><input type="text" id="username" class="form-control" ng-model="vm.username" placeholder="{{\'login.form.username.placeholder\' | translate}}" required autofocus=""></div></div><div class="form-group"><label for="password" class="sr-only" data-translate="login.form.password">Password</label><div class="input-group input-group-alternative"><div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-key"></i></span></div><input type="password" id="password" class="form-control" ng-model="vm.password" placeholder="{{\'login.form.password.placeholder\' | translate}}" required></div></div><div class="form-group"><div class="checkbox text-muted"><label><input type="checkbox" ng-model="vm.rememberMe" value="remember-me" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div></div><div class="text-center mb-3"><button class="btn btn-primary" type="submit" ng-disabled="loginForm.$invalid || vm.isSaving"><span data-translate="login.button.login">Sign in</span></button> <button class="btn btn-outline-primary" type="button" ng-click="vm.contactUs()"><span data-translate="login.button.createAccount">Create Account</span></button></div></form><div class="alert alert-light bg-light text-center m-0"><a class="alert-link" href="" ng-click="vm.requestResetPassword()"><span data-translate="login.password.forgot">Did you forget your password?</span></a></div><div class="alert alert-light bg-light text-center m-0"><a class="alert-link" href="" ng-click="vm.downloadManual()"><i class="fa fa-info-circle"></i> <span data-translate="login.getManual">Get application user manual</span></a></div></div></div>');
$templateCache.put('app/components/secret/secret-field.html','<div class="input-group input-group-sm"><input type="password" class="form-control form-control-sm" autocomplete="new-password" name=\'{{fieldName || "value"}}\' ng-model="model" ng-readonly="readOnly" placeholder="{{stored ? (\'global.secret.kept\' | translate) : \'\'}}"><div class="input-group-append" ng-if="canReveal && secretId && stored"><button type="button" class="btn btn-outline-secondary btn-sm" ng-click="reveal()" uib-tooltip="{{\'global.secret.reveal.button\' | translate}}" aria-label="{{\'global.secret.reveal.button\' | translate}}"><i class="fas fa-eye" aria-hidden="true"></i></button></div></div>');
$templateCache.put('app/components/secret/secret-reveal.html','<form name="revealForm" role="form" novalidate ng-submit="vm.submit()" autocomplete="off"><div class="modal-header"><h4 class="modal-title" data-translate="global.secret.reveal.title">Revelar credencial guardada</h4><button type="button" class="close" ng-click="vm.close()" aria-hidden="true">&times;</button></div><div class="modal-body"><div ng-if="vm.value === null"><p class="text-muted" data-translate="global.secret.reveal.explanation">Esta leitura fica registada nas auditorias, com o seu utilizador, a data e o motivo.</p><div class="form-group"><label for="secretRevealReason" data-translate="global.secret.reveal.reason">Motivo</label><textarea id="secretRevealReason" class="form-control" rows="2" ng-model="vm.reason" required placeholder="{{\'global.secret.reveal.reasonPlaceholder\' | translate}}"></textarea><small class="form-text text-muted" data-translate="global.secret.reveal.reasonHint" translate-values="{min: vm.minReasonLength}">Pelo menos 10 caracteres.</small></div><div class="form-group"><label for="secretRevealPassword" data-translate="global.secret.reveal.password">A sua palavra-passe</label><input id="secretRevealPassword" type="password" class="form-control" autocomplete="current-password" ng-model="vm.password" required></div><div class="alert alert-danger" ng-if="vm.errorKey" role="alert"><span data-translate="global.secret.reveal.error.{{vm.errorKey}}">N\xE3o foi poss\xEDvel revelar a credencial.</span></div></div><div ng-if="vm.value !== null"><label for="secretRevealValue" data-translate="global.secret.reveal.value">Credencial</label><div class="input-group"><input id="secretRevealValue" type="text" class="form-control" readonly="readonly" ng-value="vm.value" autocomplete="off"><div class="input-group-append"><button type="button" class="btn btn-outline-secondary" ng-click="vm.copy()"><i class="fas fa-copy" aria-hidden="true"></i> <span data-translate="global.secret.reveal.copy">Copiar</span></button></div></div><small class="form-text text-muted"><span data-translate="global.secret.reveal.hidesIn" translate-values="{seconds: vm.secondsLeft}">Esconde-se em 30 s.</span> <span ng-if="vm.copied" data-translate="global.secret.reveal.copied">Copiada.</span></small></div></div><div class="modal-footer"><button type="button" class="btn btn-secondary" ng-click="vm.close()"><span data-translate="entity.action.close">Fechar</span></button> <button type="submit" class="btn btn-primary" ng-if="vm.value === null" ng-disabled="!vm.canSubmit()"><i class="fas fa-eye" aria-hidden="true"></i> <span data-translate="global.secret.reveal.submit">Revelar</span></button></div></form>');
$templateCache.put('app/entities/ama-safe-credential/ama-safe-credential-add-confirmation-dialog.html','<div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.amaSafeCredential.addConfirmation.title">Add Confirmation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p data-translate="eDocumentsApp.amaSafeCredential.addConfirmation.message"></p><p data-translate="eDocumentsApp.amaSafeCredential.addConfirmation.question"></p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel"> Cancel</span></button></div><div class="float-right"><button type="button" class="btn btn-success" ng-click="vm.accept()"><i class="fas fa-check"></i>&nbsp;<span data-translate="entity.action.confirm"> Confirm</span></button></div></div>');
$templateCache.put('app/entities/ama-safe-credential/ama-safe-credential-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.amaSafeCredential.delete.question" translate-values="{credentialId: \'{{vm.amaSafeCredential.credentialId}}\'}">Are you sure you want to delete this AMA SAFE Credential?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel"> Back</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/ama-safe-credential/ama-safe-credential-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span data-translate="eDocumentsApp.amaSafeCredential.detail.title">Create a Ama Safe Credential</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span data-translate="eDocumentsApp.amaSafeCredential.communicationEntity">Communication Entity</span>&nbsp;{{vm.communicationEntity.name}}&nbsp;&nbsp;-&nbsp;&nbsp;{{vm.communicationEntity.vatRegistrationNumber}}</h5><hr></div><div class="container-fluid row"><jhi-alert-error></jhi-alert-error><div class="col-md-8"><div class="form-group"><label><span data-translate="eDocumentsApp.amaSafeCredential.credentialId" for="field_credentialId">CredentialId</span> <span style="font-size: 12px" uib-tooltip="{{\'eDocumentsApp.amaSafeCredential.tooltip.credentialId\' | translate }}" tooltip-placement="right" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></label><input type="text" class="form-control mb-2" name="credentialId" id="field_credentialId" ng-class="{\'is-invalid\': editForm.name.$invalid}" ng-model="vm.amaSafeCredential.credentialId" required ng-maxlength="255"><div class="invalid-feedback" ng-show="editForm.credentialId.$invalid && editForm.credentialId.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.credentialId.$invalid &&  editForm.credentialId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div><div class="form-group"><span style="font-size: 12px" uib-tooltip="{{\'eDocumentsApp.amaSafeCredential.tooltip.accessToken\' | translate }}" tooltip-placement="right" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i> </span><button ngf-select class="btn btn-primary" ngf-pattern="\'.txt\'" accept=".txt" ngf-change="vm.setAccessTokenFile($file,$invalidFiles)" ng-disabled=""><i class="fa fa-upload"></i> <span data-translate="eDocumentsApp.amaSafeCredential.action.uploadAccessToken"></span></button> <i ng-if="vm.accessToken" class="fas fa-check text-success"></i> <span ng-if="vm.accessToken" data-translate="eDocumentsApp.amaSafeCredential.message.accessTokenUploaded">Access Token Uploaded</span></div><div class="form-group"><span style="font-size: 12px" uib-tooltip="{{\'eDocumentsApp.amaSafeCredential.tooltip.refreshToken\' | translate }}" tooltip-placement="right" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i> </span><button ngf-select class="btn btn-primary" ngf-pattern="\'.txt\'" accept=".txt" ngf-change="vm.setRefreshTokenFile($file,$invalidFiles)" ng-disabled=""><i class="fa fa-upload"></i> <span data-translate="eDocumentsApp.amaSafeCredential.action.uploadRefreshToken"></span></button> <i ng-if="vm.refreshToken" class="fas fa-check text-success"></i> <span ng-if="vm.refreshToken" data-translate="eDocumentsApp.amaSafeCredential.message.refreshTokenUploaded">Refresh Token Uploaded</span></div><div class="form-group"><label><span data-translate="eDocumentsApp.amaSafeCredential.reason.label" for="field_reason">Reason</span> <span style="font-size: 12px" ng-click="vm.openReasonDetail()"><i class="fa fa-question-circle"></i></span></label><select id="field_reason" class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.amaSafeCredential.reason"><option value="" disabled="">{{\'eDocumentsApp.amaSafeCredential.reason.label\' | translate}}</option><option ng-repeat="reason in vm.reasons" value="{{reason}}">{{\'eDocumentsApp.AmaSafeCredentialReason.\' + reason | translate}}</option></select></div></div><div class="col-md-4 border-left border-primary text-center"><p data-translate="eDocumentsApp.amaSafeCredential.message.accessAMASAFEPlatform">Access AMA-SAFE platform</p><a class="btn btn-info" href="https://autenticacao.gov.pt" target="_blank"><i class="icon-autenticacaogovpt"></i> <span data-translate="eDocumentsApp.amaSafeCredential.action.accessAMASAFEPlatform"></span></a><p data-translate="eDocumentsApp.amaSafeCredential.message.downloadManual" class="mt-3">Download Manual</p><a class="btn btn-primary" ng-click="vm.downloadAMASAFEUserManual()"><i class="fa fa-download"></i> <span data-translate="eDocumentsApp.amaSafeCredential.action.downloadManual"></span></a></div></div><hr><div><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || !vm.accessToken || !vm.refreshToken" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ama-safe-credential/ama-safe-credential-disclaimer-dialog.html','<div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.amaSafeCredential.disclaimer.title">Disclaimer</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p data-translate="eDocumentsApp.amaSafeCredential.disclaimer.message1"></p><p><span data-translate="eDocumentsApp.amaSafeCredential.disclaimer.message2"></span>:</p><p><a href="https://www.autenticacao.gov.pt/documents/20126/0/POL%2316.PolAssQual_signed_signed.pdf" target="_blank">{{\'eDocumentsApp.amaSafeCredential.disclaimer.viewPOL16\' | translate }}</a></p><small><span data-translate="eDocumentsApp.amaSafeCredential.disclaimer.additionalInformations"></span>:</small><br><small><a href="https://dre.pt/dre/detalhe/decreto-lei/28-2019-119622094" target="_blank">{{\'eDocumentsApp.amaSafeCredential.disclaimer.viewDL282019\' | translate }}</a></small><br><small><a href="https://dre.pt/dre/detalhe/decreto-lei/12-2021-156848060" target="_blank">{{\'eDocumentsApp.amaSafeCredential.disclaimer.viewDL122021\' | translate }}</a></small><br><small><a href="https://eur-lex.europa.eu/legal-content/PT/TXT/PDF/?uri=CELEX:32014R0910" target="_blank">{{\'eDocumentsApp.amaSafeCredential.disclaimer.viewRegulation9102014\' | translate }}</a></small><br><br><p><strong data-translate="eDocumentsApp.amaSafeCredential.disclaimer.question"></strong></p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel"> Cancel</span></button></div><div class="float-right"><button type="button" class="btn btn-success" ng-click="vm.accept()"><i class="fas fa-check"></i>&nbsp;<span data-translate="entity.action.confirm"> Confirm</span></button></div></div>');
$templateCache.put('app/entities/ama-safe-credential/ama-safe-credential-reason-dialog.html','<div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.amaSafeCredential.reason.title">Reason</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p data-translate="eDocumentsApp.amaSafeCredential.reason.detail1"></p><ul class="list-group list-group-flush"><li ng-repeat="reason in vm.reasons" class="list-group-item"><span>{{\'eDocumentsApp.AmaSafeCredentialReason.\' + reason | translate}}</span><p class="mb-0"><small>{{\'eDocumentsApp.AmaSafeCredentialReason.explanation.\' + reason | translate}}</small></p></li></ul><p data-translate="eDocumentsApp.amaSafeCredential.reason.detail2"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span data-translate="entity.action.close">Close</span></button></div>');
$templateCache.put('app/entities/ama-safe-util/ama-safe-util-dialog.html','<div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.amaSafeUtil.response.title">Request response</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div ng-if="vm.responseStatus" class="alert alert-success" data-translate="eDocumentsApp.amaSafeUtil.response.success">Request response success</div><div ng-if="!vm.responseStatus" class="alert alert-danger" data-translate="eDocumentsApp.amaSafeUtil.response.error">Error on request</div><pre pretty-json="vm.message"></pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-check"></i>&nbsp;<span data-translate="entity.action.close"> Close</span></button></div>');
$templateCache.put('app/entities/ama-safe-util/ama-safe-util.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h5 data-translate="eDocumentsApp.amaSafeUtil.home.title">AMA SAFE UTIL</h5></div></div><hr></div><div id="accordion"><div class="card"><div class="card-header bg-primary" id="headingOne"><h5 class="mb-0"><button class="btn btn-block text-left text-white" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"><span data-translate="eDocumentsApp.amaSafeUtil.authenticationCall.title">TEST AMA-SAFE AUTHENTICATION</span></button></h5></div><div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion"><div class="card-body"><form id="authForm" name="authForm" role="form" novalidate ng-submit="vm.callAuthTest()" show-validation><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.authenticationCall.authForm.username" for="field_username">USERNAME</label><input type="text" class="form-control form-control-sm mb-2" name="username" id="field_username" ng-model="vm.authFormBody.username" ng-class=\'{"is-invalid": authForm.username.$invalid}\' required><div ng-show="authForm.username.$dirty && authForm.username.$invalid"><div class="text-danger" ng-show="authForm.username.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div></div><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.authenticationCall.authForm.password" for="field_password">PASSWORD</label><input type="text" class="form-control form-control-sm mb-2" name="password" id="field_password" ng-model="vm.authFormBody.password" ng-class=\'{"is-invalid": authForm.password.$invalid}\' required><div ng-show="authForm.password.$dirty && authForm.password.$invalid"><div class="text-danger" ng-show="authForm.password.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div></div><hr><div class="col-auto"><button type="button" class="btn btn-default" ng-click="vm.clearAuthForm(this.authForm)"><i class="fas fa-eraser"></i> <span data-translate="entity.action.clear">CLEAR</span></button> <button type="submit" ng-disabled="authForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-retweet"></i> <span data-translate="entity.action.callRequest">CALL REQUEST</span></button></div></form></div></div></div><div class="card"><div class="card-header bg-secondary" id="headingTwo"><h5 class="mb-0"><button class="btn btn-block text-left text-white collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"><span data-translate="eDocumentsApp.amaSafeUtil.credentialIdCall.title">GET AMA-SAFE CREDENTIAL ID</span></button></h5></div><div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion"><div class="card-body"><form id="credentialForm" name="credentialForm" role="form" novalidate ng-submit="vm.callCredentialForm()" show-validation><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.credentialIdCall.credentialForm.username" for="field_username2">USERNAME</label><input type="text" class="form-control form-control-sm mb-2" name="username" id="field_username2" ng-model="vm.credentialFormBody.username" ng-class=\'{"is-invalid": credentialForm.username.$invalid}\' required><div ng-show="credentialForm.username.$dirty && credentialForm.username.$invalid"><div class="text-danger" ng-show="credentialForm.username.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div></div><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.credentialIdCall.credentialForm.password" for="field_password2">PASSWORD</label><input type="text" class="form-control form-control-sm mb-2" name="password" id="field_password2" ng-model="vm.credentialFormBody.password" ng-class=\'{"is-invalid": credentialForm.password.$invalid}\' required><div ng-show="credentialForm.password.$dirty && credentialForm.password.$invalid"><div class="text-danger" ng-show="credentialForm.password.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div></div><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.credentialIdCall.credentialForm.authToken" for="field_authToken">SAFE AUTHORIZATION TOKEN</label><input type="text" class="form-control form-control-sm mb-2" name="authToken" id="field_authToken" ng-model="vm.credentialFormBody.authToken" ng-class=\'{"is-invalid": credentialForm.authToken.$invalid}\' required><div ng-show="credentialForm.authToken.$dirty && credentialForm.authToken.$invalid"><div class="text-danger" ng-show="credentialForm.authToken.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div></div><hr><div class="col-auto"><button type="button" class="btn btn-default" ng-click="vm.clearCredentialForm(this.credentialForm)"><i class="fas fa-eraser"></i> <span data-translate="entity.action.clear">CLEAR</span></button> <button type="submit" ng-disabled="credentialForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-retweet"></i> <span data-translate="entity.action.callRequest">CALL REQUEST</span></button></div></form></div></div></div><div class="card"><div class="card-header bg-info" id="headingThree"><h5 class="mb-0"><button class="btn btn-block text-left text-white collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"><span data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.title">SIGNATURE POSITION TESTER</span></button></h5></div><div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion"><div class="card-body"><form id="signatureForm" name="signatureForm" role="form" novalidate ng-submit="vm.callSignatureForm()" show-validation><div class="form-row align-items-center"><p data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.message">A NEW DOCUMENT WILL BE GENERATED WITH AN AREA OF DIMENSIONS, COLOR AND POSITIONING THAT YOU INDICATE IN REPRESENTATION OF THE SPACE RESERVED FOR THE DIGITAL SIGNATURE</p></div><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.signatureForm.fileSample">SAMPLE DOCUMENT (PDF)</label><div ng-if="!vm.signatureFormBody.file"><button ngf-select class="btn btn-sm btn-primary col-md-12" ngf-pattern=\'".pdf"\' accept=".pdf" ngf-change="vm.setFile($file)" ng-disabled=""><i class="fas fa-file-import"></i>&nbsp; <span data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.signatureForm.fileUpload">UPLOAD DOCUMENT</span></button></div><div ng-if="vm.signatureFormBody.file"><div class="row"><div class="btn-group col-md-12"><button ngf-select class="btn btn-sm btn-secondary" ngf-pattern=\'".pdf"\' accept=".pdf" ngf-change="vm.setFile($file)" ng-disabled=""><i class="fas fa-file-pdf"></i> <span data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.signatureForm.fileUploaded" data-translate-values="{filename: vm.signatureFormBody.filename}">DOCUMENT UPLOADED</span></button> <button type="button" class="btn btn-sm btn-danger" ng-click="vm.resetFile()"><i class="fas fa-eraser"></i> <span data-translate="entity.action.clear">CLEAR</span></button></div></div></div></div><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.signatureForm.color" for="field_color">SIGNATURE\'S BACKGROUND COLOR</label><color-picker id="field_color" name="color" ng-model="vm.signatureFormBody.color" options="vm.colorPickerOptions"></color-picker></div></div><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.signatureForm.signXCoord" for="field_signXCoord">SIGNATURE\'S X COORDINATE</label><input type="number" class="form-control form-control-sm mb-2" name="signXCoord" id="field_signXCoord" ng-model="vm.signatureFormBody.signXCoord" ng-class=\'{"is-invalid": signatureForm.signXCoord.$invalid}\' min="0" required><div ng-show="signatureForm.signXCoord.$dirty && signatureForm.signXCoord.$invalid"><div class="text-danger" ng-show="signatureForm.signXCoord.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.signatureForm.signYCoord" for="field_signYCoord">SIGNATURE\'S Y COORDINATE</label><input type="number" class="form-control form-control-sm mb-2" name="signYCoord" id="field_signYCoord" ng-model="vm.signatureFormBody.signYCoord" ng-class=\'{"is-invalid": signatureForm.signYCoord.$invalid}\' min="0" required><div ng-show="signatureForm.signYCoord.$dirty && signatureForm.signYCoord.$invalid"><div class="text-danger" ng-show="signatureForm.signYCoord.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div></div><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.signatureForm.signWidth" for="field_signWidth">SIGNATURE\'S WIDTH</label><input type="number" class="form-control form-control-sm mb-2" name="signWidth" id="field_signWidth" ng-model="vm.signatureFormBody.signWidth" ng-class=\'{"is-invalid": signatureForm.signWidth.$invalid}\' min="0" required><div ng-show="signatureForm.signWidth.$dirty && signatureForm.signWidth.$invalid"><div class="text-danger" ng-show="signatureForm.signWidth.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div><div class="form-group col-md-6"><label data-translate="eDocumentsApp.amaSafeUtil.signPositionTester.signatureForm.signHeight" for="field_signHeight">SIGNATURE\'S X HEIGHT</label><input type="number" class="form-control form-control-sm mb-2" name="signHeight" id="field_signHeight" ng-model="vm.signatureFormBody.signHeight" ng-class=\'{"is-invalid": signatureForm.signHeight.$invalid}\' min="0" required><div ng-show="signatureForm.signHeight.$dirty && signatureForm.signHeight.$invalid"><div class="text-danger" ng-show="signatureForm.signHeight.$error.required" data-translate="entity.validation.required">This field is required.</div></div></div></div><hr><div class="col-auto"><button type="button" class="btn btn-default" ng-click="vm.clearSignatureForm(this.signatureForm)"><i class="fas fa-eraser"></i> <span data-translate="entity.action.clear">CLEAR</span></button> <button type="submit" ng-if="vm.readOnly !== true" ng-disabled="signatureForm.$invalid || vm.isSaving || !vm.signatureFormBody.file" class="btn btn-primary"><i class="fas fa-retweet"></i> <span data-translate="entity.action.callRequest">CALL REQUEST</span></button></div></form></div></div></div></div><br><div class="container-fluid mt-3 mb-3"><hr><div class="row"><div class="col"><button type="button" ng-click="vm.goBack()" class="btn btn-default"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div></div></div></div>');
$templateCache.put('app/entities/communication/communication-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.communication.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.communication.delete.question" translate-values="{id: \'{{vm.communication.id}}\'}">Are you sure you want to delete this Communication?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/communication/communication-detail.html','<div class="container-fluid mt-3 mb-3"><h2><span data-translate="eDocumentsApp.communication.detail.title">Communication</span> {{vm.communication.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="jh-entity-details"><dt><span data-translate="eDocumentsApp.communication.communicationTime">Communication Time</span></dt><dd><span>{{vm.communication.communicationTime | date:\'medium\'}}</span></dd><dt><span data-translate="eDocumentsApp.communication.status">Status</span></dt><dd><span data-translate="{{\'eDocumentsApp.CommunicationStatus.\' + vm.communication.status}}">{{vm.communication.status}}</span></dd><dt><span data-translate="eDocumentsApp.communication.message">Message</span></dt><dd><span>{{vm.communication.message}}</span></dd><dt><span data-translate="eDocumentsApp.communication.document">Document</span></dt><dd><a class="btn btn-outline-info btn-sm" ui-sref="document-detail({id:vm.communication.documentId})"><i class="fas fa-eye"></i> {{vm.communication.documentNumber}}</a></dd><dt><span data-translate="eDocumentsApp.communication.communicationWorkflowStep">Communication Workflow Step</span></dt><dd><a class="btn btn-outline-info btn-sm" ui-sref="communication-workflow-step-detail({id:vm.communication.communicationWorkflowStepId})"><i class="fas fa-eye"></i> <span data-translate="eDocumentsApp.communicationDefinition.viewWorkflow">View Workflow</span> - {{vm.communication.communicationWorkflowStepId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="communication-detail.edit({id:vm.communication.id})" class="btn btn-primary"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/communication/communication-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span data-translate="eDocumentsApp.communication.home.createOrEditLabel">Create or edit a Communication</span></h5><hr></div><div class="container-fluid"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communication.communicationTime" for="field_communicationTime">Communication Time</label><div class="input-group"><input id="field_communicationTime" type="text" class="form-control form-control-sm" name="communicationTime" datetime-picker="{{dateformat}}" ng-model="vm.communication.communicationTime" is-open="vm.datePickerOpenStatus.communicationTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'communicationTime\')"><i class="far fa-calendar-alt"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communication.status" for="field_status">Status</label><select class="form-control form-control-sm" name="status" ng-model="vm.communication.status" id="field_status" required><option value="IN_EXECUTION" data-translate="eDocumentsApp.CommunicationStatus.IN_EXECUTION">IN_EXECUTION</option><option value="SUCCESS" data-translate="eDocumentsApp.CommunicationStatus.SUCCESS">SUCCESS</option><option value="ERROR" data-translate="eDocumentsApp.CommunicationStatus.ERROR">ERROR</option><option value="RETRY" data-translate="eDocumentsApp.CommunicationStatus.RETRY">RETRY</option></select><div ng-show="editForm.status.$invalid"><p class="help-block" ng-show="editForm.status.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communication.message" for="field_message">Message</label><input type="text" class="form-control form-control-sm" name="message" id="field_message" ng-model="vm.communication.message" ng-maxlength="512"><div ng-show="editForm.message.$invalid"><p class="help-block" ng-show="editForm.message.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="512">This field cannot be longer than 512 characters.</p></div></div><div class="form-group"><label data-translate="eDocumentsApp.communication.document" for="field_document">Document</label><select class="form-control form-control-sm" id="field_document" name="document" ng-model="vm.communication.documentId" ng-options="document.id as document.id for document in vm.documents"><option value=""></option></select></div><div class="form-group"><label data-translate="eDocumentsApp.communication.communicationWorkflowStep" for="field_communicationWorkflowStep">Communication Workflow Step</label><select class="form-control form-control-sm" id="field_communicationWorkflowStep" name="communicationWorkflowStep" ng-model="vm.communication.communicationWorkflowStepId" ng-options="communicationWorkflowStep.id as communicationWorkflowStep.id for communicationWorkflowStep in vm.communicationworkflowsteps"><option value=""></option></select></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div><div class="float-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/communication/communications.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.communication.home.title">Communications</h2></div><div class="col"><form class="form-inline float-right"><div class="form-group mx-2 mb-2"><input type="text" class="form-control form-control-sm" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'entity.action.search\' | translate}}"></div><button class="btn btn-info mx-2 mb-2" ng-click="vm.search(vm.searchQuery)"><i class="fas fa-search"></i></button> <button class="btn btn-dark mx-2 mb-2" ng-if="vm.currentSearch" ng-click="vm.clear()"><i class="fas fa-trash-alt"></i></button></form></div></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="eDocumentsApp.communication.communicationTime">Communication Time</span></th><th><span data-translate="eDocumentsApp.communication.status">Status</span></th><th><span data-translate="eDocumentsApp.communication.message">Message</span></th><th><span data-translate="eDocumentsApp.communication.document">Document</span></th><th><span data-translate="eDocumentsApp.communication.communicationWorkflowStep">Communication Workflow Step</span></th><th></th></tr></thead><tbody><tr ng-repeat="communication in vm.communications track by communication.id"><td>{{communication.communicationTime | date:\'medium\'}}</td><td data-translate="{{\'eDocumentsApp.CommunicationStatus.\' + communication.status}}">{{communication.status}}</td><td>{{communication.message}}</td><td><a ui-sref="document-detail({id:communication.documentId})">{{communication.documentNumber}}</a></td><td><a ui-sref="communication-workflow-step-detail({id:communication.communicationWorkflowStepId})">{{communication.communicationWorkflowStepId}} (#{{communication.communicationWorkflowStepOrder}})</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="communication-detail({id:communication.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="entity.action.view"></span> </a><a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication.edit({id:communication.id})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit"></span> </a><a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication.delete({id:communication.id})" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></a></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.communications.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></div></div></div>');
$templateCache.put('app/entities/communication-action-definition/communication-action-definition-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.communicationActionDefinition.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.communicationActionDefinition.delete.question" translate-values="{id: \'{{vm.communicationActionDefinition.id}}\'}">Are you sure you want to delete this Communication Action Definition?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/communication-action-definition/communication-action-definition-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span data-translate="eDocumentsApp.communicationActionDefinition.detail.title">Create or edit a Communication Definition</span> <span ng-if="vm.communicationActionDefinition.name">- {{vm.communicationActionDefinition.name}}</span></h5><hr></div><div class="container-fluid"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="eDocumentsApp.communicationActionDefinition.name" for="field_name">Name</label><input type="text" class="form-control mb-2" name="name" id="field_name" ng-class="{\'is-invalid\': editForm.name.$invalid}" ng-model="vm.communicationActionDefinition.name" required ng-maxlength="255"><div class="invalid-feedback" ng-show="editForm.name.$invalid && editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.name.$invalid &&  editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div><div class="form-group"><label data-translate="eDocumentsApp.communicationActionDefinition.classname" for="field_classname">Classname</label><input type="text" class="form-control mb-2" name="classname" id="field_classname" ng-class="{\'is-invalid\': editForm.classname.$invalid}" ng-model="vm.communicationActionDefinition.classname" required ng-maxlength="512"><div class="invalid-feedback" ng-show="editForm.classname.$invalid && editForm.classname.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.classname.$invalid && editForm.classname.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="512">This field cannot be longer than 512 characters.</div></div><div class="form-group"><label data-translate="eDocumentsApp.communicationActionDefinition.communicationType" for="field_communicationType">Communication Type</label><select class="form-control mb-2" name="communicationType" ng-class="{\'is-invalid\': editForm.communicationType.$invalid}" ng-model="vm.communicationActionDefinition.communicationType" id="field_communicationType" required><option value="" disabled=""></option><option ng-repeat="communicationType in vm.communicationTypes" value="{{communicationType}}">{{\'eDocumentsApp.CommunicationType.\' + communicationType | translate}}</option></select><div class="invalid-feedback" ng-show="editForm.communicationType.$invalid &&  editForm.communicationType.$error.required" data-translate="entity.validation.required">This field is required.</div></div><hr><label class="control-label" data-translate="eDocumentsApp.communicationActionDefinition.communicationParameterTypes">Communication Parameter Types</label><div class="row"><div class="col"><div class="card"><div class="card-header bg-secondary text-white" data-translate="global.available">Dispon\xEDveis</div><ul class="list-group list-group-flush" dnd-list="vm.communicationParameterTypes"><li dnd-draggable="item" dnd-moved="vm.communicationParameterTypes.splice($index, 1)" dnd-effect-allowed="move" ng-repeat="item in vm.communicationParameterTypes" class="list-group-item">{{\'eDocumentsApp.CommunicationParameterType.\' + item | translate}}</li></ul></div></div><div class="col"><div class="card"><div class="card-header bg-secondary text-white" data-translate="global.selected">Selecionados</div><ul class="list-group" dnd-list="vm.communicationActionDefinition.requiredParameters"><li dnd-draggable="item" dnd-moved="vm.communicationActionDefinition.requiredParameters.splice($index, 1)" dnd-effect-allowed="move" ng-repeat="item in vm.communicationActionDefinition.requiredParameters" class="list-group-item">{{\'eDocumentsApp.CommunicationParameterType.\' + item | translate}}</li></ul></div></div></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/communication-action-definition/communication-action-definitions.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.communicationActionDefinition.home.title">Communication Action Definitions</h2></div><div class="col"><form class="form-inline float-right" ng-submit="vm.search(vm.searchQuery)"><div class="form-group mx-2 mb-2"><input type="text" class="form-control form-control-sm" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'entity.action.search\' | translate}}"></div><button type="submit" class="btn btn-sm btn-info mx-2 mb-2"><i class="fas fa-search"></i></button> <button type="button" class="btn btn-sm btn-dark mx-2 mb-2" ng-if="vm.currentSearch" ng-click="vm.clear()"><i class="fas fa-trash-alt"></i></button></form></div></div></div><div class="alert alert-warning" ng-if="!vm.communicationActionDefinitions || vm.communicationActionDefinitions.length === 0"><span data-translate="entity.no-results">No results</span></div><div class="table-responsive" ng-if="vm.communicationActionDefinitions && vm.communicationActionDefinitions.length > 0"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="name"><span data-translate="eDocumentsApp.communicationActionDefinition.name">Name</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="classname"><span data-translate="eDocumentsApp.communicationActionDefinition.classname">Classname</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="communicationType"><span data-translate="eDocumentsApp.communicationActionDefinition.communicationType">Communication Type</span> <i class="fas sort fa-sort"></i></th><th></th></tr></thead><tbody><tr ng-repeat="communicationActionDefinition in vm.communicationActionDefinitions track by communicationActionDefinition.id"><td>{{communicationActionDefinition.name}}</td><td><i class="fas fa-info-circle text-info" uib-tooltip="{{communicationActionDefinition.classname}}"></i>&nbsp;{{vm.getAbbreviation(communicationActionDefinition.classname)}}</td><td data-translate="{{\'eDocumentsApp.CommunicationType.\' + communicationActionDefinition.communicationType}}">{{communicationActionDefinition.communicationType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="communication-action-definition-detail({id:communicationActionDefinition.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="communication-action-definition.edit({id:communicationActionDefinition.id})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="communication-action-definition.delete({id:communicationActionDefinition.id})" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.communicationActionDefinitions.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></div></div></div>');
$templateCache.put('app/entities/communication-definition/communication-definition-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.communicationDefinition.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.communicationDefinition.delete.question" translate-values="{id: \'{{vm.communicationDefinition.description}}\'}">Are you sure you want to delete this Communication Definition?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/communication-definition/communication-definition-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span data-translate="eDocumentsApp.communicationDefinition.home.createOrEditLabel">Create or edit a Communication Definition</span> <span ng-if="vm.communicationDefinition.description">- {{vm.communicationDefinition.description}}</span></h5><hr></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-row align-items-center"><div class="form-group col-md-6"><label data-translate="eDocumentsApp.communicationDefinition.description" for="field_description">Description</label><input type="text" ng-readonly="vm.readOnly===true" class="form-control form-control-sm mb-2" name="description" id="field_description" ng-model="vm.communicationDefinition.description" required ng-maxlength="255"><div ng-show="editForm.description.$invalid"><div class="invalid-feedback" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.description.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div></div><div class="form-group col-md-2"><div class="form-check mb-2 mr-sm-2"><input class="form-check-input" ng-disabled="vm.readOnly===true" type="checkbox" name="active" id="field_active" ng-model="vm.communicationDefinition.active"><label class="form-check-label" data-translate="eDocumentsApp.communicationDefinition.active" for="field_active">Active</label></div></div><div class="form-group col-md-2"><div class="form-check mb-2 mr-sm-2"><input class="form-check-input" ng-disabled="vm.readOnly===true" type="checkbox" name="defaultForOrigin" id="field_defaultForOrigin" ng-model="vm.communicationDefinition.defaultForOrigin"><label class="form-check-label" data-translate="eDocumentsApp.communicationDefinition.defaultForOrigin" for="field_defaultForOrigin">Default For Origin</label></div></div><div class="form-group col-md-2"><div class="form-check mb-2 mr-sm-2"><input class="form-check-input" ng-disabled="vm.readOnly===true" type="checkbox" name="defaultForDestination" id="field_defaultForDestination" ng-model="vm.communicationDefinition.defaultForDestination"><label class="form-check-label" data-translate="eDocumentsApp.communicationDefinition.defaultForDestination" for="field_defaultForDestination">Default For Destination</label></div></div><div class="form-group col-md-2" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><a class="btn btn-primary mt-3" href="" ui-sref="communication-workflow-step({sid:vm.communicationDefinition.id})"><i class="fas fa-code-branch"></i><span data-translate="eDocumentsApp.communicationDefinition.viewWorkflow">View Workflow</span></a></div></div><div class="form-row align-items-center"><div class="form-group col-md-6">{{$select}}<label data-translate="eDocumentsApp.communicationDefinition.origin" for="field_origin">Origin</label><div class="input-group"><ui-select ng-disabled="vm.readOnly" id="field_origin" class="col-sm ml-0 mr-0 pl-0 pr-0" ng-model="vm.communicationDefinition.originId" allow-clear="true" spinner-enabled="true" fix-selected-item reset-search-input="false"><ui-select-match placeholder="{{\'eDocumentsApp.communicationDefinition.origin\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="communicationEntity.id as communicationEntity in vm.communicationentitiesForOrigin | filter: $select.search" ng-hide="!$select.open" refresh="refreshSelectModelForOrigin($select.search)" refresh-delay="500" minimum-input-length="3"><div ng-bind-html="communicationEntity.name + \' - \' + communicationEntity.gln | highlight: $select.search"></div></ui-select-choices></ui-select><div class="input-group-append ml-0 mr-0 pl-0 pr-0"><button class="btn btn-outline-dark" type="button" ng-if="vm.communicationDefinition.originId && !vm.readOnly" ng-click="vm.communicationDefinition.originId = null"><i class="fas fa-trash-alt"></i></button></div></div></div><div class="form-group col-md-6"><label data-translate="eDocumentsApp.communicationDefinition.destination" for="field_destination">Destination</label><div class="input-group"><ui-select ng-disabled="vm.readOnly" id="field_destination" class="col-sm ml-0 mr-0 pl-0 pr-0" ng-model="vm.communicationDefinition.destinationId" allow-clear="true" fix-selected-item reset-search-input="false"><ui-select-match placeholder="{{\'eDocumentsApp.communicationDefinition.destination\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="communicationEntity.id as communicationEntity in vm.communicationentitiesForDestination | filter: $select.search" ng-hide="!$select.open" refresh="refreshSelectModelForDestination($select.search)" refresh-delay="500" minimum-input-length="3"><div ng-bind-html="communicationEntity.name + \' - \' + communicationEntity.gln | highlight: $select.search"></div></ui-select-choices></ui-select><div class="input-group-append ml-0 mr-0 pl-0 pr-0"><button class="btn btn-outline-dark" type="button" ng-if="vm.communicationDefinition.destinationId && !vm.readOnly" ng-click="vm.communicationDefinition.destinationId = null"><i class="fas fa-trash-alt"></i></button></div></div></div></div><div><button type="button" class="btn btn-success" ng-click="vm.viewEntitiesParameters()" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><i class="fas fa-sitemap"></i>&nbsp;<span data-translate="eDocumentsApp.communicationWorkflowStep.viewPreviouslyDefinedParameters">View Previously Defined Parameters</span></button></div><div ng-if="vm.communicationDefinition.id &&  vm.communicationTypes" class="card mb-3" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><div class="card-header" data-translate="eDocumentsApp.communicationDefinition.originParameters">Origin Parameters</div><div class="card-body"><div class="form-inline" ng-if="vm.readOnly !== true"><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectOriginCommunicationType" ng-change="vm.changeOriginParameter()"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</option><option ng-repeat="(communicationType, values) in vm.communicationTypes" value="{{communicationType}}">{{\'eDocumentsApp.CommunicationType.\' + communicationType | translate}}</option></select><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectOriginCommunicationParameterType"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</option><option ng-repeat="communicationParameterType in vm.communicationParameterTypes" value="{{communicationParameterType}}">{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameterType | translate}}</option></select><a class="btn btn-primary mb-2" href="" ng-click="vm.addOriginParameter()"><i class="far fa-plus-square"></i></a></div><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationDefinition.originParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                    communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\' &&\n                                     communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\'" type="text" class="form-control form-control-sm" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="vm.readOnly === true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeOrigin" ng-model="communicationParameter.disableExecutionTime" ng-disabled="vm.readOnly === true"><label class="form-check-label" for="disableExecutionTimeOrigin" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="vm.readOnly === true" name="value" placeholder="--:--"></div></td><td ng-if="vm.readOnly !== true"><a href="" ng-click="vm.deleteCommunicationOriginParameter(communicationParameter)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div></div></div><div ng-if="vm.communicationDefinition.id &&  vm.communicationTypes" class="card mb-3" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><div class="card-header" data-translate="eDocumentsApp.communicationDefinition.destinationParameters">Destination Parameters</div><div class="card-body"><div class="form-inline" ng-if="vm.readOnly !== true"><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectDestinationCommunicationType" ng-change="vm.changeDestinationParameter()"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</option><option ng-repeat="(communicationType, values) in vm.communicationTypes" value="{{communicationType}}">{{\'eDocumentsApp.CommunicationType.\' + communicationType | translate}}</option></select><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectDestinationCommunicationParameterType"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</option><option ng-repeat="communicationParameterType in vm.communicationParameterTypes" value="{{communicationParameterType}}">{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameterType | translate}}</option></select><a class="btn btn-primary mb-2" href="" ng-click="vm.addDestinationParameter()"><i class="far fa-plus-square"></i></a></div><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationDefinition.destinationParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input type="text" class="form-control form-control-sm" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value" ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                        communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                        communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="vm.readOnly === true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeDestination" ng-model="communicationParameter.disableExecutionTime" ng-disabled="vm.readOnly === true"><label class="form-check-label" for="disableExecutionTimeDestination" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="vm.readOnly === true" name="value" placeholder="--:--"></div></td><td ng-if="vm.readOnly !== true"><a href="" ng-click="vm.deleteCommunicationDestinationParameter(communicationParameter)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div></div></div><div class="col-auto"><button type="button" class="btn btn-default" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="submit" ng-if="vm.readOnly !== true" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/communication-definition/communication-definitions.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.communicationDefinition.home.title">Communication Definitions</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-sm btn-success" ui-sref="communication-definition.new" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><i class="far fa-plus-square"></i> <span class="d-none d-sm-inline-block">{{\'entity.action.add\' | translate}}</span></button> <button class="btn btn-sm ml-2" ng-if="vm.searchVisible != true" ng-click="vm.searchVisible = !vm.searchVisible" ng-class="{\'btn-primary\':  !vm.searchVisible, \'btn-warning\' :vm.searchVisible}"><i class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></i> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.search">Pesquisar</span></span></button> <button class="btn btn-sm btn-dark ml-2" ng-if="vm.searchVisible != true && vm.isSearchActive()" ng-click="vm.reset()"><i class="fas fa-trash-alt"></i> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.clear">Limpar</span></span></button></form></div></div></div><div class="card text-white bg-primary mb-3" ng-if="vm.searchVisible == true"><div class="card-header"><span data-translate="entity.action.search">Pesquisar</span> <button class="btn btn-sm btn-secondary float-right" ng-click="vm.searchVisible = !vm.searchVisible"><i class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></i>&nbsp;<span class="d-none d-sm-inline-block" data-translate="entity.action.hide"></span></button></div><div class="card-body bg-white text-primary"><form><div class="form-row"><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.communicationDefinition.description">Description</label><div class="input-group input-group-sm"><input ng-model="vm.filters.filterBy.description.value" class="form-control form-control-sm"></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.communicationDefinition.active">Active</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.active.value == null || vm.filters.filterBy.active.value == undefined}" ng-click="vm.changeActive(undefined)"><input type="radio" name="options" id="option1" autocomplete="off"> <span data-translate="eDocumentsApp.communicationDefinition.options.active.all">All</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.active.value == \'true\'}" ng-click="vm.changeActive(\'true\')"><input type="radio" name="options" id="option2" autocomplete="off"> <i class="fas fa-check"></i> <span data-translate="eDocumentsApp.communicationDefinition.options.active.true">Active</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.active.value == \'false\'}" ng-click="vm.changeActive(\'false\')"><input type="radio" name="options" id="option3" autocomplete="off"> <i class="fas fa-times"></i> <span data-translate="eDocumentsApp.communicationDefinition.options.active.false">Not active</span></label></div></div><div class="form-group col-sm-3 col-md-2 col-lg-2"><label data-translate="eDocumentsApp.communicationDefinition.defaultForOrigin">Default For Origin</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.defaultForOrigin.value == null || vm.filters.filterBy.defaultForOrigin.value == undefined}" ng-click="vm.changeDefaultForOrigin(undefined)"><input type="radio" name="options" id="option4" autocomplete="off"> <span data-translate="eDocumentsApp.communicationDefinition.options.defaultForOrigin.all">All</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.defaultForOrigin.value == \'true\'}" ng-click="vm.changeDefaultForOrigin(\'true\')"><input type="radio" name="options" id="option5" autocomplete="off"> <i class="fas fa-check"></i> <span data-translate="eDocumentsApp.communicationDefinition.options.defaultForOrigin.true">Default for origin</span></label></div></div><div class="form-group col-sm-3 col-md-2 col-lg-2"><label data-translate="eDocumentsApp.communicationDefinition.defaultForDestination">Default For Destination</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.defaultForDestination.value == null || vm.filters.filterBy.defaultForDestination.value == undefined}" ng-click="vm.changeDefaultForDestination(undefined)"><input type="radio" name="options" id="option6" autocomplete="off"> <span data-translate="eDocumentsApp.communicationDefinition.options.defaultForDestination.all">All</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.defaultForDestination.value == \'true\'}" ng-click="vm.changeDefaultForDestination(\'true\')"><input type="radio" name="options" id="option7" autocomplete="off"> <i class="fas fa-check"></i> <span data-translate="eDocumentsApp.communicationDefinition.options.defaultForDestination.true">Default for Destination</span></label></div></div></div><div class="form-row"><div class="form-group col-sm-6 col-md-2 col-lg-2"><label data-translate="eDocumentsApp.communicationDefinition.originName">Origin Name</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.originName.value"></div><div class="form-group col-sm-6 col-md-2 col-lg-2"><label data-translate="eDocumentsApp.communicationDefinition.originGln">Origin GLN</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.originGln.value"></div><div class="form-group col-sm-6 col-md-2 col-lg-2"><label data-translate="eDocumentsApp.communicationDefinition.destinationName">Destination Name</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.destinationName.value"></div><div class="form-group col-sm-6 col-md-2 col-lg-2"><label data-translate="eDocumentsApp.communicationDefinition.destinationGln">Destination GLN</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.destinationGln.value"></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label>&nbsp;</label><br><div class="btn-group col flex-btn-group-container p-0" role="group"><button class="btn btn-primary btn-sm col-6" ng-click="vm.page = 1; vm.loadAll();"><i class="fas fa-search"></i> <span data-translate="entity.action.search">Pesquisar</span></button> <button class="btn btn-dark btn-sm col-6" ng-if="vm.isSearchActive()" ng-click="vm.reset()"><i class="fas fa-trash-alt"></i> <span data-translate="entity.action.clear">Limpar</span></button></div></div></div></form></div></div><div class="alert alert-warning" ng-if="!vm.communicationDefinitions || vm.communicationDefinitions.length === 0"><span data-translate="entity.no-results">No results</span></div><div class="table-responsive" ng-if="vm.communicationDefinitions && vm.communicationDefinitions.length > 0"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th jh-sort-by="description"><span data-translate="eDocumentsApp.communicationDefinition.description">Description</span> <i class="fas sort fa-sort"></i></th><th class="text-center" jh-sort-by="active"><span data-translate="eDocumentsApp.communicationDefinition.active">Active</span> <i class="fas sort fa-sort"></i></th><th class="text-center" jh-sort-by="defaultForOrigin"><span data-translate="eDocumentsApp.communicationDefinition.defaultForOrigin">Default For Origin</span> <i class="fas sort fa-sort"></i></th><th class="text-center" jh-sort-by="defaultForDestination"><span data-translate="eDocumentsApp.communicationDefinition.defaultForDestination">Default For Destination</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="originId"><span data-translate="eDocumentsApp.communicationDefinition.origin">Origin</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="destinationId"><span data-translate="eDocumentsApp.communicationDefinition.destination">Destination</span> <i class="fas sort fa-sort"></i></th><th></th></tr></thead><tbody><tr ng-repeat="communicationDefinition in vm.communicationDefinitions track by communicationDefinition.id"><td>{{communicationDefinition.description}}</td><td class="text-center"><i class="fas" ng-class="{\'fa-check text-success\': communicationDefinition.active == true, \'fa-times text-danger\': communicationDefinition.active !== true }"></i></td><td class="text-center"><i ng-show="communicationDefinition.defaultForOrigin == true" class="fas fa-check text-success"></i></td><td class="text-center"><i ng-show="communicationDefinition.defaultForDestination == true" class="fas fa-check text-success"></i></td><td><a ng-if="vm.isUserInEntity(communicationDefinition.originId) == true" ui-sref="communication-entity-detail({id:communicationDefinition.originId})">{{communicationDefinition.originName}}</a> <span ng-if="vm.isUserInEntity(communicationDefinition.originId) !== true">{{communicationDefinition.originName}}</span><br><span style="font-size: 12px" class="text-muted">{{communicationDefinition.originGln}}</span></td><td><a ng-if="vm.isUserInEntity(communicationDefinition.destinationId) == true" ui-sref="communication-entity-detail({id:communicationDefinition.destinationId})">{{communicationDefinition.destinationName}}</a> <span ng-if="vm.isUserInEntity(communicationDefinition.destinationId) !== true">{{communicationDefinition.destinationName}}</span><br><span style="font-size: 12px" class="text-muted">{{communicationDefinition.destinationGln}}</span></td><td class="text-right"><div class="btn-group mr-2" role="group" aria-label="{{\'global.a11y.firstGroup\' | translate}}"><a ui-sref="communication-workflow-step({sid:communicationDefinition.id})" class="btn btn-secondary btn-sm"><i class="fas fa-code-branch"></i> <span class="d-none d-sm-inline-block" data-translate="eDocumentsApp.communicationDefinition.viewWorkflow">View Workflow</span></a></div><div class="btn-group mr-2" role="group" aria-label="{{\'global.a11y.secondGroup\' | translate}}"><a ui-sref="communication-definition-detail({id:communicationDefinition.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.view"></span> </a><button has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ng-click="vm.copy(communicationDefinition)" class="btn btn-warning btn-sm"><i class="far fa-copy"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.copy">Copy</span></button> <a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication-definition.edit({id:communicationDefinition.id})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span> </a><a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication-definition.delete({id:communicationDefinition.id})" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.delete"></span></a></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.communicationDefinitions.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-click="vm.loadAll()"></div></div></div>');
$templateCache.put('app/entities/communication-entity/communication-authorities-dialog.html','<div><div class="modal-header"><h4 class="modal-title" id="myCommunicationDefinitionAuthorityLabel"><span data-translate="eDocumentsApp.communicationDefinitionAuthority.home.title">Communication Definition Authority</span> <span style="font-size: 12px" uib-tooltip="{{\'eDocumentsApp.communicationDefinitionAuthority.info.main\' | translate }}" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></h4><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><!-- Generic definitions --><h5><span data-translate="eDocumentsApp.communicationDefinitionAuthority.generic">Communication Definition Authority</span> <span style="font-size: 12px" uib-tooltip="{{vm.communicationDefinitionAuthorities && vm.communicationDefinitionAuthorities.length > 0 ?\n                  \'eDocumentsApp.communicationDefinitionAuthority.info.genericWithSelectedCommunicationDefinitions\' :\n                  \'eDocumentsApp.communicationDefinitionAuthority.info.genericWithoutSelectedCommunicationDefinitions\' | translate }}" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></h5><div class="form-row align-items-center" ng-disabled="vm.communicationDefinitionAuthorities && vm.communicationDefinitionAuthorities.length > 0"><div class="form-group col-md"><label data-translate="eDocumentsApp.communicationDefinitionAuthority.sender">Emissor</label><div class="col-sm form-inline"><div class="col-sm input-group"><button ng-if="vm.readOnly !== true" class="btn btn-sm btn-primary" type="button" ng-click="vm.toggleEmitter(vm.user.emitter)" ng-disabled="vm.communicationDefinitionAuthorities && vm.communicationDefinitionAuthorities.length > 0"><span ng-if="vm.user.emitter"><i class="fa fa-check"></i> </span><span ng-if="!vm.user.emitter"><i class="fa fa-times-circle"></i></span></button> <span ng-if="vm.readOnly === true"><span ng-if="vm.user.emitter"><i class="fa fa-check text-success"></i> </span><span ng-if="!vm.user.emitter"><i class="fa fa-times-circle text-danger"></i></span></span></div></div></div><div class="form-group col-md"><label data-translate="eDocumentsApp.communicationDefinitionAuthority.receiver">Recetor</label><div class="col-sm form-inline"><div class="col-sm input-group"><button ng-if="vm.readOnly !== true" class="btn btn-sm btn-primary" type="button" ng-click="vm.toggleReceptor(vm.user.receptor)" ng-disabled="vm.communicationDefinitionAuthorities && vm.communicationDefinitionAuthorities.length > 0"><span ng-if="vm.user.receptor"><i class="fa fa-check"></i> </span><span ng-if="!vm.user.receptor"><i class="fa fa-times-circle"></i></span></button> <span ng-if="vm.readOnly === true"><span ng-if="vm.user.receptor"><i class="fa fa-check text-success"></i> </span><span ng-if="!vm.user.receptor"><i class="fa fa-times-circle text-danger"></i></span></span></div></div></div></div><hr ng-if="!vm.communicationDefinitionAuthorities || vm.communicationDefinitionAuthorities.length <= 0"><div><div ng-if="!vm.communicationDefinitionAuthorities || vm.communicationDefinitionAuthorities.length <= 0"><div class="alert alert-warning"><span data-translate="eDocumentsApp.communicationDefinitionAuthority.notFound"></span> <span style="font-size: 12px" uib-tooltip="{{\'eDocumentsApp.communicationDefinitionAuthority.info.noCommunicationDefinitions\' | translate }}" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></div></div><div ng-if="vm.communicationDefinitionAuthorities && vm.communicationDefinitionAuthorities.length > 0" class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="eDocumentsApp.communicationDefinitionAuthority.communicationDefinition">Communication Definition</span> <span style="font-size: 12px" uib-tooltip="{{\'eDocumentsApp.communicationDefinitionAuthority.info.restrictToCommunicationDefinition\' | translate }}" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="communicationDefinitionAuthority in vm.communicationDefinitionAuthorities track by communicationDefinitionAuthority.id"><td><a ui-sref="communication-definition-detail({id:communicationDefinitionAuthority.communicationDefinitionId})">{{communicationDefinitionAuthority.communicationDefinitionDescription}}</a></td><td ng-if="vm.readOnly !== true" class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.deleteCommunicationDefinitionAuthority(communicationDefinitionAuthority.id)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation ng-if="vm.readOnly !== true"><div class="form-row align-items-center"><div class="form-group col-md-12"><label><span data-translate="eDocumentsApp.communicationDefinitionAuthority.communicationDefinition" for="field_communicationDefinition">Communication Definition</span> <span style="font-size: 12px" uib-tooltip="{{vm.communicationDefinitionAuthorities && vm.communicationDefinitionAuthorities.length > 0 ?\n                              \'eDocumentsApp.communicationDefinitionAuthority.info.addCommunicationDefinition\' :\n                              \'eDocumentsApp.communicationDefinitionAuthority.info.addFirstCommunicationDefinition\' | translate }}" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></label><div class="col-sm form-inline"><div class="col-sm input-group"><ui-select id="field_communicationDefinition" name="communicationDefinition" class="col-sm ml-0 mr-0 pl-0 pr-0" ng-model="vm.communicationDefinitionAuthority.communicationDefinitionId" allow-clear="true" spinner-enabled="true" append-to-body="false" fix-selected-item reset-search-input="false"><ui-select-match placeholder="{{\'eDocumentsApp.communicationDefinitionAuthority.communicationDefinition\' | translate}}">{{$select.selected.description}}</ui-select-match><ui-select-choices repeat="communicationDefinition.id as communicationDefinition in vm.communicationdefinitions" refresh="refreshSelectModel($select.search)" refresh-delay="500" minimum-input-length="2"><div ng-bind-html="communicationDefinition.description | highlight: $select.search"></div></ui-select-choices></ui-select><button ng-if="vm.readOnly !== true" type="button" class="col-sm-2 btn btn-primary mb-2" ng-click="vm.save()" ng-disabled="!vm.communicationDefinitionAuthority.communicationDefinitionId || vm.isSaving"><i class="far fa-plus-square"></i>&nbsp; <span data-translate="entity.action.add">Add</span></button></div></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">Close</span></button></div></div>');
$templateCache.put('app/entities/communication-entity/communication-entities.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.communicationEntity.home.title">Communication Entities</h2></div><div class="col"><form class="form-inline float-right"><button type="button" class="btn btn-sm btn-success" ui-sref="communication-entity.new" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><i class="far fa-plus-square"></i> <span class="d-none d-sm-inline-block">{{\'entity.action.add\' | translate}}</span></button> <button class="btn btn-sm ml-2" ng-if="vm.searchVisible != true" ng-click="vm.searchVisible = !vm.searchVisible" ng-class="{\'btn-primary\':  !vm.searchVisible, \'btn-warning\' :vm.searchVisible}"><i class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></i> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.search">Pesquisar</span></span></button> <button class="btn btn-sm btn-dark ml-2" ng-if="vm.searchVisible != true && vm.isSearchActive()" ng-click="vm.reset()"><i class="fas fa-trash-alt"></i> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.clear">Limpar</span></span></button></form></div></div></div><div class="card text-white bg-primary mb-3" ng-if="vm.searchVisible == true"><div class="card-header"><span data-translate="entity.action.search">Pesquisar</span> <button class="btn btn-sm btn-secondary float-right" ng-click="vm.searchVisible = !vm.searchVisible"><i class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></i>&nbsp;<span class="d-none d-sm-inline-block" data-translate="entity.action.hide"></span></button></div><div class="card-body bg-white text-primary"><form><div class="form-row"><div class="form-group col-sm-6 col-md-8 col-lg-8"><label data-translate="eDocumentsApp.communicationEntity.name">Name</label><div class="input-group input-group-sm"><input ng-model="vm.filters.filterBy.name.value" class="form-control form-control-sm"></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.communicationEntity.active">Active</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.active.value == null || vm.filters.filterBy.active.value == undefined}" ng-click="vm.changeActive(undefined)"><input type="radio" name="options" id="option1" autocomplete="off"> <span data-translate="eDocumentsApp.communicationEntity.options.active.all">All</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.active.value == \'true\'}" ng-click="vm.changeActive(\'true\')"><input type="radio" name="options" id="option2" autocomplete="off"> <i class="fas fa-check"></i> <span data-translate="eDocumentsApp.communicationEntity.options.active.true">Active</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.active.value == \'false\'}" ng-click="vm.changeActive(\'false\')"><input type="radio" name="options" id="option3" autocomplete="off"> <i class="fas fa-times"></i> <span data-translate="eDocumentsApp.communicationEntity.options.active.false">Not active</span></label></div></div></div><div class="form-row"><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.communicationEntity.vatRegistrationNumber">Vat Registration Number</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.vatRegistrationNumber.value"></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.communicationEntity.gln">GLN</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.gln.value"></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label>&nbsp;</label><br><div class="btn-group col" role="group"><button class="btn btn-primary btn-sm col-6" ng-click="vm.page = 1; vm.loadAll();"><i class="fas fa-search"></i> <span data-translate="entity.action.search">Pesquisar</span></button> <button class="btn btn-dark btn-sm col-6" ng-if="vm.isSearchActive()" ng-click="vm.reset()"><i class="fas fa-trash-alt"></i> <span data-translate="entity.action.clear">Limpar</span></button></div></div></div></form></div></div><div class="alert alert-warning" ng-if="!vm.communicationEntities || vm.communicationEntities.length === 0"><span data-translate="entity.no-results">No results</span></div><div class="table-responsive" ng-if="vm.communicationEntities && vm.communicationEntities.length > 0"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th jh-sort-by="name"><span data-translate="eDocumentsApp.communicationEntity.name">Name</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="active" class="text-center"><span data-translate="eDocumentsApp.communicationEntity.active">Active</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="vatRegistrationNumber"><span data-translate="eDocumentsApp.communicationEntity.vatRegistrationNumber">VAT Registration Number</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="gln"><span data-translate="eDocumentsApp.communicationEntity.gln">Gln</span> <i class="fas sort fa-sort"></i></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="communicationEntity in vm.communicationEntities track by communicationEntity.id"><td>{{communicationEntity.name}}</td><td class="text-center"><i class="fas fa-check text-success" ng-if="communicationEntity.active == true"></i></td><td>{{communicationEntity.vatRegistrationNumber}}</td><td>{{communicationEntity.gln}}</td><td class="text-right"><div class="btn-group flex-btn-group-container" ng-if="communicationEntity.entityConnector !== \'NO_CONNECTOR\'"><a ui-sref="external-entity({ceid:communicationEntity.id})" ng-if="communicationEntity.manager == true" class="btn btn-warning btn-sm"><i class="fas fa-id-card"></i> <span class="d-none d-sm-inline-block" data-translate="global.menu.entities.externalEntity"></span></a></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="communication-entity-detail({id:communicationEntity.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.view"></span> </a><a ui-sref="communication-entity.edit({id:communicationEntity.id})" ng-if="communicationEntity.manager == true" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span> </a><a ui-sref="communication-entity.delete({id:communicationEntity.id})" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.delete"></span></a></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.communicationEntities.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-click="vm.loadAll()"></div></div></div>');
$templateCache.put('app/entities/communication-entity/communication-entity-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.communicationEntity.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.communicationEntity.delete.question" translate-values="{id: \'{{vm.communicationEntity.name}}\'}">Are you sure you want to delete this Communication Entity?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/communication-entity/communication-entity-dialog.html','<jhi-alert-error></jhi-alert-error><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span ng-if="!vm.communicationEntity.name" data-translate="eDocumentsApp.communicationEntity.home.createOrEditLabel">Create or edit a CommunicationEntity</span> <span ng-if="vm.communicationEntity.name">{{vm.communicationEntity.name}}</span></h5><hr></div><div class="container-fluid"><div class="form-row align-items-center"><div class="form-group col-md-4"><label data-translate="eDocumentsApp.communicationEntity.name" for="field_name">Name</label><input type="text" class="form-control form-control-sm mb-2" id="field_name" ng-readonly="vm.readOnly === true" name="name" placeholder="{{\'eDocumentsApp.communicationEntity.name\'|translate}}" ng-model="vm.communicationEntity.name" ng-class="{\'is-invalid\': editForm.name.$invalid}" required ng-maxlength="255"><div class="invalid-feedback" ng-show="editForm.name.$invalid && editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.name.$invalid && editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div><div class="form-group col-md-1 pt-lg-4"><div class="form-check"><input type="checkbox" name="active" ng-disabled="vm.readOnly === true" id="field_active" ng-model="vm.communicationEntity.active"><label class="form-check-label" data-translate="eDocumentsApp.communicationEntity.active" for="field_active">Active</label></div></div><div class="form-group col-md-3"><label data-translate="eDocumentsApp.communicationEntity.gln" for="field_gln">gln</label><input type="text" class="form-control form-control-sm mb-2" id="field_gln" ng-readonly="vm.readOnly === true || vm.communicationEntity.id " name="gln" placeholder="{{\'eDocumentsApp.communicationEntity.gln\'|translate}}" ng-model="vm.communicationEntity.gln" ng-class="{\'is-invalid\': editForm.gln.$invalid}" required ng-maxlength="20"><div class="invalid-feedback" ng-show="editForm.gln.$invalid && editForm.gln.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</div><div class="invalid-feedback" ng-show="editForm.gln.$invalid && editForm.gln.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.gln.$invalid && editForm.gln.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</div></div><div class="form-group col-md-2"><label data-translate="eDocumentsApp.communicationEntity.vatRegistrationNumber" for="field_vatRegistrationNumber">vatRegistrationNumber</label><input type="text" class="form-control form-control-sm mb-2" id="field_vatRegistrationNumber" ng-readonly="vm.readOnly === true || !vm.isUserAllowedToEditVATRegistrationNumber()" name="vatRegistrationNumber" placeholder="{{\'eDocumentsApp.communicationEntity.vatRegistrationNumber\'|translate}}" ng-model="vm.communicationEntity.vatRegistrationNumber" ng-class="{\'is-invalid\': editForm.vatRegistrationNumber.$invalid}" ng-maxlength="20"><div class="invalid-feedback" ng-show="editForm.vatRegistrationNumber.$invalid && editForm.vatRegistrationNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</div></div><div class="form-group col-md-2" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><label data-translate="eDocumentsApp.communicationEntity.entityConnector">Connector</label><span ng-if="vm.communicationEntityConnectorType != \'NO_CONNECTOR\'" uib-tooltip="{{\'eDocumentsApp.communicationEntity.entityConnectorHelp.\' + vm.communicationEntityConnectorType | translate}}"><i class="fas fa-exclamation-circle fa-fw"></i></span><select class="form-control form-control-sm mb-2" name="entityConnector" ng-model="vm.communicationEntity.entityConnector" id="field_entityConnector" ng-if="vm.readOnly !== true" ng-change="vm.changeExternalConnector()"><option value="NO_CONNECTOR" data-translate="eDocumentsApp.communicationEntity.options.entityConnector.NO_CONNECTOR"></option><option value="MOLONI" data-translate="eDocumentsApp.communicationEntity.options.entityConnector.MOLONI">Moloni</option><option value="PRIMAVERA_V10" data-translate="eDocumentsApp.communicationEntity.options.entityConnector.PRIMAVERAV10">Primavera V10</option></select><input type="text" class="form-control form-control-sm mb-2" id="entityConnectorDisplay" ng-readonly="vm.readOnly === true" ng-if="vm.readOnly === true" name="entityConnectorDisplay" ng-class="{\'is-invalid\': editForm.bcc.$invalid}" ng-model="vm.communicationEntity.entityConnector" ng-maxlength="255"></div></div><div class="form-row align-items-center"></div><div class="form-row align-items-center"><div class="form-group col-md-2" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><label data-translate="eDocumentsApp.communicationEntity.company" for="field_company">company</label><input type="text" class="form-control form-control-sm mb-2" id="field_company" ng-readonly="vm.readOnly === true" name="company" ng-maxlength="2" placeholder="{{\'eDocumentsApp.communicationEntity.company\'|translate}}" ng-class="{\'is-invalid\': editForm.company.$invalid}" ng-model="vm.communicationEntity.company"><div class="invalid-feedback" ng-show="editForm.company.$invalid && editForm.company.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</div></div><div class="form-group col-md-2" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><label data-translate="eDocumentsApp.communicationEntity.society" for="field_society">society</label><input type="text" class="form-control form-control-sm mb-2" id="field_society" ng-readonly="vm.readOnly === true" name="society" ng-maxlength="2" placeholder="{{\'eDocumentsApp.communicationEntity.society\'|translate}}" ng-class="{\'is-invalid\': editForm.society.$invalid}" ng-model="vm.communicationEntity.society"><div class="invalid-feedback" ng-show="editForm.society.$invalid && editForm.society.$error.maxlength" data-translate="entity.validation.society" translate-value-max="15">This field cannot be longer than 15 characters.</div></div><div class="form-group col-md-4"><label data-translate="eDocumentsApp.communicationEntity.imageUrl" for="field_imageUrl">imageUrl</label><input type="text" class="form-control form-control-sm mb-2" id="field_imageUrl" ng-readonly="vm.readOnly === true" name="imageUrl" placeholder="{{\'eDocumentsApp.communicationEntity.imageUrl\'|translate}}" ng-class="{\'is-invalid\': editForm.imageUrl.$invalid}" ng-model="vm.communicationEntity.imageUrl" ng-maxlength="1000"><div class="invalid-feedback" ng-show="editForm.imageUrl.$invalid && editForm.imageUrl.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 255 characters</div></div><div class="form-group col-md-2"><label data-translate="eDocumentsApp.communicationEntity.mainColor" for="field_mainColor">mainColor</label><input type="text" class="form-control form-control-sm mb-2" id="field_mainColor" ng-readonly="vm.readOnly === true" name="mainColor" placeholder="{{\'eDocumentsApp.communicationEntity.mainColor\'|translate}}" ng-class="{\'is-invalid\': editForm.mainColor.$invalid}" ng-model="vm.communicationEntity.mainColor" ng-maxlength="6"><div class="invalid-feedback" ng-show="editForm.mainColor.$invalid && editForm.mainColor.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 255 characters</div></div><div class="form-group col-md-2"><label data-translate="eDocumentsApp.communicationEntity.secondaryColor" for="field_secondaryColor">secondaryColor</label><input type="text" class="form-control form-control-sm mb-2" id="field_secondaryColor" ng-readonly="vm.readOnly === true" name="secondaryColor" placeholder="{{\'eDocumentsApp.communicationEntity.secondaryColor\'|translate}}" ng-class="{\'is-invalid\': editForm.secondaryColor.$invalid}" ng-model="vm.communicationEntity.secondaryColor" ng-maxlength="6"><div class="invalid-feedback" ng-show="editForm.secondaryColor.$invalid && editForm.secondaryColor.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="6">This field cannot be longer than 255 characters</div></div></div><!-- USER MANAGEMENT --><div ng-if="vm.communicationEntity.id" class="card mb-3"><div class="card-header" data-translate="userManagement.home.title">Utilizadores</div><div class="card-body"><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th>{{\'userManagement.name\' | translate}}</th><th>{{\'userManagement.email\' | translate}}</th><th class="text-center">{{\'userManagement.activated\' | translate}}</th><th class="text-center">{{\'userManagement.manager\' | translate}}</th><th class="text-center">{{\'userManagement.emailReceiver\' | translate}}</th><th class="text-center">{{\'userManagement.permissions.header\' | translate}}</th><th>{{\'userManagement.lastModifiedDate\' | translate}}</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="user in vm.users"><td>{{user.firstName}} {{user.lastName}}</td><td>{{user.email}}</td><td class="text-center"><i class="fas fa-check text-success" ng-if="user.activated"></i></td><td class="text-center"><button ng-if="vm.readOnly !== true" class="btn btn-sm btn-primary" type="button" ng-click="vm.toggleManager(user)"><i class="fa fa-check" ng-if="user.manager === true"></i> <i class="fa fa-times-circle" ng-if="user.manager !== true"></i></button> <span ng-if="vm.readOnly === true"><i class="fas fa-check text-success" ng-if="user.manager === true"></i> <i class="fas fa-times text-danger" ng-if="user.manager !== true"></i></span></td><td class="text-center"><button ng-if="vm.readOnly !== true" class="btn btn-sm btn-primary" type="button" ng-click="vm.toggleEmailReceiver(user)"><i class="fa fa-check" ng-if="user.emailReceiver === true"></i> <i class="fa fa-times-circle" ng-if="user.emailReceiver !== true"></i></button> <span ng-if="vm.readOnly === true"><i class="fas fa-check text-success" ng-if="user.emailReceiver === true"></i> <i class="fas fa-times text-danger" ng-if="user.emailReceiver !== true"></i></span></td><td class="text-center"><span ng-if="user.hasRestrictions" class="badge badge-warning col-5"><i class="fas fa-lock"></i>&nbsp; <span>{{\'userManagement.permissions.hasRestrictions\' | translate }}</span> </span><span ng-if="!user.hasRestrictions" class="badge col-5"><i class="fas fa-lock-open"></i>&nbsp; <span>{{\'userManagement.permissions.withoutRestrictions\' | translate }}</span> </span><a ng-click="vm.communicationDefinitionAuthority(user)" class="btn btn-sm btn-light col-2" uib-tooltip="{{ vm.readOnly ? \'entity.action.view\' : \'entity.action.edit\' | translate }}"><i ng-if="!vm.readOnly" class="fas fa-edit"></i> <i ng-if="vm.readOnly" class="fas fa-eye"></i></a></td><td>{{user.lastModifiedDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td ng-if="vm.readOnly !== true"><a uib-tooltip="{{\'userManagement.action.editUser\' | translate }}" ng-click="vm.editUser(user)" class="btn btn-sm btn-primary text-white"><i class="fas fa-user-edit"></i></a> <a uib-tooltip="{{\'userManagement.action.removeUserFromEntity.action\' | translate }}" ng-click="vm.removeUserFromEntity(user)" class="btn btn-sm btn-danger text-white"><i class="fas fa-user-times"></i></a></td></tr></tbody></table><hr><button type="button" ng-if="vm.readOnly !== true" ng-click="vm.findUser()" uib-tooltip="{{\'userManagement.action.addToEntity\' | translate }}" class="btn btn-sm btn-secondary"><i class="fas fa-user-check"></i> <span data-translate="userManagement.action.addToEntity">addToEntity</span></button></div></div></div><!-- AMA-SAFE CREDENTIALS --><div ng-if="vm.communicationEntity.id" class="card mb-3"><div class="card-header"><i class="icon-autenticacaogovpt"></i> <span data-translate="eDocumentsApp.amaSafeCredential.home.title">Credenciais AMA-SAFE</span></div><div class="card-body"><div class="alert alert-warning" ng-if="!vm.amaSafeCredentials || vm.amaSafeCredentials.length === 0"><span data-translate="entity.no-results">No results</span></div><div ng-if="vm.amaSafeCredentials && vm.amaSafeCredentials.length > 0" class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th data-translate="eDocumentsApp.amaSafeCredential.status">Status</th><th data-translate="eDocumentsApp.amaSafeCredential.credentialId">Credential Id</th><th data-translate="eDocumentsApp.amaSafeCredential.expirationDate">Expiration Date</th><th data-translate="eDocumentsApp.amaSafeCredential.createdDate">Created Date</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="amaSafeCredential in vm.amaSafeCredentials"><td><span ng-if="amaSafeCredential.status === \'ACTIVE\'" class="badge badge-success">{{\'eDocumentsApp.AmaSafeCredentialStatus.\' + amaSafeCredential.status | translate}}</span> <span ng-if="amaSafeCredential.status === \'EXPIRED\'" class="badge badge-light">{{\'eDocumentsApp.AmaSafeCredentialStatus.\' + amaSafeCredential.status | translate}}</span></td><td>{{amaSafeCredential.credentialId}}</td><td>{{amaSafeCredential.expirationDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{amaSafeCredential.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td ng-if="vm.readOnly !== true"><a uib-tooltip="Remover credencial" ng-click="vm.deleteCredential(amaSafeCredential)" class="btn btn-sm btn-danger text-white"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div><hr ng-if="vm.readOnly !== true"><button type="button" ng-if="vm.readOnly !== true" ng-click="vm.addCredential()" class="btn btn-sm btn-secondary"><i class="fas fa-plus-square"></i> <span data-translate="eDocumentsApp.amaSafeCredential.action.add">Adicionar credencial</span></button><div class="alert alert-warning mt-2" ng-if="vm.showMissingVatRegistrationNumber"><span data-translate="eDocumentsApp.amaSafeCredential.message.info.missingVatRegistrationNumber">Missing Vat Registration Number</span> <button type="button" ng-if="vm.readOnly !== true" ng-click="vm.contactUs()" class="btn btn-sm btn-info"><i class="fas fa-comment"></i> <span data-translate="eDocumentsApp.amaSafeCredential.message.info.contactAdmin">Contact Admin</span></button></div></div></div><!-- API KEYS --><div ng-if="vm.communicationEntity.id && vm.isUserAllowedToEditExternalAuthKeys()" class="card mb-3" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER, ROLE_DIGITAL_ARCHIVE"><div class="card-header"><i class="icon-autenticacaogovpt"></i> <span data-translate="eDocumentsApp.externalAuthKey.home.title">API Keys</span></div><div class="card-body"><p class="small text-muted" ng-if="vm.seesOwnExternalAuthKeysOnly()" data-translate="eDocumentsApp.externalAuthKey.ownKeysOnly">Only the API keys you created are shown. The entity\'s manager sees and manages all of them.</p><div class="alert alert-warning" ng-if="!vm.externalAuthKeys || vm.externalAuthKeys.length === 0"><span data-translate="entity.no-results">No results</span></div><div ng-if="vm.externalAuthKeys && vm.externalAuthKeys.length > 0" class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th data-translate="eDocumentsApp.externalAuthKey.status">Status</th><th data-translate="eDocumentsApp.externalAuthKey.processId">Process Id</th><th data-translate="eDocumentsApp.externalAuthKey.createdBy">CreatedBy</th><th data-translate="eDocumentsApp.externalAuthKey.createdDate">CreatedDate</th><th ng-if="vm.isUserAllowedToEditExternalAuthKeys()"></th></tr></thead><tbody><tr ng-repeat="externalAuthKey in vm.externalAuthKeys"><td><span ng-if="externalAuthKey.status === \'ACTIVE\'" class="badge badge-success">{{\'eDocumentsApp.ExternalAuthKeyStatus.\' + externalAuthKey.status | translate}}</span> <span ng-if="externalAuthKey.status === \'REVOKED\'" class="badge badge-light">{{\'eDocumentsApp.ExternalAuthKeyStatus.\' + externalAuthKey.status | translate}}</span></td><td>{{externalAuthKey.processId}}</td><td>{{externalAuthKey.createdBy}}<!-- SUP-12293: the key keeps working, but whoever made it could not make it today --> <span ng-if="externalAuthKey.creatorHasAccess === false" class="badge badge-warning ml-1" data-translate="eDocumentsApp.externalAuthKey.creatorNoAccess" uib-tooltip="{{\'eDocumentsApp.externalAuthKey.creatorNoAccessHint\' | translate}}" tooltip-append-to-body="true">Creator without access</span></td><td>{{externalAuthKey.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td ng-if="vm.isUserAllowedToEditExternalAuthKeys()"><a ng-if="externalAuthKey.status === \'ACTIVE\'" uib-tooltip="Revogar API key" ng-click="vm.revokeExternalAuthKey(externalAuthKey)" class="btn btn-sm btn-danger text-white"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div><!-- SUP-12293: keys are not entity data \u2014 who may use them does so from the read-only view too --><hr ng-if="vm.isUserAllowedToEditExternalAuthKeys()"><button type="button" ng-if="vm.isUserAllowedToEditExternalAuthKeys()" ng-click="vm.addExternalAuthKey()" class="btn btn-sm btn-secondary"><i class="fas fa-plus-square"></i> <span data-translate="eDocumentsApp.externalAuthKey.action.add">Add API key</span></button></div></div><!-- EXTERNAL CONNECTOR --><div ng-if="vm.communicationEntity.id && vm.communicationEntityConnectorType != \'NO_CONNECTOR\'" class="card mb-3"><div class="card-header" data-translate="eDocumentsApp.communicationEntity.entityConnectorParameters">Parametros de conectores externos</div><div class="card-body"><div class="form-inline" ng-if="vm.readOnly !== true"><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectCommunicationEntityConnectorParametersNames"><option value="" disabled="" data-translate="global.parameter">Par\xE2metro</option><option ng-repeat="parameters in vm.communicationEntityConnectorParametersNames" value="{{parameters}}">{{\'eDocumentsApp.CommunicationEntityConnectorParametersNames.\' + parameters | translate}}</option></select><a class="btn btn-primary mb-2" href="" ng-click="vm.addcommunicationEntityConnectorParameter()"><i class="far fa-plus-square"></i></a></div><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="global.parameter">Par\xE2metro</th><th data-translate="global.value">Valor</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="communicationEntityConnectorParameters in vm.communicationEntity.communicationEntityConnectorParameters"><td>{{\'eDocumentsApp.CommunicationEntityConnectorParametersNames.\' + communicationEntityConnectorParameters.parameterName | translate}}</td><td><input ng-if="communicationEntityConnectorParameters.parameterName !== \'PASSWORD\' && communicationEntityConnectorParameters.parameterName !== \'SECRET\'" type="text" class="form-control form-control-sm" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationEntityConnectorParameters.parameterValue"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog.\n                     Keep this list in step with CommunicationEntityConnectorParametersNames.isSecret(). --><ed-secret-field ng-if="communicationEntityConnectorParameters.parameterName === \'PASSWORD\' || communicationEntityConnectorParameters.parameterName === \'SECRET\'" model="communicationEntityConnectorParameters.parameterValue" secret-id="communicationEntityConnectorParameters.id" source="CONNECTOR_PARAMETER" stored="communicationEntityConnectorParameters.secretStored" read-only="vm.readOnly === true"></ed-secret-field></td><td ng-if="vm.readOnly !== true"><a href="" ng-click="vm.deleteCommunicationEntityConnectorParameter(communicationEntityConnectorParameters)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div></div></div><!-- ORIGIN PARAMETERS --><div ng-if="vm.communicationEntity.id" class="card mb-3"><div class="card-header" data-translate="eDocumentsApp.communicationEntity.originParameters">Origin Parameters</div><div class="card-body"><div class="form-inline" ng-if="vm.readOnly !== true"><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectOriginCommunicationType" ng-change="vm.changeOriginParameter()"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</option><option ng-repeat="(communicationType, values) in vm.communicationTypes" value="{{communicationType}}">{{\'eDocumentsApp.CommunicationType.\' + communicationType | translate}}</option></select><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectOriginCommunicationParameterType"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</option><option ng-repeat="communicationParameterType in vm.communicationParameterTypes" value="{{communicationParameterType}}">{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameterType | translate}}</option></select><a class="btn btn-primary mb-2" href="" ng-click="vm.addOriginParameter()"><i class="far fa-plus-square"></i></a></div><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationEntity.originParameters | orderBy: [\'communicationType\', \'communicationParameterType\']"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                 communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                 communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'" type="text" class="form-control form-control-sm" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="vm.readOnly === true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeOrigin" ng-model="communicationParameter.disableExecutionTime" ng-disabled="vm.readOnly === true"><label class="form-check-label" for="disableExecutionTimeOrigin" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="vm.readOnly === true" name="value" placeholder="--:--"></div></td><td ng-if="vm.readOnly !== true"><a href="" ng-click="vm.deleteCommunicationOriginParameter(communicationParameter)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div></div></div><!-- DESTINATION PARAMETERS --><div ng-if="vm.communicationEntity.id &&  vm.communicationTypes" class="card mb-3"><div class="card-header" data-translate="eDocumentsApp.communicationEntity.destinationParameters">Destination Parameters</div><div class="card-body"><div class="form-inline" ng-if="vm.readOnly !== true"><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectDestinationCommunicationType" ng-change="vm.changeDestinationParameter()"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</option><option ng-repeat="(communicationType, values) in vm.communicationTypes" value="{{communicationType}}">{{\'eDocumentsApp.CommunicationType.\' + communicationType | translate}}</option></select><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectDestinationCommunicationParameterType"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</option><option ng-repeat="communicationParameterType in vm.communicationParameterTypes" value="{{communicationParameterType}}">{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameterType | translate}}</option></select><a class="btn btn-primary mb-2" href="" ng-click="vm.addDestinationParameter()"><i class="far fa-plus-square"></i></a></div><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationEntity.destinationParameters | orderBy: [\'communicationType\', \'communicationParameterType\']"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input type="text" class="form-control form-control-sm" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value" ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                        communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                        communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="vm.readOnly === true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeDestination" ng-model="communicationParameter.disableExecutionTime" ng-disabled="vm.readOnly === true"><label class="form-check-label" for="disableExecutionTimeDestination" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="vm.readOnly === true" name="value" placeholder="--:--"></div></td><td ng-if="vm.readOnly !== true"><a href="" ng-click="vm.deleteCommunicationDestinationParameter(communicationParameter)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div></div></div><div class="col-auto"><button type="button" class="btn btn-default" ng-click="vm.goBack()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="submit" ng-if="vm.readOnly !== true" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i> &nbsp; <span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/communication-entity/communication-entity-user-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.action.removeUserFromEntity.message" translate-values="{userEmail: \'{{vm.user.email}}\', communicationEntityName: \'{{vm.communicationEntity.name}}\'}">Are you sure you want to delete the user\'s connection to email for entity?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/communication-entity/communication-entity-user.modal.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h5 class="modal-title" ng-if="!vm.user.id" data-translate="userManagement.action.createUser">Criar Utilizador</h5><h5 class="modal-title" ng-if="vm.user.id" data-translate="userManagement.action.editUser">Editar Utilizador</h5><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-row align-items-center"><div class="form-group col-md-12"><label data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control form-control-sm" name="firstName" ng-class="{\'is-invalid\': editForm.firstName.$invalid}" ng-model="vm.user.firstName" required ng-maxlength="50"><div class="invalid-feedback" ng-show="editForm.firstName.$invalid && editForm.firstName.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.firstName.$invalid && editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</div></div></div><div class="form-row align-items-center"><div class="form-group col-md-12"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control form-control-sm" name="lastName" ng-class="{\'is-invalid\': editForm.lastName.$invalid}" ng-model="vm.user.lastName" required ng-maxlength="50"><div class="invalid-feedback" ng-show="editForm.lastName.$invalid && editForm.lastName.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.lastName.$invalid &&  editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</div></div></div><div class="form-row align-items-center"><div class="form-group col-md-12"><label data-translate="userManagement.email">Email</label><input type="email" class="form-control form-control-sm" name="email" ng-class="{\'is-invalid\': editForm.email.$invalid}" ng-model="vm.user.email" required ng-maxlength="100" ng-readonly="vm.user.id"><div class="invalid-feedback" ng-show="editForm.email.$invalid && editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.email.$invalid && editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</div><div class="invalid-feedback" ng-show="editForm.email.$invalid && editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</div></div></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/communication-entity/user-question.html','<div class="form-group"><input autofocus ng-change="textChange()" type="email" ng-model="email" id="input-name" placeholder="{{\'userManagement.creationDialog.emailInputPlaceholder\' | translate}}" class="form-control form-control-sm"></div>');
$templateCache.put('app/entities/communication-parameter/communication-parameter-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.communicationParameter.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.communicationParameter.delete.question" translate-values="{id: \'{{vm.communicationParameter.id}}\'}">Are you sure you want to delete this Communication Parameter?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/communication-parameter/communication-parameter-detail.html','<div class="container-fluid mt-3 mb-3"><h2><span data-translate="eDocumentsApp.communicationParameter.detail.title">Communication Parameter</span> {{vm.communicationParameter.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="jh-entity-details"><dt><span data-translate="eDocumentsApp.communicationParameter.communicationType">Communication Type</span></dt><dd><span data-translate="{{\'eDocumentsApp.CommunicationType.\' + vm.communicationParameter.communicationType}}">{{vm.communicationParameter.communicationType}}</span></dd><dt><span data-translate="eDocumentsApp.communicationParameter.communicationParameterType">Communication Parameter Type</span></dt><dd><span data-translate="{{\'eDocumentsApp.CommunicationParameterType.\' + vm.communicationParameter.communicationParameterType}}">{{vm.communicationParameter.communicationParameterType}}</span></dd><dt><span data-translate="eDocumentsApp.communicationParameter.value">Value</span></dt><dd><span ng-if=" vm.communicationParameter.communicationParameterType !== \'PASSWORD\' &&  vm.communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\'">{{vm.communicationParameter.value}}</span> <span ng-if=" vm.communicationParameter.communicationParameterType == \'PASSWORD\' &&  vm.communicationParameter.communicationParameterType == \'KEYSTORE_PASSWORD\'">************</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="communication-parameter-detail.edit({id:vm.communicationParameter.id})" class="btn btn-primary"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/communication-parameter/communication-parameter-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h5 class="modal-title" id="myCommunicationParameterLabel" data-translate="eDocumentsApp.communicationParameter.home.createOrEditLabel">Create or edit a Communication Parameter</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.communicationParameter.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control form-control-sm" id="id" name="id" ng-model="vm.communicationParameter.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationParameter.communicationType" for="field_communicationType">Communication Type</label><select class="form-control form-control-sm" name="communicationType" ng-model="vm.communicationParameter.communicationType" id="field_communicationType" required><option value="FTP_IN" data-translate="eDocumentsApp.CommunicationType.FTP_IN">FTP_IN</option><option value="FTP_OUT" data-translate="eDocumentsApp.CommunicationType.FTP_OUT">FTP_OUT</option><option value="SFTP_IN" data-translate="eDocumentsApp.CommunicationType.SFTP_IN">SFTP_IN</option><option value="SFTP_OUT" data-translate="eDocumentsApp.CommunicationType.SFTP_OUT">SFTP_OUT</option><option value="ISERIES_IN" data-translate="eDocumentsApp.CommunicationType.ISERIES_IN">ISERIES_IN</option><option value="ISERIES_OUT" data-translate="eDocumentsApp.CommunicationType.ISERIES_OUT">ISERIES_OUT</option><option value="LOGITOOLS_OUT" data-translate="eDocumentsApp.CommunicationType.LOGITOOLS_OUT">LOGITOOLS_OUT</option><option value="IFS_IN" data-translate="eDocumentsApp.CommunicationType.IFS_IN">IFS_IN</option><option value="IFS_OUT" data-translate="eDocumentsApp.CommunicationType.IFS_OUT">IFS_OUT</option><option value="IBUS_RECEIVE_SUPPLIER_INVOICE" data-translate="eDocumentsApp.CommunicationType.IBUS_RECEIVE_SUPPLIER_INVOICE">IBUS_RECEIVE_SUPPLIER_INVOICE</option><option value="IBUS_RECEIVE_SUPPLIER_INVOICE_1_1" data-translate="eDocumentsApp.CommunicationType.IBUS_RECEIVE_SUPPLIER_INVOICE_1_1">IBUS_RECEIVE_SUPPLIER_INVOICE_1_1</option><option value="IBUS_RECEIVE_SUPPLIER_INVOICE_1_2" data-translate="eDocumentsApp.CommunicationType.IBUS_RECEIVE_SUPPLIER_INVOICE_1_2">IBUS_RECEIVE_SUPPLIER_INVOICE_1_2</option><option value="IBUS_RECEIVE_SUPPLIER_INVOICE_1_3" data-translate="eDocumentsApp.CommunicationType.IBUS_RECEIVE_SUPPLIER_INVOICE_1_3">IBUS_RECEIVE_SUPPLIER_INVOICE_1_3</option><option value="IBUS_RECEIVE_SUPPLIER_INVOICE_1_4" data-translate="eDocumentsApp.CommunicationType.IBUS_RECEIVE_SUPPLIER_INVOICE_1_4">IBUS_RECEIVE_SUPPLIER_INVOICE_1_4</option><option value="IBUS_SEND_SALES_INVOICE" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE">IBUS_SEND_SALES_INVOICE</option><option value="IBUS_SEND_SALES_INVOICE_1_1" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_1">IBUS_SEND_SALES_INVOICE_1_1</option><option value="IBUS_SEND_SALES_INVOICE_1_2" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_2">IBUS_SEND_SALES_INVOICE_1_2</option><option value="IBUS_SEND_SALES_INVOICE_1_3" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_3">IBUS_SEND_SALES_INVOICE_1_3</option><option value="IBUS_SEND_SALES_INVOICE_1_4" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_4">IBUS_SEND_SALES_INVOICE_1_4</option><option value="IBUS_SEND_SALES_INVOICE_1_5" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_5">IBUS_SEND_SALES_INVOICE_1_5</option><option value="IBUS_SEND_SALES_INVOICE_1_6" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_6">IBUS_SEND_SALES_INVOICE_1_6</option><option value="IBUS_SEND_SALES_INVOICE_1_7" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_7">IBUS_SEND_SALES_INVOICE_1_7</option><option value="IBUS_SEND_SALES_INVOICE_1_8" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_8">IBUS_SEND_SALES_INVOICE_1_8</option><option value="IBUS_SEND_SALES_INVOICE_1_9" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_9">IBUS_SEND_SALES_INVOICE_1_9</option><option value="IBUS_SEND_SALES_INVOICE_1_10" data-translate="eDocumentsApp.CommunicationType.IBUS_SEND_SALES_INVOICE_1_10">IBUS_SEND_SALES_INVOICE_1_10</option><option value="BOTELHO_OUT" data-translate="eDocumentsApp.CommunicationType.BOTELHO_OUT">BOTELHO_OUT</option><option value="EMAIL_OUT" data-translate="eDocumentsApp.CommunicationType.EMAIL_OUT">EMAIL_OUT</option><option value="UNEDIFACT_MESSAGE" data-translate="eDocumentsApp.CommunicationType.UNEDIFACT_MESSAGE">UNEDIFACT_MESSAGE</option><option value="UNEDIFACT_EMAIL_OUT" data-translate="eDocumentsApp.CommunicationType.UNEDIFACT_EMAIL_OUT">UNEDIFACT_EMAIL_OUT</option><option value="AS2_OUT" data-translate="eDocumentsApp.CommunicationType.AS2_OUT">AS2_OUT</option><option value="INNERGY_PORTAL_INVOICE_INTEGRATION_OUT" data-translate="eDocumentsApp.CommunicationType.INNERGY_PORTAL_INVOICE_INTEGRATION_OUT">INNERGY_PORTAL_INVOICE_INTEGRATION_OUT</option><option value="INNERGY_PORTAL_ORDER_INTEGRATION_OUT" data-translate="eDocumentsApp.CommunicationType.INNERGY_PORTAL_ORDER_INTEGRATION_OUT">INNERGY_PORTAL_ORDER_INTEGRATION_OUT</option><option value="MINSAIT_INTEGRATION" data-translate="eDocumentsApp.CommunicationType.MINSAIT_INTEGRATION">MINSAIT_INTEGRATION</option><option value="FE_AP_XML_GENERATION" data-translate="eDocumentsApp.CommunicationType.FE_AP_XML_GENERATION">FE_AP_XML_GENERATION</option><option value="AMA_SAFE_SIGNING" data-translate="eDocumentsApp.CommunicationType.AMA_SAFE_SIGNING">AMA_SAFE_SIGNING</option><option value="INNERGY_W_CHEP_CONSIGNMENT_NOTES" data-translate="eDocumentsApp.CommunicationType.INNERGY_W_CHEP_CONSIGNMENT_NOTES">INNERGY_W_CHEP_CONSIGNMENT_NOTES</option><option value="MOLONI_ORDER_INTEGRATION" data-translate="eDocumentsApp.CommunicationType.MOLONI_ORDER_INTEGRATION">MOLONI_ORDER_INTEGRATION</option></select><div ng-show="editForm.communicationType.$invalid"><p class="help-block" ng-show="editForm.communicationType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationParameter.communicationParameterType" for="field_communicationParameterType">Communication Parameter Type</label><select class="form-control form-control-sm" name="communicationParameterType" ng-model="vm.communicationParameter.communicationParameterType" id="field_communicationParameterType" required><option value="HOSTNAME" data-translate="eDocumentsApp.CommunicationParameterType.HOSTNAME">HOSTNAME</option><option value="USERNAME" data-translate="eDocumentsApp.CommunicationParameterType.USERNAME">USERNAME</option><option value="PASSWORD" data-translate="eDocumentsApp.CommunicationParameterType.PASSWORD">PASSWORD</option><option value="PORT" data-translate="eDocumentsApp.CommunicationParameterType.PORT">PORT</option><option value="URL" data-translate="eDocumentsApp.CommunicationParameterType.URL">URL</option><option value="FILE_DIRECTORY" data-translate="eDocumentsApp.CommunicationParameterType.FILE_DIRECTORY">FILE_DIRECTORY</option><option value="COMMUNICATION_SUBTYPE" data-translate="eDocumentsApp.CommunicationParameterType.COMMUNICATION_SUBTYPE">COMMUNICATION_SUBTYPE</option></select><div ng-show="editForm.communicationParameterType.$invalid"><p class="help-block" ng-show="editForm.communicationParameterType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationParameter.value" for="field_value">Value</label><input type="text" class="form-control form-control-sm" name="value" id="field_value" ng-model="vm.communicationParameter.value" ng-maxlength="255" ng-if="!(vm.communicationParameter.communicationParameterType === \'PASSWORD\' || vm.communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\')"><ed-secret-field ng-if="vm.communicationParameter.communicationParameterType === \'PASSWORD\' || vm.communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="vm.communicationParameter.value" secret-id="vm.communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="vm.communicationParameter.secretStored" read-only="false"></ed-secret-field><div ng-show="editForm.value.$invalid"><p class="help-block" ng-show="editForm.value.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div><div class="float-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/communication-parameter/communication-parameters.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.communicationParameter.home.title">Communication Parameters</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-success mx-2 mb-2" ui-sref="communication-parameter.new"><i class="far fa-plus-square"></i> <span class="hidden-xs-down">{{\'entity.action.add\' | translate}}</span></button><div class="form-group mx-2 mb-2"><input type="text" class="form-control form-control-sm" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'entity.action.search\' | translate}}"></div><button class="btn btn-info mx-2 mb-2" ng-click="vm.search(vm.searchQuery)"><i class="fas fa-search"></i></button> <button class="btn btn-dark mx-2 mb-2" ng-if="vm.currentSearch" ng-click="vm.clear()"><i class="fas fa-trash-alt"></i></button></form></div></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="eDocumentsApp.communicationParameter.communicationType">Communication Type</span></th><th><span data-translate="eDocumentsApp.communicationParameter.communicationParameterType">Communication Parameter Type</span></th><th><span data-translate="eDocumentsApp.communicationParameter.value">Value</span></th><th></th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationParameters track by communicationParameter.id"><td><a ui-sref="communication-parameter-detail({id:communicationParameter.id})">{{communicationParameter.id}}</a></td><td data-translate="{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType}}">{{communicationParameter.communicationType}}</td><td data-translate="{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType}}">{{communicationParameter.communicationParameterType}}</td><td>{{communicationParameter.value}}</td><td><span ng-if=" communicationParameter.communicationParameterType !== \'PASSWORD\' &&  communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\'">{{communicationParameter.value}}</span> <span ng-if=" communicationParameter.communicationParameterType == \'PASSWORD\' &&  communicationParameter.communicationParameterType == \'KEYSTORE_PASSWORD\'">************</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="communication-parameter-detail({id:communicationParameter.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="communication-parameter.edit({id:communicationParameter.id})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="communication-parameter.delete({id:communicationParameter.id})" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/communication-parameter/view-parameters-details-dialog.html','<div class="modal-header"><h5 class="modal-title" id="myCommunicationParameterLabel" data-translate="eDocumentsApp.communicationParameter.home.title">Communication Parameter</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><uib-tabset active="active"><uib-tab heading="Defini\xE7\xE3o de comunica\xE7\xE3o" ng-if="vm.communicationDefinition"><div class="card mb-3 mt-2" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><div class="card-header"><span data-translate="eDocumentsApp.communicationDefinition.originParameters">Origin Parameters</span> <button type="button" ng-click="vm.clear()" ui-sref="communication-definition.edit({id:vm.communicationDefinition.id})" class="btn btn-primary btn-sm float-right"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span></button></div><div class="card-body"><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationDefinition.originParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                         communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                        communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'" type="text" class="form-control form-control-sm" ng-readonly="true" name="value" ng-model="communicationParameter.value"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeOrigin" ng-model="communicationParameter.disableExecutionTime" ng-disabled="true"><label class="form-check-label" for="disableExecutionTimeOrigin" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="true" name="value" placeholder="--:--"></div></td></tr></tbody></table></div></div></div><div class="card mb-3" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><div class="card-header"><span data-translate="eDocumentsApp.communicationDefinition.destinationParameters">Destination Parameters</span> <button type="button" ng-click="vm.clear()" ui-sref="communication-definition.edit({id:vm.communicationDefinition.id})" class="btn btn-primary btn-sm float-right"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span></button></div><div class="card-body"><div class="form-inline"><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationDefinition.destinationParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input type="text" class="form-control form-control-sm" ng-readonly="true" name="value" ng-model="communicationParameter.value" ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                        communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                        communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeDestination" ng-model="communicationParameter.disableExecutionTime" ng-disabled="true"><label class="form-check-label" for="disableExecutionTimeDestination" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="true" name="value" placeholder="--:--"></div></td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab heading="{{(\'eDocumentsApp.communicationDefinition.origin\' | translate) + \': \' +vm.communicationEntityOrigin.name}}" ng-if="vm.communicationEntityOrigin"><div class="card mb-3 mt-2" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><div class="card-header"><span data-translate="eDocumentsApp.communicationDefinition.originParameters">Origin Parameters</span> <button type="button" ng-click="vm.clear()" ui-sref="communication-entity.edit({id:vm.communicationEntityOrigin.id})" class="btn btn-primary btn-sm float-right"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span></button></div><div class="card-body"><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationEntityOrigin.originParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                         communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                        communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'" type="text" class="form-control form-control-sm" ng-readonly="true" name="value" ng-model="communicationParameter.value"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeEntityOrigin" ng-model="communicationParameter.disableExecutionTime" ng-disabled="true"><label class="form-check-label" for="disableExecutionTimeEntityOrigin" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="true" name="value" placeholder="--:--"></div></td></tr></tbody></table></div></div></div><div class="card mb-3" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><div class="card-header"><span data-translate="eDocumentsApp.communicationDefinition.destinationParameters">Destination Parameters</span> <button type="button" ng-click="vm.clear()" ui-sref="communication-entity.edit({id:vm.communicationEntityOrigin.id})" class="btn btn-primary btn-sm float-right"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span></button></div><div class="card-body"><div class="form-inline"><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationEntityOrigin.destinationParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input type="text" class="form-control form-control-sm" ng-readonly="true" name="value" ng-model="communicationParameter.value" ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                                communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                                communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeEntityDestination" ng-model="communicationParameter.disableExecutionTime" ng-disabled="true"><label class="form-check-label" for="disableExecutionTimeEntityDestination" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="true" name="value" placeholder="--:--"></div></td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab heading="{{(\'eDocumentsApp.communicationDefinition.destination\' | translate) + \': \' +vm.communicationEntityDestination.name}}" ng-if="vm.communicationEntityDestination"><div class="card mb-3 mt-2" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><div class="card-header"><span data-translate="eDocumentsApp.communicationDefinition.originParameters">Origin Parameters</span> <button type="button" ng-click="vm.clear()" ui-sref="communication-entity.edit({id:vm.communicationEntityDestination.id})" class="btn btn-primary btn-sm float-right"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span></button></div><div class="card-body"><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationEntityDestination.originParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                         communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                        communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'" type="text" class="form-control form-control-sm" ng-readonly="true" name="value" ng-model="communicationParameter.value"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeEntityDestinationOrigin" ng-model="communicationParameter.disableExecutionTime" ng-disabled="true"><label class="form-check-label" for="disableExecutionTimeEntityDestinationOrigin" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="true" name="value" placeholder="--:--"></div></td></tr></tbody></table></div></div></div><div class="card mb-3" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><div class="card-header"><span data-translate="eDocumentsApp.communicationDefinition.destinationParameters">Destination Parameters</span> <button type="button" ng-click="vm.clear()" ui-sref="communication-entity.edit({id:vm.communicationEntityDestination.id})" class="btn btn-primary btn-sm float-right"><i class="far fa-edit"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span></button></div><div class="card-body"><div class="form-inline"><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationEntityDestination.destinationParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input type="text" class="form-control form-control-sm" ng-readonly="true" name="value" ng-model="communicationParameter.value" ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                                communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                                                communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeDefinitionDestination" ng-model="communicationParameter.disableExecutionTime" ng-disabled="true"><label class="form-check-label" for="disableExecutionTimeDefinitionDestination" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="true" name="value" placeholder="--:--"></div></td></tr></tbody></table></div></div></div></div></uib-tab></uib-tabset><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div></div>');
$templateCache.put('app/entities/communication-workflow-step/communication-workflow-step-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.communicationWorkflowStep.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.communicationWorkflowStep.delete.question" translate-values="{id: \'{{vm.communicationWorkflowStep.id}}\'}">Are you sure you want to delete this Communication Workflow Step?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/communication-workflow-step/communication-workflow-step-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span class="badge badge-primary" ng-if="vm.communicationDefinition.description">{{vm.communicationDefinition.description}}</span> <span data-translate="eDocumentsApp.communicationWorkflowStep.home.createOrEditLabel">Create or edit a Communication Workflow Step</span></h5><hr></div><div class="modal-body col-6"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationWorkflowStep.order" for="field_order">Order</label><input type="number" ng-disabled="vm.readOnly===true" class="form-control form-control-sm" name="order" id="field_order" ng-model="vm.communicationWorkflowStep.order" required min="1" ng-class="{\'is-invalid\': editForm.order.$invalid}"><div class="invalid-feedback" ng-show="editForm.order.$invalid && editForm.order.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.order.$invalid && editForm.order.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be at least 1.</div><div class="invalid-feedback" ng-show="editForm.order.$invalid && editForm.order.$error.number" data-translate="entity.validation.number">This field should be a number.</div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationWorkflowStep.description" for="field_description">description</label><input type="text" name="description" ng-disabled="vm.readOnly===true" class="form-control form-control-sm" id="field_description" ng-model="vm.communicationWorkflowStep.description"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationWorkflowStep.executionType.label">Execution Type</label><div class="btn-group btn-group-toggle col" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.communicationWorkflowStep.executionType === \'PASSIVE\', \'disabled\': vm.readOnly && vm.communicationWorkflowStep.executionType !== \'PASSIVE\'}" ng-click="!vm.readOnly ? vm.changeExecutionType(\'PASSIVE\') : false;"><input type="radio" name="options" id="executionType_passive" autocomplete="off"> <span data-translate="eDocumentsApp.communicationWorkflowStep.executionType.passive">Passive</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.communicationWorkflowStep.executionType === \'AUTOMATIC\', \'disabled\': vm.readOnly && vm.communicationWorkflowStep.executionType !== \'AUTOMATIC\'}" ng-click="!vm.readOnly ? vm.changeExecutionType(\'AUTOMATIC\') : false;"><input type="radio" name="options" id="executionType_automatic" autocomplete="off"> <span data-translate="eDocumentsApp.communicationWorkflowStep.executionType.automatic">Automatic</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.communicationWorkflowStep.executionType === \'MANUAL\', \'disabled\': vm.readOnly && vm.communicationWorkflowStep.executionType !== \'MANUAL\'}" ng-click="!vm.readOnly ? vm.changeExecutionType(\'MANUAL\') : false;"><input type="radio" name="options" id="executionType_manual" autocomplete="off"> <span data-translate="eDocumentsApp.communicationWorkflowStep.executionType.manual">Manual</span></label></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationWorkflowStep.sendEmailToOriginOnError" for="field_sendEmailToOriginOnError">sendEmailToOriginOnError</label>&nbsp; <input type="checkbox" name="sendEmailToOriginOnError" ng-disabled="vm.readOnly===true" id="field_sendEmailToOriginOnError" ng-model="vm.communicationWorkflowStep.sendEmailToOriginOnError"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationWorkflowStep.sendEmailToDestinationOnError" for="field_sendEmailToDestinationOnError">sendEmailToDestinationOnError</label>&nbsp; <input type="checkbox" name="sendEmailToDestinationOnError" ng-disabled="vm.readOnly===true" id="field_sendEmailToDestinationOnError" ng-model="vm.communicationWorkflowStep.sendEmailToDestinationOnError"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationWorkflowStep.sendEmailToSuperAdminOnError" for="field_sendEmailToSuperAdminOnError">sendEmailToSuperAdminOnError</label>&nbsp; <input type="checkbox" name="sendEmailToDestinationOnError" ng-disabled="vm.readOnly===true" id="field_sendEmailToSuperAdminOnError" ng-model="vm.communicationWorkflowStep.sendEmailToSuperAdminOnError"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationWorkflowStep.numberOfRetries" for="field_numberOfRetries">Number Of Retries</label>&nbsp; <input type="number" class="form-control form-control-sm" ng-disabled="vm.readOnly===true" name="numberOfRetries" id="field_numberOfRetries" ng-model="vm.communicationWorkflowStep.numberOfRetries"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.communicationWorkflowStep.retryDelay" for="field_retryDelay">Retry Delay</label>&nbsp; <input type="number" class="form-control form-control-sm" ng-disabled="vm.readOnly===true" name="retryDelay" id="field_retryDelay" ng-model="vm.communicationWorkflowStep.retryDelay"></div><div class="form-group"><label data-translate="eDocumentsApp.communicationWorkflowStep.communicationActionDefinition" for="field_communicationActionDefinition">Communication Action Definition</label><select ng-disabled="vm.readOnly===true" class="form-control form-control-sm" id="field_communicationActionDefinition" name="communicationActionDefinition" ng-model="vm.communicationWorkflowStep.communicationActionDefinitionId" ng-options="communicationActionDefinition.id as communicationActionDefinition.name for communicationActionDefinition in vm.communicationactiondefinitions"><option value=""></option></select></div></div><div><button type="button" class="btn btn-success" ng-click="vm.viewEntitiesParameters()" ng-if="vm.communicationWorkflowStep.id"><i class="fas fa-sitemap"></i>&nbsp;<span data-translate="eDocumentsApp.communicationWorkflowStep.viewPreviouslyDefinedParameters">View Previously Defined Parameters</span></button></div><div ng-if="vm.communicationWorkflowStep.id" class="card mb-3"><div class="card-header" data-translate="eDocumentsApp.communicationWorkflowStep.originParameters">Origin Parameters</div><div class="card-body"><div class="form-inline" ng-if="vm.readOnly !== true"><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectOriginCommunicationType" ng-change="vm.changeOriginParameter()"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</option><option ng-repeat="(communicationType, values) in vm.communicationTypes" value="{{communicationType}}">{{\'eDocumentsApp.CommunicationType.\' + communicationType | translate}}</option></select><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectOriginCommunicationParameterType"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</option><option ng-repeat="communicationParameterType in vm.communicationParameterTypes" value="{{communicationParameterType}}">{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameterType | translate}}</option></select><a class="btn btn-primary mb-2" href="" ng-click="vm.addOriginParameter()"><i class="far fa-plus-square"></i></a></div><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationWorkflowStep.originParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input ng-if="communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                             communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\' &&\n                             communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'" type="text" class="form-control form-control-sm" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="vm.readOnly === true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeOrigin" ng-model="communicationParameter.disableExecutionTime" ng-disabled="vm.readOnly === true"><label class="form-check-label" for="disableExecutionTimeOrigin" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="vm.readOnly === true" name="value" placeholder="--:--"></div></td><td ng-if="vm.readOnly !== true"><a href="" ng-click="vm.deleteCommunicationOriginParameter(communicationParameter)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div></div></div><div ng-if="vm.communicationWorkflowStep.id &&  vm.communicationTypes" class="card mb-3"><div class="card-header" data-translate="eDocumentsApp.communicationWorkflowStep.destinationParameters">Destination Parameters</div><div class="card-body"><div class="form-inline" ng-if="vm.readOnly !== true"><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectDestinationCommunicationType" ng-change="vm.changeDestinationParameter()"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</option><option ng-repeat="(communicationType, values) in vm.communicationTypes" value="{{communicationType}}">{{\'eDocumentsApp.CommunicationType.\' + communicationType | translate}}</option></select><select class="form-control form-control-sm mb-2 mr-sm-2" ng-model="vm.selectDestinationCommunicationParameterType"><option value="" disabled="" data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</option><option ng-repeat="communicationParameterType in vm.communicationParameterTypes" value="{{communicationParameterType}}">{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameterType | translate}}</option></select><a class="btn btn-primary mb-2" href="" ng-click="vm.addDestinationParameter()"><i class="far fa-plus-square"></i></a></div><div class="table-responsive"><table class="jh-table table table-condensed table-striped table-sm"><thead><tr><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationType">Communication Type</th><th data-translate="eDocumentsApp.communicationWorkflowStep.communicationParameter">Communication Parameter</th><th data-translate="eDocumentsApp.communicationWorkflowStep.value">Value</th><th ng-if="vm.readOnly !== true"></th></tr></thead><tbody><tr ng-repeat="communicationParameter in vm.communicationWorkflowStep.destinationParameters"><td>{{\'eDocumentsApp.CommunicationType.\' + communicationParameter.communicationType | translate}}</td><td>{{\'eDocumentsApp.CommunicationParameterType.\' + communicationParameter.communicationParameterType | translate}}</td><td><input type="text" class="form-control form-control-sm" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value" ng-if="communicationParameter.communicationParameterType !== \'PASSWORD\' && communicationParameter.communicationParameterType !== \'KEYSTORE_PASSWORD\'&&\n                                    communicationParameter.communicationParameterType !== \'EMAIL_EXECUTION_TIME\' && communicationParameter.communicationParameterType !== \'EXECUTION_TIME\' &&\n                                    communicationParameter.communicationParameterType !== \'SUSPENSION_START_TIME\' && communicationParameter.communicationParameterType !== \'SUSPENSION_END_TIME\'"><!-- EDOCS-627: write-only secret; SUPERADMIN reveals through the audited dialog --><ed-secret-field ng-if="communicationParameter.communicationParameterType === \'PASSWORD\' || communicationParameter.communicationParameterType === \'KEYSTORE_PASSWORD\'" model="communicationParameter.value" secret-id="communicationParameter.id" source="COMMUNICATION_PARAMETER" stored="communicationParameter.secretStored" read-only="vm.readOnly === true"></ed-secret-field><div ng-if="communicationParameter.communicationParameterType === \'EXECUTION_TIME\' || communicationParameter.communicationParameterType === \'EMAIL_EXECUTION_TIME\' ||\n                                            communicationParameter.communicationParameterType === \'SUSPENSION_START_TIME\' || communicationParameter.communicationParameterType === \'SUSPENSION_END_TIME\'" class="input-group input-group-sm"><div class="input-group-prepend"><div class="input-group-text"><div class="form-group form-check mb-0"><input type="checkbox" class="form-check-input" id="disableExecutionTimeDestination" ng-model="communicationParameter.disableExecutionTime" ng-disabled="vm.readOnly === true"><label class="form-check-label" for="disableExecutionTimeDestination" data-translate="entity.action.cancel">Cancel</label></div></div></div><input type="time" class="form-control form-control-sm" ng-if="!communicationParameter.disableExecutionTime" ng-readonly="vm.readOnly === true" name="value" ng-model="communicationParameter.value"> <input type="text" class="form-control form-control-sm" ng-if="communicationParameter.disableExecutionTime" disabled="disabled" ng-readonly="vm.readOnly === true" name="value" placeholder="--:--"></div></td><td ng-if="vm.readOnly !== true"><a href="" ng-click="vm.deleteCommunicationDestinationParameter(communicationParameter)" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i></a></td></tr></tbody></table></div></div></div><div class="col-auto"><button type="button" class="btn btn-default" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/communication-workflow-step/communication-workflow-steps.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2>{{vm.communicationDefinition.description}} {{\'global.workflow\' | translate}}</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-success mx-2 mb-2" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication-workflow-step.new"><i class="far fa-plus-square"></i> <span class="hidden-xs-down">{{\'entity.action.add\' | translate}}</span></button></form></div></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th><span data-translate="eDocumentsApp.communicationWorkflowStep.order">Order</span></th><th><span data-translate="eDocumentsApp.communicationWorkflowStep.communicationActionDefinition">Communication Action Definition</span></th><th class="text-center"><span data-translate="eDocumentsApp.communicationWorkflowStep.description">description</span></th><th class="text-center"><span data-translate="eDocumentsApp.communicationWorkflowStep.executionType.label">Execution Type</span></th><th class="text-center"><span data-translate="eDocumentsApp.communicationWorkflowStep.numberOfRetries">Number Of Retries</span></th><th class="text-center"><span data-translate="eDocumentsApp.communicationWorkflowStep.retryDelay">Retry Delay</span></th><th></th></tr></thead><tbody><tr ng-repeat="communicationWorkflowStep in vm.communicationWorkflowSteps track by communicationWorkflowStep.id"><td>{{communicationWorkflowStep.order}}</td><td><span>{{communicationWorkflowStep.communicationActionDefinitionName}}</span></td><td>{{communicationWorkflowStep.description}}</td><td class="text-center"><span ng-if="communicationWorkflowStep.executionType === \'PASSIVE\'" data-translate="eDocumentsApp.communicationWorkflowStep.executionType.passive">Passive</span> <span ng-if="communicationWorkflowStep.executionType === \'AUTOMATIC\'" data-translate="eDocumentsApp.communicationWorkflowStep.executionType.automatic">Automatic</span> <span ng-if="communicationWorkflowStep.executionType === \'MANUAL\'" data-translate="eDocumentsApp.communicationWorkflowStep.executionType.manual">Manual</span></td><td class="text-center">{{communicationWorkflowStep.numberOfRetries}}</td><td class="text-center">{{communicationWorkflowStep.retryDelay}}</td><td class="text-right"><div class="btn-group mr-2" role="group" aria-label="{{\'global.a11y.firstGroup\' | translate}}"><a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication-workflow-step-detail({id:communicationWorkflowStep.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="entity.action.view"></span> </a><a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication-workflow-step.edit({id:communicationWorkflowStep.id})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit"></span> </a><a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication-workflow-step.delete({id:communicationWorkflowStep.id})" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></a></div></td></tr></tbody></table></div><hr><button type="button" ui-sref="communication-definition" class="btn btn-info"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/document/document-approval-by-hashid-dialog.html','<form name="approvalForm" ng-submit="vm.confirmApproval(vm.document.hashedId)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.approve.title">Confirm approve operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n            The statement comes from the server, not from this bundle. It is the sentence recorded\n            verbatim on the evidence row, so displaying a locally-composed variant would mean the\n            recipient agreed to one wording and we kept another.\n        --><p class="approval-statement" ng-if="vm.statement">{{ vm.statement }}</p><p class="text-muted small" ng-if="vm.recipientEmail" data-translate="eDocumentsApp.document.approve.attribution" translate-values="{email: \'{{ vm.recipientEmail }}\'}">This approval will be recorded on behalf of the recipient.</p><p data-translate="eDocumentsApp.document.approve.question" translate-values="{documentNumber: \'{{ vm.document.documentNumber }}\'}">Are you sure you want to approve this Document?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="approvalForm.$invalid || vm.approving || !vm.statement" class="btn btn-success"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/document/document-approval-dialog.html','<form name="approvalForm" ng-submit="vm.confirmApproval(vm.document.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.approve.title">Confirm approve operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--\n            The statement comes from the server, not from this bundle - the same renderer that\n            writes acceptance_text onto the evidence row. This dialog used to compose its own\n            wording from creditNote.explanation1/2 while the server recorded a different sentence,\n            so every in-application approval asserted an acceptance the approver had never read.\n        --><p class="approval-statement" ng-if="vm.statement">{{ vm.statement }}</p><p data-translate="eDocumentsApp.document.approve.question" translate-values="{documentNumber: \'{{vm.document.documentNumber}}\'}">Are you sure you want to approve this Document?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="approvalForm.$invalid || vm.approving || !vm.statement" class="btn btn-success"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span data-translate="entity.action.approve">Approve</span></button></div></div></form>');
$templateCache.put('app/entities/document/document-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.document.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.document.delete.question" translate-values="{id: \'{{vm.document.documentNumber}}\'}">Are you sure you want to delete this Document?</p><div class="alert alert-warning" ng-if="vm.externalRecipients.length > 0"><p><i class="fas fa-exclamation-triangle"></i>&nbsp; <span data-translate="eDocumentsApp.document.delete.externalAccessWarning" translate-values="{count: \'{{vm.externalRecipients.length}}\'}">This document was already sent by email. Deleting it permanently breaks the links the recipients received.</span></p><ul class="mb-0"><li ng-repeat="email in vm.externalRecipients">{{ email }}</li></ul></div><div class="alert alert-warning" ng-if="vm.recipientsCheckFailed"><i class="fas fa-exclamation-triangle"></i>&nbsp; <span data-translate="eDocumentsApp.document.delete.externalAccessUnknown">Could not confirm whether links to this document were already emailed. If they were, deleting it breaks them permanently.</span></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid || vm.recipientsLoading" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/document/document-delete-selected-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.document.deleteSelected.question">Are you sure you want to delete this Documents?</p><div class="alert alert-warning" ng-if="vm.externalRecipients.length > 0"><p><i class="fas fa-exclamation-triangle"></i>&nbsp; <span data-translate="eDocumentsApp.document.delete.externalAccessWarning" translate-values="{count: \'{{vm.externalRecipients.length}}\'}">These documents were already sent by email. Deleting them permanently breaks the links the recipients received.</span></p><ul class="mb-0"><li ng-repeat="email in vm.externalRecipients">{{ email }}</li></ul></div><div class="alert alert-warning" ng-if="vm.recipientsCheckFailed"><i class="fas fa-exclamation-triangle"></i>&nbsp; <span data-translate="eDocumentsApp.document.delete.externalAccessUnknown">Could not confirm whether links to these documents were already emailed. If they were, deleting them breaks the links permanently.</span></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid || vm.recipientsLoading" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/document/document-detail.html','<div class="container-fluid mt-3 mb-3"><!-- Skeleton loading state --><div ng-if="!vm.document" class="row"><div class="col-lg-8 col-sm-12"><div class="skeleton skeleton-title mb-3"></div><hr><section class="card"><div class="card-body"><div class="row"><div class="col-md-6"><div class="skeleton skeleton-line mb-2"></div><div class="skeleton skeleton-line mb-2" style="width: 80%"></div><div class="skeleton skeleton-line mb-2" style="width: 60%"></div><div class="skeleton skeleton-line mb-4" style="width: 40%"></div></div><div class="col-md-6"><div class="skeleton skeleton-badge float-right mb-3"></div><div class="clearfix"></div><div class="skeleton skeleton-line mb-2" style="width: 70%"></div><div class="skeleton skeleton-line mb-2" style="width: 50%"></div></div></div><div class="skeleton skeleton-table mt-4"></div></div></section></div><div class="col-lg-4 col-sm-12"><div class="skeleton skeleton-title mb-3" style="width: 70%"></div><hr><div class="skeleton skeleton-step mb-3"></div><div class="skeleton skeleton-step mb-3"></div><div class="skeleton skeleton-step mb-3"></div></div></div><!-- Main content --><div ng-if="vm.document" class="row"><div class="col-lg-8 col-sm-12"><!-- Sticky action bar --><div class="document-detail-actions d-flex justify-content-between align-items-center mb-3"><h2 class="mb-0">{{vm.document.documentNumber}}</h2><div><span class="badge badge-info mr-2" ng-if="vm.document.firstViewedDate"><span data-translate="eDocumentsApp.document.detail.seenOn">Visto em</span>&nbsp; <span>{{vm.document.firstViewedDate | date: \'dd/MM/yyyy HH:mm:ss\'}}</span> </span><button type="button" class="btn btn-info btn-sm" ng-click="vm.goBack()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" ui-sref="document-storage-detail({id:vm.document.id})" class="btn btn-primary btn-sm"><i class="fas fa-code"></i> <span class="hidden-sm-down" data-translate="eDocumentsApp.document.actions.seeOriginals">Ver Originais</span></button></div></div><hr><section class="card"><div ng-if="vm.document.documentType != \'ORDER\' && vm.document.documentType != \'DESPATCHADVICE\'" id="invoice-template" class="card-body"><p class="watermark" data-translate="eDocumentsApp.document.detail.preview">Pr\xE9-visualiza\xE7\xE3o</p><div id="invoice-company-details" class="row"><div class="col-md-6 col-sm-12 text-center text-md-left"><div class="media mb-3"><div class="media-body"><ul class="ml-2 px-0 list-unstyled" ng-hide="vm.document.documentType==\'SELFBILLED\'"><li class="text-bold-800">{{vm.invoice.sender.companyName}}</li><li>{{vm.invoice.sender.addressDetail}}</li><li>{{vm.invoice.sender.postalCode}} {{vm.invoice.sender.city}}</li><li>{{vm.invoice.sender.vatRegistrationNumber}}</li><li>{{vm.invoice.sender.country}}</li></ul><ul class="ml-2 px-0 list-unstyled" ng-show="vm.document.documentType==\'SELFBILLED\'"><li class="text-bold-800">{{vm.invoice.receiver.companyName}}</li><li>{{vm.invoice.receiver.addressDetail}}</li><li>{{vm.invoice.receiver.postalCode}} {{vm.invoice.receiver.city}}</li><li>{{vm.invoice.receiver.vatRegistrationNumber}}</li><li>{{vm.invoice.receiver.country}}</li></ul></div></div><p><span class="text-muted" data-translate="eDocumentsApp.document.detail.dueDate">Data de Pagamento:</span> {{vm.invoice.header.dueDate | date:\'mediumDate\'}}</p><p><span class="text-muted" data-translate="eDocumentsApp.document.detail.vatRegistrationNumber">N.\xBA Contribuinte:</span> {{vm.invoice.invoiceTo.vatRegistrationNumber}}</p><p ng-if="vm.invoice.header.termsOfPayment"><span class="text-muted" data-translate="eDocumentsApp.document.detail.termsOfPayment">Termos:</span> {{vm.invoice.header.termsOfPayment}}</p></div><div class="col-md-6 col-sm-12"><div class="text-md-right mb-4"><h2 class="badge badge-{{vm.document.documentType}}" data-translate="{{ \'eDocumentsApp.DocumentType.\' + vm.document.documentType }}">{{vm.document.documentType}}</h2><span ng-if="(vm.document.documentType == \'SELFBILLED\' || vm.document.documentType == \'CREDITNOTE\') && vm.document.approved" uib-tooltip="{{ \'eDocumentsApp.document.approve.tooltip\' | translate:vm.approvalInfo }}"><i class="fas fa-check text-success"></i></span><p><span class="text-muted" data-translate="eDocumentsApp.document.detail.documentDate">Data do Documento:</span> {{vm.invoice.header.documentDate | date:\'mediumDate\'}}</p></div><div class="d-flex justify-content-center"><div><!--<p class="text-muted" data-translate="{{\'eDocumentsApp.document.detail.documentAction.\' + vm.document.documentType}}">Document Action</p>--><ul class="px-0 list-unstyled" ng-hide="vm.document.documentType==\'SELFBILLED\'"><li class="text-bold-800">{{vm.invoice.receiver.companyName}}</li><li>{{vm.invoice.receiver.addressDetail}}</li><li>{{vm.invoice.receiver.postalCode}} {{vm.invoice.receiver.city}}</li><li>{{vm.invoice.receiver.vatRegistrationNumber}}</li><li>{{vm.invoice.receiver.country}}</li></ul><ul class="px-0 list-unstyled" ng-show="vm.document.documentType==\'SELFBILLED\'"><li class="text-bold-800">{{vm.invoice.sender.companyName}}</li><li>{{vm.invoice.sender.addressDetail}}</li><li>{{vm.invoice.sender.postalCode}} {{vm.invoice.sender.city}}</li><li>{{vm.invoice.sender.vatRegistrationNumber}}</li><li>{{vm.invoice.sender.country}}</li></ul></div></div></div></div><div id="invoice-customer-details" class="row pt-2 mb-2"><div class="col-md-6 col-sm-12 text-center text-md-left"></div><div class="col-md-4 col-md-offset-2 col-sm-12 text-md-left"></div></div><!--/ Invoice Customer Details --><!-- Invoice Items Details --><div id="invoice-items-details" class="pt-2"><div class="row"><div class="table-responsive col-sm-12"><table class="table table-sm"><thead><tr><th>#</th><th data-translate="eDocumentsApp.document.detail.item">Item</th><th data-translate="eDocumentsApp.document.detail.serialNumber">N\xFAmero de s\xE9rie</th><th class="text-right" data-translate="eDocumentsApp.document.detail.unitCost">Custo Unit\xE1rio</th><th class="text-right" data-translate="eDocumentsApp.document.detail.quantity">Quantidade</th><th class="text-right" data-translate="eDocumentsApp.document.detail.vat">IVA</th><th class="text-right" data-translate="eDocumentsApp.document.detail.total">Total</th></tr></thead><tbody><tr ng-repeat-start="line in vm.invoice.lines |orderBy: lineNumber"><td>{{line.lineNumber}}</td><td class="font-weight-bold">{{line.itemCode}} - <span class="text-muted">{{line.itemDescription}}</span></td><td>{{line.serialNumber ? line.serialNumber.serialNumber : \'\'}}</td><td class="text-right">{{line.netUnitPrice | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2 }}</td><td class="text-right">{{line.quantity}}&nbsp;{{line.unitOfMeasure}}</td><td class="text-right">{{line.vatRate}}&nbsp;%</td><td class="text-right">{{line.grossLineAmount | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr><tr ng-if="line.lineDescription"><td style="border-top: 0; padding-top: 0"></td><td style="border-top: 0; padding-top: 0">{{line.lineDescription}}</td></tr><tr ng-repeat-end ng-if="line.lots && line.lots.length > 0" ng-repeat="lot in line.lots" class="col-sm-12" style="font-size: 0.85rem"><td style="border-top: 0; padding-top: 0" colspan="2"></td><td style="border-top: 0; padding-top: 0"><strong data-translate="eDocumentsApp.document.detail.lot">Lote</strong>&nbsp;{{lot.lotCode}}</td><td style="border-top: 0; padding-top: 0"><strong data-translate="eDocumentsApp.document.detail.expiry">Val.</strong>&nbsp;{{lot.lotExpirationDate | date:\'dd/MM/yyyy\'}}</td><td style="border-top: 0; padding-top: 0" class="text-right"><strong data-translate="eDocumentsApp.document.detail.quantityShort">Qtd.</strong>&nbsp;{{lot.lotQuantity}}</td></tr></tbody></table></div></div><div class="row"><div class="col-md-7 col-sm-12 text-center text-md-left" ng-if="vm.invoice.deliveryPlace"><p class="lead" data-translate="eDocumentsApp.document.detail.deliveryPlace.title">Local de Entrega</p><div class="row"><div class="col-md-8"><table class="jh-table tabletable-borderless table-sm"><tbody><tr><td data-translate="eDocumentsApp.document.detail.deliveryPlace.companyName">Nome:</td><td class="text-right">{{vm.invoice.deliveryPlace.companyName}}</td></tr><tr><td data-translate="eDocumentsApp.document.detail.deliveryPlace.address">Endere\xE7o:</td><td class="text-right">{{vm.invoice.deliveryPlace.addressDetail}}</td></tr><tr><td data-translate="eDocumentsApp.document.detail.deliveryPlace.postalCode">C\xF3digo Postal:</td><td class="text-right">{{vm.invoice.deliveryPlace.postalCode}} {{vm.invoice.deliveryPlace.city}}</td></tr><tr><td data-translate="eDocumentsApp.document.detail.deliveryPlace.vatRegistrationNumber">NIF:</td><td class="text-right">{{vm.invoice.deliveryPlace.vatRegistrationNumber}}</td></tr><tr><td data-translate="eDocumentsApp.document.detail.deliveryPlace.country">Pa\xEDs:</td><td class="text-right">{{vm.invoice.deliveryPlace.country}}</td></tr></tbody></table></div></div></div><div class="col-md-5 col-sm-12"><p class="lead" data-translate="eDocumentsApp.document.detail.totals">Totais</p><div class="table-responsive"><table class="table"><tbody><tr><td colspan="2" data-translate="eDocumentsApp.document.detail.subTotal">Sub Total</td><td class="text-right">{{vm.invoice.header.vatBaseAmount | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr><tr ng-if="vm.invoice.header.vatAmount1"><td><span data-translate="eDocumentsApp.document.detail.vat"></span> ({{vm.invoice.header.vatRate1}}%)</td><td class="text-right">{{vm.invoice.header.vatBaseAmount1 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td><td class="text-right">{{vm.invoice.header.vatAmount1 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr><tr ng-if="vm.invoice.header.vatAmount2"><td><span data-translate="eDocumentsApp.document.detail.vat"></span> ({{vm.invoice.header.vatRate2}}%)</td><td class="text-right">{{vm.invoice.header.vatBaseAmount2 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td><td class="text-right">{{vm.invoice.header.vatAmount2 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr><tr ng-if="vm.invoice.header.vatAmount3"><td><span data-translate="eDocumentsApp.document.detail.vat"></span> ({{vm.invoice.header.vatRate3}}%)</td><td class="text-right">{{vm.invoice.header.vatBaseAmount3 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td><td class="text-right">{{vm.invoice.header.vatAmount3 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr><tr ng-if="vm.invoice.header.vatAmount4"><td><span data-translate="eDocumentsApp.document.detail.vat"></span> ({{vm.invoice.header.vatRate4}}%)</td><td class="text-right">{{vm.invoice.header.vatBaseAmount4 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td><td class="text-right">{{vm.invoice.header.vatAmount4 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr><tr ng-if="vm.invoice.header.vatAmount5"><td><span data-translate="eDocumentsApp.document.detail.vat"></span> ({{vm.invoice.header.vatRate5}}%)</td><td class="text-right">{{vm.invoice.header.vatBaseAmount5 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td><td class="text-right">{{vm.invoice.header.vatAmount5 | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr><tr ng-if="vm.invoice.header.totalDiscountAmount"><td class="text-bold-800" colspan="2" data-translate="eDocumentsApp.document.detail.discounts">Descontos</td><td class="text-bold-800 text-right">{{vm.invoice.header.totalDiscountAmount | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr><tr><td class="text-bold-800" colspan="2" data-translate="eDocumentsApp.document.detail.total">Total</td><td class="text-bold-800 text-right">{{vm.invoice.header.totalAmount | currency: vm.getCurrency(vm.invoice.header.currencyCode) :2}}</td></tr></tbody></table></div></div></div></div><div id="invoice-footer"><div class="row"><div class="col-md-7 col-sm-12"><h6>{{vm.invoice.header.documentCertification}}</h6></div><div class="col-md-5 col-sm-12 text-center"><button class="btn btn-primary btn-sm" uib-tooltip="{{ \'eDocumentsApp.document.message.downloaded\' | translate:{filename: vm.getViewableFilename(file.filename), sizeString: vm.formatFileSize(file.size), numberOfDownloads: vm.downloaded(file.id)} }}" ng-click="vm.download($event, file.id,file.fileType)" ng-repeat="file in vm.document.files"><span class="fa-layers fa-fw"><i class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></i> <span class="fa-layers-counter fa-2x bg-dark" ng-show="vm.downloaded(file.id ) > 0" style="top: -5px; right: -1px">{{vm.downloaded(file.id)}}</span> </span><span class="d-inline d-md-none ml-1">{{vm.getViewableFilename(file.filename)}}</span></button></div></div></div></div><div ng-if="vm.document.documentType == \'ORDER\'" id="order-template" class="card-body"><p class="watermark" data-translate="eDocumentsApp.document.detail.preview">Pr\xE9-visualiza\xE7\xE3o</p><div id="order-company-details" class="row"><div class="col-md-6 col-sm-12 text-center text-md-left"><div class="media mb-3"><div class="media-body"><ul class="ml-2 px-0 list-unstyled"><li class="text-bold-800">{{vm.order.header.supplier.gln}}<span ng-if="vm.orderSupplier"> - {{vm.orderSupplier.name}}</span></li></ul></div></div></div><div class="col-md-6 col-sm-12"><div class="text-md-right mb-4"><h2 class="badge badge-{{vm.document.documentType}}" data-translate="{{\'eDocumentsApp.DocumentType.\' + vm.document.documentType}}">{{vm.document.documentType}}</h2><p><span class="text-muted" data-translate="eDocumentsApp.document.detail.documentDate">Data do Documento:</span> {{vm.order.header.orderDate | date:\'mediumDate\'}}</p></div><div class="d-flex justify-content-center"><div><ul class="px-0 list-unstyled"><li class="text-bold-800">{{vm.order.header.buyer.gln}}<span ng-if="vm.orderReceiver"> - {{vm.orderReceiver.name}}</span></li></ul></div></div></div></div><div id="order-customer-details" class="row pt-2 mb-2"><div class="col-md-6 col-sm-12 text-center text-md-left"></div><div class="col-md-4 col-md-offset-2 col-sm-12 text-md-left"></div></div><!--/ Order Customer Details --><!-- Order Items Details --><div id="order-items-details" class="pt-2"><div class="row"><div class="table-responsive col-sm-12"><table class="table table-sm"><thead><tr><th>#</th><th data-translate="eDocumentsApp.document.detail.item">Item</th><th class="text-right" data-translate="eDocumentsApp.document.detail.unitCost">Custo Unit\xE1rio</th><th class="text-right" data-translate="eDocumentsApp.document.detail.quantity">Quantidade</th><th class="text-right" data-translate="eDocumentsApp.document.detail.total">Total</th></tr></thead><tbody><tr ng-repeat="line in vm.order.lines |orderBy: lineNumber"><td>{{line.lineNumber}}</td><td class="font-weight-bold">{{line.suppliersProductCode}} - <span class="text-muted">{{line.productDescription}}</span></td><td class="text-right">{{line.netUnitPrice | currency: vm.getCurrency(vm.order.header.currencyCode) :2 }}</td><td class="text-right">{{line.quantity}}&nbsp;{{line.unitOfMeasure}}</td><td class="text-right">{{line.netUnitPrice * line.quantity | currency: vm.getCurrency(vm.order.header.currencyCode) :2}}</td></tr></tbody></table></div></div><div class="row"><div class="col-md-7 col-sm-12 text-center text-md-left" ng-if="vm.order.header.delivery"><p class="lead" data-translate="eDocumentsApp.document.detail.deliveryPlace.title">Local de Entrega</p><div class="row"><div class="col-md-8"><table class="jh-table tabletable-borderless table-sm"><tbody><tr><td><span data-translate="eDocumentsApp.document.detail.gln">GLN</span>:</td><td class="text-right">{{vm.order.header.delivery.deliveryTo.gln}}</td></tr><tr><td data-translate="eDocumentsApp.document.detail.deliveryDate">Data:</td><td class="text-right">{{vm.order.header.delivery.latestAcceptableDate}}</td></tr></tbody></table></div></div></div><div class="col-md-5 col-sm-12" ng-if="vm.order.header.totalAmount"><p class="lead" data-translate="eDocumentsApp.document.detail.totals">Totais</p><div class="table-responsive"><table class="table"><tbody><tr><td class="text-bold-800" colspan="2" data-translate="eDocumentsApp.document.detail.total">Total</td><td class="text-bold-800 text-right">{{vm.order.header.totalAmount | currency: vm.getCurrency(vm.order.header.currencyCode) :2}}</td></tr></tbody></table></div></div></div></div><div id="order-footer"><div class="row"><div class="col-md-12 col-sm-12 text-center"><button class="btn btn-primary btn-sm" uib-tooltip="{{ \'eDocumentsApp.document.message.downloaded\' | translate:{filename: vm.getViewableFilename(file.filename), sizeString: vm.formatFileSize(file.size), numberOfDownloads: vm.downloaded(file.id)} }}" ng-click="vm.download($event, file.id,file.fileType)" ng-repeat="file in vm.document.files"><span class="fa-layers fa-fw"><i class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></i> <span class="fa-layers-counter fa-2x bg-dark" ng-show="vm.downloaded(file.id ) > 0" style="top: -5px; right: -1px">{{vm.downloaded(file.id)}}</span> </span><span class="d-inline d-md-none ml-1">{{vm.getViewableFilename(file.filename)}}</span></button></div></div></div></div><!-- Despatch advice preview (EDOCS-662): supplier, buyer, lines and their pallets --><div ng-if="vm.document.documentType == \'DESPATCHADVICE\'" id="despatch-advice-template" class="card-body"><p class="watermark" data-translate="eDocumentsApp.document.detail.preview">Pr\xE9-visualiza\xE7\xE3o</p><div id="despatch-advice-company-details" class="row"><div class="col-md-6 col-sm-12 text-center text-md-left"><div class="media mb-3"><div class="media-body"><p class="text-muted mb-1" data-translate="eDocumentsApp.document.detail.despatchAdvice.supplier">Fornecedor</p><ul class="ml-2 px-0 list-unstyled" ng-if="vm.despatchAdvice.supplier"><li class="text-bold-800">{{vm.despatchAdvice.supplier.name}}</li><li ng-repeat="text in vm.despatchAdvice.supplier.lines">{{text}}</li><li ng-repeat="id in vm.despatchAdvice.supplier.identifiers"><span class="text-muted"><span ng-if="id.label.key" data-translate="{{id.label.key}}"></span><span ng-if="!id.label.key">{{id.label.text}}</span>:</span> {{id.value}}</li></ul></div></div></div><div class="col-md-6 col-sm-12"><div class="text-md-right mb-4"><h2 class="badge badge-{{vm.document.documentType}}" data-translate="{{ \'eDocumentsApp.DocumentType.\' + vm.document.documentType }}">{{vm.document.documentType}}</h2><p class="mb-1"><span class="text-muted" data-translate="eDocumentsApp.document.detail.despatchAdvice.number">N.\xBA:</span> {{vm.despatchAdvice.number}} <span ng-if="vm.despatchAdvice.statusType && vm.despatchAdvice.statusType != \'Original\'" class="badge badge-warning ml-1" data-translate="{{ \'eDocumentsApp.document.detail.despatchAdvice.statusType.\' + vm.despatchAdvice.statusType }}">{{vm.despatchAdvice.statusType}}</span></p><p class="mb-1"><span class="text-muted" data-translate="eDocumentsApp.document.detail.documentDate">Data do Documento:</span> {{vm.despatchAdvice.date | date:\'mediumDate\'}} <span ng-if="vm.despatchAdvice.time">{{vm.despatchAdvice.time | limitTo:5}}</span></p><p class="mb-1" ng-if="vm.despatchAdvice.despatchDate"><span class="text-muted" data-translate="eDocumentsApp.document.detail.despatchAdvice.despatchDate">Data de expedi\xE7\xE3o:</span> {{vm.despatchAdvice.despatchDate | date:\'mediumDate\'}}</p><p class="mb-1" ng-if="vm.despatchAdvice.estimatedDeliveryDate"><span class="text-muted" data-translate="eDocumentsApp.document.detail.despatchAdvice.estimatedDeliveryDate">Entrega prevista:</span> {{vm.despatchAdvice.estimatedDeliveryDate | date:\'mediumDate\'}}</p></div><div class="d-flex justify-content-center"><div><p class="text-muted mb-1" data-translate="eDocumentsApp.document.detail.despatchAdvice.buyer">Cliente</p><ul class="px-0 list-unstyled" ng-if="vm.despatchAdvice.buyer"><li class="text-bold-800">{{vm.despatchAdvice.buyer.name}}</li><li ng-repeat="text in vm.despatchAdvice.buyer.lines">{{text}}</li><li ng-repeat="id in vm.despatchAdvice.buyer.identifiers"><span class="text-muted"><span ng-if="id.label.key" data-translate="{{id.label.key}}"></span><span ng-if="!id.label.key">{{id.label.text}}</span>:</span> {{id.value}}</li></ul></div></div></div></div><!-- Despatch advice lines, each with its pallets underneath (as an invoice line shows its lots) --><div id="despatch-advice-items-details" class="pt-2"><div class="row"><div class="table-responsive col-sm-12"><table class="table table-sm"><thead><tr><th>#</th><th data-translate="eDocumentsApp.document.detail.despatchAdvice.purchaseOrder">Encomenda</th><th data-translate="eDocumentsApp.document.detail.item">Item</th><th data-translate="eDocumentsApp.document.detail.despatchAdvice.references">Refer\xEAncias</th><th class="text-right" data-translate="eDocumentsApp.document.detail.despatchAdvice.pallets">Paletes</th></tr></thead><tbody><tr ng-repeat-start="line in vm.despatchAdvice.lines"><td>{{line.lineNumber}}</td><td><span class="font-weight-bold">{{line.purchaseOrderNumber}}</span> <span ng-if="line.purchaseOrderLineItemNumber" class="text-muted">/ {{line.purchaseOrderLineItemNumber}}</span></td><td><div ng-if="line.description" class="font-weight-bold">{{line.description}}</div><div ng-repeat="product in line.products"><span class="text-muted"><span ng-if="product.label.key" data-translate="{{product.label.key}}"></span><span ng-if="!product.label.key">{{product.label.text}}</span><span ng-if="product.label.agency"> (<span ng-if="product.label.agency.key" data-translate="{{product.label.agency.key}}"></span><span ng-if="!product.label.agency.key">{{product.label.agency.text}}</span>)</span>:</span> {{product.value}}</div></td><td><div ng-repeat="reference in line.references"><span class="text-muted"><span ng-if="reference.label.key" data-translate="{{reference.label.key}}"></span><span ng-if="!reference.label.key">{{reference.label.text}}</span>:</span> {{reference.value}}</div></td><td class="text-right">{{line.pallets.length}}</td></tr><tr ng-repeat="instance in line.itemInstances" style="font-size: 0.85rem"><td style="border-top: 0; padding-top: 0" colspan="2"></td><td style="border-top: 0; padding-top: 0"><strong data-translate="eDocumentsApp.document.detail.lot">Lote</strong>&nbsp;{{instance.batchNumber}} <span ng-if="instance.expiryDate">&nbsp;<strong data-translate="eDocumentsApp.document.detail.expiry">Val.</strong>&nbsp;{{instance.expiryDate | date:\'dd/MM/yyyy\'}}</span></td><td style="border-top: 0; padding-top: 0" colspan="2">{{instance.serialNumbers.join(\', \')}}</td></tr><tr ng-repeat-end ng-repeat="pallet in line.pallets" class="despatch-advice-pallet" style="font-size: 0.85rem"><td style="border-top: 0; padding-top: 0"></td><td style="border-top: 0; padding-top: 0" class="text-muted"><i class="fas fa-pallet" aria-hidden="true"></i>&nbsp;<span ng-if="pallet.type.key" data-translate="{{pallet.type.key}}"></span><span ng-if="!pallet.type.key">{{pallet.type.text}}</span></td><td style="border-top: 0; padding-top: 0"><div ng-if="pallet.sscc"><strong data-translate="eDocumentsApp.document.detail.despatchAdvice.sscc">SSCC</strong>&nbsp;{{pallet.sscc}}</div><div ng-if="pallet.uic14"><strong data-translate="eDocumentsApp.document.detail.despatchAdvice.uic14">UIC14</strong>&nbsp;{{pallet.uic14}}</div></td><td style="border-top: 0; padding-top: 0"><span ng-repeat="quantity in pallet.quantities" class="mr-2"><strong><span ng-if="quantity.label.key" data-translate="{{quantity.label.key}}"></span><span ng-if="!quantity.label.key">{{quantity.label.text}}</span></strong>&nbsp;{{quantity.value | number}}&nbsp;{{quantity.uom}}</span></td><td style="border-top: 0; padding-top: 0" class="text-right"><span ng-if="pallet.itemCount"><strong data-translate="eDocumentsApp.document.detail.quantityShort">Qtd.</strong>&nbsp;{{pallet.itemCount.value | number}}&nbsp;{{pallet.itemCount.uom}}</span></td></tr></tbody></table></div></div><div class="row"><div class="col-md-7 col-sm-12 text-center text-md-left" ng-if="vm.despatchAdvice.shipTo || vm.despatchAdvice.references.length"><p class="lead" data-translate="eDocumentsApp.document.detail.deliveryPlace.title">Local de Entrega</p><ul class="px-0 list-unstyled" ng-if="vm.despatchAdvice.shipTo"><li class="text-bold-800">{{vm.despatchAdvice.shipTo.name}}</li><li ng-repeat="text in vm.despatchAdvice.shipTo.lines">{{text}}</li><li ng-repeat="id in vm.despatchAdvice.shipTo.identifiers"><span class="text-muted"><span ng-if="id.label.key" data-translate="{{id.label.key}}"></span><span ng-if="!id.label.key">{{id.label.text}}</span>:</span> {{id.value}}</li></ul><p class="mb-1" ng-if="vm.despatchAdvice.carrier"><span class="text-muted" data-translate="eDocumentsApp.document.detail.despatchAdvice.carrier">Transportador:</span> {{vm.despatchAdvice.carrier.name}}</p><p class="mb-1" ng-if="vm.despatchAdvice.transport.meansIdentifier"><span class="text-muted" data-translate="eDocumentsApp.document.detail.despatchAdvice.vehicle">Ve\xEDculo:</span> {{vm.despatchAdvice.transport.meansIdentifier}}</p><p class="mb-1" ng-repeat="reference in vm.despatchAdvice.references"><span class="text-muted"><span ng-if="reference.label.key" data-translate="{{reference.label.key}}"></span><span ng-if="!reference.label.key">{{reference.label.text}}</span>:</span> {{reference.value}}</p></div><div class="col-md-5 col-sm-12"><p class="lead" data-translate="eDocumentsApp.document.detail.totals">Totais</p><div class="table-responsive"><table class="table"><tbody><tr><td data-translate="eDocumentsApp.document.detail.despatchAdvice.lines">Linhas</td><td class="text-right">{{vm.despatchAdvice.totals.lines}}</td></tr><tr><td data-translate="eDocumentsApp.document.detail.despatchAdvice.pallets">Paletes</td><td class="text-right">{{vm.despatchAdvice.totals.pallets}}</td></tr><tr ng-repeat="total in vm.despatchAdvice.totals.items"><td data-translate="eDocumentsApp.document.detail.quantity">Quantidade</td><td class="text-right">{{total.value | number}}&nbsp;{{total.uom}} <span ng-if="total.partial" class="text-muted small" data-translate="eDocumentsApp.document.detail.despatchAdvice.partialTotal" translate-values="{n: total.partial.n, total: total.partial.total}"></span></td></tr><tr ng-repeat="total in vm.despatchAdvice.totals.net"><td data-translate="eDocumentsApp.document.detail.despatchAdvice.quantityType.NetWeight">Peso l\xEDquido</td><td class="text-right">{{total.value | number}}&nbsp;{{total.uom}} <span ng-if="total.partial" class="text-muted small" data-translate="eDocumentsApp.document.detail.despatchAdvice.partialTotal" translate-values="{n: total.partial.n, total: total.partial.total}"></span></td></tr><tr ng-repeat="total in vm.despatchAdvice.totals.gross"><td class="text-bold-800" data-translate="eDocumentsApp.document.detail.despatchAdvice.quantityType.GrossWeight">Peso bruto</td><td class="text-bold-800 text-right">{{total.value | number}}&nbsp;{{total.uom}} <span ng-if="total.partial" class="text-muted small" data-translate="eDocumentsApp.document.detail.despatchAdvice.partialTotal" translate-values="{n: total.partial.n, total: total.partial.total}"></span></td></tr></tbody></table></div></div></div></div><div id="despatch-advice-footer"><div class="row"><div class="col-md-12 col-sm-12 text-center"><button class="btn btn-primary btn-sm" uib-tooltip="{{ \'eDocumentsApp.document.message.downloaded\' | translate:{filename: vm.getViewableFilename(file.filename), sizeString: vm.formatFileSize(file.size), numberOfDownloads: vm.downloaded(file.id)} }}" ng-click="vm.download($event, file.id,file.fileType)" ng-repeat="file in vm.document.files"><span class="fa-layers fa-fw"><i class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></i> <span class="fa-layers-counter fa-2x bg-dark" ng-show="vm.downloaded(file.id ) > 0" style="top: -5px; right: -1px">{{vm.downloaded(file.id)}}</span> </span><span class="d-inline d-md-none ml-1">{{vm.getViewableFilename(file.filename)}}</span></button></div></div></div></div></section></div><div class="col-lg-4 col-sm-12"><h2><span data-translate="eDocumentsApp.document.detail.integrationStatus">Estado da integra\xE7\xE3o</span> <span uib-tooltip="{{\'eDocumentsApp.DocumentStatus.\' + vm.document.status | translate}}" class="btn bg-{{vm.document.status}} float-right mr-3 mt-2"></span> <span ng-if="vm.document.status === \'WAITING\'" class="fa-layers fa-fw text-secondary" uib-tooltip="{{\'eDocumentsApp.document.message.waitingForAction\' | translate}}"><em class="fas fa-exclamation-circle fa-fw"></em></span></h2><hr><div class="container document-timeline-container"><div class="row" ng-repeat="(key, step) in vm.currentWorkflow"><div class="col-auto text-center flex-column d-none d-sm-flex"><div class="row h-50"><div class="col">&nbsp;</div><div class="col">&nbsp;</div></div><h5 class="m-2"><span class="badge badge-pill border bg-{{step.status}}">{{step.order}}</span></h5><div class="row h-50"><div class="col border-right">&nbsp;</div><div class="col">&nbsp;</div></div></div><!-- timeline item 1 event content --><div class="col py-2"><div class="card bg-{{step.status}}" ng-class="{\'bg-dark\': !step.status}"><div class="card-body p-3"><div class="row mb-2"><div class="col-10"><h4 class="card-title text-white" style="font-size: 15px;display: inline"><span>{{step.description}}</span> <small ng-if="step.executionTime.value && step.previousStatus == \'SUCCESS\' && !step.status">{{\'eDocumentsApp.document.detail.scheduledFor\' | translate}} {{step.executionTime.value}}</small></h4></div><div class="col-2 p-0 pr-2 text-right" style="font-size:12px" ng-if="step.status && step.status === \'SUCCESS\'"><span uib-tooltip="{{\'messages.\' + step.code | translate}}" tooltip-placement="top-right" tooltip-append-to-body="true"><em class="far fa-comment fa-fw"></em></span> <span has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" uib-tooltip="{{step.message}}" tooltip-placement="top-right" tooltip-append-to-body="true"><em class="fa fa-plus-circle fa-fw"></em></span></div></div><p class="text-white" style="font-size: 10px;margin-bottom: 0" ng-if="step.time"><em class="far fa-clock fa-fw"></em>&nbsp;{{step.time | date: \'dd/MM/yyyy HH:mm:ss\'}} <span ng-click="vm.redoStep(step)" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ng-if="vm.canAdminRedoStep(step)" uib-tooltip="{{\'eDocumentsApp.document.detail.resend.button\' | translate}}" tooltip-placement="top-right" tooltip-append-to-body="true" class="float-right" style="cursor: pointer; font-size: 10px"><em class="fas fa-redo"></em> </span><span ng-click="vm.redoStep(step)" ng-if="vm.canRedoStep(step)" uib-tooltip="{{\'eDocumentsApp.document.detail.resend.button\' | translate}}" tooltip-append-to-body="true" class="float-right" style="cursor: pointer; font-size: 10px"><em class="fas fa-redo"></em></span></p><p class="text-white" style="font-size: 10px;margin-bottom: 0" ng-if="!step.time || step.time === null"><span ng-click="vm.doStep(step)" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ng-if="vm.canAdminDoStep(step)" uib-tooltip="{{\'eDocumentsApp.document.detail.execute.button\' | translate}}" tooltip-append-to-body="true" class="float-right" style="cursor: pointer; font-size: 16px"><em class="fas fa-play"></em> </span><span ng-click="vm.doStep(step)" ng-if="vm.canDoStep(step)" uib-tooltip="{{\'eDocumentsApp.document.detail.execute.button\' | translate}}" tooltip-append-to-body="true" class="float-right" style="cursor: pointer; font-size: 16px"><em class="fas fa-play"></em></span></p><p class="text-white card-text" ng-if="!step.time && step.executionType!==\'MANUAL\'" style="font-size: 12px"><em class="far fa-comment fa-fw"></em>&nbsp;<span data-translate="eDocumentsApp.document.toBeExecuted">Por Executar</span></p><p ng-if="step.status && step.status !== \'SUCCESS\' && step.code" class="text-white card-text mt-3" style="font-size: 12px"><em class="far fa-comment fa-fw"></em>&nbsp;{{\'messages.\' + step.code | translate}} <span has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" uib-tooltip="{{step.message}}" tooltip-append-to-body="true"><em class="fa fa-plus-circle"></em></span></p><p class="text-white card-text" ng-if="!step.code && step.message" style="font-size: 12px"><em class="far fa-comment fa-fw"></em>&nbsp;{{step.message}}</p></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/document/documents.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.document.home.title">Documents</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-sm" ng-if="vm.searchVisible != true" ng-click="vm.searchVisible = !vm.searchVisible" ng-class="{\'btn-primary\':  !vm.searchVisible, \'btn-warning\' :vm.searchVisible}"><em class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></em> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.search">Pesquisar</span></span></button><!-- TODO RFERNANDES --><!--                    <button class="btn btn-sm btn-warning ml-1" ng-if="vm.searchVisible != true"--><!--                            ng-click="vm.viewFavoriteSearches()">--><!--                        <i class="fas fa-star"></i>&nbsp;<span class="d-none d-sm-inline-block" data-translate="global.favourites">Favoritos</span>--><!--                    </button>--> <button class="btn btn-sm btn-dark ml-2" ng-if="vm.searchVisible != true && vm.isSearchActive()" ng-click="vm.reset()"><em class="fas fa-trash-alt"></em> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.clear">Limpar</span></span></button></form></div></div></div><div class="card text-white bg-primary mb-3" ng-if="vm.searchVisible == true"><div class="card-header pb-2 pt-2"><span data-translate="entity.action.search">Pesquisar</span> <button class="btn btn-sm btn-secondary float-right" ng-click="vm.searchVisible = !vm.searchVisible"><em class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></em>&nbsp;<span class="d-none d-sm-inline-block" data-translate="entity.action.hide"></span></button></div><div class="card-body bg-white text-primary"><form><div class="form-row"><div class="form-group col-sm-12 col-md-12 col-lg-3"><label data-translate="eDocumentsApp.document.documentNumber">Document Number</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.documentNumber.value"></div><div class="form-group col-sm-12 col-md-12 col-lg-9"><label data-translate="eDocumentsApp.document.documentType">Document Type</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons" ng-class="{\'btn-group-vertical\': vm.width < 660}"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentType.value == null || vm.filters.filterBy.documentType.value == undefined}" ng-click="vm.changeDocumentType(undefined)"><input type="radio" name="options" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.documentType.all">Todos</span></label><label ng-repeat="type in vm.types" class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentType.value == type}" ng-click="vm.changeDocumentType(type)"><input type="radio" name="options" autocomplete="off"> <span>{{\'eDocumentsApp.DocumentType.\' + type | translate}}</span></label></div></div><div class="form-group col-sm-12 col-md-12 col-lg-3"><label data-translate="eDocumentsApp.document.search.viewingType">Viewing Type</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentViews.value == null || vm.filters.filterBy.documentViews.value == undefined}" ng-click="vm.changeVisualization(undefined)"><input type="radio" name="options" id="option1" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.visualization.all">Todos</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentViews.value == \'1\'}" ng-click="vm.changeVisualization(\'1\')"><input type="radio" name="options" id="option2" autocomplete="off"> <em class="fas fa-check"></em> <span data-translate="eDocumentsApp.document.options.visualization.seen">Vistos</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentViews.value == \'0\'}" ng-click="vm.changeVisualization(\'0\')"><input type="radio" name="options" id="option3" autocomplete="off"> <span class="fa-layers fa-fw text-secondary"><em class="fas fa-certificate fa-fw"></em> <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-11.5 rotate--30" style="font-weight: 900">{{ \'eDocumentsApp.document.options.visualization.new\' | translate }}</span></span> <span data-translate="eDocumentsApp.document.options.visualization.multipleNew">Novos</span></label></div></div><div class="form-group col-sm-12 col-md-12 col-lg-9"><label data-translate="eDocumentsApp.document.status">Status</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons" ng-class="{\'btn-group-vertical\': vm.width < 660}"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.status.value == null || vm.filters.filterBy.status.value == undefined}" ng-click="vm.changeStatus(undefined)"><input type="radio" name="options" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.status.all">Todos</span></label><label ng-repeat="state in vm.states" class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.status.value == state}" ng-click="vm.changeStatus(state)"><input type="radio" name="options" autocomplete="off"> <span>{{\'eDocumentsApp.DocumentStatus.\' + state | translate}}</span></label></div></div><div class="form-group col-sm-12 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.search.files">Files</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == null || vm.filters.filterBy.documentFiles.value == undefined}" ng-click="vm.changeFiles(undefined)"><input type="radio" name="options" id="optionAll" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.files.all">Todos</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == \'1\'}" ng-click="vm.changeFiles(\'1\')"><input type="radio" name="options" id="optionYes" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.files.yes">Yes</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == \'0\'}" ng-click="vm.changeFiles(\'0\')"><input type="radio" name="options" id="optionNo" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.files.no">No</span></label></div></div><!-- Combined search fields for USER and MANAGER --><div has-any-authority="ROLE_USER, ROLE_MANAGER" class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.name">Entity Name</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.entityName.value"></div><div has-any-authority="ROLE_USER, ROLE_MANAGER" class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.vatRegistrationNumber">Entity VAT Number</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.entityVatRegistrationNumber.value"></div><!-- Search fields for SUPERADMIN, ADMIN, and PARTNER --><div has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="form-group col-sm-6 col-md-3 col-lg-3"><label data-translate="eDocumentsApp.document.origin.name">Origin Name</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.originName.value"></div><div has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="form-group col-sm-6 col-md-3 col-lg-3"><label data-translate="eDocumentsApp.document.destination.name">Destination Name</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.destinationName.value"></div><div has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="form-group col-sm-6 col-md-3 col-lg-3"><label data-translate="eDocumentsApp.document.origin.vatRegistrationNumber">Origin VAT Number</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.originVatRegistrationNumber.value"></div><div has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="form-group col-sm-6 col-md-3 col-lg-3"><label data-translate="eDocumentsApp.document.destination.vatRegistrationNumber">Destination VAT Number</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.destinationVatRegistrationNumber.value"></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.createdDate">Created Date</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.from">De</span></div><input ng-model="vm.startDateForCreatedDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.createdDate.startDate" locale="pt" format="DD/MM/YYYY HH:[00]" max-view="day" start-view="month" today="false"><div class="input-group-append" ng-if="vm.startDateForCreatedDate != null"><button class="input-group-text btn btn-outline-default" type="button" ng-click="vm.clearInputDate(\'startDateForCreatedDate\')"><em class="fas fa-times"></em></button></div></div><br><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.to">A</span></div><input ng-model="vm.endDateForCreatedDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.createdDate.endDate" locale="pt" format="DD/MM/YYYY HH:[00]" max-view="day" start-view="month" today="true"><div class="input-group-append" ng-if="vm.endDateForCreatedDate != null"><button class="input-group-text btn btn-outline-default" type="button" ng-click="vm.clearInputDate(\'endDateForCreatedDate\')"><em class="fas fa-times"></em></button></div></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.documentDate">Document Date</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.from">De</span></div><input ng-model="vm.startDateForDocumentDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.documentDate.startDate" locale="pt" format="DD/MM/YYYY" max-view="day" start-view="month" today="true"><div class="input-group-append" ng-if="vm.startDateForDocumentDate != null"><button class="input-group-text btn btn-outline-default" type="button" ng-click="vm.clearInputDate(\'startDateForDocumentDate\')"><em class="fas fa-times"></em></button></div></div><br><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.to">A</span></div><input ng-model="vm.endDateForDocumentDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.documentDate.endDate" locale="pt" format="DD/MM/YYYY" max-view="day" start-view="month" today="true"><div class="input-group-append" ng-if="vm.endDateForDocumentDate != null"><button class="input-group-text btn btn-outline-default" type="button" ng-click="vm.clearInputDate(\'endDateForDocumentDate\')"><em class="fas fa-times"></em></button></div></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.documentValue">Document Value</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.from">De</span></div><input ng-model="vm.filters.filterBy.documentValue.startValue" type="number" class="form-control form-control-sm"></div><br><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.to">A&nbsp;</span></div><input ng-model="vm.filters.filterBy.documentValue.endValue" type="number" class="form-control form-control-sm"></div></div><div class="form-group d-sm-none d-md-block col-md-8 col-lg-8"></div><div class="form-group col-sm-6 col-md-12 col-lg-4 mb-0 align-self-center"><br><div class="btn-group col flex-btn-group-container p-0" role="group"><button class="btn btn-primary btn-sm col-sm-6" ng-click="vm.page = 1; vm.loadAll()"><em class="fas fa-search"></em> <span data-translate="entity.action.search">Pesquisar</span></button> <button class="btn btn-dark btn-sm col-sm-6" ng-if="vm.isSearchActive()" ng-click="vm.reset()"><em class="fas fa-trash-alt"></em> <span data-translate="entity.action.clear">Limpar</span></button></div></div></div></form></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm" aria-label="{{\'global.a11y.documentsTable\' | translate}}"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th class="d-xs-block d-sm-none"></th><th></th><th jh-sort-by="documentNumber"><span data-translate="eDocumentsApp.document.documentNumber">Document Number</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="createdDate"><span data-translate="eDocumentsApp.document.createdDate">Created Date</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="documentDate"><span data-translate="eDocumentsApp.document.documentDate">Document Date</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="documentType"><span data-translate="eDocumentsApp.document.documentType">Document Type</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="documentValue"><span data-translate="eDocumentsApp.document.documentValue">Document Value</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="originName"><span data-translate="eDocumentsApp.document.origin.label">Origin</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="destinationName"><span data-translate="eDocumentsApp.document.destination.label">Destination</span> <em class="fas sort fa-sort"></em></th><th><span data-translate="eDocumentsApp.document.documentFiles">documentFiles</span></th><th class="text-center"><div class="custom-control custom-checkbox" style="display: inline-block"><input class="custom-control-input" id="selectedAll" type="checkbox" name="selectedAll" ng-model="vm.selectedAll"><label ng-click="vm.selectAll()" class="custom-control-label" for="selectedAll">&nbsp;</label></div><button type="button" class="btn btn-sm btn-primary" ng-show="vm.getTotalSelected() > 0" ng-click="vm.viewSelectedDocuments()"><em class="far fa-eye"></em> <span style="font-size: 100%" class="badge badge-primary d-none d-sm-inline-block">{{vm.getTotalSelected()}}</span></button></th><th class="text-right"><div class="btn-group"><button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><em class="fas fa-file-export"></em> <span data-translate="entity.action.export">Export</span></button><div class="dropdown-menu"><h6 class="dropdown-header"><span data-translate="eDocumentsApp.document.export.selected.title">Selected</span></h6><a class="dropdown-item" href="#" ng-click="vm.exportSelectedDocsToExcel()"><em class="fas fa-file-excel fa-lg"></em> <span data-translate="eDocumentsApp.document.export.selected.xls">Export documents in xls</span></a> <a class="dropdown-item" href="#" ng-click="vm.exportSelectedDocsToCSV()"><em class="fas fa-file-csv fa-lg"></em> <span data-translate="eDocumentsApp.document.export.selected.csv">Export documents in csv</span></a> <a class="dropdown-item" href="#" ng-click="vm.exportDocumentsFiles()"><em class="fas fa-file-archive fa-lg"></em> <span data-translate="eDocumentsApp.document.export.selected.files">Export files</span></a><h6 class="dropdown-header"><span data-translate="eDocumentsApp.document.export.search.title">Search</span></h6><a class="dropdown-item" href="#" ng-click="vm.exportAllDocsAsCSV()"><em class="fas fa-file-csv fa-lg"></em> <span data-translate="eDocumentsApp.document.export.search.csv">Export all in csv</span></a></div></div></th></tr></thead><tbody><tr><td colspan="11"><div class="alert alert-warning" ng-if="!vm.documents || vm.documents.length === 0"><span data-translate="entity.no-results">No results</span></div></td></tr><tr ng-repeat="document in vm.documents track by document.id"><td class="d-xs-block d-sm-none"><div class="btn-group flex-btn-group-container"><a ui-sref="document-detail({id:document.id})" class="btn btn-info btn-sm"><em class="far fa-eye"></em></a></div></td><td><span ng-if="!document.hasViews" class="fa-layers fa-fw text-secondary"><em class="fas fa-certificate fa-fw"></em> <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-11.5 rotate--30" style="font-weight: 900">{{ \'eDocumentsApp.document.options.visualization.new\' | translate }}</span> </span><span ng-if="document.hasViews"><em class="fas fa-fw" style="visibility: hidden"></em> </span><span uib-tooltip="{{\'eDocumentsApp.DocumentStatus.\' + document.status | translate}}" class="btn bg-{{document.status}}"></span> <span ng-if="document.status === \'WAITING\'" class="fa-layers fa-fw text-secondary" uib-tooltip="{{\'eDocumentsApp.document.message.waitingForAction\' | translate}}"><em class="fas fa-exclamation-circle fa-fw"></em></span></td><td>{{document.documentNumber}}</td><td>{{document.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{document.documentDate | date:\'dd/MM/yyyy\'}}</td><td><span class="badge badge-{{document.documentType}}">{{\'eDocumentsApp.DocumentType.\' + document.documentType | translate}}</span> <span ng-if="(document.documentType == \'SELFBILLED\' || document.documentType == \'CREDITNOTE\') && document.approved" uib-tooltip="{{ \'eDocumentsApp.document.approve.tooltip\' | translate:document }}"><em class="fas fa-check text-success"></em></span></td><td class="text-right nowrap">{{document.documentValue | currency: vm.getCurrency(document.currency) :2}}</td><td>{{document.originName}}</td><td>{{document.destinationName}}</td><td ng-if="!document.hasFiles"><td ng-if="document.hasFiles"><span style="color: #0071ff; cursor: pointer; outline: none" ng-repeat="file in document.files | orderBy : \'fileType\'" ng-click="vm.download($event,document, file.id, file.fileType)" class="fa-layers fa-fw" uib-tooltip="{{ \'eDocumentsApp.document.message.downloaded\' | translate:{filename: vm.getViewableFilename(file.filename), sizeString: vm.formatFileSize(file.size), numberOfDownloads: file.numberOfDownloads || 0} }}"><em class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></em> <span class="fa-layers-counter fa-2x bg-dark" ng-show="file.numberOfDownloads > 0" style="top: -5px; right: -1px">{{file.numberOfDownloads}}</span></span></td><td class="text-center"><div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" name="selected" ng-disabled="vm.readOnly === true" id="selected{{document.id}}" ng-change="vm.selectChange(document)" ng-model="document.selected"><label class="custom-control-label" ng-click="vm.deselectOne();" for="selected{{document.id}}"></label></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="document-detail({id:document.id})" class="btn btn-info btn-sm d-none d-sm-block"><em class="far fa-eye"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.view"></span> </a><a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="document.delete({id:document.id})" class="btn btn-danger btn-sm"><em class="fas fa-trash-alt"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.delete"></span></a></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.documents.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-click="vm.loadAll()"></div></div></div>');
$templateCache.put('app/entities/document/export-all-documents-error-dialog.html','<form name="selectedDocuments"><div class="modal-header"><h5 class="modal-title"><span data-translate="eDocumentsApp.document.exportAllError.title">N\xE3o foi poss\xEDvel exportar todos os documentos</span></h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p data-translate="eDocumentsApp.document.exportAllError.body" data-translate-values="{count: vm.numberOfDocuments, limit: 15000}">N\xE3o foi poss\xEDvel exportar todos devido ao excesso de documentos.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="glyphicon glyphicon-ban-circle"></i>&nbsp;<span data-translate="entity.action.close">Close</span></button></div></form>');
$templateCache.put('app/entities/document/favorite-searches-dialog.html','<form name="selectedDocuments"><div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.document.favoriteSearches.title">Confirm approve operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><uib-tabset type="pills" active="vm.active"><uib-tab ng-repeat="tab in vm.favoriteSearches" select="vm.tabSelected(tab)" index="tab.id"><uib-tab-heading><i class="fas fa-star"></i> {{tab.name}}</uib-tab-heading><div ng-include="\'search.html\'"></div></uib-tab><uib-tab classes="btn btn-success" select="vm.addTab()" index="-1"><uib-tab-heading><i class="far fa-plus-square"></i> <span class="hidden-xs-down">{{\'entity.action.add\' | translate}}</span></uib-tab-heading><div ng-include="\'search.html\'"></div></uib-tab></uib-tabset></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.close">Close</span></button></div><div class="float-right"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.apply()"><i class="fa fa-check"></i>&nbsp;<span data-translate="entity.action.apply">Apply</span></button></div></div></form><script type="text/ng-template" id="search.html"><div class=\'card text-white bg-primary mb-3\'>\n    <div class=\'card-body bg-white text-primary\'>\n      <form>\n        <div class=\'form-row\'>\n          <div class=\'form-group col-sm-4 col-lg-4\'>\n            <label data-translate=\'eDocumentsApp.document.documentNumber\'>Document Number</label>\n            <input class=\'form-control form-control-sm\' ng-model=\'vm.filters.filterBy.documentNumber.value\'>\n          </div>\n          <div class=\'form-group col-sm-8 col-lg-8\'>\n            <label data-translate=\'eDocumentsApp.document.documentType\'>Document Type</label>\n            <div class=\'btn-group btn-group-sm btn-group-toggle col p-0\' data-toggle=\'buttons\'>\n              <label class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.documentType.value == null || vm.filters.filterBy.documentType.value == undefined}"\n                     ng-click=\'vm.changeDocumentType(undefined)\'>\n                <input type=\'radio\' name=\'options\' autocomplete=\'off\'>\n                <span data-translate=\'eDocumentsApp.document.options.documentType.all\'>Todos</span>\n              </label>\n              <label ng-repeat=\'type in vm.types\' class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.documentType.value == type}"\n                     ng-click=\'vm.changeDocumentType(type)\'>\n                <input type=\'radio\' name=\'options\' autocomplete=\'off\'>\n                <span>{{\'eDocumentsApp.DocumentType.\' + type | translate}}</span>\n              </label>\n            </div>\n          </div>\n        </div>\n        <div class=\'form-row\'>\n          <div class=\'form-group col-sm-4 col-lg-4\'>\n            <label>Visualiza\xE7\xE3o</label>\n            <div class=\'btn-group btn-group-sm btn-group-toggle col p-0\' data-toggle=\'buttons\'>\n              <label class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.documentViews.value == null || vm.filters.filterBy.documentViews.value == undefined}"\n                     ng-click=\'vm.changeVisualization(undefined)\'>\n                <input type=\'radio\' name=\'options\' id=\'option1\' autocomplete=\'off\'>\n                <span data-translate=\'eDocumentsApp.document.options.visualization.all\'>Todos</span>\n              </label>\n              <label class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.documentViews.value == \'1\'}"\n                     ng-click="vm.changeVisualization(\'1\')">\n                <input type=\'radio\' name=\'options\' id=\'option2\' autocomplete=\'off\'>\n                <i class=\'fas fa-check\'></i>\n                <span data-translate=\'eDocumentsApp.document.options.visualization.seen\'>Vistos</span>\n              </label>\n              <label class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.documentViews.value == \'0\'}"\n                     ng-click="vm.changeVisualization(\'0\')">\n                <input type=\'radio\' name=\'options\' id=\'option3\' autocomplete=\'off\'>\n                <span class=\'fa-layers fa-fw text-secondary\'>\n                                    <i class=\'fas fa-certificate  fa-fw\'></i>\n                                    <span class=\'fa-layers-text fa-inverse\' data-fa-transform=\'shrink-11.5 rotate--30\'\n                                          style=\'font-weight:900\'>Novo</span>\n                                </span>\n                <span data-translate=\'eDocumentsApp.document.options.visualization.new\'>Novos</span>\n              </label>\n            </div>\n          </div>\n          <div class=\'form-group col-sm-8 col-lg-8\'>\n            <label data-translate=\'eDocumentsApp.document.status\'>Status</label>\n            <div class=\'btn-group btn-group-sm btn-group-toggle col p-0\' data-toggle=\'buttons\'>\n              <label class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': !vm.filters.filterBy.status.value}"\n                     ng-click=\'vm.changeStatus(undefined)\'>\n                <input type=\'radio\' name=\'options\' autocomplete=\'off\'>\n                <span data-translate=\'eDocumentsApp.document.options.status.all\'>Todos</span>\n              </label>\n              <label ng-repeat=\'state in vm.states\' class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.status.value == state}"\n                     ng-click=\'vm.changeStatus(state)\'>\n                <input type=\'radio\' name=\'options\' autocomplete=\'off\'>\n                <span>{{\'eDocumentsApp.DocumentStatus.\' + state | translate}}</span>\n              </label>\n            </div>\n          </div>\n\n        </div>\n        <div class=\'form-row\'>\n          <div class=\'form-group col-sm-4 col-lg-4\'>\n            <label>Ficheiros</label>\n            <div class=\'btn-group btn-group-sm btn-group-toggle col p-0\' data-toggle=\'buttons\'>\n              <label class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == null || vm.filters.filterBy.documentFiles.value == undefined}"\n                     ng-click=\'vm.changeFiles(undefined)\'>\n                <input type=\'radio\' name=\'options\' id=\'optionAll\' autocomplete=\'off\'>\n                <span data-translate=\'eDocumentsApp.document.options.files.all\'>Todos</span>\n              </label>\n              <label class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == \'1\'}"\n                     ng-click="vm.changeFiles(\'1\')">\n                <input type=\'radio\' name=\'options\' id=\'optionYes\' autocomplete=\'off\'>\n                <span data-translate=\'eDocumentsApp.document.options.files.yes\'>Yes</span>\n              </label>\n              <label class=\'btn btn-outline-primary col\'\n                     ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == \'0\'}"\n                     ng-click="vm.changeFiles(\'0\')">\n                <input type=\'radio\' name=\'options\' id=\'optionNo\' autocomplete=\'off\'>\n                <span data-translate=\'eDocumentsApp.document.options.files.no\'>No</span>\n              </label>\n            </div>\n          </div>\n          <div class=\'form-group col-sm-6 col-md-4 col-lg-4\'>\n            <label data-translate=\'eDocumentsApp.document.origin.label\'>Origin</label>\n            <input class=\'form-control form-control-sm\' ng-model=\'vm.filters.filterBy.origin.value\'>\n          </div>\n          <div class=\'form-group col-sm-6 col-md-4 col-lg-4\'>\n            <label data-translate=\'eDocumentsApp.document.destination.label\'>Destination</label>\n            <input class=\'form-control form-control-sm\' ng-model=\'vm.filters.filterBy.destination.value\'>\n\n          </div>\n        </div>\n\n        <div class=\'form-row\'>\n          <div class=\'form-group col-sm-6 col-md-4 col-lg-4\'>\n            <label data-translate=\'eDocumentsApp.document.createdDate\'>Created Date</label>\n            <div class=\'input-group input-group-sm\'>\n              <div class=\'input-group-prepend\'>\n                <span style=\'width: 30px;\' class=\'input-group-text bg-primary text-white\'>De</span>\n              </div>\n              <input ng-value=\'vm.filters.filterBy.createdDate.startDate\'\n                     moment-picker=\'vm.filters.filterBy.createdDate.startDate\' locale=\'pt\'\n                     format=\'DD/MM/YYYY HH:[00]\' max-view=\'day\'\n                     start-view=\'month\'\n                     today=\'false\'\n                     class=\'form-control form-control-sm\'>\n            </div>\n            <br>\n            <div class=\'input-group input-group-sm\'>\n              <div class=\'input-group-prepend\'>\n                <span style=\'width: 30px;\' class=\'input-group-text bg-primary text-white\'>A</span>\n              </div>\n              <input ng-value=\'vm.filters.filterBy.createdDate.endDate\'\n                     class=\'form-control form-control-sm\'\n                     moment-picker=\'vm.filters.filterBy.createdDate.endDate\'\n                     locale=\'pt\' format=\'DD/MM/YYYY HH:[00]\' max-view=\'day\' start-view=\'month\'\n                     today=\'true\'>\n            </div>\n          </div>\n          <div class=\'form-group col-sm-6 col-md-4 col-lg-4\'>\n            <label data-translate=\'eDocumentsApp.document.documentDate\'>Document Date</label>\n            <div class=\'input-group input-group-sm\'>\n              <div class=\'input-group-prepend\'>\n                <span style=\'width: 30px;\' class=\'input-group-text bg-primary text-white\'>De</span>\n              </div>\n              <input ng-value=\'vm.filters.filterBy.documentDate.startDate\'\n                     class=\'form-control form-control-sm\'\n                     moment-picker=\'vm.filters.filterBy.documentDate.startDate\' locale=\'pt\'\n                     format=\'DD/MM/YYYY\' max-view=\'day\' start-view=\'month\' today=\'true\'>\n            </div>\n            <br>\n            <div class=\'input-group input-group-sm\'>\n              <div class=\'input-group-prepend\'>\n                <span style=\'width: 30px;\' class=\'input-group-text bg-primary text-white\'>A</span>\n              </div>\n              <input ng-value=\'vm.filters.filterBy.documentDate.endDate\'\n                     class=\'form-control form-control-sm\'\n                     moment-picker=\'vm.filters.filterBy.documentDate.endDate\' locale=\'pt\'\n                     format=\'DD/MM/YYYY\' max-view=\'day\' start-view=\'month\' today=\'true\'>\n            </div>\n          </div>\n          <div class=\'form-group col-sm-6 col-md-4 col-lg-4\'>\n            <label data-translate=\'eDocumentsApp.document.documentValue\'>Document Value</label>\n            <div class=\'input-group input-group-sm\'>\n              <div class=\'input-group-prepend\'>\n                <span style=\'width: 30px;\' class=\'input-group-text bg-primary text-white\'>De</span>\n              </div>\n              <input ng-model=\'vm.filters.filterBy.documentValue.startValue\' type=\'number\'\n                     class=\'form-control form-control-sm\'>\n            </div>\n            <br>\n            <div class=\'input-group input-group-sm\'>\n              <div class=\'input-group-prepend\'>\n                <span style=\'width: 30px;\' class=\'input-group-text bg-primary text-white\'>A&nbsp;</span>\n              </div>\n              <input ng-model=\'vm.filters.filterBy.documentValue.endValue\' type=\'number\'\n                     class=\'form-control form-control-sm\'>\n            </div>\n          </div>\n        </div>\n        <div class=\'form-row\'>\n          <div class=\'form-group col-sm-6 col-md-6 col-lg-6 text-dark\'>\n            <label>Nome</label>\n            <input class=\'form-control form-control-sm\' ng-model=\'vm.name\'>\n          </div>\n          <div class=\'form-group col-sm-6 col-md-6 col-lg-6\'>\n            <label>&nbsp;</label><br>\n            <div class=\'btn-group col flex-btn-group-container\' role=\'group\'>\n              <button type=\'button\' class=\'btn btn-primary btn-sm col-sm-6\'\n                      ng-click=\'vm.saveChanges(tab)\'>\n                <i class=\'fas fa-save\'></i>&nbsp;<span data-translate=\'entity.action.save\'>Save</span>\n              </button>\n              <button type=\'button\' ng-if=\'tab\' class=\'btn btn-default btn-sm col-sm-6\'\n                      ng-click=\'vm.tabSelected(tab)\'>\n                <i class=\'fas fa-ban\'></i>&nbsp;\n                <span data-translate=\'entity.action.cancel\'>Cancel</span>\n              </button>\n              <button type=\'button\' class=\'btn btn-dark btn-sm col-sm-6\'\n                      ng-click=\'vm.reset()\'>\n                <i class=\'fas fa-trash-alt\'></i> <span data-translate=\'entity.action.clear\'>Limpar</span>\n              </button>\n              <button type=\'button\' ng-if=\'tab && tab.id\' autofocus class=\'btn btn-danger btn-sm col-sm-6\'\n                      ng-click=\'vm.deleteRecord(tab)\'>\n                <i class=\'fas fa-trash-alt\'></i>&nbsp;<span\n                data-translate=\'entity.action.delete\'>Delete</span>\n              </button>\n            </div>\n          </div>\n        </div>\n\n      </form>\n    </div>\n  </div></script>');
$templateCache.put('app/entities/document/order-detail.html','<div id="order-template" class="card-body"><p class="watermark" data-translate="eDocumentsApp.document.detail.preview">Pr\xE9-visualiza\xE7\xE3o</p><div id="order-company-details" class="row"><div class="col-md-6 col-sm-12 text-center text-md-left"><div class="media mb-5"><div class="media-body"><ul class="ml-2 px-0 list-unstyled"><li class="text-bold-800">{{vm.order.header.supplier.gln}}<span ng-if="vm.orderSupplier"> - {{vm.orderSupplier.name}}</span></li></ul></div></div><p><span class="text-muted"><span data-translate="eDocumentsApp.document.detail.paymentDate">Data de Pagamento</span>:</span> {{vm.order.header.orderDate | date:\'mediumDate\'}}</p></div><div class="col-md-6 col-sm-12"><div class="text-md-right mb-4"><h2 class="badge badge-{{vm.document.documentType}}" data-translate="{{\'eDocumentsApp.DocumentType.\' + vm.document.documentType}}">{{vm.document.documentType}}</h2><p><span class="text-muted" data-translate="eDocumentsApp.document.detail.documentDate">Data do Documento:</span> {{vm.order.header.orderDate | date:\'mediumDate\'}}</p></div><div class="d-flex justify-content-center"><div><ul class="px-0 list-unstyled"><li class="text-bold-800">{{vm.order.header.buyer.gln}}<span ng-if="vm.orderReceiver"> - {{vm.orderReceiver.name}}</span></li></ul></div></div></div></div><div id="order-customer-details" class="row pt-2 mb-2"><div class="col-md-6 col-sm-12 text-center text-md-left"></div><div class="col-md-4 col-md-offset-2 col-sm-12 text-md-left"></div></div><!--/ Order Customer Details --><!-- Order Items Details --><div id="order-items-details" class="pt-2"><div class="row"><div class="table-responsive col-sm-12"><table class="table table-sm"><thead><tr><th>#</th><th data-translate="eDocumentsApp.document.detail.item">Item</th><th class="text-right" data-translate="eDocumentsApp.document.detail.unitCost">Custo Unit\xE1rio</th><th class="text-right" data-translate="eDocumentsApp.document.detail.quantity">Quantidade</th><th class="text-right" data-translate="eDocumentsApp.document.detail.total">Total</th></tr></thead><tbody><tr ng-repeat="line in vm.order.lines |orderBy: lineNumber"><td>{{line.lineNumber}}</td><td class="font-weight-bold">{{line.suppliersProductCode}} - <span class="text-muted">{{line.productDescription}}</span></td><td class="text-right">{{line.netUnitPrice | currency: vm.getCurrency(vm.order.header.currencyCode) :2 }}</td><td class="text-right">{{line.quantity}}&nbsp;{{line.unitOfMeasure}}</td><td class="text-right">{{line.netUnitPrice * line.quantity | currency: vm.getCurrency(vm.order.header.currencyCode) :2}}</td></tr></tbody></table></div></div><div class="row"><div class="col-md-7 col-sm-12 text-center text-md-left"><p class="lead" ng-if="vm.order.header.delivery.deliveryTo" data-translate="eDocumentsApp.document.detail.deliveryLocation">Local de Entrega</p><div class="row"><div class="col-md-8"><table class="jh-table tabletable-borderless table-sm"><tbody><tr><td><span data-translate="eDocumentsApp.document.detail.gln">GLN</span>:</td><td class="text-right">{{vm.order.header.delivery.deliveryTo}}</td></tr><tr><td><span data-translate="eDocumentsApp.document.detail.date">Data</span>:</td><td class="text-right">{{vm.order.header.delivery.latestAcceptableDate}}</td></tr></tbody></table></div></div></div><div class="col-md-5 col-sm-12"><p class="lead" data-translate="eDocumentsApp.document.detail.totals">Totais</p><div class="table-responsive"><table class="table"><tbody><tr><td class="text-bold-800" colspan="2" data-translate="eDocumentsApp.document.detail.total">Total</td><td class="text-bold-800 text-right">{{vm.order.header.totalAmount | currency: vm.getCurrency(vm.order.header.currencyCode) :2}}</td></tr></tbody></table></div></div></div></div><div id="order-footer"><div class="row"><div class="col-md-12 col-sm-12 text-center"><button class="btn btn-primary btn-sm" uib-tooltip="{{ \'eDocumentsApp.document.message.downloaded\' | translate:{filename: vm.getViewableFilename(file.filename), sizeString: vm.formatFileSize(file.size), numberOfDownloads: vm.downloaded(file.id)} }}" ng-click="vm.download($event, file.id,file.fileType)" ng-repeat="file in vm.document.files"><span class="fa-layers fa-fw"><i class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></i> <span class="fa-layers-counter fa-2x bg-dark" ng-show="vm.downloaded(file.id ) > 0" style="top: -5px;right: -1px">{{vm.downloaded(file.id)}}</span></span></button></div></div></div></div>');
$templateCache.put('app/entities/document/selected-documents-dialog.html','<form name="selectedDocuments"><div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.document.showSelected.title">Confirm approve operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th></th><th><span data-translate="eDocumentsApp.document.documentNumber">Document Number</span></th><th><span data-translate="eDocumentsApp.document.createdDate">Created Date</span></th><th><span data-translate="eDocumentsApp.document.documentDate">Document Date</span></th><th><span data-translate="eDocumentsApp.document.documentType">Document Type</span></th><th><span data-translate="eDocumentsApp.document.documentValue">Document Value</span></th><th><span data-translate="eDocumentsApp.document.origin.label">Origin</span></th><th><span data-translate="eDocumentsApp.document.destination.label">Destination</span></th><th class="text-center"><div class="custom-control custom-checkbox" style="display: inline-block"><input class="custom-control-input" id="selectedAll" type="checkbox" name="selectedAll" ng-model="selectedAll"><label class="custom-control-label" ng-click="vm.deselectAll()" for="selectedAll"></label></div></th><th><div class="btn-group"><div class="btn-group"><button type="button" class="btn btn-sm dropdown-toggle" data-toggle="dropdown" id="dropdownMenuButtonExport" aria-haspopup="true" aria-expanded="false"><i class="fas fa-file-export"></i> <span data-translate="entity.action.export">Export</span></button><div class="dropdown-menu" aria-labelledby="dropdownMenuButtonExport"><h6 class="dropdown-header"><span data-translate="eDocumentsApp.document.export.selected.title">Selected</span></h6><a class="dropdown-item" href="#" ng-click="vm.exportSelectedDocsToExcelModal()"><i class="fas fa-file-excel fa-lg"></i> <span data-translate="eDocumentsApp.document.export.selected.xls">Export documents in xls</span></a> <a class="dropdown-item" href="#" ng-click="vm.exportSelectedDocsToCSVModal()"><i class="fas fa-file-csv fa-lg"></i> <span data-translate="eDocumentsApp.document.export.selected.csv">Export documents in csv</span></a> <a class="dropdown-item" href="#" ng-click="vm.exportDocumentsFilesModal()"><i class="fas fa-file-archive fa-lg"></i> <span data-translate="eDocumentsApp.document.export.selected.files">Export files</span></a></div></div><div class="btn-group"><button type="button" class="btn btn-sm dropdown-toggle" id="dropdownMenuButtonActions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="far fa-clipboard"></i> <span data-translate="entity.action.actions">A\xE7\xF5es</span></button><div class="dropdown-menu" aria-labelledby="dropdownMenuButtonActions"><h6 class="dropdown-header"><span data-translate="entity.action.actions">A\xE7\xF5es</span></h6><a has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="dropdown-item" href="#" ng-click="vm.delete()"><i class="fas fa-trash-alt"></i> <span data-translate="eDocumentsApp.document.actions.remove">Delete</span></a> <span class="dropdown-item"><button has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="dropdown-item" style="display: contents" href="#" ng-click="vm.resend()" ng-disabled="!vm.isAbleToResend()"><i class="fas fa-redo"></i> <span data-translate="eDocumentsApp.document.actions.resend">Resend</span></button> <span style="font-size: 12px" ng-if="!vm.isAbleToResend()" uib-tooltip="{{\'eDocumentsApp.document.message.actionNotAvailable\' | translate }}" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span> </span><span class="dropdown-item"><button has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="dropdown-item" style="display: contents" href="#" ng-click="vm.executeWaitingAction()" ng-disabled="!vm.isAbleToExecuteWaitingAction()"><i class="fas fa-play"></i> <span data-translate="eDocumentsApp.document.actions.executeStep">Execute</span></button> <span style="font-size: 12px" ng-if="!vm.isAbleToExecuteWaitingAction()" uib-tooltip="{{\'eDocumentsApp.document.message.actionNotAvailable\' | translate }}" tooltip-placement="bottom" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></span></div></div></div></th></tr></thead><tbody><tr ng-repeat="(key, document) in vm.documents track by document.id"><td><span ng-if="!document.documentViews || document.documentViews.length< 1" class="fa-layers fa-fw text-secondary"><i class="fas fa-certificate fa-fw"></i> <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-11.5 rotate--30" style="font-weight: 900" data-translate="global.new">Novo</span> </span><span ng-if="document.documentViews && document.documentViews.length >= 1"><i class="fas fa-fw" style="visibility: hidden"></i> </span><span uib-tooltip="{{\'eDocumentsApp.DocumentStatus.\' + document.status | translate}}" class="btn bg-{{document.status}}"></span></td><td>{{document.documentNumber}}</td><td>{{document.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{document.documentDate | date:\'dd/MM/yyyy\'}}</td><td><span class="badge badge-{{document.documentType}}">{{\'eDocumentsApp.DocumentType.\' + document.documentType | translate}}</span> <span ng-if="(document.documentType == \'SELFBILLED\' || document.documentType == \'CREDITNOTE\') && document.approved" uib-tooltip="{{ \'eDocumentsApp.document.approve.tooltip\' | translate:document }}"><i class="fas fa-check text-success"></i></span></td><td class="text-right nowrap">{{document.documentValue | currency: vm.getCurrency(document.currency) :2 }}</td><td>{{document.origin}}</td><td>{{document.destination}}</td><td></td><td><div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" name="selected" id="selected{{document.id}}" ng-change="vm.selectChangeModal(document)" ng-model="document.selected"><label class="custom-control-label" ng-click="vm.selectChangeModal();" for="selected{{document.id}}">&nbsp;</label></div></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="glyphicon glyphicon-ban-circle"></i>&nbsp;<span data-translate="entity.action.close">Close</span></button></div></form>');
$templateCache.put('app/entities/document-file/document-file-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documentFile.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.documentFile.delete.question" translate-values="{id: \'{{vm.documentFile.id}}\'}">Are you sure you want to delete this Document File?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/document-file/document-file-detail.html','<div class="container-fluid mt-3 mb-3"><h2><span data-translate="eDocumentsApp.documentFile.detail.title">Document File</span> {{vm.documentFile.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="jh-entity-details"><dt><span data-translate="eDocumentsApp.documentFile.filename">Filename</span></dt><dd><span>{{vm.documentFile.filename}}</span></dd><dt><span data-translate="eDocumentsApp.documentFile.path">Path</span></dt><dd><span>{{vm.documentFile.path}}</span></dd><dt><span data-translate="eDocumentsApp.documentFile.fileType">File Type</span></dt><dd><span data-translate="{{\'eDocumentsApp.FileType.\' + vm.documentFile.fileType}}">{{vm.documentFile.fileType}}</span></dd><dt><span data-translate="eDocumentsApp.documentFile.document">Document</span></dt><dd><a ui-sref="document-detail({id:vm.documentFile.documentId})">{{vm.documentFile.documentId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="document-file-detail.edit({id:vm.documentFile.id})" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" class="btn btn-primary"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/document-file/document-file-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h5 class="modal-title" id="myDocumentFileLabel" data-translate="eDocumentsApp.documentFile.home.createOrEditLabel">Create or edit a Document File</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documentFile.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control form-control-sm" id="id" name="id" ng-model="vm.documentFile.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.documentFile.filename" for="field_filename">Filename</label><input type="text" class="form-control form-control-sm" name="filename" id="field_filename" ng-model="vm.documentFile.filename" required ng-maxlength="255"><div ng-show="editForm.filename.$invalid"><p class="help-block" ng-show="editForm.filename.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.filename.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.documentFile.path" for="field_path">Path</label><input type="text" class="form-control form-control-sm" name="path" id="field_path" ng-model="vm.documentFile.path" required ng-maxlength="512"><div ng-show="editForm.path.$invalid"><p class="help-block" ng-show="editForm.path.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.path.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="512">This field cannot be longer than 512 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.documentFile.fileType" for="field_fileType">File Type</label><select class="form-control form-control-sm" name="fileType" ng-model="vm.documentFile.fileType" id="field_fileType" required><option value="PDF" data-translate="eDocumentsApp.FileType.PDF">PDF</option><option value="XLS" data-translate="eDocumentsApp.FileType.XLS">XLS</option><option value="XML" data-translate="eDocumentsApp.FileType.XML">XML</option></select><div ng-show="editForm.fileType.$invalid"><p class="help-block" ng-show="editForm.fileType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="eDocumentsApp.documentFile.document" for="field_document">Document</label><select class="form-control form-control-sm" id="field_document" name="document" ng-model="vm.documentFile.documentId" ng-options="document.id as document.id for document in vm.documents"><option value=""></option></select></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div><div class="float-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/document-file/document-files.html','<div></div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.documentFile.home.title">Document Files</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-success mx-2 mb-2" ui-sref="document-file.new"><i class="far fa-plus-square"></i> <span class="hidden-xs-down">{{\'entity.action.add\' | translate}}</span></button><div class="form-group mx-2 mb-2"><input type="text" class="form-control form-control-sm" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'entity.action.search\' | translate}}"></div><button class="btn btn-info mx-2 mb-2" ng-click="vm.search(vm.searchQuery)"><i class="fas fa-search"></i></button> <button class="btn btn-dark mx-2 mb-2" ng-if="vm.currentSearch" ng-click="vm.clear()"><i class="fas fa-trash-alt"></i></button></form></div></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="eDocumentsApp.documentFile.filename">Filename</span></th><th><span data-translate="eDocumentsApp.documentFile.path">Path</span></th><th><span data-translate="eDocumentsApp.documentFile.fileType">File Type</span></th><th><span data-translate="eDocumentsApp.documentFile.document">Document</span></th><th></th></tr></thead><tbody><tr ng-repeat="documentFile in vm.documentFiles track by documentFile.id"><td><a ui-sref="document-file-detail({id:documentFile.id})">{{documentFile.id}}</a></td><td>{{documentFile.filename}}</td><td>{{documentFile.path}}</td><td data-translate="{{\'eDocumentsApp.FileType.\' + documentFile.fileType}}">{{documentFile.fileType}}</td><td><a ui-sref="document-detail({id:documentFile.documentId})">{{documentFile.documentId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="document-file-detail({id:documentFile.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="document-file.edit({id:documentFile.id})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="document-file.delete({id:documentFile.id})" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div>');
$templateCache.put('app/entities/document-storage/document-storage-detail.html','<div class="container-fluid mt-3 mb-3"><!-- Loading state --><div ng-if="vm.loading" class="text-center py-5"><div class="spinner-border text-primary" role="status"><span class="sr-only" data-translate="global.loading">A carregar\u2026</span></div></div><!-- Empty state --><div ng-if="!vm.loading && (!vm.documentStorage || !vm.selectedTab)" class="text-center py-5"><i class="fas fa-inbox fa-3x text-muted mb-3"></i><p class="text-muted" data-translate="eDocumentsApp.documentStorage.noData">No data available for this document.</p><button type="button" ng-click="vm.goBack()" class="btn btn-info mt-2"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button></div><!-- Main content --><div ng-if="!vm.loading && vm.documentStorage && vm.selectedTab"><!-- Header --><div class="d-flex justify-content-between align-items-center mb-3"><div><h4 class="mb-1">{{vm.documentStorage.documentNumber}}</h4><small class="text-muted" ng-if="vm.documentStorage.originName || vm.documentStorage.destinationName"><span ng-if="vm.documentStorage.originName">{{vm.documentStorage.originName}}</span> <i ng-if="vm.documentStorage.originName && vm.documentStorage.destinationName" class="fas fa-arrow-right mx-1"></i> <span ng-if="vm.documentStorage.destinationName">{{vm.documentStorage.destinationName}}</span></small></div><div class="btn-group"><button type="button" ng-click="vm.goBack()" class="btn btn-info"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back">Back</span></button> <button type="button" ng-click="vm.copyToClipboard()" class="btn btn-outline-primary"><i class="fas fa-copy"></i>&nbsp;<span data-translate="eDocumentsApp.documentStorage.copy">Copy</span></button> <button type="button" ng-click="vm.download()" class="btn btn-primary"><i class="fas fa-file-download"></i>&nbsp;<span data-translate="entity.action.download">Download</span></button></div></div><!-- Tabs --><ul class="nav nav-tabs" role="tablist"><li class="nav-item" ng-if="vm.documentStorage.incomingString"><a class="nav-link" ng-class=\'{active: vm.selectedTab === "incomingString"}\' id="incomingString-tab" data-toggle="tab" data-target="#incomingString" role="tab" aria-controls="incomingString" ng-attr-aria-selected=\'{{vm.selectedTab === "incomingString"}}\' ng-click="vm.selected(\'incomingString\')"><i class="fas fa-sign-in-alt"></i>&nbsp; {{\'eDocumentsApp.documentStorage.incomingString\' | translate}}</a></li><li class="nav-item" ng-if="vm.documentStorage.typedString"><a class="nav-link" ng-class=\'{active: vm.selectedTab === "typedString"}\' id="typedString-tab" data-toggle="tab" data-target="#typedString" role="tab" aria-controls="typedString" ng-attr-aria-selected=\'{{vm.selectedTab === "typedString"}}\' ng-click="vm.selected(\'typedString\')"><i class="fas fa-exchange-alt"></i>&nbsp; {{\'eDocumentsApp.documentStorage.typedString\' | translate}}</a></li><li class="nav-item" ng-if="vm.documentStorage.outgoingString"><a class="nav-link" ng-class=\'{active: vm.selectedTab === "outgoingString"}\' id="outgoingString-tab" data-toggle="tab" data-target="#outgoingString" role="tab" aria-controls="outgoingString" ng-attr-aria-selected=\'{{vm.selectedTab === "outgoingString"}}\' ng-click="vm.selected(\'outgoingString\')"><i class="fas fa-sign-out-alt"></i>&nbsp; {{\'eDocumentsApp.documentStorage.outgoingString\' | translate}}</a></li><li class="nav-item" ng-if="vm.documentStorage.responseString"><a class="nav-link" ng-class=\'{active: vm.selectedTab === "responseString"}\' id="responseString-tab" data-toggle="tab" data-target="#responseString" role="tab" aria-controls="responseString" ng-attr-aria-selected=\'{{vm.selectedTab === "responseString"}}\' ng-click="vm.selected(\'responseString\')"><i class="fas fa-reply"></i>&nbsp; {{\'eDocumentsApp.documentStorage.responseString\' | translate}}</a></li></ul><!-- Tab panes --><div class="tab-content"><div class="tab-pane active" id="incomingString" ng-if=\'vm.documentStorage.incomingString && vm.selectedTab === "incomingString"\' role="tabpanel" aria-labelledby="incomingString-tab"><div class="document-storage-content"><span class="badge badge-secondary document-storage-type-badge">{{vm.documentStorage.incomingStringType}}</span><pre ng-if="vm.documentStorage.incomingStringType===\'JSON\'" pretty-json="vm.documentStorage.incomingString"></pre><pre ng-if="vm.documentStorage.incomingStringType===\'XML\'">{{vm.documentStorage.incomingString | prettyXml}}</pre><pre ng-if="vm.documentStorage.incomingStringType===\'STRING\'">{{vm.documentStorage.incomingString}}</pre></div></div><div class="tab-pane active" id="typedString" ng-if=\'vm.documentStorage.typedString && vm.selectedTab === "typedString"\' role="tabpanel" aria-labelledby="typedString-tab"><div class="document-storage-content"><span class="badge badge-secondary document-storage-type-badge">{{vm.documentStorage.typedStringType}}</span><pre ng-if="vm.documentStorage.typedStringType===\'JSON\'" pretty-json="vm.documentStorage.typedString"></pre><pre ng-if="vm.documentStorage.typedStringType===\'XML\'">{{vm.documentStorage.typedString | prettyXml}}</pre><pre ng-if="vm.documentStorage.typedStringType===\'STRING\'">{{vm.documentStorage.typedString}}</pre></div></div><div class="tab-pane active" id="outgoingString" ng-if=\'vm.documentStorage.outgoingString && vm.selectedTab === "outgoingString"\' role="tabpanel" aria-labelledby="outgoingString-tab"><div class="document-storage-content"><span class="badge badge-secondary document-storage-type-badge">{{vm.documentStorage.outgoingStringType}}</span><pre ng-if="vm.documentStorage.outgoingStringType===\'JSON\'" pretty-json="vm.documentStorage.outgoingString"></pre><pre ng-if="vm.documentStorage.outgoingStringType===\'XML\'">{{vm.documentStorage.outgoingString | prettyXml}}</pre><pre ng-if="vm.documentStorage.outgoingStringType===\'STRING\'">{{vm.documentStorage.outgoingString}}</pre></div></div><div class="tab-pane active" id="responseString" ng-if=\'vm.documentStorage.responseString && vm.selectedTab === "responseString"\' role="tabpanel" aria-labelledby="responseString-tab"><div class="document-storage-content"><span class="badge badge-secondary document-storage-type-badge">{{vm.documentStorage.responseStringType}}</span><pre ng-if="vm.documentStorage.responseStringType===\'JSON\'" pretty-json="vm.documentStorage.responseString"></pre><pre ng-if="vm.documentStorage.responseStringType===\'XML\'">{{vm.documentStorage.responseString | prettyXml}}</pre><pre ng-if="vm.documentStorage.responseStringType===\'STRING\'">{{vm.documentStorage.responseString}}</pre></div></div></div></div></div>');
$templateCache.put('app/entities/external-auth-key/external-auth-key-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span data-translate="eDocumentsApp.externalAuthKey.detail.title">Create an API Key</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span data-translate="eDocumentsApp.externalAuthKey.communicationEntity">Communication Entity</span>&nbsp;{{vm.communicationEntity.name}}</h5><hr></div><div class="container-fluid row"><jhi-alert-error></jhi-alert-error><div class="col-md-12"><div class="form-group"><label for="field_processId"><span data-translate="eDocumentsApp.externalAuthKey.processId">ProcessId</span> <span style="font-size: 12px" uib-tooltip="{{\'eDocumentsApp.externalAuthKey.tooltip.processId\' | translate }}" tooltip-placement="right" tooltip-append-to-body="true"><i class="fa fa-question-circle"></i></span></label><input type="text" class="form-control mb-2" name="processId" id="field_processId" ng-class="{\'is-invalid\': editForm.name.$invalid}" ng-model="vm.externalAuthKey.processId" required ng-maxlength="255"><div class="invalid-feedback" ng-show="editForm.processId.$invalid && editForm.processId.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.processId.$invalid &&  editForm.processId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div><div class="form-group"></div><hr><div><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-cog"></i>&nbsp;<span data-translate="entity.action.generate">Generate</span></button></div></div></div></form>');
$templateCache.put('app/entities/external-auth-key/external-auth-key-disclaimer-dialog.html','<div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.externalAuthKey.disclaimer.title">Disclaimer</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p data-translate="eDocumentsApp.externalAuthKey.disclaimer.message1"></p><p><u data-translate="eDocumentsApp.externalAuthKey.disclaimer.message2"></u>&nbsp;<span data-translate="eDocumentsApp.externalAuthKey.disclaimer.message3"></span></p><br><p><strong data-translate="eDocumentsApp.externalAuthKey.disclaimer.question"></strong></p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel"> Cancel</span></button></div><div class="float-right"><button type="button" class="btn btn-success" ng-click="vm.accept()"><i class="fas fa-check"></i>&nbsp;<span data-translate="entity.action.confirm"> Confirm</span></button></div></div>');
$templateCache.put('app/entities/external-auth-key/external-auth-key-generation-dialog.html','<div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.externalAuthKey.generation.title">Generation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><p data-translate="eDocumentsApp.externalAuthKey.generation.message1"></p><p data-translate="eDocumentsApp.externalAuthKey.generation.message2"></p><p data-translate="eDocumentsApp.externalAuthKey.generation.message3"></p><br><div class="form-group col-md"><label data-translate="eDocumentsApp.externalAuthKey.externalAuthKey" for="externalAuthKeyInput">externalAuthKey</label><div class="input-group"><input type="text" class="form-control mb-2" ng-readonly="true" name="externalAuthKey" ng-model="vm.externalAuthKeyGenerationResponse.apiKey" id="externalAuthKeyInput"><div class="input-group-append"><button type="button" class="btn btn-primary mb-2" ng-click="vm.copyExternalAuthKey()" uib-tooltip="{{\'entity.action.copy\' | translate}}"><i class="fas fa-copy"></i></button></div></div></div></div><div class="modal-footer"><div class="flex-fill float-left"></div><div class="float-right"><button type="button" class="btn btn-default" ng-click="vm.close()"><i class="fas fa-times"></i>&nbsp;<span data-translate="entity.action.close">Close</span></button></div></div>');
$templateCache.put('app/entities/external-auth-key/external-auth-key-revoke-dialog.html','<form name="deleteForm" ng-submit="vm.confirmRevoke()"><div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.externalAuthKey.revoke.title">Confirm revoke operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.externalAuthKey.revoke.information">API Key revoke information</p><p data-translate="eDocumentsApp.externalAuthKey.revoke.question" translate-values="{processId: \'{{vm.externalAuthKey.processId}}\'}">Are you sure you want to revoke this API Key?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel"> Back</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/external-entity/external-entities-activate-confirmation-dialog.html','<form name="deleteForm" ng-submit="vm.confirmActivation()"><div class="modal-header"><h5 class="modal-title" data-translate="entity.activation.title">Confirm activation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.externalEntity.activate.question">Are you sure you want to activate entities?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel"> Cancel</span></button></div><div class="float-right"><button type="submit" autofocus class="btn btn-primary"><i class="fas fa-check"></i>&nbsp;<span data-translate="entity.action.confirm">Confirmar</span></button></div></div></form>');
$templateCache.put('app/entities/external-entity/external-entities-error-dialog.html','<form name="selectedDocuments"><div class="modal-header"><h5 class="modal-title" data-translate="eDocumentsApp.externalEntity.showErrors.title">Confirm approve operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div class="table-responsive"><div class="alert alert-danger" data-translate="eDocumentsApp.externalEntity.showErrors.message"></div><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th jh-sort-by="name"><span data-translate="eDocumentsApp.externalEntity.name">Name</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="vatRegistrationNumber"><span data-translate="eDocumentsApp.externalEntity.vatRegistrationNumber">VAT Registration Number</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="postalCode"><span data-translate="eDocumentsApp.externalEntity.postalCode">Postal Code</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="postalCode"><span data-translate="eDocumentsApp.externalEntity.gln">GLN </span><i class="fas sort fa-sort"></i></th><th jh-sort-by="postalCode"><span data-translate="eDocumentsApp.externalEntity.emailTo">GLN </span><i class="fas sort fa-sort"></i></th></tr></thead><tbody><tr ng-repeat="(key, externalEntity) in vm.externalEntities track by externalEntity.id"><td>{{externalEntity.name}}</td><td>{{externalEntity.vatRegistrationNumber}}</td><td>{{externalEntity.postalCode}}</td><td>{{externalEntity.gln}}</td><td>{{externalEntity.emailTo}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="glyphicon glyphicon-ban-circle"></i>&nbsp;<span data-translate="entity.action.close">Close</span></button></div></form>');
$templateCache.put('app/entities/external-entity/external-entities-inactivate-confirmation-dialog.html','<form name="deleteForm" ng-submit="vm.confirmInactivation()"><div class="modal-header"><h5 class="modal-title" data-translate="entity.inactivation.title">Confirm inactivation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.externalEntity.inactivate.question">Are you sure you want to inactivate entity?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel"> Cancel</span></button></div><div class="float-right"><button type="submit" autofocus class="btn btn-primary"><i class="fas fa-check"></i>&nbsp;<span data-translate="entity.action.confirm">Confirmar</span></button></div></div></form>');
$templateCache.put('app/entities/external-entity/external-entities.html','<div><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-12 col-lg-7"><h2>{{vm.communicationEntity.name}}</h2><h5 data-translate="eDocumentsApp.externalEntity.home.title">External Entities</h5></div><div class="col-6 col-lg-3 text-center"><div class="mb-2"><button type="button" class="btn btn-md btn-primary" ng-click="vm.synchronize()" ng-disabled="vm.synchronizeButtonProtected"><em class="fas fa-sync-alt"></em> <span class="d-none d-sm-inline-block">{{\'entity.action.synchronize\' | translate}}</span></button></div><span ng-if="vm.lastSynchronizationData.endDate != null"><h6 data-translate="eDocumentsApp.externalEntity.lastSynchronization.date" data-translate-values="{date: vm.lastSynchronizationData.endDate}"></h6><h6 ng-if="vm.lastSynchronizationData.numberEntitiesSynchronized >= 0" data-translate="eDocumentsApp.externalEntity.lastSynchronization.entities" data-translate-values="{entities: vm.lastSynchronizationData.numberEntitiesSynchronized}"></h6><h6 ng-if="vm.lastSynchronizationData.numberEntitiesSynchronized < 0" data-translate="eDocumentsApp.externalEntity.lastSynchronization.syncError" data-translate-values="{entities: vm.lastSynchronizationData.numberEntitiesSynchronized}"></h6></span><span ng-if="vm.lastSynchronizationData.endDate == null"><h6 data-translate="eDocumentsApp.externalEntity.lastSynchronization.endDateNull" data-translate-values="{date: vm.lastSynchronizationData.startDate}"></h6></span></div><div class="col-6 col-lg-2"><form class="form-inline float-right"><button class="btn btn-sm ml-2" ng-if="vm.searchVisible != true" ng-click="vm.searchVisible = !vm.searchVisible" ng-class="{\'btn-primary\':  !vm.searchVisible, \'btn-warning\' :vm.searchVisible}"><em class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></em> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.search">Pesquisar</span></span></button> <button class="btn btn-sm btn-dark ml-2" ng-if="vm.searchVisible != true && vm.isSearchActive()" ng-click="vm.reset()"><em class="fas fa-trash-alt"></em> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.clear">Limpar</span></span></button></form></div></div></div><div class="card text-white bg-primary mb-3" ng-if="vm.searchVisible == true"><div class="card-header"><span data-translate="entity.action.search">Pesquisar</span> <button class="btn btn-sm btn-secondary float-right" ng-click="vm.searchVisible = !vm.searchVisible"><em class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></em>&nbsp;<span class="d-none d-sm-inline-block" data-translate="entity.action.hide"></span></button></div><div class="card-body bg-white text-primary"><form><div class="form-row"><div class="form-group col-sm-12 col-md-6 col-lg-6"><label data-translate="eDocumentsApp.externalEntity.name">Nome</label><div class="input-group input-group-sm"><input ng-model="vm.filters.filterBy.name.value" class="form-control form-control-sm"></div></div><div class="form-group col-sm-12 col-md-6 col-lg-6"><label data-translate="eDocumentsApp.externalEntity.status">Estado</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons" ng-class="{\'btn-group-vertical\': vm.width < 500}"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.status.value == null || vm.filters.filterBy.status.value == undefined}" ng-click="vm.changeStatus(undefined)"><input type="radio" name="options" autocomplete="off"> <span data-translate="eDocumentsApp.ExternalEntityStatus.null">Todos</span></label><label ng-repeat="status in vm.statuses" class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.status.value == status}" ng-click="vm.changeStatus(status)"><input type="radio" name="options" autocomplete="off"> <span>{{\'eDocumentsApp.ExternalEntityStatus.\' + status | translate}}</span></label></div></div><div class="form-group col-sm-6 col-md-4 col-lg-2"><label data-translate="eDocumentsApp.externalEntity.country">Country</label><input class="form-control form-control-sm" name="country" ng-model="vm.filters.filterBy.country.value"></div><div class="form-group col-sm-6 col-md-4 col-lg-2"><label data-translate="eDocumentsApp.externalEntity.vatRegistrationNumber">VAT Registration Number</label><input class="form-control form-control-sm" name="vatRegistrationNumber" ng-model="vm.filters.filterBy.vatRegistrationNumber.value"></div><div class="form-group col-sm-6 col-md-4 col-lg-2"><label data-translate="eDocumentsApp.externalEntity.postalCode">Postal Code</label><input class="form-control form-control-sm" name="postalCode" ng-model="vm.filters.filterBy.postalCode.value"></div><div class="form-group col-sm-6 col-md-12 col-lg-6"><label>&nbsp;</label><br><div class="btn-group col p-0" role="group"><button class="btn btn-primary btn-sm col-6" ng-click="vm.page = 1; vm.loadAll();"><em class="fas fa-search"></em> <span data-translate="entity.action.search">Pesquisar</span></button> <button class="btn btn-dark btn-sm col-6" ng-if="vm.isSearchActive()" ng-click="vm.reset()"><em class="fas fa-trash-alt"></em> <span data-translate="entity.action.clear">Limpar</span></button></div></div></div></form></div></div><div class="alert alert-warning" ng-if="!vm.externalEntities || vm.externalEntities.length === 0"><span data-translate="entity.no-results">No results</span></div><div class="table-responsive" ng-if="vm.externalEntities && vm.externalEntities.length > 0"><table class="jh-table table table-hover table-sm" aria-label="{{\'global.a11y.externalEntitiesTable\' | translate}}"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th jh-sort-by="name"><span data-translate="eDocumentsApp.externalEntity.name">Name</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="country"><span data-translate="eDocumentsApp.externalEntity.country">Country</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="vatRegistrationNumber"><span data-translate="eDocumentsApp.externalEntity.vatRegistrationNumber">VAT Registration Number</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="postalCode"><span data-translate="eDocumentsApp.externalEntity.postalCode">Postal Code</span> <em class="fas sort fa-sort"></em></th><th class="text-center" jh-sort-by="status"><span data-translate="eDocumentsApp.externalEntity.status">Status</span><em class="fas sort fa-sort"></em></th><th class="text-center"><div class="custom-control custom-checkbox" style="display: inline-block"><input class="custom-control-input" id="selectedAll" type="checkbox" name="selectedAll" ng-model="vm.selectedAll"><label ng-click="vm.selectAll()" class="custom-control-label" for="selectedAll">&nbsp;</label></div><button type="button" class="btn btn-sm btn-warning" ng-show="vm.getTotalSelected() > 0" ng-click="vm.activateEntities()"><em class="fa fa-check"></em> <span class="d-none d-sm-inline-block">{{\'entity.action.activate\' | translate}} ({{vm.getTotalSelected()}})</span></button></th><th></th></tr></thead><tbody><tr ng-repeat="externalEntity in vm.externalEntities track by externalEntity.id"><td>{{externalEntity.name}}</td><td>{{externalEntity.country}}</td><td>{{externalEntity.vatRegistrationNumber}}</td><td>{{externalEntity.postalCode}}</td><td class="text-center"><span class="badge badge-pill badge-secondary" ng-if="externalEntity.status === \'CREATED\'">{{\'eDocumentsApp.ExternalEntityStatus.\' + externalEntity.status | translate}}</span> <span class="badge badge-pill badge-success" ng-if="externalEntity.status === \'ACTIVE\'">{{\'eDocumentsApp.ExternalEntityStatus.\' + externalEntity.status | translate}}</span> <span class="badge badge-pill badge-warning" ng-if="externalEntity.status === \'PENDING\'">{{\'eDocumentsApp.ExternalEntityStatus.\' + externalEntity.status | translate}}</span></td><td class="text-center"><div class="custom-control custom-checkbox" ng-hide="externalEntity.status !== \'CREATED\'"><input type="checkbox" class="custom-control-input" name="selected" ng-disabled="vm.readOnly === true" id="selected{{externalEntity.id}}" ng-change="vm.selectChange(externalEntity)" ng-model="externalEntity.selected"><label class="custom-control-label" ng-click="vm.deselectOne();" for="selected{{externalEntity.id}}"></label></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-class="{\'disabled\': !vm.activateBtnEnable(externalEntity)}" ng-click="vm.activateBtnEnable(externalEntity) && vm.activateEntity(externalEntity)" uib-tooltip="{{\'eDocumentsApp.externalEntity.activate.disabledInfo\' | translate }}" tooltip-enable="{{vm.showTooltipOnActivateButton(externalEntity)}}" tooltip-placement="right" class="btn btn-warning btn-sm"><em class="fa fa-check"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.activate"></span></button> <a ng-class="{\'disabled\': externalEntity.status !== \'ACTIVE\'}" ng-click="vm.inactivateEntity(externalEntity)" class="btn btn-secondary btn-sm"><em class="fa fa-ban"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.inactivate"></span> </a><a ui-sref="external-entity-detail({id:externalEntity.id})" class="btn btn-info btn-sm"><em class="far fa-eye"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.view"></span> </a><a ui-sref="external-entity.edit({id:externalEntity.id})" class="btn btn-primary btn-sm" ng-class="{\'disabled\': externalEntity.status !== \'CREATED\'}"><em class="far fa-edit"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.edit"></span> </a><a ui-sref="external-entity.delete({id:externalEntity.id})" class="btn btn-danger btn-sm" ng-class="{\'disabled\': externalEntity.status !== \'CREATED\'}"><em class="fas fa-trash-alt"></em> <span class="d-none d-sm-inline-block" data-translate="entity.action.delete"></span></a></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.externalEntities.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-click="vm.loadAll()"></div></div><div class="col-auto mt-4"><div class="btn-group"><a ui-sref="communication-entity" class="btn btn-default"><em class="fas fa-arrow-left"></em> <span data-translate="entity.action.back">Back</span></a></div></div></div>');
$templateCache.put('app/entities/external-entity/external-entity-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.externalEntity.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.externalEntity.delete.question" translate-values="{id: \'{{vm.externalEntity.name}}\'}">Are you sure you want to delete this External Entity?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel"> Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" autofocus class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/external-entity/external-entity-dialog.html','<jhi-alert-error></jhi-alert-error><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="m-3"><h5><span ng-if="!vm.externalEntity.name" data-translate="eDocumentsApp.externalEntity.home.createOrEditLabel">Create or edit a ExternalEntity</span> <span ng-if="vm.externalEntity.name">{{vm.externalEntity.name}}</span></h5><hr></div><div class="container-fluid"><div class="form-row align-items-center"><div class="form-group col-md-4"><label data-translate="eDocumentsApp.externalEntity.name" for="field_name">Name</label><input type="text" class="form-control form-control-sm mb-2" id="field_name" ng-readonly="true" name="name" placeholder="{{\'eDocumentsApp.externalEntity.name\'|translate}}" ng-model="vm.externalEntity.name"></div><div class="form-group col-md-2 text-center"><label data-translate="eDocumentsApp.externalEntity.status">Status</label><div><i class="fas fa-check text-warning" ng-show="vm.externalEntity.status === \'PENDING\'"></i> <i class="fas fa-check text-success" ng-show="vm.externalEntity.status === \'ACTIVE\'"></i></div></div></div><div class="form-row align-items-center"><div class="form-group col-md-2"><label data-translate="eDocumentsApp.externalEntity.country" for="field_country">Country</label><input type="text" class="form-control form-control-sm mb-2" id="field_country" ng-readonly="true" name="name" placeholder="{{\'eDocumentsApp.externalEntity.country\'|translate}}" ng-model="vm.externalEntity.country"></div><div class="form-group col-md-2"><label data-translate="eDocumentsApp.externalEntity.vatRegistrationNumber" for="field_vatRegistrationNumber">Vat Registration Number</label><input type="text" class="form-control form-control-sm mb-2" id="field_vatRegistrationNumber" ng-readonly="true" name="vatRegistrationNumber" placeholder="{{\'eDocumentsApp.externalEntity.vatRegistrationNumber\'|translate}}" ng-model="vm.externalEntity.vatRegistrationNumber"></div><div class="form-group col-md-2"><label data-translate="eDocumentsApp.externalEntity.postalCode" for="field_postalCode">Postal Code</label><input type="text" class="form-control form-control-sm mb-2" id="field_postalCode" ng-readonly="true" name="postalCode" placeholder="{{\'eDocumentsApp.externalEntity.postalCode\'|translate}}" ng-model="vm.externalEntity.postalCode"></div><div class="form-group col-md-2"><label data-translate="eDocumentsApp.externalEntity.gln" for="field_gln">GLN</label><input type="text" class="form-control form-control-sm mb-2" id="field_gln" ng-readonly="vm.readOnly === true" name="gln" placeholder="{{\'eDocumentsApp.externalEntity.gln\'|translate}}" ng-model="vm.externalEntity.gln" ng-class="{\'is-invalid\': editForm.gln.$invalid}" ng-maxlength="255"><div class="invalid-feedback" ng-show="editForm.gln.$invalid && editForm.gln.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.gln.$invalid && editForm.gln.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div></div><div class="form-row align-items-center"><div class="form-group col-md-4"><label data-translate="eDocumentsApp.externalEntity.emails">Email To</label><input type="text" class="form-control form-control-sm mb-2" id="field_emailTo" ng-readonly="vm.readOnly === true" name="emailTo" placeholder="{{\'eDocumentsApp.externalEntity.emailTo\'|translate}}" ng-model="vm.externalEntity.emailTo" ng-class="{\'is-invalid\': editForm.emailTo.$invalid}" required ng-maxlength="255"><div class="invalid-feedback" ng-show="editForm.emailTo.$invalid && editForm.emailTo.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.emailTo.$invalid && editForm.emailTo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div><div class="form-group col-md-4"><label data-translate="eDocumentsApp.externalEntity.emailCc" for="field_emailCc">Email CC</label><input type="text" class="form-control form-control-sm mb-2" id="field_emailCc" ng-readonly="vm.readOnly === true" name="name" placeholder="{{\'eDocumentsApp.externalEntity.emailCc\'|translate}}" ng-model="vm.externalEntity.emailCc" ng-class="{\'is-invalid\': editForm.name.$invalid}" ng-maxlength="255"><div class="invalid-feedback" ng-show="editForm.emailCc.$invalid && editForm.emailCc.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.emailCc.$invalid && editForm.emailCc.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div><div class="form-group col-md-4"><label data-translate="eDocumentsApp.externalEntity.emailBcc" for="field_emailBcc">Email BCC</label><input type="text" class="form-control form-control-sm mb-2" id="field_emailBcc" ng-readonly="vm.readOnly === true" name="name" placeholder="{{\'eDocumentsApp.externalEntity.emailBcc\'|translate}}" ng-model="vm.externalEntity.emailBcc" ng-class="{\'is-invalid\': editForm.name.$invalid}" ng-maxlength="255"><div class="invalid-feedback" ng-show="editForm.emailBcc.$invalid && editForm.emailBcc.$error.required" data-translate="entity.validation.required">This field is required.</div><div class="invalid-feedback" ng-show="editForm.emailCc.$invalid && editForm.emailCc.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</div></div></div><div class="col-auto"><button type="button" class="btn btn-default" ng-click="vm.goBack()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="submit" ng-if="vm.readOnly !== true" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i> &nbsp; <span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/invoice-header/invoice-header-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.invoiceHeader.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.invoiceHeader.delete.question" translate-values="{id: \'{{vm.invoiceHeader.id}}\'}">Are you sure you want to delete this Invoice Header?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/invoice-header/invoice-header-detail.html','<div class="container-fluid mt-3 mb-3"><h2><span data-translate="eDocumentsApp.invoiceHeader.detail.title">Invoice Header</span> {{vm.invoiceHeader.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="jh-entity-details"><dt><span data-translate="eDocumentsApp.invoiceHeader.environment">Environment</span></dt><dd><span>{{vm.invoiceHeader.environment}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.company">Company</span></dt><dd><span>{{vm.invoiceHeader.company}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.subCompany">Sub Company</span></dt><dd><span>{{vm.invoiceHeader.subCompany}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.documentType">Document Type</span></dt><dd><span>{{vm.invoiceHeader.documentType}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.selfBilling">Self Billing</span></dt><dd><span>{{vm.invoiceHeader.selfBilling}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.documentSeries">Document Series</span></dt><dd><span>{{vm.invoiceHeader.documentSeries}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.documentNumber">Document Number</span></dt><dd><span>{{vm.invoiceHeader.documentNumber}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.supplierCode">Supplier Code</span></dt><dd><span>{{vm.invoiceHeader.supplierCode}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.documentCertification">Document Certification</span></dt><dd><span>{{vm.invoiceHeader.documentCertification}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.salesOrderNumber">Sales Order Number</span></dt><dd><span>{{vm.invoiceHeader.salesOrderNumber}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.salesOrderDate">Sales Order Date</span></dt><dd><span>{{vm.invoiceHeader.salesOrderDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.invoiceExpirationDate">Invoice Expiration Date</span></dt><dd><span>{{vm.invoiceHeader.invoiceExpirationDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.customerOrderReference">Customer Order Reference</span></dt><!-- should be PurchaseOrderNumber --><dd><span>{{vm.invoiceHeader.customerOrderReference}}</span><!-- should be PurchaseOrderNumber --></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.externalCustomerId">External Customer Id</span></dt><dd><span>{{vm.invoiceHeader.externalCustomerId}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.currencyCode">Currency Code</span></dt><dd><span>{{vm.invoiceHeader.currencyCode}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.vatBaseAmount">Vat Base Amount</span></dt><dd><span>{{vm.invoiceHeader.vatBaseAmount}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.vatAmount">Vat Amount</span></dt><dd><span>{{vm.invoiceHeader.vatAmount}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.totalAmount">Total Amount</span></dt><dd><span>{{vm.invoiceHeader.totalAmount}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.totalDiscountAmount">Total Discount Amount</span></dt><dd><span>{{vm.invoiceHeader.totalDiscountAmount}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.dueDate">Due Date</span></dt><dd><span>{{vm.invoiceHeader.dueDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.salesReference">Sales Reference</span></dt><dd><span>{{vm.invoiceHeader.salesReference}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceHeader.document">Document</span></dt><dd><a ui-sref="document-detail({id:vm.invoiceHeader.documentId})">{{vm.invoiceHeader.documentId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="invoice-header-detail.edit({id:vm.invoiceHeader.id})" class="btn btn-primary"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/invoice-header/invoice-header-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h5 class="modal-title" id="myInvoiceHeaderLabel" data-translate="eDocumentsApp.invoiceHeader.home.createOrEditLabel">Create or edit an Invoice Header</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.invoiceHeader.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control form-control-sm" id="id" name="id" ng-model="vm.invoiceHeader.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.environment" for="field_environment">Environment</label><input type="text" class="form-control form-control-sm" name="environment" id="field_environment" ng-model="vm.invoiceHeader.environment" ng-maxlength="3"><div ng-show="editForm.environment.$invalid"><p class="help-block" ng-show="editForm.environment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3">This field cannot be longer than 3 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.company" for="field_company">Company</label><input type="text" class="form-control form-control-sm" name="company" id="field_company" ng-model="vm.invoiceHeader.company" required ng-maxlength="2"><div ng-show="editForm.company.$invalid"><p class="help-block" ng-show="editForm.company.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.company.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.subCompany" for="field_subCompany">Sub Company</label><input type="text" class="form-control form-control-sm" name="subCompany" id="field_subCompany" ng-model="vm.invoiceHeader.subCompany" ng-maxlength="15"><div ng-show="editForm.subCompany.$invalid"><p class="help-block" ng-show="editForm.subCompany.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.documentType" for="field_documentType">Document Type</label><input type="text" class="form-control form-control-sm" name="documentType" id="field_documentType" ng-model="vm.invoiceHeader.documentType" required ng-maxlength="2"><div ng-show="editForm.documentType.$invalid"><p class="help-block" ng-show="editForm.documentType.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.documentType.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="2">This field cannot be longer than 2 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.selfBilling" for="field_selfBilling">Self Billing</label><input type="checkbox" name="selfBilling" id="field_selfBilling" ng-model="vm.invoiceHeader.selfBilling"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.documentSeries" for="field_documentSeries">Document Series</label><input type="text" class="form-control form-control-sm" name="documentSeries" id="field_documentSeries" ng-model="vm.invoiceHeader.documentSeries" required ng-maxlength="15"><div ng-show="editForm.documentSeries.$invalid"><p class="help-block" ng-show="editForm.documentSeries.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.documentSeries.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="15">This field cannot be longer than 15 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.documentNumber" for="field_documentNumber">Document Number</label><input type="number" class="form-control form-control-sm" name="documentNumber" id="field_documentNumber" ng-model="vm.invoiceHeader.documentNumber" required><div ng-show="editForm.documentNumber.$invalid"><p class="help-block" ng-show="editForm.documentNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.documentNumber.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.supplierCode" for="field_supplierCode">Supplier Code</label><input type="number" class="form-control form-control-sm" name="supplierCode" id="field_supplierCode" ng-model="vm.invoiceHeader.supplierCode"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.documentCertification" for="field_documentCertification">Document Certification</label><input type="text" class="form-control form-control-sm" name="documentCertification" id="field_documentCertification" ng-model="vm.invoiceHeader.documentCertification" ng-maxlength="70"><div ng-show="editForm.documentCertification.$invalid"><p class="help-block" ng-show="editForm.documentCertification.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="70">This field cannot be longer than 70 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.salesOrderNumber" for="field_salesOrderNumber">Sales Order Number</label><input type="text" class="form-control form-control-sm" name="salesOrderNumber" id="field_salesOrderNumber" ng-model="vm.invoiceHeader.salesOrderNumber" ng-maxlength="50"><div ng-show="editForm.salesOrderNumber.$invalid"><p class="help-block" ng-show="editForm.salesOrderNumber.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.salesOrderDate" for="field_salesOrderDate">Sales Order Date</label><div class="input-group"><input id="field_salesOrderDate" type="text" class="form-control form-control-sm" name="salesOrderDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoiceHeader.salesOrderDate" is-open="vm.datePickerOpenStatus.salesOrderDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'salesOrderDate\')"><i class="far fa-calendar-alt"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.invoiceExpirationDate" for="field_invoiceExpirationDate">Invoice Expiration Date</label><div class="input-group"><input id="field_invoiceExpirationDate" type="text" class="form-control form-control-sm" name="invoiceExpirationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoiceHeader.invoiceExpirationDate" is-open="vm.datePickerOpenStatus.invoiceExpirationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'invoiceExpirationDate\')"><i class="far fa-calendar-alt"></i></button></span></div></div><div class="form-group"><!-- should be PurchaseOrderNumber --><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.customerOrderReference" for="field_customerOrderReference">Customer Order Reference</label><input type="text" class="form-control form-control-sm" name="customerOrderReference" id="field_customerOrderReference" ng-model="vm.invoiceHeader.customerOrderReference" ng-maxlength="50"><div ng-show="editForm.customerOrderReference.$invalid"><p class="help-block" ng-show="editForm.customerOrderReference.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.externalCustomerId" for="field_externalCustomerId">External Customer Id</label><input type="text" class="form-control form-control-sm" name="externalCustomerId" id="field_externalCustomerId" ng-model="vm.invoiceHeader.externalCustomerId" ng-maxlength="100"><div ng-show="editForm.externalCustomerId.$invalid"><p class="help-block" ng-show="editForm.externalCustomerId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.currencyCode" for="field_currencyCode">Currency Code</label><input type="text" class="form-control form-control-sm" name="currencyCode" id="field_currencyCode" ng-model="vm.invoiceHeader.currencyCode" ng-maxlength="10"><div ng-show="editForm.currencyCode.$invalid"><p class="help-block" ng-show="editForm.currencyCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.vatBaseAmount" for="field_vatBaseAmount">Vat Base Amount</label><input type="number" class="form-control form-control-sm" name="vatBaseAmount" id="field_vatBaseAmount" ng-model="vm.invoiceHeader.vatBaseAmount"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.vatAmount" for="field_vatAmount">Vat Amount</label><input type="number" class="form-control form-control-sm" name="vatAmount" id="field_vatAmount" ng-model="vm.invoiceHeader.vatAmount"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.totalAmount" for="field_totalAmount">Total Amount</label><input type="number" class="form-control form-control-sm" name="totalAmount" id="field_totalAmount" ng-model="vm.invoiceHeader.totalAmount"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.totalDiscountAmount" for="field_totalDiscountAmount">Total Discount Amount</label><input type="number" class="form-control form-control-sm" name="totalDiscountAmount" id="field_totalDiscountAmount" ng-model="vm.invoiceHeader.totalDiscountAmount"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.dueDate" for="field_dueDate">Due Date</label><div class="input-group"><input id="field_dueDate" type="text" class="form-control form-control-sm" name="dueDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoiceHeader.dueDate" is-open="vm.datePickerOpenStatus.dueDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dueDate\')"><i class="far fa-calendar-alt"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceHeader.salesReference" for="field_salesReference">Sales Reference</label><input type="text" class="form-control form-control-sm" name="salesReference" id="field_salesReference" ng-model="vm.invoiceHeader.salesReference" ng-maxlength="50"><div ng-show="editForm.salesReference.$invalid"><p class="help-block" ng-show="editForm.salesReference.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="eDocumentsApp.invoiceHeader.document" for="field_document">Document</label><select class="form-control form-control-sm" id="field_document" name="document" ng-model="vm.invoiceHeader.documentId" ng-options="document.id as document.id for document in vm.documents | orderBy:\'id\'"><option value=""></option></select></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div><div class="float-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/invoice-header/invoice-headers.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.invoiceHeader.home.title">Invoice Headers</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-success mx-2 mb-2" ui-sref="invoice-header.new"><i class="far fa-plus-square"></i> <span class="hidden-xs-down">{{\'entity.action.add\' | translate}}</span></button></form></div></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="environment"><span data-translate="eDocumentsApp.invoiceHeader.environment">Environment</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="company"><span data-translate="eDocumentsApp.invoiceHeader.company">Company</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="subCompany"><span data-translate="eDocumentsApp.invoiceHeader.subCompany">Sub Company</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentType"><span data-translate="eDocumentsApp.invoiceHeader.documentType">Document Type</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="selfBilling"><span data-translate="eDocumentsApp.invoiceHeader.selfBilling">Self Billing</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentSeries"><span data-translate="eDocumentsApp.invoiceHeader.documentSeries">Document Series</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentNumber"><span data-translate="eDocumentsApp.invoiceHeader.documentNumber">Document Number</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="supplierCode"><span data-translate="eDocumentsApp.invoiceHeader.supplierCode">Supplier Code</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentCertification"><span data-translate="eDocumentsApp.invoiceHeader.documentCertification">Document Certification</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="salesOrderNumber"><span data-translate="eDocumentsApp.invoiceHeader.salesOrderNumber">Sales Order Number</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="salesOrderDate"><span data-translate="eDocumentsApp.invoiceHeader.salesOrderDate">Sales Order Date</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="invoiceExpirationDate"><span data-translate="eDocumentsApp.invoiceHeader.invoiceExpirationDate">Invoice Expiration Date</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="customerOrderReference"><span data-translate="eDocumentsApp.invoiceHeader.customerOrderReference">Customer Order Reference</span> <i class="fas sort fa-sort"></i></th><!-- should be PurchaseOrderNumber --><th jh-sort-by="externalCustomerId"><span data-translate="eDocumentsApp.invoiceHeader.externalCustomerId">External Customer Id</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="currencyCode"><span data-translate="eDocumentsApp.invoiceHeader.currencyCode">Currency Code</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="vatBaseAmount"><span data-translate="eDocumentsApp.invoiceHeader.vatBaseAmount">Vat Base Amount</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="vatAmount"><span data-translate="eDocumentsApp.invoiceHeader.vatAmount">Vat Amount</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="totalAmount"><span data-translate="eDocumentsApp.invoiceHeader.totalAmount">Total Amount</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="totalDiscountAmount"><span data-translate="eDocumentsApp.invoiceHeader.totalDiscountAmount">Total Discount Amount</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="dueDate"><span data-translate="eDocumentsApp.invoiceHeader.dueDate">Due Date</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="salesReference"><span data-translate="eDocumentsApp.invoiceHeader.salesReference">Sales Reference</span> <i class="fas sort fa-sort"></i></th><th jh-sort-by="documentId"><span data-translate="eDocumentsApp.invoiceHeader.document">Document</span> <i class="fas sort fa-sort"></i></th><th></th></tr></thead><tbody><tr ng-repeat="invoiceHeader in vm.invoiceHeaders track by invoiceHeader.id"><td><a ui-sref="invoice-header-detail({id:invoiceHeader.id})">{{invoiceHeader.id}}</a></td><td>{{invoiceHeader.environment}}</td><td>{{invoiceHeader.company}}</td><td>{{invoiceHeader.subCompany}}</td><td>{{invoiceHeader.documentType}}</td><td>{{invoiceHeader.selfBilling}}</td><td>{{invoiceHeader.documentSeries}}</td><td>{{invoiceHeader.documentNumber}}</td><td>{{invoiceHeader.supplierCode}}</td><td>{{invoiceHeader.documentCertification}}</td><td>{{invoiceHeader.salesOrderNumber}}</td><td>{{invoiceHeader.salesOrderDate | date:\'mediumDate\'}}</td><td>{{invoiceHeader.invoiceExpirationDate | date:\'mediumDate\'}}</td><td>{{invoiceHeader.customerOrderReference}}</td><!-- should be PurchaseOrderNumber --><td>{{invoiceHeader.externalCustomerId}}</td><td>{{invoiceHeader.currencyCode}}</td><td>{{invoiceHeader.vatBaseAmount}}</td><td>{{invoiceHeader.vatAmount}}</td><td>{{invoiceHeader.totalAmount}}</td><td>{{invoiceHeader.totalDiscountAmount}}</td><td>{{invoiceHeader.dueDate | date:\'mediumDate\'}}</td><td>{{invoiceHeader.salesReference}}</td><td><a ui-sref="document-detail({id:invoiceHeader.documentId})">{{invoiceHeader.documentId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="invoice-header-detail({id:invoiceHeader.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="invoice-header.edit({id:invoiceHeader.id})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="invoice-header.delete({id:invoiceHeader.id})" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.invoiceHeaders.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></div></div></div>');
$templateCache.put('app/entities/invoice-line/invoice-line-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.invoiceLine.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.invoiceLine.delete.question" translate-values="{id: \'{{vm.invoiceLine.id}}\'}">Are you sure you want to delete this Invoice Line?</p></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div><div class="float-right"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></div></form>');
$templateCache.put('app/entities/invoice-line/invoice-line-detail.html','<div class="container-fluid mt-3 mb-3"><h2><span data-translate="eDocumentsApp.invoiceLine.detail.title">Invoice Line</span> {{vm.invoiceLine.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="jh-entity-details"><dt><span data-translate="eDocumentsApp.invoiceLine.lineNumber">Line Number</span></dt><dd><span>{{vm.invoiceLine.lineNumber}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.itemCode">Item Code</span></dt><dd><span>{{vm.invoiceLine.itemCode}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.itemDescription">Item Description</span></dt><dd><span>{{vm.invoiceLine.itemDescription}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.supplierLotCode">Supplier Lot Code</span></dt><dd><span>{{vm.invoiceLine.supplierLotCode}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.lotValidUntil">Lot Valid Until</span></dt><dd><span>{{vm.invoiceLine.lotValidUntil | date:\'mediumDate\'}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.lotQualityCode">Lot Quality Code</span></dt><dd><span>{{vm.invoiceLine.lotQualityCode}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.productType">Product Type</span></dt><dd><span>{{vm.invoiceLine.productType}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.quantity">Quantity</span></dt><dd><span>{{vm.invoiceLine.quantity}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.bonusQuantity">Bonus Quantity</span></dt><dd><span>{{vm.invoiceLine.bonusQuantity}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.unitOfMeasure">Unit Of Measure</span></dt><dd><span>{{vm.invoiceLine.unitOfMeasure}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.grossUnitPrice">Gross Unit Price</span></dt><dd><span>{{vm.invoiceLine.grossUnitPrice}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.netUnitPrice">Net Unit Price</span></dt><dd><span>{{vm.invoiceLine.netUnitPrice}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.grossLineAmount">Gross Line Amount</span></dt><dd><span>{{vm.invoiceLine.grossLineAmount}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.lineDiscountAmount">Line Discount Amount</span></dt><dd><span>{{vm.invoiceLine.lineDiscountAmount}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.lineNetAmount">Line Net Amount</span></dt><dd><span>{{vm.invoiceLine.lineNetAmount}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.vatRate">Vat Rate</span></dt><dd><span>{{vm.invoiceLine.vatRate}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.vatAmount">Vat Amount</span></dt><dd><span>{{vm.invoiceLine.vatAmount}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.deliveryDate">Delivery Date</span></dt><dd><span>{{vm.invoiceLine.deliveryDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.lineDiscountPercentage">Line Discount Percentage</span></dt><dd><span>{{vm.invoiceLine.lineDiscountPercentage}}</span></dd><dt><span data-translate="eDocumentsApp.invoiceLine.document">Document</span></dt><dd><a ui-sref="document-detail({id:vm.invoiceLine.documentId})">{{vm.invoiceLine.documentId}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="invoice-line-detail.edit({id:vm.invoiceLine.id})" class="btn btn-primary"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/invoice-line/invoice-line-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h5 class="modal-title" id="myInvoiceLineLabel" data-translate="eDocumentsApp.invoiceLine.home.createOrEditLabel">Create or edit a Invoice Line</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.invoiceLine.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control form-control-sm" id="id" name="id" ng-model="vm.invoiceLine.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.lineNumber" for="field_lineNumber">Line Number</label><input type="number" class="form-control form-control-sm" name="lineNumber" id="field_lineNumber" ng-model="vm.invoiceLine.lineNumber" required><div ng-show="editForm.lineNumber.$invalid"><p class="help-block" ng-show="editForm.lineNumber.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.lineNumber.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.itemCode" for="field_itemCode">Item Code</label><input type="text" class="form-control form-control-sm" name="itemCode" id="field_itemCode" ng-model="vm.invoiceLine.itemCode" required ng-maxlength="100"><div ng-show="editForm.itemCode.$invalid"><p class="help-block" ng-show="editForm.itemCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.itemCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.itemDescription" for="field_itemDescription">Item Description</label><input type="text" class="form-control form-control-sm" name="itemDescription" id="field_itemDescription" ng-model="vm.invoiceLine.itemDescription" ng-maxlength="255"><div ng-show="editForm.itemDescription.$invalid"><p class="help-block" ng-show="editForm.itemDescription.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.supplierLotCode" for="field_supplierLotCode">Supplier Lot Code</label><input type="text" class="form-control form-control-sm" name="supplierLotCode" id="field_supplierLotCode" ng-model="vm.invoiceLine.supplierLotCode" ng-maxlength="100"><div ng-show="editForm.supplierLotCode.$invalid"><p class="help-block" ng-show="editForm.supplierLotCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.lotValidUntil" for="field_lotValidUntil">Lot Valid Until</label><div class="input-group"><input id="field_lotValidUntil" type="text" class="form-control form-control-sm" name="lotValidUntil" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoiceLine.lotValidUntil" is-open="vm.datePickerOpenStatus.lotValidUntil"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lotValidUntil\')"><i class="far fa-calendar-alt"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.lotQualityCode" for="field_lotQualityCode">Lot Quality Code</label><input type="text" class="form-control form-control-sm" name="lotQualityCode" id="field_lotQualityCode" ng-model="vm.invoiceLine.lotQualityCode" ng-maxlength="100"><div ng-show="editForm.lotQualityCode.$invalid"><p class="help-block" ng-show="editForm.lotQualityCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.productType" for="field_productType">Product Type</label><input type="text" class="form-control form-control-sm" name="productType" id="field_productType" ng-model="vm.invoiceLine.productType" ng-maxlength="100"><div ng-show="editForm.productType.$invalid"><p class="help-block" ng-show="editForm.productType.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.quantity" for="field_quantity">Quantity</label><input type="number" class="form-control form-control-sm" name="quantity" id="field_quantity" ng-model="vm.invoiceLine.quantity"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.bonusQuantity" for="field_bonusQuantity">Bonus Quantity</label><input type="number" class="form-control form-control-sm" name="bonusQuantity" id="field_bonusQuantity" ng-model="vm.invoiceLine.bonusQuantity"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.unitOfMeasure" for="field_unitOfMeasure">Unit Of Measure</label><input type="text" class="form-control form-control-sm" name="unitOfMeasure" id="field_unitOfMeasure" ng-model="vm.invoiceLine.unitOfMeasure" ng-maxlength="100"><div ng-show="editForm.unitOfMeasure.$invalid"><p class="help-block" ng-show="editForm.unitOfMeasure.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.grossUnitPrice" for="field_grossUnitPrice">Gross Unit Price</label><input type="number" class="form-control form-control-sm" name="grossUnitPrice" id="field_grossUnitPrice" ng-model="vm.invoiceLine.grossUnitPrice"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.netUnitPrice" for="field_netUnitPrice">Net Unit Price</label><input type="number" class="form-control form-control-sm" name="netUnitPrice" id="field_netUnitPrice" ng-model="vm.invoiceLine.netUnitPrice"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.grossLineAmount" for="field_grossLineAmount">Gross Line Amount</label><input type="number" class="form-control form-control-sm" name="grossLineAmount" id="field_grossLineAmount" ng-model="vm.invoiceLine.grossLineAmount"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.lineDiscountAmount" for="field_lineDiscountAmount">Line Discount Amount</label><input type="number" class="form-control form-control-sm" name="lineDiscountAmount" id="field_lineDiscountAmount" ng-model="vm.invoiceLine.lineDiscountAmount"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.lineNetAmount" for="field_lineNetAmount">Line Net Amount</label><input type="number" class="form-control form-control-sm" name="lineNetAmount" id="field_lineNetAmount" ng-model="vm.invoiceLine.lineNetAmount"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.vatRate" for="field_vatRate">Vat Rate</label><input type="number" class="form-control form-control-sm" name="vatRate" id="field_vatRate" ng-model="vm.invoiceLine.vatRate"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.vatAmount" for="field_vatAmount">Vat Amount</label><input type="number" class="form-control form-control-sm" name="vatAmount" id="field_vatAmount" ng-model="vm.invoiceLine.vatAmount"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.deliveryDate" for="field_deliveryDate">Delivery Date</label><div class="input-group"><input id="field_deliveryDate" type="text" class="form-control form-control-sm" name="deliveryDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.invoiceLine.deliveryDate" is-open="vm.datePickerOpenStatus.deliveryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'deliveryDate\')"><i class="far fa-calendar-alt"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.invoiceLine.lineDiscountPercentage" for="field_lineDiscountPercentage">Line Discount Percentage</label><input type="number" class="form-control form-control-sm" name="lineDiscountPercentage" id="field_lineDiscountPercentage" ng-model="vm.invoiceLine.lineDiscountPercentage"></div><div class="form-group"><label data-translate="eDocumentsApp.invoiceLine.document" for="field_document">Document</label><select class="form-control form-control-sm" id="field_document" name="document" ng-model="vm.invoiceLine.documentId" ng-options="document.id as document.id for document in vm.documents"><option value=""></option></select></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-arrow-left"></i>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div><div class="float-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/invoice-line/invoice-lines.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.invoiceLine.home.title">Invoice Lines</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-success mx-2 mb-2" ui-sref="invoice-line.new"><i class="far fa-plus-square"></i> <span class="hidden-xs-down">{{\'entity.action.add\' | translate}}</span></button><div class="form-group mx-2 mb-2"><input type="text" class="form-control form-control-sm" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'entity.action.search\' | translate}}"></div><button class="btn btn-info mx-2 mb-2" ng-click="vm.search(vm.searchQuery)"><i class="fas fa-search"></i></button> <button class="btn btn-dark mx-2 mb-2" ng-if="vm.currentSearch" ng-click="vm.clear()"><i class="fas fa-trash-alt"></i></button></form></div></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="eDocumentsApp.invoiceLine.lineNumber">Line Number</span></th><th><span data-translate="eDocumentsApp.invoiceLine.itemCode">Item Code</span></th><th><span data-translate="eDocumentsApp.invoiceLine.itemDescription">Item Description</span></th><th><span data-translate="eDocumentsApp.invoiceLine.supplierLotCode">Supplier Lot Code</span></th><th><span data-translate="eDocumentsApp.invoiceLine.lotValidUntil">Lot Valid Until</span></th><th><span data-translate="eDocumentsApp.invoiceLine.lotQualityCode">Lot Quality Code</span></th><th><span data-translate="eDocumentsApp.invoiceLine.productType">Product Type</span></th><th><span data-translate="eDocumentsApp.invoiceLine.quantity">Quantity</span></th><th><span data-translate="eDocumentsApp.invoiceLine.bonusQuantity">Bonus Quantity</span></th><th><span data-translate="eDocumentsApp.invoiceLine.unitOfMeasure">Unit Of Measure</span></th><th><span data-translate="eDocumentsApp.invoiceLine.grossUnitPrice">Gross Unit Price</span></th><th><span data-translate="eDocumentsApp.invoiceLine.netUnitPrice">Net Unit Price</span></th><th><span data-translate="eDocumentsApp.invoiceLine.grossLineAmount">Gross Line Amount</span></th><th><span data-translate="eDocumentsApp.invoiceLine.lineDiscountAmount">Line Discount Amount</span></th><th><span data-translate="eDocumentsApp.invoiceLine.lineNetAmount">Line Net Amount</span></th><th><span data-translate="eDocumentsApp.invoiceLine.vatRate">Vat Rate</span></th><th><span data-translate="eDocumentsApp.invoiceLine.vatAmount">Vat Amount</span></th><th><span data-translate="eDocumentsApp.invoiceLine.deliveryDate">Delivery Date</span></th><th><span data-translate="eDocumentsApp.invoiceLine.lineDiscountPercentage">Line Discount Percentage</span></th><th><span data-translate="eDocumentsApp.invoiceLine.document">Document</span></th><th></th></tr></thead><tbody><tr ng-repeat="invoiceLine in vm.invoiceLines track by invoiceLine.id"><td><a ui-sref="invoice-line-detail({id:invoiceLine.id})">{{invoiceLine.id}}</a></td><td>{{invoiceLine.lineNumber}}</td><td>{{invoiceLine.itemCode}}</td><td>{{invoiceLine.itemDescription}}</td><td>{{invoiceLine.supplierLotCode}}</td><td>{{invoiceLine.lotValidUntil | date:\'mediumDate\'}}</td><td>{{invoiceLine.lotQualityCode}}</td><td>{{invoiceLine.productType}}</td><td>{{invoiceLine.quantity}}</td><td>{{invoiceLine.bonusQuantity}}</td><td>{{invoiceLine.unitOfMeasure}}</td><td>{{invoiceLine.grossUnitPrice}}</td><td>{{invoiceLine.netUnitPrice}}</td><td>{{invoiceLine.grossLineAmount}}</td><td>{{invoiceLine.lineDiscountAmount}}</td><td>{{invoiceLine.lineNetAmount}}</td><td>{{invoiceLine.vatRate}}</td><td>{{invoiceLine.vatAmount}}</td><td>{{invoiceLine.deliveryDate | date:\'mediumDate\'}}</td><td>{{invoiceLine.lineDiscountPercentage}}</td><td><a ui-sref="document-detail({id:invoiceLine.documentId})">{{invoiceLine.documentId}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="invoice-line-detail({id:invoiceLine.id})" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="invoice-line.edit({id:invoiceLine.id})" class="btn btn-primary btn-sm"><i class="far fa-edit"></i> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="invoice-line.delete({id:invoiceLine.id})" class="btn btn-danger btn-sm"><i class="fas fa-trash-alt"></i> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/scheduled-task/scheduled-task-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.scheduledTask.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.scheduledTask.delete.question" translate-values="{id: \'{{vm.scheduledTask.id}}\'}">Are you sure you want to delete this Scheduled Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/scheduled-task/scheduled-task-detail.html','<div><h2><span data-translate="eDocumentsApp.scheduledTask.detail.title">Scheduled Task</span> {{vm.scheduledTask.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="eDocumentsApp.scheduledTask.executionDate">Execution Date</span></dt><dd><span>{{vm.scheduledTask.executionDate | date:\'medium\'}}</span></dd><dt><span data-translate="eDocumentsApp.scheduledTask.document">Document</span></dt><dd><a ui-sref="document-detail({id:vm.scheduledTask.documentId})">{{vm.scheduledTask.documentDocumentNumber}}</a></dd><dt><span data-translate="eDocumentsApp.scheduledTask.communicationWorkflowStep">Communication Workflow Step</span></dt><dd><a ui-sref="communication-workflow-step({sid:vm.scheduledTask.communicationWorkflowStepId})">{{vm.scheduledTask.communicationWorkflowStepDescription}}</a></dd></dl><button type="button" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button><!--<button type="button" ui-sref="scheduled-task-detail.edit({id:vm.scheduledTask.id})" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"> Edit</span>--><!--</button>--></div>');
$templateCache.put('app/entities/scheduled-task/scheduled-task-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myScheduledTaskLabel" data-translate="eDocumentsApp.scheduledTask.home.createOrEditLabel">Create or edit a Scheduled Task</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.scheduledTask.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.scheduledTask.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.scheduledTask.executionDate" for="field_executionDate">Execution Date</label><div class="input-group"><input id="field_executionDate" type="text" class="form-control form-control-sm" name="executionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.scheduledTask.executionDate" is-open="vm.datePickerOpenStatus.executionDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'executionDate\')"><i class="far fa-calendar-alt"></i></button></span></div><div ng-show="editForm.executionDate.$invalid"><p class="help-block" ng-show="editForm.executionDate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.executionDate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label data-translate="eDocumentsApp.scheduledTask.document" for="field_document">Document</label><select class="form-control" id="field_document" name="document" ng-model="vm.scheduledTask.documentId" ng-options="document.id as document.documentNumber for document in vm.documents" required></select></div><div ng-show="editForm.document.$invalid"><p class="help-block" ng-show="editForm.document.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="eDocumentsApp.scheduledTask.communicationWorkflowStep" for="field_communicationWorkflowStep">Communication Workflow Step</label><select class="form-control" id="field_communicationWorkflowStep" name="communicationWorkflowStep" ng-model="vm.scheduledTask.communicationWorkflowStepId" ng-options="communicationWorkflowStep.id as communicationWorkflowStep.id for communicationWorkflowStep in vm.communicationworkflowsteps" required></select></div><div ng-show="editForm.communicationWorkflowStep.$invalid"><p class="help-block" ng-show="editForm.communicationWorkflowStep.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/scheduled-task/scheduled-tasks.html','<div><h2 data-translate="eDocumentsApp.scheduledTask.home.title">Scheduled Tasks</h2><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="executionDate"><span data-translate="eDocumentsApp.scheduledTask.executionDate">Execution Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="documentDocumentNumber"><span data-translate="eDocumentsApp.scheduledTask.document">Document</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="communicationWorkflowStepId"><span data-translate="eDocumentsApp.scheduledTask.communicationWorkflowStep">Communication Workflow Step</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="scheduledTask in vm.scheduledTasks track by scheduledTask.id"><td><a ui-sref="scheduled-task-detail({id:scheduledTask.id})">{{scheduledTask.id}}</a></td><td>{{scheduledTask.executionDate | date:\'medium\'}}</td><td><a ui-sref="document-detail({id:scheduledTask.documentId})">{{scheduledTask.documentDocumentNumber}}</a></td><td><!--ui-sref="communication-workflow-step({sid:communicationDefinition.id})"--> <a ui-sref="communication-workflow-step({sid:scheduledTask.communicationWorkflowStepId})">{{scheduledTask.communicationWorkflowStepDescription}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="scheduled-task-detail({id:scheduledTask.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button><!--<button type="submit"--><!--ui-sref="scheduled-task.edit({id:scheduledTask.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--> <button type="submit" ui-sref="scheduled-task.delete({id:scheduledTask.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/unit-of-measure/unit-of-measure-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.unitOfMeasure.id)"><div class="modal-header"><h5 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="eDocumentsApp.unitOfMeasure.delete.question" translate-values="{id: \'{{vm.unitOfMeasure.commonCode}}\'}">Are you sure you want to delete this Unit Of Measure?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-ban"></i>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fas fa-trash-alt"></i>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/unit-of-measure/unit-of-measure-detail.html','<div><h2><span data-translate="eDocumentsApp.unitOfMeasure.detail.title">Unit Of Measure</span> {{vm.unitOfMeasure.commonCode}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="eDocumentsApp.unitOfMeasure.commonCode">Common Code</span></dt><dd><span>{{vm.unitOfMeasure.commonCode}}</span></dd><dt><span data-translate="eDocumentsApp.unitOfMeasure.name">Name</span></dt><dd><span>{{vm.unitOfMeasure.name}}</span></dd><dt><span data-translate="eDocumentsApp.unitOfMeasure.symbol">Symbol</span></dt><dd><span>{{vm.unitOfMeasure.symbol}}</span></dd><dt><span data-translate="eDocumentsApp.unitOfMeasure.description">Description</span></dt><dd><span>{{vm.unitOfMeasure.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="unit-of-measure-detail.edit({id:vm.unitOfMeasure.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/unit-of-measure/unit-of-measure-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><h4 class="modal-title" id="myUnitOfMeasureLabel" data-translate="eDocumentsApp.unitOfMeasure.home.createOrEditLabel">Create or edit a Unit Of Measure</h4><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.unitOfMeasure.commonCode" for="field_commonCode">Common Code</label><input type="text" class="form-control" name="commonCode" id="field_commonCode" ng-model="vm.unitOfMeasure.commonCode"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.unitOfMeasure.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.unitOfMeasure.name"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.unitOfMeasure.symbol" for="field_symbol">Symbol</label><input type="text" class="form-control" name="symbol" id="field_symbol" ng-model="vm.unitOfMeasure.symbol"></div><div class="form-group"><label class="control-label" data-translate="eDocumentsApp.unitOfMeasure.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.unitOfMeasure.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/unit-of-measure/unit-of-measures.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.unitOfMeasure.home.title">Unit Of Measures</h2></div><div class="col"><form class="form-inline float-right" ng-submit="vm.search(vm.searchQuery)"><div class="form-group mx-2 mb-2"><input type="text" class="form-control form-control-sm" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{\'entity.action.search\' | translate}}"></div><button type="submit" class="btn btn-sm btn-info mx-2 mb-2"><i class="fas fa-search"></i></button> <button type="button" class="btn btn-sm btn-dark mx-2 mb-2" ng-if="vm.currentSearch" ng-click="vm.clear()"><i class="fas fa-trash-alt"></i></button></form></div></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="commonCode"><span data-translate="eDocumentsApp.unitOfMeasure.commonCode">Common Code</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span data-translate="eDocumentsApp.unitOfMeasure.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="symbol"><span data-translate="eDocumentsApp.unitOfMeasure.symbol">Symbol</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="description"><span data-translate="eDocumentsApp.unitOfMeasure.description">Description</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="unitOfMeasure in vm.unitOfMeasures track by unitOfMeasure.id"><td>{{unitOfMeasure.commonCode}}</td><td>{{unitOfMeasure.name}}</td><td>{{unitOfMeasure.symbol}}</td><td>{{unitOfMeasure.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="unit-of-measure-detail({id:unitOfMeasure.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="unit-of-measure.edit({id:unitOfMeasure.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="unit-of-measure.delete({id:unitOfMeasure.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center" ng-show="vm.unitOfMeasures.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div class="modal-body text-center"><img class="mb-4" src="content/images/Flowinn_cores-01.png" alt="" height="200"><form class="form-signin"><h1 class="display-4 text-primary">eDocuments</h1><h1 class="h3 mb-3 font-weight-normal" data-translate="error.title">Error Page!</h1><div class="alert alert-danger" ng-if="!vm.noAccess" data-translate="global.accessDenied">You are not authorised to access this page.</div><div class="alert alert-warning" ng-if="vm.noAccess" role="alert" data-translate="global.noAccessRole">This account no longer has access to any area of eDocuments. Please contact the administrator of your account.</div><a class="btn btn-lg btn-primary btn-block" ng-if="!vm.noAccess" ui-sref="home" data-translate="global.backToHome">Voltar ao in\xEDcio</a> <button type="button" class="btn btn-lg btn-primary btn-block" ng-if="vm.noAccess" ng-click="vm.logout()" data-translate="global.menu.account.logout">Terminar sess\xE3o</button><p class="mt-5 mb-3 text-muted">\xA9 flowinn {{RELEASE_YEAR}}</p></form></div>');
$templateCache.put('app/layouts/error/error.html','<div class="modal-body text-center"><img class="mb-4" src="content/images/Flowinn_cores-01.png" alt="" height="200"><form class="form-signin"><h1 class="display-4 text-primary">eDocuments</h1><h1 class="h3 mb-3 font-weight-normal" data-translate="error.title">Error Page!</h1><div class="alert alert-danger">{{errorMessage}}</div><a class="btn btn-lg btn-primary btn-block" ui-sref="home" data-translate="global.backToHome">Voltar ao in\xEDcio</a><p class="mt-5 mb-3 text-muted">\xA9 flowinn {{RELEASE_YEAR}}</p></form></div>');
$templateCache.put('app/external/document/document.external.html','<div class="modal-body text-center" style="padding: 2rem"><div class="row"><div ng-class="{\'col-lg-3 col-md-12\':vm.viewableFile, \'form-document-external-access\':!vm.viewableFile}"><h4 class="external-logo-text mb-4"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--lg">eDocuments<span class="ed-wordmark__dot">.biz</span></span></h4><div ng-if="!vm.error && !vm.externalDocument" class="spinner-border"></div><dl class="row" style="text-align: left" ng-hide="vm.hashMissing || vm.error"><dt class="col-sm-4" data-translate="eDocumentsApp.document.documentNumber">Document Number</dt><dd class="col-sm-8">{{vm.externalDocument.documentNumber}} <span ng-if="(vm.externalDocument.documentType == \'SELFBILLED\' || vm.externalDocument.documentType == \'CREDITNOTE\') && vm.externalDocument.approved" uib-tooltip="{{ \'eDocumentsApp.document.approve.tooltip\' | translate:vm.approvalInfo }}"><i class="fas fa-check text-success"></i></span></dd><dt class="col-sm-4" data-translate="eDocumentsApp.document.documentDate">Document Date</dt><dd class="col-sm-8">{{vm.externalDocument.documentDate | date}}</dd><dt class="col-sm-4" data-translate="eDocumentsApp.document.documentValue">Document Value</dt><dd class="col-sm-8">{{vm.externalDocument.documentValue | currency: vm.getCurrency(vm.externalDocument.currency) :2 }}</dd><dt class="col-sm-4" data-translate="eDocumentsApp.document.origin.label">Origin</dt><dd class="col-sm-8">{{vm.externalDocument.origin}}</dd><dt class="col-sm-4" data-translate="eDocumentsApp.document.destination.label">Destination</dt><dd class="col-sm-8">{{vm.externalDocument.destination}}</dd></dl><div class="card" style="text-align: left" ng-hide="vm.hashMissing || vm.error"><div class="card-header"><h5 class="card-title" data-translate="eDocumentsApp.document.external.files">Files</h5></div><ul class="list-group list-group-flush"><li ng-repeat="file in vm.externalDocument.files | orderBy : \'fileType\'" class="list-group-item"><span class="fa-layers fa-fw"><i class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></i> </span>{{file.filename}} <span style="cursor: pointer; outline: none" ng-click="vm.download($event, file.hashedId)" class="fa-layers fa-fw float-right text-muted"><i class="fas fa-lg fa-download"></i></span></li></ul></div><div class="btn" ng-hide="vm.hashMissing || vm.error"><button class="btn btn-lg btn-primary btn-block" type="button" ng-click="vm.downloadAllFiles($event)" data-translate="eDocumentsApp.document.external.downloadAll">Download all</button></div><div><div class="alert alert-warning" ng-show="vm.hashMissing">{{ \'error.hashMissing\' | translate }}</div></div><div><div class="alert alert-danger" ng-show="vm.error">{{ vm.error.data.message | translate }}</div></div><div><div class="alert alert-light"><span data-translate="global.noAccount.prefix">Ainda n\xE3o tem conta? Envie-nos um</span> <a class="alert-link" href="mailto:clientes@flowinn.biz" data-translate="global.noAccount.email">e-mail</a> <span data-translate="global.noAccount.middle">ou visite o nosso</span> <a class="alert-link" target="_blank" href="https://www.flowinn.biz" data-translate="global.noAccount.site">site!</a></div><p class="mt-5 mb-3 text-muted">\xA9 flowinn {{RELEASE_YEAR}}</p></div></div><div class="col-lg-9 col-md-12" ng-show="vm.viewableFile"><embed ng-src="{{vm.viewableFile}}" style="width:99%;height:1200px"></div></div></div>');
$templateCache.put('app/external/document/documents.external.html','<div class="modal-body text-center" style="padding: 2rem"><div class="row"><div class="form-documents-external-access"><h4 class="external-logo-text mb-4"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--lg">eDocuments<span class="ed-wordmark__dot">.biz</span></span></h4><div ng-if="vm.error"><div class="alert alert-danger" role="alert"><span data-translate="eDocumentsApp.document.message.documentsNotFound">Documents not found</span></div></div><div ng-if="!vm.error && !vm.externalDocuments" class="spinner-border"></div><div ng-if="!vm.error && vm.externalDocuments"><div class="table-responsive"><table class="jh-table table table-hover table-sm"><thead><tr><th><span data-translate="eDocumentsApp.document.documentType">Document Type</span></th><th><span data-translate="eDocumentsApp.document.documentNumber">Document Number</span></th><th><span data-translate="eDocumentsApp.document.documentDate">Document Date</span></th><th><span data-translate="eDocumentsApp.document.origin.label">Origin</span></th><th><span data-translate="eDocumentsApp.document.documentValue">Document Value</span></th><th><span data-translate="eDocumentsApp.document.documentFiles">documentFiles</span></th><th></th></tr></thead><tbody><tr ng-repeat="document in vm.externalDocuments | orderBy : \'documentNumber\'"><td><span class="badge badge-{{document.documentType}}">{{\'eDocumentsApp.DocumentType.\' + document.documentType | translate}}</span> <span ng-if="(document.documentType == \'SELFBILLED\' || document.documentType == \'CREDITNOTE\') && document.approved" uib-tooltip="{{ \'eDocumentsApp.document.approve.tooltip\' | translate:document }}"><i class="fas fa-check text-success"></i></span></td><td>{{document.documentNumber}}</td><td>{{document.documentDate | date:\'dd/MM/yyyy\'}}</td><td>{{document.origin}}</td><td class="text-right nowrap">{{document.documentValue | currency: vm.getCurrency(document.currency) :2 }}</td><td><span style="color:#0071ff; cursor: pointer; outline: none" ng-repeat="file in document.files | orderBy : \'fileType\'" ng-click="vm.download($event, document, file.hashedId)" class="fa-layers fa-fw" uib-tooltip="Download {{file.filename}}"><i class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></i></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><a ui-sref="externalDocument({hash:document.hashedId})" target="_blank" class="btn btn-info btn-sm"><i class="far fa-eye"></i> <span class="d-none d-sm-inline-block" data-translate="entity.action.view"></span></a></div></td></tr></tbody></table></div><div class="btn" ng-hide="vm.hashMissing || vm.error"><button class="btn btn-lg btn-primary btn-block" type="button" ng-click="vm.downloadAllFiles($event)" data-translate="eDocumentsApp.document.external.downloadAll">Download all</button></div></div><div><div class="alert alert-light"><span data-translate="global.noAccount.prefix">Ainda n\xE3o tem conta? Envie-nos um</span> <a class="alert-link" href="mailto:clientes@flowinn.biz" data-translate="global.noAccount.email">e-mail</a> <span data-translate="global.noAccount.middle">ou visite o nosso</span> <a class="alert-link" target="_blank" href="https://www.flowinn.biz" data-translate="global.noAccount.site">site!</a></div><p class="mt-5 mb-3 text-muted">\xA9 flowinn {{RELEASE_YEAR}}</p></div></div><div class="col-lg-9 col-md-12" ng-show="vm.viewableFile"><embed ng-src="{{vm.viewableFile}}" style="width:99%;height:1200px"></div></div></div>');
$templateCache.put('app/layouts/footer/footer-no-version.html','<footer class="footer_wrapper navbar navbar-inverse"><div class="container"><div class="col-sm-6"><ul class="social_links"><li><a class="facebook" href="javascript:void(0)"><i class="fa fa-facebook"></i></a></li><li><a class="twitter" href="javascript:void(0)"><i class="fa fa-twitter"></i></a></li><li><a class="gplus" href="javascript:void(0)"><i class="fa fa-google-plus"></i></a></li></ul></div><div class="col-sm-6"><span class="navbar-version"><i class="fa fa-copyright" aria-hidden="true"></i> {{RELEASE_YEAR}}, <span data-translate="global.poweredBy">com tecnologia de</span> <a href="https://www.flowinn.biz"></a></span></div></div></footer>');
$templateCache.put('app/layouts/footer/footer.html','<footer class="footer_wrapper navbar navbar-inverse col-sm-12 bg-white mt-2 row" style="max-height: 50px"><div class="row justify-content-center col-sm-12"><span class="navbar-version text-primary" style="cursor: pointer" ng-click="vm.knowMore()"><u data-translate="global.footer">Saber mais sobre a Flowinn</u> <img class="footer_logo" src="content/images/Flowinn_cores-01.png" alt="{{\'global.a11y.eDocumentsLogo\' | translate}}"></span></div></footer>');
$templateCache.put('app/layouts/landing-page/landing-page.html','<div ui-view="navbar@" id="navbar" ng-cloak role="navigation" aria-label="{{\'global.a11y.mainNav\' | translate}}"></div><section id="home" class="container-fluid" style="margin-top: 80px !important" role="banner"><div class="row"><div class="card text-white w-100"><img class="card-img" src="/content/images/lp/section-1.jpg" alt="{{\'global.a11y.heroLogo\' | translate}}"><div class="card-img-overlay d-flex"><div class="align-self-end py-5 px-md-5 w-100"><div class="row"><div class="col-md-6 offset-md-6 text-right"><h2 class="font-weight-bold text-uppercase" style="font-size: 3.5vw !important" data-translate="landingPage.title1">title1</h2></div></div><div class="row"><div class="col-md-6 text-center order-2 order-md-1"><button class="btn btn-lg btn-primary" ng-click="vm.contactUs()" data-translate="landingPage.tryNow" aria-label="{{\'global.a11y.tryCta\' | translate}}">tryNow</button></div><div class="col-md-6 text-right order-1 order-md-2"><h5 class="font-weight-bold"><span class="d-md-none" style="font-size: 1vh" data-translate="landingPage.description1">description1</span> <span class="d-none d-md-block" style="font-size: 1.3vw" data-translate="landingPage.description1">description1</span></h5></div></div><div class="row"><p></p></div></div></div></div></div></section><div class="sectionSep d-none d-lg-block"></div><section class="container-fluid"><div class="d-sm-block d-lg-flex flex-row py-5 my-0 my-lg-5"><div class="order-1 col-sm-12 col-lg-6 px-0 px-lg-5"><img class="card-img" style="border-radius: 1rem !important" src="/content/images/lp/section-2.jpg" alt="{{\'global.a11y.featuresImage\' | translate}}" loading="lazy"></div><div class="order-0 col-sm-12 col-lg-6 align-self-center"><div class="px-0 px-lg-5"><h2 class="font-weight-bold text-primary my-5" data-translate="landingPage.title2">title2</h2><p class="font-weight-bold" data-translate="landingPage.description2_1">description2_1</p><p class="font-weight-bold" data-translate="landingPage.description2_2">description2_2</p></div></div></div></section><div class="sectionSep d-none d-lg-block"></div><section class="bggradient text-center text-white py-3 py-lg-5"><h2 class="font-weight-bold my-3 my-lg-5"><span data-translate="landingPage.tryNowFrom">tryNowFrom</span>&nbsp;<u>15\u20AC/<span data-translate="landingPage.month">month</span></u>*</h2><button class="btn btn-lg btn-outline-light mt-3 mt-lg-5" ng-click="vm.contactUs()" aria-label="{{\'global.a11y.moreCta\' | translate}}"><span data-translate="landingPage.contactUs">contactUs</span></button><div class="col text-right mt-3 pr-2 pt-3 mt-lg-5 pr-lg-5 pt-lg-4"><small>*<span data-translate="landingPage.conditions">conditions</span></small></div></section><div class="sectionSep d-none d-lg-block bg-grey"></div><section id="benefits" class="container-fluid bg-grey py-3 py-lg-5" role="region" aria-label="{{\'global.a11y.benefits\' | translate}}"><div id="carousel" class="carousel slide w-100 py-3 py-lg-5" data-ride="carousel" role="listbox" aria-label="{{\'global.a11y.carousel\' | translate}}"><div class="carousel-inner py-3 py-lg-5"><div class="carousel-item active" role="option"><div class="d-sm-block d-lg-flex flex-row"><div class="order-1 offset-sm-3 offset-lg-0 col-sm-6 px-5 text-center"><img class="w-75" src="/content/images/lp/slide-1.png" alt="{{\'global.a11y.formatsImage\' | translate}}" loading="lazy"></div><div class="order-0 col-sm-12 col-lg-6 align-self-center p-3"><div class="px-0 px-lg-5 mx-0 mx-lg-5"><h2 class="font-weight-bold text-primary mb-5" data-translate="landingPage.title3">title3</h2><p class="font-weight-bold" data-translate="landingPage.description3_1">description3_1</p><p class="font-weight-bold" data-translate="landingPage.description3_2">description3_2</p><p class="font-weight-bold" data-translate="landingPage.description3_3">description3_3</p></div></div></div></div><div class="carousel-item" role="option"><div class="d-sm-block d-lg-flex flex-row"><div class="order-1 offset-sm-3 offset-lg-0 col-sm-6 px-5 text-center"><img class="w-75" src="/content/images/lp/slide-2.png" alt="{{\'global.a11y.automationImage\' | translate}}" loading="lazy"></div><div class="order-0 col-sm-12 col-lg-6 align-self-center p-3"><div class="px-0 px-lg-5 mx-0 mx-lg-5"><h2 class="font-weight-bold text-primary mb-5" data-translate="landingPage.title4">title4</h2><p class="font-weight-bold" data-translate="landingPage.description4">description4</p></div></div></div></div><div class="carousel-item" role="option"><div class="d-sm-block d-lg-flex flex-row"><div class="order-1 offset-sm-3 offset-lg-0 col-sm-6 px-5 text-center"><img class="w-75" src="/content/images/lp/slide-3.png" alt="{{\'global.a11y.secureImage\' | translate}}" loading="lazy"></div><div class="order-0 col-sm-12 col-lg-6 align-self-center p-3"><div class="px-0 px-lg-5 mx-0 mx-lg-5"><h2 class="font-weight-bold text-primary mb-5" data-translate="landingPage.title5">title5</h2><p class="font-weight-bold" data-translate="landingPage.description5">description5</p></div></div></div></div><div class="carousel-item" role="option"><div class="d-sm-block d-lg-flex flex-row"><div class="order-1 offset-sm-3 offset-lg-0 offset-sm-3 col-sm-6 px-5 text-center"><img class="w-75" src="/content/images/lp/slide-4.png" alt="{{\'global.a11y.integrationImage\' | translate}}" loading="lazy"></div><div class="order-0 col-sm-12 col-lg-6 align-self-center p-3"><div class="px-3 px-lg-5 mx-0 mx-lg-5"><h2 class="font-weight-bold text-primary mb-5" data-translate="landingPage.title6">title6</h2><p class="font-weight-bold" data-translate="landingPage.description6">description6</p></div></div></div></div></div><ol class="carousel-indicators" role="tablist" aria-label="{{\'global.a11y.carouselNav\' | translate}}"><li data-target="#carousel" data-slide-to="0" class="bg-primary rounded-circle active" style="height: 20px; width: 20px" role="tab" aria-label="{{\'global.a11y.slide\' | translate:{number:1} }}" aria-selected="true"></li><li data-target="#carousel" data-slide-to="1" class="bg-primary rounded-circle" style="height: 20px; width: 20px" role="tab" aria-label="{{\'global.a11y.slide\' | translate:{number:2} }}" aria-selected="false"></li><li data-target="#carousel" data-slide-to="2" class="bg-primary rounded-circle" style="height: 20px; width: 20px" role="tab" aria-label="{{\'global.a11y.slide\' | translate:{number:3} }}" aria-selected="false"></li><li data-target="#carousel" data-slide-to="3" class="bg-primary rounded-circle" style="height: 20px; width: 20px" role="tab" aria-label="{{\'global.a11y.slide\' | translate:{number:4} }}" aria-selected="false"></li></ol></div></section><div class="sectionSep d-none d-lg-block"></div><section class="container-fluid py-3 py-lg-5"><div class="text-center py-0 py-lg-5"><h2 class="font-weight-bold text-primary mb-3 mb-lg-5 pb-3 pb-lg-5" data-translate="landingPage.someOfOurClients">someOfOurClients</h2><div class="container align-content-center justify-content-center flex-wrap bd-highlight mt-0 mt-lg-5 pt-0 pt-lg-5" role="list" aria-label="{{\'global.a11y.clients\' | translate}}"><div class="float-start"><img class="img-fluid m-2" src="/content/images/lp/inout.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'InOut\'} }}" loading="lazy"> <img class="img-fluid m-2" src="/content/images/lp/dpd.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'DPD\'} }}" loading="lazy"> <img class="img-fluid m-2" src="/content/images/lp/flw.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'Flowinn\'} }}" loading="lazy"> <img class="img-fluid m-2" src="/content/images/lp/mdpharma.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'MDPharma\'} }}" loading="lazy"> <img class="img-fluid m-2" src="/content/images/lp/nutricial.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'Nutricial\'} }}" loading="lazy"></div><div class="float-start"><img class="img-fluid m-2" src="/content/images/lp/medzediz.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'Medzediz\'} }}" loading="lazy"> <img class="img-fluid m-2" src="/content/images/lp/inncloud.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'InCloud\'} }}" loading="lazy"> <img class="img-fluid m-2" src="/content/images/lp/teksajo.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'Teksajo\'} }}" loading="lazy"> <img class="img-fluid m-2" src="/content/images/lp/fersil.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'Fersil\'} }}" loading="lazy"> <img class="img-fluid m-2" src="/content/images/lp/novotipo.png" alt="{{\'global.a11y.clientLogo\' | translate:{name:\'NovoTipo\'} }}" loading="lazy"></div></div></div></section><div class="sectionSep d-none d-lg-block"></div><section id="about" class="container-fluid bg-grey py-3 py-lg-5" role="region" aria-label="{{\'global.a11y.about\' | translate}}"><div class="d-flex-row d-lg-flex py-0 py-lg-5 my-0 my-lg-5"><div class="d-sm-block d-lg-flex py-0 py-lg-5 my-0 my-lg-5"><div class="col-md align-self-center p-0 p-lg-5 my-0 my-lg-5"><h2 class="font-weight-bold text-primary mb-3 mb-lg-5" data-translate="landingPage.title7">title7</h2><div class="pl-3 pl-lg-5"><p class="font-weight-bold" data-translate="landingPage.description7_1">description7_1</p><p class="font-weight-bold" data-translate="landingPage.description7_2">description7_2</p><p class="font-weight-bold" data-translate="landingPage.description7_3">description7_3</p><p class="font-weight-bold" data-translate="landingPage.description7_4">description7_4</p></div></div><div class="col-md align-self-end p-0 p-lg-5 my-3 my-lg-5"><h2 class="font-weight-bold text-primary mb-3 mb-lg-5" data-translate="landingPage.title8">title8</h2><div class="pl-3 pl-lg-5"><p class="font-weight-bold" data-translate="landingPage.description8">description8</p></div></div></div></div></section><div class="sectionSep d-none d-lg-block"></div><section id="faqs" class="container-fluid py-3 py-lg-5" role="region" aria-label="{{\'global.a11y.faq\' | translate}}"><div class="d-flex-row d-lg-flex py-0 py-lg-5 my-0 my-lg-5"><div class="w-100 px-lg-5"><h2 class="font-weight-bold text-primary mb-3 mb-lg-5" data-translate="landingPage.title9">FAQs (Frequently Asked Questions)</h2><faqs-component></faqs-component></div></div></section><section class="bggradient text-center text-white py-3 py-lg-5"><h2 class="font-weight-bold my-3 my-lg-5" data-translate="landingPage.subscribeNewsletter">subscribeNewsletter</h2><form name="newsletterForm" role="form" novalidate ng-submit="vm.addToNewsletter()" show-validation aria-label="{{\'global.a11y.newsletterForm\' | translate}}"><div class="d-flex justify-content-center my-5"><div class="col-sm-10 col-lg-4 input-group input-group-lg"><label class="sr-only" for="field_email" data-translate="global.newsletterEmailLabel">Endere\xE7o de e-mail para a newsletter</label><input type="email" class="form-control" placeholder="{{\'landingPage.yourEmail\' | translate}}" name="email" id="field_email" ng-model="vm.email" required aria-required="true" aria-describedby="newsletter-help"><div class="input-group-append"><button type="submit" class="btn btn-outline-light" id="button-addon2" ng-disabled="newsletterForm.$invalid || vm.isSaving" aria-label="{{\'global.a11y.subscribe\' | translate}}"><i class="fa fa-arrow-right" aria-hidden="true"></i>&nbsp;</button></div></div></div></form></section><footer class="container-fluid pt-3 pt-lg-5" role="contentinfo" aria-label="{{\'global.a11y.footer\' | translate}}"><div class="d-flex-row d-lg-flex"><div class="col-sm-12 col-lg-6 p-0"><div class="justify-content-center d-flex"><h2 class="align-self-end m-0"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--md">eDocuments<span class="ed-wordmark__dot">.biz</span></span></h2></div><div class="col-sm d-flex justify-content-center mt-2 p-0"><div class="btn-group-vertical ml-4"><a class="btn btn-link pl-3 py-2 text-left" ng-click="$event.stopPropagation()" ng-href="{{vm.userManualUrl()}}" target="_blank" rel="noopener"><span class="font-weight-bold text-secondary" data-translate="landingPage.userManual">userManual</span> </a><a class="btn btn-link pl-3 py-2 text-left" ng-click="$event.stopPropagation()" ng-href="/content/documentation/index.html" target="_blank"><span class="font-weight-bold text-secondary" data-translate="landingPage.documentation">Documentation</span> </a><a class="btn btn-link pl-3 py-2 text-left" href="https://www.flowinn.biz/contacts/" target="_blank"><span class="font-weight-bold text-secondary" data-translate="landingPage.contacts">contacts</span></a></div></div></div><div class="border-right"></div><div class="col-sm-12 col-lg-6 p-0"><div class="justify-content-center d-flex"><div class="align-self-center"><small class="align-self-end" data-translate="global.poweredBy">com tecnologia de</small></div><a href="https://www.flowinn.biz/" target="_blank" aria-label="{{\'global.a11y.visitFlowinn\' | translate}}"><img src="/content/images/Flowinn-02.png" height="60" alt="{{\'global.a11y.flowinnLogo\' | translate}}"></a></div></div></div><div class="d-flex bd-highlight py-4"><div class="flex-fill align-self-end text-center"><small class="font-weight-bold">&copy;&nbsp;{{RELEASE_YEAR}}&nbsp;|&nbsp;<span data-translate="landingPage.allRightsReserved">allRightsReserved</span>&nbsp;|&nbsp;<a href="https://www.flowinn.biz/politica-privacidade/" target="_blank"><u><span data-translate="landingPage.privacyPolicy">privacyPolicy</span></u></a></small></div></div></footer>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-expand-lg p-3 pl-4 pr-4 bg-white fixed-top" ng-if="!vm.isAuthenticated()"><div class="container-fluid"><a class="navbar-brand" href="#home" du-scrollspy du-smooth-scroll onclick="jQuery(\'#navbarNavAltMarkup\').removeClass(\'show\')"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--md">eDocuments<span class="ed-wordmark__dot">.biz</span></span> </a><button class="navbar-toggler btn btn-link bg-white img-navbar active" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"><img class="rounded-circle" src="content/images/Flowinn-06.png" alt="{{\'global.a11y.flowinnLogo\' | translate}}"></button><div class="collapse navbar-collapse" id="navbarNavAltMarkup"><ul class="navbar-nav ml-auto"><li class="nav-item pr-4 pl-4" du-scrollspy="benefits"><a class="nav-link font-weight-bold" id="benefitsNavLink" href="#benefits" du-smooth-scroll onclick="jQuery(\'#navbarNavAltMarkup\').removeClass(\'show\')" data-translate="global.menu.account.benefits">Benefits</a></li><li class="nav-item pr-4 pl-4" du-scrollspy="about"><a class="nav-link font-weight-bold" id="aboutNavLink" href="#about" du-smooth-scroll onclick="jQuery(\'#navbarNavAltMarkup\').removeClass(\'show\')" data-translate="global.menu.account.about">About</a></li><li class="nav-item pr-4 pl-4" du-scrollspy="faqs"><a class="nav-link font-weight-bold" id="faqsNavLink" href="#faqs" du-smooth-scroll onclick="jQuery(\'#navbarNavAltMarkup\').removeClass(\'show\')" data-translate="global.faqs">FAQs</a></li><li class="nav-item pr-4 pl-4" ng-click="vm.contactUs()"><a class="nav-link font-weight-bold" id="contactUsNavLink" onclick="jQuery(\'#navbarNavAltMarkup\').removeClass(\'show\')" data-translate="global.menu.account.contactUs">Get in touch</a></li><li class="nav-item pr-4 pl-4"><div class="row" ng-controller="JhiLanguageController as languageVm"><div class="col dropdown ml-3" style="line-height: 50px"><a class="dropdown-toggle language-toggle" style="text-decoration: none" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="flag-icon flag-icon-{{languageVm.getCurrentLanguageIcon()}}"></span></a><div class="dropdown-menu" id="language-menu"><a class="dropdown-item" active-menu="{{language}}" ng-repeat="language in languageVm.languages" ng-click="languageVm.changeLanguage(language);"><span class="flag-icon flag-icon-{{languageVm.findLanguageIcon(language)}}"></span> {{language | findLanguageFromKey}}</a></div></div></div></li><li class="nav-item pl-4" ng-click="vm.login()" id="login"><a class="nav-link" onclick="jQuery(\'#navbarNavAltMarkup\').removeClass(\'show\')"><button class="btn btn-sm btn-outline-primary"><i class="fa fa-sign-in-alt" fixedwidth="true"></i> <span class="mb-0 text-sm font-weight-bold" data-translate="global.menu.account.login">Sign in</span></button></a></li></ul></div></div></nav><nav class="navbar navbar-expand-lg navbar-light p-3 pl-4 pr-4 bg-white" ng-if="vm.isAuthenticated()"><div class="container-fluid"><button type="button" id="sidebarCollapse" ng-click="vm.toggleSidebar()" class="btn btn-light bg-white active"><i class="navbar-toggler-icon"></i></button><!-- Shown only while the sidebar is collapsed. With the sidebar open it already\n             carries the mark, and the identity must never be on screen twice. The CSS is in\n             scss/_wordmark.scss (and its hand-synced twin in content/css/main.css). --> <span class="ed-navbar-brand"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--md">eDocuments<span class="ed-wordmark__dot">.biz</span></span></span><div class="collapse navbar-collapse" id="navbarNav"><ul class="navbar-nav ml-auto"><li ng-class="{active: vm.$state.includes(\'account\')}" class="nav-item dropdown"><a class="nav-link dropdown-toggle img-navbar" href="" id="account-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img class="rounded-circle" ng-if="vm.account.imageURL" ng-src="{{vm.account.imageURL}}" alt="{{\'global.a11y.accountImage\' | translate}}"> <img class="rounded-circle" ng-if="!vm.account.imageURL" src="content/images/Flowinn-06.png" alt="{{\'global.a11y.flowinnLogo\' | translate}}"></a><div class="dropdown-menu dropdown-menu-right" aria-labelledby="account-menu"><h6 class="dropdown-header">{{vm.account.firstName}}&nbsp;{{vm.account.lastName}}</h6><div class="dropdown-divider"></div><a class="dropdown-item" ui-sref-active="active" has-any-authority="ROLE_USER, ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="settings" ng-click="vm.collapseNavbar()"><i class="fas fa-wrench fa-fw"></i>&nbsp; <span data-translate="global.menu.account.settings">Settings</span> </a><a class="dropdown-item" ui-sref-active="active" ui-sref="password" ng-click="vm.collapseNavbar()"><i class="fas fa-lock fa-fw"></i>&nbsp; <span data-translate="global.menu.account.password">Password</span></a><div class="dropdown-divider"></div><a class="dropdown-item" ng-click="vm.logout()" id="logout"><i class="fas fa-sign-out-alt fa-fw"></i>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></div></li></ul></div></div></nav>');
$templateCache.put('app/layouts/send-grid/send-grid-checker.html','<div><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col text-center"><h2 data-translate="sendGrid.checker.title">Check if email is in SendGrid unsubscribe/bounce list</h2></div></div></div><div class="container"><div class="card text-white bg-primary" ng-if="vm.step1"><div class="card-header"><h5 class="mb-0" data-translate="sendGrid.checker.card1.title">Search email</h5></div><div class="card-body bg-white text-primary"><form ng-submit="vm.getEmailStatus()"><div class="form-group row"><label for="email" class="col-sm-3 col-form-label" data-translate="sendGrid.checker.card1.label">Email Address</label><div class="col-sm-9"><input type="email" class="form-control" ng-model="vm.email" id="email" name="email"></div></div><div class="form-group row"><div class="col"><button type="submit" class="btn btn-primary btn-block" data-translate="sendGrid.checker.card1.btn">Check Email</button></div></div></form></div></div><div class="card text-white bg-secondary" ng-if="vm.step2"><div class="card-header"><h5 class="mb-0" data-translate="sendGrid.checker.card2.title">Email found</h5></div><div class="card-body bg-white text-primary"><form ng-submit="vm.removeFromList()"><div class="form-group row"><h5 class="mb-0 col"><p data-translate="sendGrid.checker.card2.message1" translate-values="{email: \'{{vm.email}}\'}">The email address <b>\\"{{email}}\\"</b> is in SendGrid unsubscribe/bounce list</p><p data-translate="sendGrid.checker.card2.message2">Do you want to remove it?</p></h5></div><div class="form-group row"><div class="col"><button type="submit" class="btn btn-secondary btn-block" data-translate="sendGrid.checker.card2.btn">Remove from list</button> <button type="submit" class="btn btn-primary btn-block" ng-click="vm.back()" data-translate="sendGrid.checker.card3.btn">Back</button></div></div></form></div></div><div class="card text-white bg-primary" ng-if="vm.step3"><div class="card-header"><h5 class="mb-0" data-translate="sendGrid.checker.card3.title">Email not found</h5></div><div class="card-body bg-white text-primary"><div class="form-group row"><h5 class="mb-0 col"><p data-translate="sendGrid.checker.card3.message" translate-values="{email: \'{{vm.email}}\'}">The email address <b>"admin@localhost"</b> is not in SendGrid unsubscribe/bounce list</p></h5></div><div class="form-group row"><div class="col"><button type="submit" class="btn btn-primary btn-block" ng-click="vm.back()" data-translate="sendGrid.checker.card3.btn">Back</button></div></div></div></div></div></div>');
$templateCache.put('app/layouts/send-grid/send-grid.html','<section class="container bggradient text-center text-white p-5 mt-5"><div class="justify-content-center my-5" ng-if="vm.errorEmail"><h2 class="font-weight-bold my-3 my-lg-5" data-translate="sendGrid.unsubscribe.titleError">Unsubscribe email notifications from e-documents</h2><h5 data-translate="sendGrid.unsubscribe.error1">Dear user, the email for the request is null or invalid.</h5><h5 data-translate="sendGrid.unsubscribe.error2">Please close this window and try to use the link that you have received in your email.</h5><p class="p-2">&nbsp;</p><a href="#" class="btn btn-light btn-lg" ng-click="vm.goHome()" data-translate="sendGrid.unsubscribe.btnHome">Go to homepage</a></div><div class="justify-content-center my-5" ng-if="!vm.errorEmail"><h2 class="font-weight-bold my-3 my-lg-5"><i class="text-warning fa fa-exclamation-triangle"></i> <span class="font-weight-bolder" data-translate="sendGrid.unsubscribe.attention">Attention: </span><span data-translate="sendGrid.unsubscribe.title">eDocuments notifications canceled</span></h2><h5 data-translate="sendGrid.unsubscribe.body1" translate-values="{email: \'{{vm.email}}\'}">Dear <b>admin@localhost</b>, we are so sorry to see that you want to stop receiving our notifications.</h5><h5 data-translate="sendGrid.unsubscribe.body2">Your email has been removed from our mailing list, and therefore you will no longer receive email notifications about new documents in your reserved area.</h5><h5 data-translate="sendGrid.unsubscribe.body3">If you want to revert this action and continue receiving emails from eDocuments application, click the button below.</h5><p class="p-2">&nbsp;</p><a href="#" class="btn btn-primary btn-lg" ng-click="vm.subscribeAgain()" data-translate="sendGrid.unsubscribe.btnConfirm">Subscribe again</a></div></section>');
$templateCache.put('app/layouts/sidebar/sidebar.html','<div class="sidebar-header"><h4 class="sidebar-text"><span class="ed-wordmark ed-wordmark--on-blue ed-wordmark--md">eDocuments<span class="ed-wordmark__dot">.biz</span></span></h4></div><!-- The 160px of bottom padding that used to be here reserved room for a position:fixed\n     footer. The footer is in the flow now, so the space is real instead of reserved. --><ul class="list-unstyled components mb-0" ng-if="vm.isAuthenticated() == true"><!--  <li ui-sref-active="active" ui-sref="home" ng-click="vm.toggleSidebar()">--><!--    <a>--><!--      <i class="fas fa-home fa-fw"></i>&nbsp;--><!--      <span data-translate="global.menu.home">In\xEDcio</span>--><!--    </a>--><!--  </li>--><!-- SUP-12293: the screens an archive-only account cannot open are not offered to it --><li class="nav-item" ui-sref-active="active" has-any-authority="ROLE_USER, ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="document" ng-click="vm.toggleSidebar()"><a><i class="fas fa-receipt fa-fw"></i>&nbsp; <span data-translate="global.menu.entities.document">Document</span></a></li><li class="nav-item" ui-sref-active="active" has-any-authority="ROLE_SUPERADMIN, ROLE_DIGITAL_ARCHIVE" ui-sref="digital-archive-document" ng-click="vm.toggleSidebar()"><a><i class="fas fa-archive fa-fw"></i>&nbsp; <span data-translate="global.menu.entities.digitalArchive">DigitalArchive</span></a></li><li class="nav-item" ui-sref-active="active" has-any-authority="ROLE_USER, ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication-entity" ng-click="vm.toggleSidebar()"><a><i class="fas fa-user-tie fa-fw"></i>&nbsp; <span data-translate="global.menu.entities.communicationEntity">Communication Entity</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_USER, ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="communication-definition" ng-click="vm.toggleSidebar()"><a><i class="fab fa-readme fa-fw"></i>&nbsp; <span data-translate="global.menu.entities.communicationDefinition">Communication Definition</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_SUPERADMIN, ROLE_BETATESTER" ui-sref="smart-search" ng-click="vm.toggleSidebar()"><a><i class="fas fa-search fa-fw"></i>&nbsp;<!--fa-searchengin--> <span data-translate="global.menu.entities.smartSearch">Smart Search</span> <strong><sup data-translate="global.beta">BETA</sup></strong></a></li><li ng-class="{active: vm.$state.includes(\'admin\')}" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER"><a data-target="#admin-menu" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="fas fa-toolbox fa-fw"></i> {{\'global.menu.admin.main\' | translate}}</a><ul class="collapse list-unstyled" id="admin-menu"><li ui-sref-active="active" ui-sref="admin-documents" ng-click="vm.toggleSidebar()" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN"><a class="dropdown-item"><i class="fas fa-receipt fa-fw"></i>&nbsp; <span data-translate="global.menu.entities.document">Documents</span></a></li><li ui-sref-active="active" ui-sref="communication-action-definition" ng-click="vm.toggleSidebar()" has-authority="ROLE_SUPERADMIN"><a class="dropdown-item"><i class="fas fa-tasks fa-fw"></i>&nbsp; <span data-translate="global.menu.entities.communicationActionDefinition">Communication Action Definition</span></a></li><li ui-sref-active="active" ui-sref="user-management" ng-click="vm.toggleSidebar()" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN"><a><span class="fas fa-users-cog fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active" ui-sref="scheduled-task" ng-click="vm.toggleSidebar()" has-authority="ROLE_SUPERADMIN"><a><span class="fas fa-clock fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.scheduledTask">Scheduled Tasks</span></a></li><li ng-show="vm.swaggerEnabled" has-authority="ROLE_SUPERADMIN" ui-sref-active="active" ui-sref="unit-of-measure" ng-click="vm.toggleSidebar()"><a><span class="fas fa-cog fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.unitOfMeasure">Unit Of Measure</span></a></li><li ui-sref-active="active" ui-sref="ama-safe-util" ng-click="vm.toggleSidebar()"><a><span class="fas fa-bacon fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.amaSafeUtils">AMA SAFE Utils</span></a></li><li ui-sref-active="active" ui-sref="send-grid-checker" ng-click="vm.toggleSidebar()"><a><span class="fas fa-mail-bulk fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.sendGrid">SendGrid Email Checker</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_SUPERADMIN, ROLE_ADMIN, ROLE_PARTNER" ui-sref="parameterization-docs" ng-click="vm.toggleSidebar()"><a class="dropdown-item"><i class="fas fa-book fa-fw"></i>&nbsp; <span data-translate="global.menu.admin.parameterizationDocs">Parameterization Docs</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPERADMIN" ui-sref="jhi-metrics" ng-click="vm.toggleSidebar()"><a><span class="fas fa-tachometer-alt fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPERADMIN" ui-sref="jhi-health" ng-click="vm.toggleSidebar()"><a><span class="fas fa-heart fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPERADMIN" ui-sref="jhi-configuration" ng-click="vm.toggleSidebar()"><a><span class="fas fa-list-alt fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPERADMIN" ui-sref="audits" ng-click="vm.toggleSidebar()"><a><span class="fas fa-bell fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active" has-authority="ROLE_SUPERADMIN" ui-sref="logs" ng-click="vm.toggleSidebar()"><a><span class="fas fa-tasks fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" has-authority="ROLE_SUPERADMIN" ui-sref-active="active" ui-sref="docs" ng-click="vm.toggleSidebar()"><a><span class="fas fa-book fa-fw"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li></ul></li></ul><div class="sidebar-footer pb-2"><ul class="list-unstyled components mb-0 pb-0"><li ng-if="vm.isAuthenticated() == true"><a ng-click="vm.logout(); vm.toggleSidebar()"><i class="fas fa-sign-out-alt fa-fw"></i>&nbsp; <span data-translate="global.menu.account.logout">Logout</span></a></li><!-- The manual is a public page under /content/, not an application state, so one\n             entry serves everyone: there is no signed-in variant left to gate on. --><li><a ng-href="{{vm.userManualUrl()}}" target="_blank" rel="noopener" ng-click="vm.toggleSidebar()"><i class="fa fa-book"></i>&nbsp; <span data-translate="global.userManual">User manual</span></a></li><li ui-sref-active="active" has-authority="ROLE_USER" ui-sref="faqs" ng-click="vm.toggleSidebar()"><a><span class="fas fa-question fa-fw"></span>&nbsp; <span data-translate="global.faqs">FAQs</span></a></li><li><a ng-click="vm.knowMore()"><i class="fa fa-info-circle"></i>&nbsp; <span data-translate="global.knowMore.title">Know more</span></a></li></ul><div class="container"><div class="row" ng-controller="JhiLanguageController as languageVm"><div class="col dropup" style="line-height: 27px"><a class="dropdown-toggle language-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="flag-icon flag-icon-{{languageVm.getCurrentLanguageIcon()}}"></span></a><div class="dropdown-menu" id="language-menu"><a class="dropdown-item" active-menu="{{language}}" ng-repeat="language in languageVm.languages" ng-click="languageVm.changeLanguage(language);"><span class="flag-icon flag-icon-{{languageVm.findLanguageIcon(language)}}"></span> {{language | findLanguageFromKey}}</a></div><span class="version">v{{VERSION}}</span> <img class="logo" src="content/images/Flowinn-13.png" alt="{{\'global.a11y.eDocumentsLogo\' | translate}}"></div></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="card bg-light shadow border-0"><div class="card-header bg-white border-0 text-center"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="m-3"><div class="login-logo-text"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--lg">eDocuments<span class="ed-wordmark__dot">.biz</span></span></div></h4></div><div class="card-body p-4 pb-0"><div class="text-center text-muted mb-4" data-translate="reset.finish.title">Reset password</div><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><span data-translate="reset.finish.messages.info">Choose a new password</span></div><div class="alert alert-danger" ng-show="vm.error"><span data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</span></div><div class="alert alert-success" ng-show="vm.success"><span data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a></span></div><div class="alert alert-danger" ng-show="vm.doNotMatch"><span data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</span></div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label for="password" class="sr-only" data-translate="global.form.newpassword">New password</label><div class="input-group input-group-alternative"><div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-key"></i></span></div><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="5" ng-maxlength="100" required></div><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label for="confirmPassword" class="sr-only" data-translate="global.form.confirmpassword">New password confirmation</label><div class="input-group input-group-alternative"><div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-key"></i></span></div><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="5" ng-maxlength="100" required></div><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><div class="text-center"><button class="btn btn-primary" type="submit" ng-disabled="form.$invalid"><span data-translate="reset.finish.button.validate">Validate new password</span></button> <button class="btn btn-outline-primary" type="button" ng-click="vm.cancel()"><span data-translate="reset.finish.button.cancel">Cancel</span></button></div></form></div><div class="text-center" ng-show="vm.keyMissing"><button class="btn btn-outline-primary" type="button" ng-click="vm.cancel()"><span data-translate="reset.finish.button.back">Back home</span></button></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="card bg-light shadow border-0"><div class="card-header bg-white border-0 text-center"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="m-3"><div class="login-logo-text"><span class="ed-wordmark ed-wordmark--on-light ed-wordmark--lg">eDocuments<span class="ed-wordmark__dot">.biz</span></span></div></h4></div><div class="card-body p-4 pb-0"><form class="form" name="resetRequestForm" ng-submit="vm.requestReset($event)"><div class="text-center text-muted mb-4" data-translate="reset.request.title">Reset your password</div><div class="alert alert-danger" ng-show="vm.errorEmailNotExists" data-translate="reset.request.messages.notfound"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><div class="form-group"><label for="email" class="sr-only" data-translate="reset.request.form.email">Email</label><div class="input-group input-group-alternative"><div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-at"></i></span></div><input type="email" class="form-control" id="email" name="email" ng-model="vm.email" placeholder="{{\'reset.request.form.email.placeholder\' | translate}}" ng-minlength="5" ng-maxlength="100" required autofocus=""></div></div><div class="text-center"><button class="btn btn-primary" type="submit" ng-disabled="resetRequestForm.$invalid || vm.isSaving"><span data-translate="reset.request.button.reset">Reset</span></button> <button class="btn btn-outline-primary" type="button" ng-click="vm.cancel()"><span data-translate="reset.request.button.cancel">Cancel</span></button></div></form></div></div>');
$templateCache.put('app/entities/digital-archive/document/documents.html','<div><jhi-alert></jhi-alert><div class="container-fluid mt-3 mb-3"><div class="row"><div class="col"><h2 data-translate="eDocumentsApp.digitalArchive.home.title">Digital Archive</h2></div><div class="col"><form class="form-inline float-right"><button class="btn btn-sm" ng-if="vm.searchVisible != true" ng-click="vm.searchVisible = !vm.searchVisible" ng-class="{\'btn-primary\':  !vm.searchVisible, \'btn-warning\' :vm.searchVisible}"><em class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></em> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.search">Pesquisar</span></span></button><!-- TODO RFERNANDES --><!--                    <button class="btn btn-sm btn-warning ml-1" ng-if="vm.searchVisible != true"--><!--                            ng-click="vm.viewFavoriteSearches()">--><!--                        <i class="fas fa-star"></i>&nbsp;<span class="d-none d-sm-inline-block" data-translate="global.favourites">Favoritos</span>--><!--                    </button>--> <button class="btn btn-sm btn-dark ml-2" ng-if="vm.searchVisible != true && vm.isSearchActive()" ng-click="vm.reset()"><em class="fas fa-trash-alt"></em> <span class="d-none d-sm-inline-block">&nbsp; <span data-translate="entity.action.clear">Limpar</span></span></button></form></div></div></div><div class="card text-white bg-primary mb-3" ng-if="vm.searchVisible == true"><div class="card-header pb-2 pt-2"><span data-translate="entity.action.search">Pesquisar</span> <button class="btn btn-sm btn-secondary float-right" ng-click="vm.searchVisible = !vm.searchVisible"><em class="fas fa-search-minus" ng-class="{\'fa-search\':  !vm.searchVisible}"></em>&nbsp;<span class="d-none d-sm-inline-block" data-translate="entity.action.hide"></span></button></div><div class="card-body bg-white text-primary"><form><div class="form-row"><div class="form-group col-sm-12 col-md-12 col-lg-3"><label data-translate="eDocumentsApp.document.documentNumber">Document Number</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.documentNumber.value"></div><div class="form-group col-sm-12 col-md-12 col-lg-9"><label data-translate="eDocumentsApp.document.documentType">Document Type</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons" ng-class="{\'btn-group-vertical\': vm.width < 660}"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentType.value == null || vm.filters.filterBy.documentType.value == undefined}" ng-click="vm.changeDocumentType(undefined)"><input type="radio" name="options" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.documentType.all">Todos</span></label><label ng-repeat="type in vm.types" class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentType.value == type}" ng-click="vm.changeDocumentType(type)"><input type="radio" name="options" autocomplete="off"> <span>{{\'eDocumentsApp.DocumentType.\' + type | translate}}</span></label></div></div><div class="form-group col-sm-12 col-md-12 col-lg-3"><label data-translate="eDocumentsApp.document.search.viewingType">Viewing Type</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentViews.value == null || vm.filters.filterBy.documentViews.value == undefined}" ng-click="vm.changeVisualization(undefined)"><input type="radio" name="options" id="option1" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.visualization.all">Todos</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentViews.value == \'1\'}" ng-click="vm.changeVisualization(\'1\')"><input type="radio" name="options" id="option2" autocomplete="off"> <em class="fas fa-check"></em> <span data-translate="eDocumentsApp.document.options.visualization.seen">Vistos</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentViews.value == \'0\'}" ng-click="vm.changeVisualization(\'0\')"><input type="radio" name="options" id="option3" autocomplete="off"> <span class="fa-layers fa-fw text-secondary"><em class="fas fa-certificate fa-fw"></em> <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-11.5 rotate--30" style="font-weight: 900">{{ \'eDocumentsApp.document.options.visualization.new\' | translate }}</span></span> <span data-translate="eDocumentsApp.document.options.visualization.multipleNew">Novos</span></label></div></div><div class="form-group col-sm-12 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.search.files">Files</label><div class="btn-group btn-group-sm btn-group-toggle col p-0" data-toggle="buttons"><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == null || vm.filters.filterBy.documentFiles.value == undefined}" ng-click="vm.changeFiles(undefined)"><input type="radio" name="options" id="optionAll" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.files.all">Todos</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == \'1\'}" ng-click="vm.changeFiles(\'1\')"><input type="radio" name="options" id="optionYes" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.files.yes">Yes</span></label><label class="btn btn-outline-primary col" ng-class="{\'active\': vm.filters.filterBy.documentFiles.value == \'0\'}" ng-click="vm.changeFiles(\'0\')"><input type="radio" name="options" id="optionNo" autocomplete="off"> <span data-translate="eDocumentsApp.document.options.files.no">No</span></label></div></div><div class="form-group col-sm-12 col-md-8 col-lg-5"><label data-translate="eDocumentsApp.document.origin.label">Origin</label><input class="form-control form-control-sm" ng-model="vm.filters.filterBy.originName.value"></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.createdDate">Created Date</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.from">De</span></div><input ng-model="vm.startDateForCreatedDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.createdDate.startDate" locale="pt" format="DD/MM/YYYY HH:[00]" max-view="day" start-view="month" today="false"><div class="input-group-append" ng-if="vm.startDateForCreatedDate != null"><button class="input-group-text btn btn-outline-default" type="button" ng-click="vm.clearInputDate(\'startDateForCreatedDate\')"><em class="fas fa-times"></em></button></div></div><br><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.to">A</span></div><input ng-model="vm.endDateForCreatedDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.createdDate.endDate" locale="pt" format="DD/MM/YYYY HH:[00]" max-view="day" start-view="month" today="true"><div class="input-group-append" ng-if="vm.endDateForCreatedDate != null"><button class="input-group-text btn btn-outline-default" type="button" ng-click="vm.clearInputDate(\'endDateForCreatedDate\')"><em class="fas fa-times"></em></button></div></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.documentDate">Document Date</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.from">De</span></div><input ng-model="vm.startDateForDocumentDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.documentDate.startDate" locale="pt" format="DD/MM/YYYY" max-view="day" start-view="month" today="true"><div class="input-group-append" ng-if="vm.startDateForDocumentDate != null"><button class="input-group-text btn btn-outline-default" type="button" ng-click="vm.clearInputDate(\'startDateForDocumentDate\')"><em class="fas fa-times"></em></button></div></div><br><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.to">A</span></div><input ng-model="vm.endDateForDocumentDate" class="form-control form-control-sm" moment-picker="vm.filters.filterBy.documentDate.endDate" locale="pt" format="DD/MM/YYYY" max-view="day" start-view="month" today="true"><div class="input-group-append" ng-if="vm.endDateForDocumentDate != null"><button class="input-group-text btn btn-outline-default" type="button" ng-click="vm.clearInputDate(\'endDateForDocumentDate\')"><em class="fas fa-times"></em></button></div></div></div><div class="form-group col-sm-6 col-md-4 col-lg-4"><label data-translate="eDocumentsApp.document.documentValue">Document Value</label><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.from">De</span></div><input ng-model="vm.filters.filterBy.documentValue.startValue" type="number" class="form-control form-control-sm"></div><br><div class="input-group input-group-sm"><div class="input-group-prepend"><span style="width: 46px" class="input-group-text bg-primary text-white" data-translate="eDocumentsApp.document.search.to">A&nbsp;</span></div><input ng-model="vm.filters.filterBy.documentValue.endValue" type="number" class="form-control form-control-sm"></div></div><div class="form-group d-sm-none d-md-block col-md-8 col-lg-8"></div><div class="form-group col-sm-6 col-md-12 col-lg-4 mb-0 align-self-center"><br><div class="btn-group col flex-btn-group-container p-0" role="group"><button class="btn btn-primary btn-sm col-sm-6" ng-click="vm.page = 1; vm.loadAll()"><em class="fas fa-search"></em> <span data-translate="entity.action.search">Pesquisar</span></button> <button class="btn btn-dark btn-sm col-sm-6" ng-if="vm.isSearchActive()" ng-click="vm.reset()"><em class="fas fa-trash-alt"></em> <span data-translate="entity.action.clear">Limpar</span></button></div></div></div></form></div></div><div class="table-responsive"><table class="jh-table table table-hover table-sm" aria-label="{{\'global.a11y.documentsTable\' | translate}}"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th></th><th jh-sort-by="documentNumber"><span data-translate="eDocumentsApp.document.documentNumber">Document Number</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="createdDate"><span data-translate="eDocumentsApp.document.createdDate">Created Date</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="documentDate"><span data-translate="eDocumentsApp.document.documentDate">Document Date</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="documentType"><span data-translate="eDocumentsApp.document.documentType">Document Type</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="documentValue"><span data-translate="eDocumentsApp.document.documentValue">Document Value</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="originName"><span data-translate="eDocumentsApp.document.origin.label">Origin</span> <em class="fas sort fa-sort"></em></th><th jh-sort-by="apiKeyCreatedBy"><span data-translate="eDocumentsApp.document.createdBy">CreatedBy</span> <em class="fas sort fa-sort"></em></th><th><span data-translate="eDocumentsApp.document.documentFiles">documentFiles</span></th></tr></thead><tbody><tr><td colspan="11"><div class="alert alert-warning" ng-if="!vm.documents || vm.documents.length === 0"><span data-translate="entity.no-results">No results</span></div></td></tr><tr ng-repeat="document in vm.documents track by document.id"><td><span ng-if="!document.hasViews" class="fa-layers fa-fw text-secondary"><em class="fas fa-certificate fa-fw"></em> <span class="fa-layers-text fa-inverse" data-fa-transform="shrink-11.5 rotate--30" style="font-weight: 900">{{ \'eDocumentsApp.document.options.visualization.new\' | translate }}</span> </span><span ng-if="document.hasViews"><em class="fas fa-fw" style="visibility: hidden"></em></span></td><td>{{document.documentNumber}}</td><td>{{document.createdDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{document.documentDate | date:\'dd/MM/yyyy\'}}</td><td><span class="badge badge-{{document.documentType}}">{{\'eDocumentsApp.DocumentType.\' + document.documentType | translate}}</span></td><td class="text-right nowrap">{{document.documentValue | currency: vm.getCurrency(document.currency) :2}}</td><td>{{document.originName}}</td><td>{{document.apiKeyCreatedBy}}</td><td ng-if="!document.hasFiles"><td ng-if="document.hasFiles"><div ng-if="!document.files && !document.filesUnavailable" class="spinner-border spinner-border-sm text-primary" role="status"><span class="sr-only" data-translate="global.loading">A carregar\u2026</span></div><span ng-if="document.filesUnavailable" class="text-muted" uib-tooltip="{{ \'eDocumentsApp.document.message.filesUnavailable\' | translate }}"><span aria-hidden="true">&mdash;</span> <span class="sr-only" data-translate="eDocumentsApp.document.message.filesUnavailable">N\xE3o foi poss\xEDvel carregar os ficheiros. Atualize a p\xE1gina.</span> </span><span style="cursor: pointer; outline: none" ng-style="{\'color\': file.checksumValid === false ? \'#dc3545\' : \'#0071ff\'}" ng-repeat="file in document.files | orderBy : \'fileType\'" ng-click="vm.download($event,document, file.id,file.fileType)" class="fa-layers fa-fw" uib-tooltip="{{ file.checksumValid === false ? (\'eDocumentsApp.digitalArchive.integrityWarning.compromisedFileTooltip\' | translate:{filename: vm.getViewableFilename(file.filename)}) : (\'eDocumentsApp.document.message.downloaded\' | translate:{filename: vm.getViewableFilename(file.filename), sizeString: vm.formatFileSize(file.size), numberOfDownloads: file.numberOfDownloads || 0}) }}"><em class="fas fa-lg" ng-class="vm.getFileIconClass(file.fileType)"></em> <span class="fa-layers-counter fa-2x bg-dark" ng-show="file.numberOfDownloads > 0" style="top: -5px; right: -1px">{{file.numberOfDownloads}}</span></span></td></tr></tbody></table></div><div class="text-center" ng-show="vm.documents.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-click="vm.loadAll()"></div></div></div>');
$templateCache.put('app/layouts/footer/know-more/know-more-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h5 class="modal-title" id="knowMoreTranslationLabel" data-translate="global.knowMore.title">Know More</h5><button type="button" class="close" data-dismiss="modal" aria-label="{{\'entity.action.close\' | translate}}" ng-click="vm.clear()"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><div class="form-group col-md"><!--<label class="form-control-label" >Pretendo receber informa\xE7\xE3o sobre novas funcionalidades do eDocuments.</label>--><div class="custom-control custom-switch"><input type="checkbox" class="custom-control-input" name="eDocumentsNewFunctionalities" id="field_eDocumentsNewFunctionalities" ng-model="vm.eDocumentsNewFunctionalities"><label class="custom-control-label" data-translate="global.knowMore.eDocumentsNewFunctionalities" for="field_eDocumentsNewFunctionalities"></label></div></div><div class="form-group col-md"><!--<label class="form-control-label" >Pretendo receber informa\xE7\xE3o sobre novas funcionalidades do eDocuments.</label>--><div class="custom-control custom-switch"><input type="checkbox" class="custom-control-input" name="flowinnProducts" id="field_flowinnProducts" ng-model="vm.flowinnProducts"><label class="custom-control-label" data-translate="global.knowMore.flowinnProducts" for="field_flowinnProducts"></label></div></div><div class="form-group col-md"><!--<label class="form-control-label" >Pretendo receber informa\xE7\xE3o sobre novas funcionalidades do eDocuments.</label>--><div class="custom-control custom-switch"><input type="checkbox" class="custom-control-input" name="beContactedByFlowinn" id="field_beContactedByFlowinn" ng-model="vm.beContactedByFlowinn"><label class="custom-control-label" data-translate="global.knowMore.beContactedByFlowinn" for="field_beContactedByFlowinn"></label></div></div><div class="form-group col-md" ng-if="!vm.isAuthenticated"><label class="form-control-label" for="field_email" data-translate="global.knowMore.email">Email</label><input type="email" class="form-control form-control-sm" name="email" id="field_email" required ng-model="vm.email"></div><div class="form-group col-md"><p class="text-muted"><span ng-if="!vm.isAuthenticated" data-translate="global.termsAndConditionsAcceptance">Termos e Condi\xE7\xF5es</span> <span ng-if="vm.isAuthenticated" data-translate="global.termsAndConditionsAcceptanceLogged">Termos e Condi\xE7\xF5es</span></p><p class="text-primary"><a href="https://www.flowinn.biz/politica-privacidade/" target="_blank"><u data-translate="global.termsAndConditions">Termos e Condi\xE7\xF5es</u></a></p></div></div><div class="modal-footer"><div class="flex-fill float-left"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><i class="fas fa-times"></i>&nbsp;<span data-translate="entity.action.close"> Close</span></button></div><div class="float-right"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');}]);})();